<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 612 369.3"
    style="enable-background: new 0 0 612 369.3"
    xml:space="preserve"
  >
    <g id="C1_00000018215412033080011900000002087109250731909559_" :fill="fill">
      <path
        class="st3"
        d="M148.4,126c-0.3,0.1-0.5,0.2-0.8,0.3c0.1,0.1,0.2,0.2,0.3,0.4c0.7,0.7,1.1,1.6,1.5,2.5c0.1-0.8,0.4-1.5,1.7-2
		C149.3,126.9,148.7,126.7,148.4,126z"
      />
      <path
        class="st3"
        d="M75.6,167.6c0-0.2,0.1-0.3,0.3-0.4c-0.2-0.2-0.5-0.5-0.8-0.8c-0.2,0.3-0.3,0.6-0.5,0.9
		c0.3-0.1,0.6-0.2,0.9-0.3C75.5,167.3,75.5,167.5,75.6,167.6z"
      />
      <path
        class="st3"
        d="M85.3,163.6c0.1,0,0.2-0.1,0.3-0.1l-0.1-0.1C85.4,163.5,85.4,163.6,85.3,163.6z"
      />
      <path
        class="st3"
        d="M77.2,168v0.1C77.2,168.1,77.3,168.1,77.2,168C77.3,168,77.3,168,77.2,168z"
      />
      <path
        class="st3"
        d="M81.1,167.4c-0.1,0-0.2,0.1-0.3,0.1c0,0,0,0,0-0.1c-1.1,0.6-2.3,1.3-3.4,1.9c0.3,0.6,0.3,1.2,0.2,2.1
		c0.7-0.2,1.2-0.5,1.8-0.6c2-0.5,3.8,0.4,4.3,2c1.6,0.5,2,0.6,2.6,0.4c-0.1,0-0.1-0.1-0.2-0.1c0.1-0.1,0.2-0.2,0.3-0.3
		c0.2,0,0.3,0,0.5,0.1c0.1,0,0.1-0.1,0.1-0.1c0.2-0.1,0.2-0.5,0.3-0.8c0.2-0.1,0.4-0.2,0.7-0.2c-0.3-0.5-0.5-0.8-0.8-1.2
		c0.3-0.1,0.6-0.2,0.8-0.3c-0.1-0.4-1.2-0.2-0.3-1.2c-0.8,0.3-1.2,0.5-1.6,0.7c-0.6,0.3-1.1,0.3-1.5,0.2l0,0
		c-0.1,0.1-0.4-0.1-0.6-0.2c0.1-0.1,0.1-0.2,0.2-0.3c-0.4-0.6-1-0.9-1.9-1C81.4,168.3,81.2,167.9,81.1,167.4z M79.6,169.2l-0.1-0.1
		c0.1,0,0.2-0.1,0.2-0.1s0.1,0,0.1,0.1C79.8,169,79.7,169.1,79.6,169.2z M82.7,170.2c-0.1,0.1-0.2,0.2-0.3,0.2
		c-0.2-0.2-0.3-0.3-0.5-0.5c-0.3,0.1-0.4,0.1-0.6,0.1s-0.3-0.1-0.4-0.2c0.5-0.5-0.7-0.8-0.1-1.3l0,0c-0.1,0-0.2,0-0.3,0
		c0-0.1,0.1-0.1,0.1-0.2c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0.1,0l0,0c1,0,1,0.7,1.4,1.2C82.4,169.9,82.6,170,82.7,170.2z"
      />
      <path
        class="st3"
        d="M85,177.1c-0.2,0.2-0.3,0.3-0.5,0.5c-0.8,0-1.5-0.2-1.3-0.8c0.1-0.4,0.5-0.8,0.9-1.2c-0.2,0-0.4,0-0.6,0
		c0-0.1-0.1-0.1-0.1-0.2c-0.3,0.5-0.8,0.9-1.3,1.2c0,0.1,0.1,0.2,0.1,0.3c0.3,0,0.5,0.2,0.7,0.4c0.1,0.1,0.3,0.3,0.4,0.4
		c0.4,0.5,0.4,0.9,0,1.3c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.2,0.1,0.4,0.1c0.3-0.6,0.5-0.9,0.9-1.1C84.6,177.9,84.8,177.5,85,177.1
		C85,177.1,85,177.1,85,177.1z"
      />
      <path
        class="st3"
        d="M108.1,141.7c0.2-0.1,0.4-0.2,0.6-0.2c0.9-0.2,1.7,0.3,2,1c0.2-0.2,0.5-0.3,0.8-0.5c-0.3-0.5-0.5-1-0.5-1.6
		C110,140.8,109,141.3,108.1,141.7C108.1,141.7,108.1,141.7,108.1,141.7z"
      />
      <path
        class="st3"
        d="M136.8,113c-0.2-0.2-0.1-0.6-0.1-0.9c-0.1,0.6-0.3,1.1-0.6,1.6c0.2,0,0.3-0.1,0.5-0.1
		C136.7,113.3,136.9,113,136.8,113z"
      />
      <path
        class="st3"
        d="M137.6,111.1c0.8,0,1,0.5,1,0.9s-0.3,0.8-0.5,1.1c0.2-0.1,0.4-0.1,0.6-0.2c0-0.1,0-0.3,0.1-0.3
		c0.3-0.3,0.6-0.2,0.9,0.1c0.4-0.1,0.7-0.2,1.1-0.3c0.1-0.1,0.2-0.3,0.4-0.4c-0.4-1-1.2-1.1-2.4-0.8c0-0.6,0-1.1-0.1-1.6
		c-0.5,0.1-1,0.2-1.7,0.4c0,0.2-0.1,0.3-0.1,0.5C137.2,110.9,137.4,111.1,137.6,111.1z M139.8,112.1L139.8,112.1L139.8,112.1
		L139.8,112.1z"
      />
      <path
        class="st3"
        d="M138.4,120.3c-0.7-0.1-1,0.2-1.4,0.5c-0.9,0.6-2,0.7-2.8,0.2c-0.9-0.7-1.8-0.7-3-0.7c0,0.1,0,0.3,0,0.5
		c0.3,0.1,0.6,0.3,0.9,0.7c-0.1,0.6-0.5,1-1,1.3c0.1,0.2,0.1,0.4,0.1,0.6c0.1,0.9,0.7,1.3,1.4,1.8c0.6,0.4,1,0.8,1.6,1.2
		c0.4,0.3,0.7,0.5,1.1,0.7c0.2,0.1,0.4,0.3,0.6,0.4c1-0.4,2.1-0.8,3.1-1.1c-0.3-0.3-0.5-0.5-0.8-0.8c0-0.7,0.6-1,1.3-1.2
		c0.6,0.4,0.9,0.9,1.1,1.5c1.6-0.6,3.2-1.1,4.7-1.7v-0.1c-0.2,0.1-0.3,0.1-0.5,0.2c-0.7,0.2-1.3,0.1-1.7-0.4c0.5-0.7,1-1.4,1.5-2.2
		c-1.8-0.5-1.7-1.5-1.3-2.6c0.1-0.2,0.1-0.3,0.2-0.5c0-0.1-0.1-0.2-0.1-0.2c-1.2-0.1-1.1,1.4-2.3,1.4c-0.2-0.2-0.5-0.5-0.7-0.8
		C140.4,119.5,139.5,120.4,138.4,120.3z M135.7,124.6c-0.4,0.3-0.8,0.5-1.2,0.1c-0.1-0.1,0-0.3,0.1-0.4c0.2-0.3,0.3-0.3,1.3,0
		C135.8,124.5,135.8,124.6,135.7,124.6z M141.8,122.5c0.1,0,0.1,0.1,0.2,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C141.7,122.6,141.8,122.5,141.8,122.5z M140.8,123.6L140.8,123.6v0.2V123.6C140.7,123.6,140.8,123.6,140.8,123.6z"
      />
      <path
        class="st3"
        d="M148.8,122.6c-0.5,0.2-1,0.4-1.6,0.6c0,0.1-0.1,0.1-0.1,0.2c0.6-0.2,1.1-0.4,1.7-0.6
		C148.8,122.8,148.8,122.7,148.8,122.6z"
      />
      <path
        class="st3"
        d="M143.2,117.3c-0.1-0.3-0.3-0.5-0.5-0.8c0.1,0.3,0.3,0.6,0.4,0.9C143.2,117.4,143.2,117.4,143.2,117.3z"
      />
      <path
        class="st3"
        d="M99.1,142.9c1.9-0.9,3.9-1.9,5.8-2.8c-0.3,0-0.6-0.1-0.8-0.3c-0.3,0.1-0.5,0.3-0.8,0.3
		c-1.4,0.4-2.9-0.3-3.2-1.5c-0.2-0.5,0-1.1,0.3-1.6c-0.5,0.1-1,0.2-1.5,0.4c0.5,0.4,0.9,0.9,1.1,1.6c-0.4,0.3-0.7,0.7-1.1,1
		C99.3,140.9,100.2,141.7,99.1,142.9z"
      />
      <path
        class="st3"
        d="M103.3,135.2c0.1,0.1,0,0.3-0.1,0.5c1,0.1,1.9,0.7,2.1,1.6c0.1,0.4,0,0.8-0.1,1.2c0.4,0.1,0.6,0.3,0.6,0.7
		c0,0.2-0.1,0.4-0.2,0.5c1-0.5,2.1-1,3.1-1.4c0.1-0.4,0.4-0.7,0.9-0.8c0.3-0.1,0.6-0.1,0.9,0c0.3-0.1,0.7-0.3,1-0.4
		c0.1-0.2,0.1-0.5,0.2-0.8c-0.2-0.2-0.4-0.4-0.6-0.7c-0.1-0.2-0.2-0.3-0.3-0.5c-0.3,0.1-0.6,0.2-0.9,0.2c-0.5,0-1.1-0.1-1.8-0.1
		c-0.3,0.6-0.8,1.3-1.9,1.2c-0.6-0.1-0.9-0.5-0.9-1c-0.1-1.1,1.1-1.1,2-1.5c-0.3-0.3-0.5-0.4-0.8-0.6h-0.1l0,0l0,0
		c-0.2,0-0.3,0-0.5,0c0.2,0,0.3,0,0.5,0c0,0,0,0,0.1,0.1c0.6,0,0.6-0.5,0.8-0.9c0.5-0.9,1.4-1.5,2.6-1.6c0.8,0,1.4,0.2,1.9,0.6
		c0.1-0.1,0.2-0.2,0.3-0.3c0.9-0.6,2-0.7,3-0.5c0-0.2,0-0.4,0-0.6c-1.4,0-2.7-0.1-3.4-1.2c-0.6,1.2-2.1,2-3.6,1.8
		c-0.2,0-0.4,0-0.5-0.1c-1.2-0.7-2.1-0.6-3.1,0.6c-0.3,0.3-0.9,0.3-1.6,0.4c0.1,0.3,0.2,0.6,0.1,1c-0.1,0.1-0.2,0.1-0.4,0.2v0.1
		c0,0.4-0.4,0.8-0.7,1.2C102.5,134.4,103,134.8,103.3,135.2z M105.3,132.8c-0.3-0.5-0.5-0.8-0.7-1.2
		C105.4,131.6,105.5,132,105.3,132.8z"
      />
      <path
        class="st3"
        d="M112.4,125.4c-0.7,0.3-1.4,0-1.2-0.6c0.1-0.5,0-0.8-0.2-1.1c-0.2-0.1-0.4-0.3-0.5-0.6V123
		c-0.9,0.3-1.9,0.7-2.8,1c0.1,0,0.1,0.1,0.2,0.1c0.6,0.9,1.5,0.9,2.4,1.2c1.1,0.3,1.7,1.2,1.8,2.2c0.4-0.9,0.8-1,2.6-1.2
		c0-0.4-0.1-0.8-0.1-1.2c-0.3-0.1-0.7-0.3-1-0.5C113.1,124.9,112.8,125.2,112.4,125.4z"
      />
      <path
        class="st3"
        d="M98.3,142.5c0,0.3,0,0.6-0.1,0.9c0.3-0.1,0.5-0.3,0.8-0.4C98.7,142.8,98.4,142.6,98.3,142.5z"
      />
      <path
        class="st3"
        d="M76.1,167.4c0,0.1-0.1,0.2-0.1,0.3c0.2,0,0.4,0,0.5,0C76.4,167.6,76.2,167.5,76.1,167.4z"
      />
      <path
        class="st3"
        d="M225.5,114.4C225.4,114.4,225.4,114.4,225.5,114.4c0,0.1,0.2,0.1,0.3,0.2c0,0-0.1-0.1-0.1-0.2
		C225.6,114.4,225.6,114.4,225.5,114.4L225.5,114.4z"
      />
      <path
        class="st3"
        d="M301.7,100.5L301.7,100.5c0.1-0.6,0.1-1.1,0.2-1.6c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0.5-0.2,0.9-0.2,1.4
		C301.5,100.4,301.6,100.5,301.7,100.5z"
      />
      <path
        class="st3"
        d="M264.1,103.4c0.1,0,0.2-0.1,0.3-0.1c-0.2-0.2-0.3-0.4-0.5-0.6C264,103,264,103.2,264.1,103.4z"
      />
      <path
        class="st3"
        d="M293.2,264.4c0.2-0.2,0.5-0.4,0.7-0.6c0-0.6,0.5-1.2,1.3-1.4c0.9-0.3,1.9,0.1,2.2,0.8c0.1,0.4,0.1,0.8-0.2,1.1
		c0.4,0.3,0.8,0.6,1.2,0.8c0.2-0.1,0.4-0.1,0.7-0.2c0-0.2-0.2-0.5-0.1-0.7c0.8-1.2,0.2-2-0.6-3c-1.1-1.4-1.3-3.3,0.5-4.6
		c0.2-0.1,0.4-0.3,0.5-0.4c-0.3-0.6-0.7-0.6-1.3-0.5c0,0,0,0.1-0.1,0.1c0,0-0.1,0-0.2,0h-0.1c-0.3-0.5-0.6-0.9-1.1-1.6
		c0,0.7,0,1.1,0,1.6c-0.6-0.4-0.9-0.9-1-1.5h-0.1c-0.9,0.2-1.8-0.3-2.1-1c-0.3,0.1-0.5,0.1-0.8,0.1c-0.7,0-1.4,0.6-2.4,1.1
		c0.6,0.2,0.9,0.4,1.2,0.5c-0.1,0.2-0.2,0.4-0.3,0.6c0.1,0.1,0.2,0.2,0.2,0.3c-0.1,0-0.1,0.1-0.2,0.1c0-0.1-0.1-0.2-0.1-0.3
		c-0.5,0.8-1,1.6,0.1,2.3c-0.4,0.6-0.9,1.2-1.3,1.7c-0.3,0.4-0.6,0.8-1,1.1c-0.9,0.7-1.3,1.5-0.8,2.4c0.3,0,0.5-0.2,0.8-0.4
		c-0.2-0.7,0.2-1.3,1.2-1.8c0.5,0.4,1,0.7,1.5,1c0.1-0.2,0.2-0.4,0.2-0.6c0.4,0,1,0.1,1.9,0.1c0,0.2,0.1,0.7,0.2,1.1
		c-0.7,0.1-1.3,0.1-1.5,0.3c-0.2,0.3-0.2,0.8,0,1.1c0.1,0.2,0.3,0.4,0.6,0.6h0.1v0.1c0.1,0.1,0.3,0.3,0.4,0.4
		c0.2,0.4-0.4,0.7-0.4,1.2c0.1,1.1,0.4,1.6,1.7,1.6h0.1c0.2-0.4,0.7-0.8,1.3-1c-0.8-0.6-1.6-1.1-2.4-1.7
		C293.3,265.4,293.1,264.4,293.2,264.4z M291.4,255.6L291.4,255.6L291.4,255.6L291.4,255.6z M295,255c0.1,0,0.2,0.1,0.2,0.2
		c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2-0.1-0.3-0.1C294.8,255.1,294.9,255,295,255z M296.1,256.9c0.7,0,1.2,0.3,1.4,0.9
		c0.1,0.5-0.2,0.9-0.7,1.2c-0.6,0.3-1.3,0.5-1.9,0.1c-0.3-0.2-0.5-0.6-0.8-0.9C294.5,257.1,295.2,256.9,296.1,256.9z M291.9,257.3
		c-0.1-0.1-0.2-0.2-0.2-0.3c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0.1,0.2,0.2C292.1,257.2,292,257.3,291.9,257.3z M292.4,256.5
		c0-0.1-0.1-0.2-0.1-0.2c0-0.1,0.1-0.1,0.2-0.2c0,0.1,0.1,0.1,0.1,0.2C292.5,256.4,292.5,256.5,292.4,256.5z M293.2,255.4
		c0,0-0.2-0.1-0.2-0.2c0.2-0.2,0.4-0.5,0.6-0.7c0.2,0.1,0.3,0.2,0.5,0.3C293.8,255,293.5,255.2,293.2,255.4z"
      />
      <path
        class="st3"
        d="M173.4,106.9c0-0.1,0.1-0.1,0.1-0.2C173.4,106.7,173.3,106.7,173.4,106.9C173.3,106.8,173.3,106.9,173.4,106.9
		z"
      />
      <path
        class="st3"
        d="M201.2,117.5c-0.4-0.4-0.6-1-1.5-0.7c0.1,0.4,0.3,0.8,0.2,1.2c-0.1,0.4-0.5,0.7-0.8,1.1
		c1.3,0.7,2.2-0.3,3.2-0.7C201.7,118.3,201.5,117.8,201.2,117.5z"
      />
      <path
        class="st3"
        d="M207.1,105.4l-0.1-0.1C207,105.4,207,105.5,207.1,105.4L207.1,105.4z"
      />
      <path
        class="st3"
        d="M220,106.4c0-0.1,0.1-0.3,0.1-0.4c-0.8,0.1-1.6,0.3-2.4,0.4c0.1,0.1,0.1,0.2,0.1,0.4
		C218.6,106.7,219.3,106.6,220,106.4z"
      />
      <path
        class="st3"
        d="M301.6,259.5c-0.2,0-0.4,0-0.5,0c0.3,0.2,0.6,0.3,0.8,0.5c1.3,0.9,2.7,1.7,4,2.6c1.5,1,3,2,4.6,3
		c-0.1-0.6,0-1.4,0.4-2.4c-1.8,0.2-3.2-0.1-3.9-1.4c-0.5-0.9-0.3-1.9,0.5-2.7c0,0-0.1,0-0.1-0.1c-0.2,0.3-0.6,0.6-0.9,0.7
		c-0.2,0-0.4,0-0.5,0v-1.5V258c-0.3-0.2-0.6-0.4-0.8-0.6c-0.1-0.1-0.2-0.3-0.3-0.4c0.5-0.6,0.8-0.9,1.2-1.2v-3.5
		c-1.4,0.5-2.9,0.5-4.4-0.1c-2-0.8-3-2.6-2.7-4.4c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1-0.1-0.2-0.2-0.2-0.3c0.2-0.1,0.4-0.2,0.5-0.3l0,0
		c0.1-0.5,0.3-0.9,0.6-1.4c-0.2,0-0.3-0.1-0.4-0.1c-0.1-0.4-0.2-0.5-0.3-0.9c-0.6,0.4-1.1,0.6-1.5,0.9c0.1,0.1,0.1,0.2,0.2,0.4
		c0.3,0.1,0.7,0.3,1.1,0.4c-0.4,0.4-0.7,0.6-1.1,0.7c-0.1,0.4-0.3,0.7-0.4,1.1c-0.2-0.3-0.2-0.6-0.3-0.9l0,0l0,0l0,0l0,0
		c-0.2-0.6-1-0.9-1.8-0.9c-0.1,0-0.1,0-0.1,0c-0.2,0.3-0.5,0.7-0.8,1c-0.4,0.4-0.5,0.8-0.5,1.3c0,0.4-0.1,0.7-0.2,1.1
		c0.4,0.3,0.8,0.6,1.2,0.9c0.2-0.1,0.3-0.1,0.5-0.1c1.1-0.2,2.2,0.4,2.4,1.3c0.1,0.5-0.1,1-0.5,1.5c0.4,0.3,0.9,0.4,1.4,0.6
		c1.1,0.3,1.8,0.8,1.7,1.7c0.9,0.4,1.6,0.7,2.3,1c0,0.2-0.1,0.4-0.2,0.5c0.4,0.2,0.7,0.4,0.7,0.7
		C302.9,258.8,302.4,259.4,301.6,259.5z M295.3,247.2c0,0-0.1,0-0.1-0.1s0-0.2,0.1-0.3c0.1,0,0.2,0.1,0.2,0.1
		C295.4,247,295.3,247.1,295.3,247.2z M297,249.8c0-0.2-0.1-0.3-0.1-0.5c0.1,0,0.1,0,0.2,0c0.1,0.2,0.1,0.3,0.2,0.5
		C297.1,249.7,297,249.8,297,249.8z M304.2,252.7c0.7-0.1,1.4,0.2,1.5,0.8s-0.4,1.1-1.1,1.2c-0.6,0.1-1.2-0.2-1.4-0.7
		C303.1,253.5,303.6,252.8,304.2,252.7z"
      />
      <path
        class="st3"
        d="M180.2,274.5c0.1-0.1,0.1-0.1,0.2-0.2l0,0C180.3,274.4,180.2,274.5,180.2,274.5z"
      />
      <path
        class="st3"
        d="M242.4,247.2c-0.2-0.2-0.4-0.4-0.7-0.6c-0.1,0-0.1,0.1-0.2,0.1c-0.1-0.1-0.2-0.2-0.3-0.2
		c0.1-0.1,0.1-0.1,0.2-0.2c-0.2-0.2-0.4-0.3-0.5-0.5c-0.3-0.5-1.1-0.7-1.3-0.5c-0.1,0-0.1,0.1-0.2,0.1c0.2,0.2,0.5,0.4,0.7,0.6l0,0
		c0,0,0,0,0,0.1c0.5,0.4,1,0.8,1.5,1.2C242,247.4,242.2,247.3,242.4,247.2z"
      />
      <path
        class="st3"
        d="M262,254.9L262,254.9c0.1,0.4-0.1,0.8-0.3,1.2c0,0,0.1,0,0.1,0.1c0.4,0.3,0.6,0.8,0.8,1.2
		c0.1,0.6-0.2,1.1-1,1.3c-0.2,0.1-0.4,0.1-0.6,0.2c-0.3,0.5-0.8,1-1.4,1.1s-1.2-0.3-1.3-0.9c0-0.1,0-0.2,0-0.4
		c-0.1-0.2-0.2-0.4-0.2-0.6c0.4-0.3,0.7-0.4,1.1-0.4c0.1-0.1,0.3-0.1,0.4-0.1c0.4,0,0.8,0,1.1,0.2c0.2-0.3,0-0.6-0.2-0.8h-0.1
		c-0.9,0.2-1.8-0.2-2.2-0.9c-0.2,0.2-0.3,0.3-0.5,0.6c0.1,0.2,0.3,0.5,0.5,0.8c-1.6,0.6-2.5,0-3.6-0.6c-0.4-0.1-0.6-0.4-0.4-0.9
		c0.4,0.1,0.6,0.2,0.7,0.5c0.5-0.4,0.9-0.9,1.8-0.8c0.1,0,0.4-0.4,0.6-0.7l0,0c0.3-0.1,0.6-0.2,0.9-0.3c0.2-0.4,0.6-0.7,1.2-0.9
		c0.2-0.5,0.3-0.9,0.4-1.5c-0.1-0.1-0.2-0.2-0.3-0.2c-0.9,0-1.7,0-2.6,0h-0.1c-0.1,0.1-0.3,0.2-0.4,0.3c0.1,0.1,0.3,0.2,0.4,0.4
		c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1-0.1-0.3-0.3-0.4-0.4c-0.2,0.1-0.4,0.1-0.7,0.2c-0.2,0.2-0.4,0.4-0.6,0.5l0,0
		c0.1,0.5,0.1,0.9,0.3,1.3c0.2,0.4-0.5,0.9-1.1,0.8c-0.4-0.1-0.9-0.3-1.2-0.5c-0.2-0.1-0.4-0.3-0.4-0.6c-0.1,0-0.2,0-0.2,0l0,0
		c-0.1,0.1-0.2,0.1-0.2,0.2c0-0.1-0.1-0.1-0.1-0.2c-0.6,0-1.2-0.1-1.7-0.4c-0.2,0.2-0.4,0.3-0.6,0.5c-0.1,0-0.2,0.1-0.2,0.1
		c0.2,0,0.5-0.1,0.9-0.1c-0.5,0.4-1.1,0.7-1.7,0.8v0.1c0,0.7-0.2,1.4-0.6,2c-0.1,0.1-0.2,0.2-0.3,0.3c0.5-0.1,1,0,1.6,0.3
		c0.7,0.3,1.5,0.4,2.5,0.6c-1,0.9-1.8,1.6-2.6,2.3c-2-0.2-2.7-0.7-3.1-1.9c-0.2,0-0.5-0.1-0.7-0.1c-0.1,0-0.1,0-0.2,0
		c-0.7-0.1-1.5-0.3-2.3-0.5c-0.3,0.2-0.7,0.2-1.2,0.2c-0.2,0.5-0.4,1-0.6,1.5c-0.2,0.7-0.4,1.4-0.6,2.1l0,0l0,0c0.1,0,0.2,0,0.3,0
		c0,0,0,0.1-0.1,0.1c0.3,0.1,0.6,0.3,0.9,0.4c0.1,0.5,0.2,0.9,0.3,1.5c0.9-0.3,1.7-0.3,2.4,0.1c0.1-0.7,0.7-0.9,1.9-1.2
		c0.2,0,0.4-0.1,0.5-0.1c1.3,0,2.6,0.1,3.9,0.1c0,0.1,0,0.2,0,0.3c-0.3,0-0.5,0-0.8,0.1l-0.1,0.1c0.4,0.1,0.9,0.2,1.3,0.2
		c0,0.1,0,0.1,0,0.2c-0.3,0-0.5,0.1-0.9,0.1c-0.2,0.3-0.4,0.6-0.6,0.9c-0.3,0.5-0.6,0.7-1.3,0.8c-0.7,0.1-1.4,0.3-2.1,0.5
		c-0.1-0.3-0.1-0.4-0.1-0.7c-0.1,0-0.1,0-0.2,0c0,0.1,0.1,0.2,0.1,0.2c0.4,1.4-0.6,2.5-2.9,3.3c0.7,0.7,1.6,0.8,2.5,0.5
		c0.9-0.4,1.6-0.2,2.4,0c0.8,0.3,1.7,0.4,2.5,0.6c0.7,0.9,1,1.8,0.4,3.1c1.6-0.5,3-0.8,4.5-1.3c-0.1,1.4-0.1,1.4,1,1.6
		c0.3-0.5,0.7-1,0.9-1.5c0.1-0.3,0.2-0.8,0.1-0.9c-0.9-0.5-0.7-1.4-1-2.1c-0.2-0.3-0.4-0.6-0.6-0.9c-0.6,0.1-0.8,0.4-0.9,0.8
		c0.2,0.2,0.2,0.4,0.1,0.8c-0.3,0-0.5,0-0.6-0.1c-0.1,0.1-0.2,0.1-0.3,0.1c-0.8-1-1.5-2-2.3-3.1c1.2-1.1,2.6-1.3,4-1.7
		c0-0.4,0.1-0.8,0.1-1.2c0.9-0.8,1.6,0,2.4,0.1c0.2,0-0.3,0.7,0.3,0.3c0.1-0.1,0.2-0.4,0.1-0.5c0-0.2-0.2-0.3,0-0.6
		c0.4,0.2,0.8,0.4,1.3,0.6c0.4-0.4,0.8-0.8,1.3-1.3c0.5,0.1,1.1,0.1,1.7,0.2c0.5-0.2,0.9-0.5,1.4-0.7c-0.1-0.2-0.1-0.5-0.1-0.8
		c0-1.5,1.5-2.2,2.4-3.3c0.1-0.1,0.3-0.3,0.5-0.4c-0.7-0.6-1.5-1.1-2.2-1.7C263.6,255.9,262.7,255.6,262,254.9z M244.8,260.6
		c0,0.3-0.3,0.5-0.7,0.6c0.1-0.2,0.1-0.4,0.2-0.6l-0.1-0.1c0.1,0,0.1,0,0.2,0c0.1-0.1,0.1-0.3,0.2-0.5
		C244.7,260.2,244.8,260.4,244.8,260.6c0-0.1,0.1-0.1,0.1-0.1C244.9,260.5,244.8,260.6,244.8,260.6z M245.2,262.3
		c-0.1-0.1-0.2-0.2-0.2-0.2s0.1-0.1,0.2-0.2c0.1,0.1,0.1,0.1,0.1,0.2C245.3,262.2,245.3,262.2,245.2,262.3z M245.9,260.6
		L245.9,260.6l0.1-0.1L245.9,260.6z M249.3,265.9C249.3,266,249.3,266,249.3,265.9C249.2,266,249.2,266,249.3,265.9
		c-0.1,0.2-0.2,0.2-0.3,0.3c-0.1,0-0.1-0.1-0.2-0.1C248.9,266.1,249.1,266.1,249.3,265.9C249.2,266,249.2,266,249.3,265.9
		C249.2,266,249.3,265.9,249.3,265.9c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0.1C249.4,265.8,249.3,265.9,249.3,265.9z M254.5,259.6
		c0,0,0,0.1,0.1,0.1l-0.1,0.1c0-0.1-0.1-0.1-0.1-0.2C254.4,259.6,254.5,259.5,254.5,259.6z M254.2,257.9l-0.1,0.1v-0.1H254.2z
    M253.3,256.4c0.1,0.1,0.2,0.1,0.2,0.2c-0.3,0.2-0.5,0.3-0.8,0.5c-0.1-0.1-0.1-0.1-0.2-0.2C252.8,256.7,253,256.5,253.3,256.4z
    M251.1,259.9c0.9,0,1,0.5,1.2,1.2C251.4,260.9,251,260.6,251.1,259.9z M254.9,264.8c-1.9,0.2-2.4-0.1-2.9-1.6
		c0.9-0.5,1.7-0.4,2.5,0C255,263.6,255.4,264.1,254.9,264.8z"
      />
      <path
        class="st3"
        d="M246.9,253.2c0.4-0.7,0.6-0.8,1.3-0.9c-0.1-0.2-0.3-0.4-0.4-0.7c-0.5,0.4-1,0.7-1.7,1.1
		C246.4,252.9,246.7,253,246.9,253.2z"
      />
      <path
        class="st3"
        d="M279.5,264.2c-0.5-0.3-1-0.6-1.5-0.9c-0.1,0.2-0.2,0.5-0.3,0.8c0,0.1,0,0.2-0.1,0.3c0.3,0.2,0.6,0.5,1,0.7
		c0.4-0.1,0.8-0.1,1.2,0c0-0.2,0.1-0.5,0.1-0.7c0.6,0.5,1.1,0.8,1.7,0.7c-0.6-0.4-1.2-0.9-1.8-1.3
		C279.7,263.9,279.6,264,279.5,264.2z"
      />
      <path
        class="st3"
        d="M270.6,267.3c-0.2-0.2-0.4-0.3-0.6-0.5c-0.1,0.1-0.1,0.2-0.2,0.3C270,267.2,270.3,267.2,270.6,267.3
		L270.6,267.3z"
      />
      <path
        class="st3"
        d="M273.2,267.7c-0.7,0.1-1.3,0.1-2-0.1c-0.5,0.2-1,0.4-1.7,0.7c1.7,0.4,3.3,0,4.3,1.1c-0.3,0.8-0.3,1.2,0.1,1.3
		c0.2-0.1,0.4-0.2,0.7-0.3c-0.1-0.1-0.2-0.3-0.3-0.4c0.1-0.1,0.1-0.3,0.2-0.3c0.5-0.3,1.1-0.6,1.6-0.8c0.1,0,0.1-0.1,0.2-0.1
		c0-0.1,0.1-0.1,0.1-0.2v0.1c0.3-0.1,0.5-0.2,0.7-0.4c-1.4,0-2.8,0.1-4.2,0.1C273,268.2,273.1,268,273.2,267.7z"
      />
      <path
        class="st3"
        d="M298.1,268.8c-0.1,0.3-0.4,0.7-0.7,0.9c0.1,0,0.2,0,0.2,0c0,0.3-0.1,0.5-0.2,0.8l0,0c0.9,0.1,1.7,0.1,2.7,0.2
		c0-0.2-0.1-0.4-0.1-0.6C299.4,269.7,298.7,269.2,298.1,268.8z"
      />
      <path
        class="st3"
        d="M118.5,144.9c-0.3,0-0.5,0-0.8,0.1c0,0.4,0,0.7-0.1,1.1c0,0.2,0,0.5,0.1,0.7c0.7,0,1.4,0.2,2.1,0.5
		c0.2-0.1,0.4-0.1,0.5-0.2c-0.1-0.4-0.2-0.8-0.3-1.2C119.4,145.9,118.7,145.5,118.5,144.9z"
      />
      <path
        class="st3"
        d="M132.3,117.5c-0.3-0.1-0.7-0.2-1.3-0.3C131.6,117.8,132,117.6,132.3,117.5z"
      />
      <path
        class="st3"
        d="M118.8,126.9c0.5-0.5,1.1-0.8,1.9-1c0.3-0.1,0.7-0.1,1.2-0.1c-0.9-2,0-3.7,1.2-5.4c-0.7-0.3-1.4-0.5-1.9-0.9
		l-0.1-0.1c-1.3,0.4-2.5,0.8-3.8,1.2c0.7,0.3,1.3,0.8,1.5,1.6c0.3,0.9-0.1,1.8-1,2.5c-0.8,0.6-1.6,0.8-2.4,0.6
		c0.1,0.4,0.2,0.8,0.3,1.1C117.2,126.3,118.3,126.4,118.8,126.9z"
      />
      <path
        class="st3"
        d="M133.2,117.4c1.2-0.8,2.4-1.2,3.8-0.6c0-0.3-0.1-0.5-0.1-0.9c-0.5-0.2-1.1-0.4-1.6-0.7c-0.1,0-0.2,0-0.3,0.1
		c-0.1,0.2-0.3,0.4-0.4,0.6l0,0c0.1,0,0,0.3-0.1,0.4c-0.1,0-0.2,0.1-0.4,0.1c-0.3,0.3-0.8,0.6-1.2,0.9c-0.2,0.1-0.4,0.1-0.6,0.2
		c0.1,0.1,0.2,0.3,0.3,0.4C132.9,117.7,133,117.6,133.2,117.4z"
      />
      <path
        class="st3"
        d="M96.9,159.2c-0.5,0.3-1,0.5-1.5,0.8c0.2,0.1,0.5,0.2,0.7,0.3s0.4,0.3,0.5,0.5c0,0.1-0.4,0.4-0.5,0.4
		c-0.6-0.2-1.3-0.4-1.8-0.6c-0.3,0.1-0.6,0.3-0.9,0.4c0.2,0.4,0.4,0.7,0.5,1.2c0,0,0,0,0.1,0l0,0l0,0l0,0c0,0,0,0,0,0.1
		c0.5-0.2,1-0.4,1.6-0.7c0.5,0.5,1,1,1.4,1.5c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.7,0.4-1.5,0.6-2.5C97.2,159.8,97,159.5,96.9,159.2z"
      />
      <path
        class="st3"
        d="M113.6,151.4c-1.8,0.8-3.7,1.6-5.5,2.5l0.1,0.1c1.8,0.1,3.7-0.3,5.4,0.2c0.2,0.1,0.6-0.1,0.9-0.1
		c0.5-0.1,0.9-0.3,1.2-0.6C114.7,153.2,113.9,152.5,113.6,151.4z"
      />
      <path
        class="st3"
        d="M128.7,120c-0.1-0.6,0.2-0.8,1.6-0.9c0.3-1.4,0.3-1.4-0.9-2.2c-0.5,0.2-0.9,0.4-1.4,0.7c0,0,0.1,0,0.1,0.1
		c0.1,0.1-0.1,0.5-0.2,0.5c-0.3,0.1-0.7,0.3-1,0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.3,0.2-0.7,0.3-1,0.5c-0.4,0.2-0.6,0.7-0.9,1
		c0.6,0.9,2.2,1.6,3.5,1.6c0.4,0,0.7,0,1,0.1c0.1-0.1,0.2-0.2,0.3-0.4c0.1-0.1,0.3-0.2,0.4-0.3c-0.2-0.3-0.3-0.6-0.5-0.8
		C129.3,119.9,129,120,128.7,120z"
      />
      <path
        class="st3"
        d="M103.8,155.8c-0.6,0.3-1.2,0.6-1.8,0.9c0.6,0.1,1.2,0.3,1.8,0.3c-0.1-0.3-0.3-0.5-0.2-0.7
		C103.7,156.2,103.8,156,103.8,155.8z"
      />
      <path
        class="st3"
        d="M252.4,118c-0.4-0.1-0.9-0.2-0.9-0.7c-0.5,0.4-1.1,0.8-2,0.2c0,0,0-0.1,0-0.2c-0.4,0.2-0.8,0.5-1.3,0.8
		c0.5,0.3,0.9,0.8,1.1,0.7c1.2-0.3,1.3,0.4,1.4,0.7c-0.3,1.2-0.6,2.1-0.8,3.1c0.7-0.1,1.1-0.4,1.5-0.3c0.3,0,0.5,0.4,0.8,0.8
		c0.4-0.9,0.8-1.7,1.2-2.5c-0.5-0.5-1-1-1.5-1.5c0.4-0.4,0.7-0.7,1-1c0,0,0,0,0-0.1C252.8,118.1,252.6,118.1,252.4,118L252.4,118z
    M251.1,118.8c-0.2-0.3-0.4-0.6-0.6-0.8c0.1,0,0.2-0.1,0.3-0.1c0.2,0.3,0.3,0.6,0.5,0.9C251.2,118.7,251.1,118.7,251.1,118.8z
    M251.5,119.1L251.5,119.1h0.1H251.5z"
      />
      <path
        class="st3"
        d="M248.1,117.5c0.1,0,0.1,0,0.2,0c0-0.1,0-0.1,0-0.2C248.2,117.4,248.1,117.4,248.1,117.5z"
      />
      <path
        class="st3"
        d="M146.2,135.4c0.4-0.2,0.8-0.4,1.1-0.6c0.6,0.3,1.2,0.6,1.7,0.9c0.1,0.1,0.2,0.2,0.3,0.3c1-0.3,1.9-0.7,2.9-1
		c0.5-0.8,0.9-1.3,1.1-1.8c0.1-0.4,0.4-0.7,0.6-1c-0.4-0.1-0.7-0.4-0.9-0.7c-0.3-0.3-0.4-0.7-0.4-1.1c-0.1,0-0.2,0-0.3,0
		c-0.1,0.5-0.2,1-0.3,1.4c-0.9,0.8-1.9,0.3-2.8,0.3l-0.1,0.1c-0.2,0.4-0.5,0.7-0.8,1.2c-0.1-0.1-0.1-0.2-0.2-0.3
		c-0.4,0.2-0.8,0.4-1.3,0.6c-0.5,0.1-1,0.2-1.4,0.1c0.1,0.1,0.3,0.1,0.4,0.2C146.3,134.2,146.2,134.8,146.2,135.4
		C146.1,135.3,146.1,135.3,146.2,135.4L146.2,135.4z M148.7,133.6c0.4-0.2,0.9-0.2,1.5-0.3c0.2,0.7-0.1,1.1-0.6,1.4
		c-0.5,0.3-0.9,0.2-1.2-0.2C148.1,134.2,148.3,133.8,148.7,133.6z"
      />
      <path
        class="st3"
        d="M306,243v-0.7l0,0c-0.3-0.2-0.6-0.3-0.8-0.5c-0.2,0.2-0.4,0.4-0.6,0.4c-0.1,0.2-0.1,0.3-0.3,0.5
		c-0.2,0.3-0.4,0.6-0.7,0.8c0.8,0.1,1.6,0.2,2.4,0.4V243z"
      />
      <polygon class="st3" points="259.9,121.9 259.8,121.8 259.8,121.9 	" />
      <path
        class="st3"
        d="M220.1,131.8c0,0-0.1,0-0.1-0.1c-0.7,0.9-1,1.9-1.2,2.9c0.7-0.1,1.5-0.3,2.1-0.8c-0.1-0.2-0.2-0.3-0.4-0.5
		C220.1,132.9,220,132.3,220.1,131.8z"
      />
      <path
        class="st3"
        d="M179.5,123.5c0.1,0,0.2-0.1,0.3-0.1c0.5-0.2,0.4-0.5,0.2-0.8c-0.1-0.1-0.5-0.1-0.6,0
		C179,122.9,179.1,123.2,179.5,123.5C179.5,123.4,179.5,123.4,179.5,123.5z"
      />
      <path
        class="st3"
        d="M201.9,121.7C201.9,121.7,201.8,121.8,201.9,121.7c0,0.1,0,0.2,0,0.2c0.3,0.5-0.1,0.4-0.4,0.5
		c-0.1,0.1-0.1,0.2-0.2,0.3l0,0c0,0,0,0,0,0.1c0,0,0.2,0.2,0.3,0.4c0.1,0.2,0.3,0.4,0.5,0.8c-0.2,0.1-0.4,0.3-0.7,0.5c0,0,0,0,0,0.1
		c0.2-0.1,0.4-0.1,0.6-0.2c0.3-0.9,0.6-1.8,0.8-2.7c0,0,0,0-0.1,0C202.4,121.6,202.2,121.6,201.9,121.7z"
      />
      <path
        class="st3"
        d="M173.8,123.9C173.7,123.8,173.7,123.8,173.8,123.9c0,0.5-0.5,0.7-1.3,0.8c-0.2-0.4-0.5-0.9-0.7-1.4l0,0
		c0,0,0,0,0-0.1l0,0l0,0c0.3-0.2,0.5-0.4,0.6-0.6c-0.4-0.4-0.8-0.8-0.9-1.5c0.8-0.5,1.7-1,2.6-1.4c0.2-0.1,0.7,0.3,1,0.2
		c0.9-0.3,1.8-0.7,2.6-1c0-0.3,0-0.5-0.1-0.7c-0.2,0.2-0.4,0.4-0.6,0.7c-0.4-0.3-0.6-0.4-1-0.7c0.2-0.2,0.3-0.4,0.5-0.6
		c-0.6,0.2-1.2,0.3-1.7,0.5c0.1,0.2,0.2,0.4,0.3,0.6c-0.7,0.2-1-0.1-1.2-0.4c-0.7,0.2-1.4,0.4-2.1,0.6c-0.3,0.1-0.6,0.2-0.9,0.2
		c-0.1,0.3-0.4,0.6-0.6,0.9c0,0,0,0,0,0.1l0,0c1.1,1-0.2,2.2,0,3.3c-0.5,0.4-0.6,0.8-0.7,1.3c0.2,0,0.3,0,0.6,0
		c0.2,0.1,0.4,0.1,0.9,0.3c-0.2,0.4-0.3,0.8-0.5,1c-0.3,0.3-0.7,0.4-1.1,0.4c0.1,0.1,0.3,0.2,0.4,0.2c0.4-0.1,0.8-0.2,1.2-0.3
		c0.1-0.1,0.3-0.2,0.5-0.3l0.1,0.1c0.3-0.1,0.6-0.1,0.8-0.2c0.7-0.3,1.5-0.6,2.4-1C174.5,124.6,174.1,124.3,173.8,123.9z
    M173.9,119.5h0.1l0.1-0.1v0.1l0,0C174,119.5,174,119.5,173.9,119.5C173.9,119.6,173.9,119.6,173.9,119.5
		C173.9,119.6,173.9,119.6,173.9,119.5z M171.4,123.1c0,0,0,0.1,0.1,0.1L171.4,123.1C171.4,123.2,171.4,123.2,171.4,123.1
		C171.3,123.1,171.4,123.1,171.4,123.1z M171.5,125.4c-0.1,0-0.2,0-0.3,0l0.1-0.1c0.1,0,0.2,0,0.3,0
		C171.6,125.3,171.6,125.4,171.5,125.4z"
      />
      <path
        class="st3"
        d="M215.9,118.5c0,0.1,0,0.1,0,0.2c0.1,0,0.2,0.1,0.2,0.1c0.4,0,0.6,0,0.9,0c0.4-0.1,0.8-0.4,1.2-0.7
		C217.4,118.2,216.7,118.3,215.9,118.5z"
      />
      <path
        class="st3"
        d="M201.8,110.1c0.8-0.2,1.6-0.3,2.4-0.5c0.3-0.2,0.7-0.4,1.1-0.6c-1.3,0.3-2.6,0.6-4,0.9
		C201.5,109.9,201.7,110,201.8,110.1z"
      />
      <path
        class="st3"
        d="M93.9,162.1c-0.3,0.1-0.6,0.2-1.1,0.4c0.2-0.3,0.3-0.5,0.5-0.8c-0.4,0-0.8,0-1.3,0v-0.1
		c-0.2,0.1-0.5,0.2-0.7,0.4c-0.1,0.1-0.1,0.1-0.2,0.2H91c-0.5,0.3-1,0.5-1.6,0.8c0.3,0,0.6,0,1-0.1c0.1,0.2,0.2,0.4,0.3,0.5
		c0.2-0.2,0.5-0.4,0.9-0.5c0.4,0,0.7,0.1,0.9,0.3c0.4-0.2,0.8-0.3,1-0.5C93.8,162.5,93.9,162.3,93.9,162.1L93.9,162.1L93.9,162.1z
    M91.4,162.8l-0.2-0.1c0-0.1,0.1-0.2,0.2-0.4c0.2,0.1,0.4,0.2,0.4,0.3C91.7,162.6,91.5,162.7,91.4,162.8z"
      />
      <path
        class="st3"
        d="M199.9,110.6c0-0.1,0-0.3,0-0.4h-0.1c-0.2,0.2-0.3,0.3-0.5,0.5C199.5,110.6,199.7,110.6,199.9,110.6z"
      />
      <path
        class="st3"
        d="M170.3,120.1c-0.2-0.3-0.2-0.5-0.2-0.7c-1.9,0.5-3.7,1-5.6,1.6c0.2,0.2,0.6,0.4,0.8,0.4c1-0.2,1.5,0.5,2.4,0.6
		c-0.1-1.2,1-1.6,1.9-2.2c0.1,0.2,0.2,0.3,0.2,0.5C170.1,120.1,170.2,120.1,170.3,120.1L170.3,120.1L170.3,120.1z"
      />
      <polygon class="st3" points="151.6,129.3 151.5,129.3 151.6,129.4 	" />
      <path
        class="st3"
        d="M151.7,126.8c0,0.1,0,0.2,0,0.3c0.1-0.1,0.1-0.2,0.2-0.2C151.8,126.9,151.7,126.9,151.7,126.8z"
      />
      <path
        class="st3"
        d="M235.4,135.3c-1-1,0.4-2.7-1.2-3.4c-0.7,0-1.3,0-1.8-0.1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2-0.1-0.3-0.3-0.5-0.4
		c-0.5-0.2-0.8-0.6-1-1.1c-0.2-0.8,0.3-1.9,1.2-2.4c1.2-0.7,2.5-0.6,4.1,0.4c2.5-1.4,5-2,7.5-1.2c0.4,0.3,0.8,0.6,1.1,1
		c0.1,0.1,0.2,0.1,0.2,0.2c0.3-0.3,0.5-0.6,0.8-0.9c0.6,0.2,1.2,0.3,1.6,0.4c0.4-0.3,0.7-0.4,0.9-0.7c0.3-0.3,0.6-0.8,0.5-1.1
		c-0.3-0.7-0.1-1.5-0.6-2c0.4-0.6,0.7-1.1,1-1.6c-0.2-0.1-0.4-0.1-0.5-0.1s-0.2,0.1-0.3,0.1c-0.9,0.2-1.8-0.4-1.9-1.2
		c-0.1-0.4,0.1-0.8,0.4-1.2c0-0.2,0-0.4,0-0.6c-0.3,0.3-0.6,0.4-0.9,0.7c-0.3-1.1-1.4-0.3-2.1-0.5c-0.5,0.4-0.6,1.1-1.5,1.3
		c-0.2-1.1,0.9-1.7,1.3-2.5c-0.2-0.1-0.4-0.2-0.7-0.4c-0.3,0.3-0.5,0.5-0.8,0.7s-0.8,0.3-1,0.2c-0.2-0.1-0.3-0.5-0.3-0.8
		c0.2-0.5,0.5-1,0.8-1.6c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.3,0.2-0.4c0.6,0.2,1,0.3,0.8,0.8c0.2,0.1,0.4,0.1,0.6,0.1
		c1.1-0.3,1.4,0.2,1.7,0.8c-0.2,0.4-0.3,0.7-0.6,1.3c0.7-0.4,1.1-0.6,1.5-0.7s0.9-0.2,1.4-0.3c-0.1-0.3-0.2-0.5-0.2-0.7
		c-0.1-0.1-0.2-0.1-0.4-0.2c0.1-0.1,0.1-0.2,0.2-0.3l0,0l0,0c0.1-0.2,0.3-0.4,0.4-0.5c0.2-0.1,0.5,0.1,0.9,0.2c0-0.2,0-0.3,0-0.5
		l0,0v-0.1c-0.5-0.2-1.2,0-1.2-0.8c0.7,0,1.1,0.3,1.2,0.8h0.1l0,0c1-0.2,1.3-0.3,1.6,0.1c0.2-0.9,0.4-1.8,0.6-2.8
		c1.4-0.1,2.6,0.5,2.9,1.3c0.1,0.2,0.1,0.5,0.1,0.8c0.5,0.6,1.6,0.2,1.9,1c-1.8,0.2-2.3,0-1.9-1c0,0,0,0.1-0.1,0.1
		c-0.2,0.3-0.5,0.6-0.8,0.8c0.4,0.4,0.6,0.8,0.7,1.3c0,0,0,0,0.1,0l-0.1,0.1c0.5-0.3,0.9-0.5,1.4-0.8c0.6,0.5,1.1,0.9,1.5,1.3
		c0.3-0.4,0.7-0.7,1-1.1c0.2,0.1,0.5,0.2,0.5,0.3c0.4,0.8,1.5,1.2,1.7,2.1c0,0.1,0.2,0.3,0.3,0.3c1.3-0.4,1.2,0.6,1.7,0.9
		c-0.2,0.1-0.4,0.2-0.5,0.3l0,0l0,0c-0.4,0.3-0.3,0.4-0.2,1c0.4-0.2,0.9-0.1,1.3-0.6c0.6-0.7,1-0.7,1.6-0.2c0.2-0.1,0.3-0.1,0.5-0.2
		c-0.2-0.4-0.2-0.6-0.4-0.9c0,0-0.3,0-0.5,0.1l0,0l-0.1,0.1c0,0.1,0,0.3-0.1,0.4c-0.1,0-0.2,0-0.2-0.1c0.1-0.1,0.2-0.2,0.3-0.3v-0.1
		c0,0,0,0,0.1,0c0.1-0.5,0.2-1.1,0.3-1.6c-0.1-0.1-0.1-0.2-0.2-0.4c-0.3-1,0.4-1.9,1.6-2.2c0.4-0.1,0.9-0.1,1.2,0
		c0.2-0.1,0.4-0.1,0.6-0.1c1.5-0.2,3.1,0.4,3.7,1.5c0,0,0,0.1,0.1,0.1c0.1-0.2,0.3-0.3,0.5-0.4c-0.3-0.2-0.5-0.3-0.8-0.6
		c-0.4-0.4-0.7-0.8-0.9-1.3c-1.4,0.2-2.7,0.4-4.1,0.6c0.3-0.3,1.7-0.7,3.8-1.1c-0.4-1.2-0.2-2.5,0.6-3.7c0.2-0.4,0.5-0.7,0.9-1.3
		c-0.4,0-0.8,0.1-1.2,0.1c-1.4,0.2-2.7,0.3-4.1,0.5c0,0.2,0,0.4-0.1,0.6c0,0,0,0.1,0.1,0.1h-0.1c-0.2,0.6-0.5,1.2-1.1,1.8
		c-0.4,0.4-0.5,0.8-0.4,1.3c0,0.5-0.1,1-0.3,1.3c0.1,0.1,0.2,0.2,0.3,0.3c-0.2,0-0.3-0.1-0.4-0.1c-0.3,0.5-0.8,0.8-1.4,1
		c0.3,0.2,0.5,0.6,0.2,0.9c-0.5,0.6-0.3,1,0,1.5c-0.1,0.1-0.3,0.1-0.4,0.2c-0.4-0.9-0.8-1.7-1.2-2.5c-0.3,0-0.6-0.1-0.8-0.2
		c-0.1,0-0.2-0.1-0.4-0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1-0.1-0.1-0.2-0.2-0.4c-0.9-0.4-1.5-1-1.2-2.2c0-0.2-0.1-0.4-0.2-0.7l0,0
		c-0.3-0.2-0.6-0.4-0.8-0.6c-0.1,0.4-0.1,0.8-0.3,1.5c-0.5-0.5-0.9-0.8-0.9-1c0.1-0.6-0.1-1-0.4-1.4c-0.1-0.1-0.1-0.2-0.1-0.4
		c-2.2,0.3-4.4,0.5-6.6,0.8c-1.8,0.2-3.7,0.5-5.5,0.7c0,0-0.1,0-0.1,0.1c-0.1,0.4-0.5,0.9-1.2,1.2c-0.6,0.3-1.5,0.3-2-0.2
		c-0.2-0.2-0.3-0.4-0.4-0.6c-0.7,0.1-1.3,0.2-2,0.3c0,0.1,0,0.1,0,0.2l0,0c0.2,0.1,0.5,0.3,0.6,0.5c0.6,0.7,0.3,1.8-0.4,2.6
		c0.3,0.1,0.5,0.4,0.8,0.6c0.7,0.1,1.3,0.6,1.4,1.1c0.1,0.8-0.6,1.7-1.6,1.9c-0.5,0.1-1,0-1.4-0.2c-1.5,0.3-2.1-0.1-2.8-1.5
		c-0.6,0.1-1.3,0.3-1.9,0.3l0,0c0.1,0.2,0.2,0.4,0.2,0.6c0,0.3,0,0.7-0.2,0.9c0.5,0.2,1,0.4,1.4,0.7c0.9,0.7,1.4,1.7,2.1,2.6
		c0.2-0.3,0.4-0.7,0.5-1l0,0c0,0,0,0,0-0.1c-0.1,0-0.2,0-0.2-0.1c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0-0.1s0.1-0.1,0.1-0.2
		c0,0.1-0.1,0.2-0.1,0.2l0,0c0,0.1,0,0.1,0,0.2c0,0,0,0,0.1,0l0,0c1.2-0.2,2.3-0.8,3.5-0.3c0.6,0.3,1,0.6,0.8,1.2
		c-0.1,0.5-0.3,0.9-0.4,1.4c-0.4-0.2-1-0.2-1.7-0.2c-1,0-1.9-0.1-2.9-0.1l0,0c-0.2-0.1-0.4-0.2-0.6-0.3c-1,1.4-2.3,2.5-4.3,2.6
		c-0.2,0-0.4,0-0.6,0c-0.4,0.4-1,0.7-1.7,0.9c-0.4,0.1-0.9,0.1-1.3,0c0.2,0.6,0,1.2-0.4,1.8c0.2,0.3,0.2,0.7,0.2,1.1
		c0,0.4,0,0.8,0.1,1.1c1.2-0.7,2.6-0.8,3.8-0.2c0,0,0,0,0.1,0h0.1c0.5,0.2,0.9,0.5,1.2,0.9c0.1,0,0.1,0.1,0.2,0.1c0,0.1,0,0.1,0,0.2
		c0.1,0.3,0.1,0.6,0.1,0.9c0.6-0.1,0.8,0.1,1.3,0.8c0.3,0,0.7,0,1.1,0.2c0.4,0.1,0.9,0,1.4,0.1c0.9,0.1,1.5,0.5,1.8,1.2
		c0,0,0,0,0,0.1c0.4-0.1,0.8-0.2,1.2-0.2c0.1-0.1,0.2-0.2,0.3-0.3c-0.4-0.4-1-0.6-1.4-0.9C236.8,135.3,236.1,135.2,235.4,135.3z
    M243.2,126.4c0-0.1,0-0.1-0.1-0.2h0.1V126.4C243.3,126.3,243.2,126.4,243.2,126.4z M242.7,123.9c0.1,0,0.1,0.1,0.2,0.1
		c0,0,0,0,0.1,0l0,0c0.1,0,0.2,0,0.4,0l0,0c0,0,0,0,0.1,0c-0.1-0.2-0.1-0.4-0.2-0.5c-0.2-0.3-0.5-0.7,0-0.9c0.3-0.2,0.8-0.3,1.2-0.2
		c1.3,0.4,2.6,0.8,3.3,1.9c-0.9,1.1-1.4,1.2-2.1,0.3c-0.6-0.7-1.3-0.7-2.1-0.6l0,0c0,0,0,0-0.1,0c0.2,0.3,0.4,0.7,0.6,1
		c-0.8-0.1-1.5-0.2-1-1l0,0l0,0c-0.1,0-0.1,0-0.2,0C242.7,124,242.7,124,242.7,123.9z M242.6,121.8L242.6,121.8L242.6,121.8
		L242.6,121.8z M267.3,113.3c0.1,0,0.2,0,0.4,0c-0.1,0.3-0.1,0.7-0.2,1c-0.1,0-0.2,0-0.4,0C267.2,113.9,267.2,113.6,267.3,113.3z
    M254,112.8c0.1,0.1,0.1,0.2,0.2,0.2l-0.1,0.1C254,113,254,113,254,112.8C253.9,112.9,254,112.8,254,112.8z M249.8,113
		c0,0.1,0.1,0.2,0.1,0.2c0,0.1-0.2,0.1-0.3,0.2c0,0-0.1,0-0.2,0C249.6,113.3,249.7,113.2,249.8,113z M246.2,115.4L246.2,115.4
		l-0.1,0.1L246.2,115.4z M245.5,114.8c0.1,0,0.2,0,0.3,0c0,0.1-0.1,0.1-0.1,0.2c-0.1,0-0.2-0.1-0.3-0.1
		C245.4,114.9,245.4,114.9,245.5,114.8z M244.4,114.4c0.1,0.1,0.1,0.1,0.2,0.2c-0.1,0-0.1,0.1-0.2,0.1c0-0.1-0.1-0.2-0.1-0.3
		C244.3,114.4,244.4,114.4,244.4,114.4z M243.9,113.7c0.1,0,0.2,0.1,0.2,0.1c0,0.1,0,0.2,0,0.3c-0.1,0-0.2,0-0.2-0.1
		C243.8,113.8,243.9,113.8,243.9,113.7z M243,114.2c0.1-0.1,0.4,0.1,0.7,0.2c-0.2,0.2-0.3,0.5-0.5,0.5c-0.1,0-0.5-0.1-0.5-0.2
		C242.6,114.5,242.8,114.3,243,114.2z M238,116.9c-0.1-0.2-0.1-0.4-0.2-0.6c0.1,0,0.2,0,0.3-0.1c0.1,0.2,0.1,0.4,0.2,0.6
		C238.2,116.9,238.1,116.9,238,116.9z M239.1,117.7c0,0-0.1,0-0.1-0.1v-0.1h0.1C239.1,117.6,239.1,117.6,239.1,117.7z M233.5,121.1
		c-0.1-0.1-0.2-0.1-0.2-0.2s0.1-0.3,0.2-0.5c0.2,0.3,0.4,0.4,0.3,0.4C233.7,120.9,233.6,121,233.5,121.1z M236.3,127.5L236.3,127.5
		L236.3,127.5L236.3,127.5z M227.5,131.3c-0.2-0.1-0.3-0.1-0.6-0.2c0.2-0.2,0.3-0.4,0.5-0.5c0.1,0,0.4,0.1,0.4,0.2
		C227.8,131,227.6,131.2,227.5,131.3z M228.6,132.3c-0.2-0.2-0.3-0.2-0.3-0.3c0,0,0.1-0.2,0.2-0.2c0.1,0,0.3,0.1,0.4,0.1
		C228.9,132,228.8,132.1,228.6,132.3z M232.3,133.6v-0.1c0.3-0.1,0.7-0.1,1-0.2v0.1C232.9,133.4,232.6,133.5,232.3,133.6z
    M234.7,134.8c-0.1,0-0.2,0-0.3-0.1c0-0.1,0-0.2,0.1-0.2s0.2,0,0.3,0C234.8,134.6,234.7,134.7,234.7,134.8z"
      />
      <path
        class="st3"
        d="M219,118.3c-0.3,0.5-0.6,0.9-1,1.4c0,0.1,0,0.1,0,0.2c0.1,0.1,0.3,0.2,0.4,0.3c0.3-0.2,0.6-0.3,1.1-0.6
		c-0.4,0.5-0.6,0.7-0.8,0.8c0.5,0.3,0.9,0.7,1.4,1c0.3,0.2,0.9-0.1,0.9-0.5c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.9-0.1-1.7,0.3-2.4
		c0,0,0,0-0.1,0l0.1-0.1c0.1-0.2,0.2-0.3,0.3-0.5c-0.9,0.2-1.9,0.4-2.8,0.6C218.9,118.1,219,118.2,219,118.3z"
      />
      <path
        class="st3"
        d="M85.2,175.5c0,0,0.1,0.1,0.1,0.2c0.1,0,0.2-0.1,0.4-0.1C85.5,175.5,85.3,175.5,85.2,175.5
		C85.1,175.5,85.2,175.5,85.2,175.5z"
      />
      <path
        class="st3"
        d="M253.4,247.5c-0.1-0.1-0.2-0.1-0.3-0.2v0.1C253.2,247.4,253.3,247.4,253.4,247.5z"
      />
      <path
        class="st3"
        d="M83.2,166.7l0.1-0.1c0,0.1,0,0.1,0.1,0.2c0,0,0,0,0.1,0c0,0,0,0,0.1,0.1h0.1h-0.1l0,0h-0.1c0,0,0,0,0-0.1
		C83.4,166.8,83.3,166.7,83.2,166.7c0.5,0.2,0.9,0.5,1.4,0.7c0.7,0.2,1.2,0.6,1.5,1.1c0.2,0.2,0.4,0.4,0.8,0.7
		c0.4-0.5,0.7-0.9,1-1.3l0,0l0,0c0.1-0.2,0.2-0.3,0.4-0.5c-0.5-0.1-0.8-0.1-1.1-0.1c-1.5-0.2-1.8-0.5-1.7-1.7c0-0.2,0.1-0.5,0.2-0.7
		c-1.1,0.6-2.1,1.1-3.2,1.7C82.9,166.6,83.1,166.6,83.2,166.7z"
      />
      <path
        class="st3"
        d="M277.5,109.8c1,1,1.6,2.2,1.8,3.5c0,0.2,0,0.4,0,0.5c2.3-0.3,4.8-0.6,7.5-1c-0.1-0.1-0.1-0.1-0.2-0.2
		c0.1-0.1,0.3-0.2,0.4-0.3c0.1,0.1,0.2,0.3,0.3,0.4c0.3,0,0.6-0.1,0.9-0.1c0.1-0.4,0.5-0.7,0.9-0.7c0.5-0.1,0.9,0.2,1,0.5
		c0.4,0,0.8-0.1,1.2-0.1c-0.1-0.5,0.1-0.7,0.7-0.9c0.2,0.3,0.1,0.6-0.1,0.8c1.5-0.2,3.1-0.4,4.6-0.5c0.3-0.4,0.6-0.7,1-1
		c0-0.2,0-0.4,0-0.6c-0.2,0-0.4-0.1-0.6-0.1c-1.1,1-2.7,1.4-4,0.8c-1.1-0.5-1.5-1.5-1.3-2.6c-0.1,0-0.1,0-0.2,0l0,0l0,0
		c-0.7,0.1-1.4,0.1-2.1,0.2c0,0.1-0.1,0.2-0.1,0.3c-0.1,0-0.2,0-0.3,0c0-0.1,0-0.1,0.1-0.2c-1,0.1-2.1,0.2-3.1,0.3
		c0,0.1,0,0.1,0,0.2c0.2,1.3-0.6,2.5-2,3c-1.5,0.6-3.1,0.3-3.9-0.7c-0.3-0.4-0.6-0.9-0.8-1.4c-0.1,0.1-0.3,0.2-0.4,0.4
		c-0.1-0.2-0.2-0.4-0.3-0.7c0,0,0,0-0.1,0l0,0c-0.1,0-0.1,0-0.2,0C278.2,109.6,277.9,109.6,277.5,109.8
		C277.6,109.7,277.6,109.7,277.5,109.8C277.6,109.7,277.6,109.7,277.5,109.8z M290.3,109.3c0,0,0.1,0,0.1,0.1v0.1
		c-0.1,0-0.1,0-0.2-0.1C290.2,109.4,290.2,109.3,290.3,109.3z"
      />
      <path
        class="st3"
        d="M285.7,243.4c0.1,0.3,0.6,0.5,0.1,0.8c0.2,0.1,0.3,0.3,0.5,0.4c0.2-0.5,0.5-0.9,0.9-1.4l0.1-0.1
		c-0.2-0.4-0.5-0.8-0.8-1.2C285.4,242.4,285.5,242.9,285.7,243.4z"
      />
      <path
        class="st3"
        d="M276.7,109.7c0.1,0,0.1,0,0.2,0.1c0.2,0.1,0.4,0,0.7-0.1l0,0h0.1v-0.1C277.3,109.7,277,109.7,276.7,109.7z"
      />
      <path
        class="st3"
        d="M38.7,170.9c0-0.1,0-0.2-0.1-0.3c-0.2-0.8-0.2-1.6,0.1-2.3c-0.3-0.1-0.5-0.3-0.6-0.6c-0.1-0.5,0.4-1.1,1-1.3
		c0.3-0.1,0.7,0,0.9,0.1c0.2-0.2,0.4-0.3,0.7-0.5c0.9-0.6,1.5-1.3,1.7-2.3c0.1-0.4,0.2-0.8,0.4-1.2c0.1-0.5,0.2-1,0.4-1.6l0,0
		c-0.1,0.7-0.6,1.3-1.4,1.6c-0.5,0.2-1,0.3-1.5,0.1c-0.1,0.2-0.2,0.5-0.3,0.7c-0.2,0.3,0,0.8,0.1,1.4c-0.7-0.1-1.2-0.2-1.7-0.2
		c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.2-0.2,0.4-0.3,0.5c0.1,0.1,0.2,0.2,0.3,0.3c0.3,0.5,0.1,0.9-0.8,1.6c0.1,0.5,0,0.9-0.4,1.3
		c-0.4,0.4-0.9,0.8-1.4,1c-1,0.4-1.8,0.2-2.6-0.5c-0.1,0.1-0.1,0.2-0.2,0.3c-0.4-0.4-0.5-0.6-0.4-0.9c-0.1-0.1-0.2-0.1-0.4-0.2
		c-0.4,0.4-0.8,0.9-1.4,1.4c-0.6-0.6-1.5-0.9-1.7-1.7c-0.1-0.4-0.3-0.3-1.1,0c0.6,1,0.9,1.8,1,2.4c0,0,0,0,0.1,0
		c2,1.4,3.9,2.8,5.9,4.2c0-0.3,0.1-0.5,0.2-0.8c0.5-0.9,1.3-1.7,2-2.6c-0.6-0.2-1.2-0.5-1.4-1.2c0.7-0.1,1.2-0.2,1.8-0.3
		c0.4,1.4,0.4,1.4,1.3,1.3C38.6,171,38.7,171,38.7,170.9z M32.7,171.8c-0.1,0-0.5-0.2-0.5-0.3c0-0.2,0.2-0.4,0.3-0.8
		c0.3,0.2,0.6,0.4,0.7,0.5C33.2,171.5,32.9,171.7,32.7,171.8z"
      />
      <path
        class="st3"
        d="M61.2,172.6C61.3,172.6,61.3,172.6,61.2,172.6c0.2-0.6,0.6-1.1,1.2-1.5c-0.1-0.1-0.1-0.2-0.2-0.3
		c0.6-0.2,1.1-0.3,1.6-0.2c1-0.1,1.9,0.3,2.4,0.9c0-0.4-0.1-0.8-0.1-1.2H66l0,0c-0.1-1.4-0.2-2.8-0.3-4.2c0-0.1,0-0.2,0-0.3
		c-0.3,0-0.5,0-0.8-0.1s-0.5-0.2-0.7-0.3c-0.4,0.6-1,1-1.7,1.2c-1.5,0.3-2.9-0.5-3.1-1.7l0,0c-0.4-0.1-0.8-0.3-1-0.6
		c-0.1-0.2-0.2-0.3-0.4-0.6c0.3-0.2,0.5-0.3,0.7-0.4c-0.5,0-1,0-1.5,0c0.6,0.2,1.1,0.7,1.3,1.5c0.3,0.9-0.3,1.9-1.3,2.5
		c-0.4,0.2-0.8,0.4-1.1,0.4c-0.5,0.9-1.5,1.5-2.1,2.4c-0.2,0.3-0.6,0.5-0.9,0.8c-0.1,0.1-0.1,0.2-0.2,0.2c0.1,0.4,0.2,0.7,0.9,0.8
		c0.4,0.1,0.9,0.2,1.3,0.2V172h0.1h-0.1c1.2,0.2,2.5,0.5,3.3,1.4c0.3,0.4,0.9,0.3,1.4-0.2C60.1,173,60.7,172.6,61.2,172.6z
    M62.6,167.3c0.1,0,0.2,0.1,0.3,0.2c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0-0.2-0.1-0.3-0.1C62.4,167.5,62.5,167.3,62.6,167.3z
    M58.5,172.2c-0.4-0.3-0.7-0.8-0.8-1.3c-0.1-0.6,0.2-1.1,1-1.4c0.4-0.1,0.8-0.2,1-0.6c0-0.1,0.6-0.2,0.8-0.2c1,0.1,1.6,0.6,1.7,1.5
		c-0.9,0.8-1.5,0.2-2.2-0.1c-1.2,1.1,0.6,1.3,0.5,2.2C59.8,172.7,59,172.6,58.5,172.2z"
      />
      <path
        class="st3"
        d="M253.4,99.2c0.3,0.1,0.4,0.2,0.5,0.4c0.2,0,0.4,0,0.6-0.1v-0.1c-1-0.1-1.7-0.4-2.2-0.7
		c-0.1,0.3-0.1,0.7-0.2,1.1c0.3,0,0.6-0.1,0.8-0.1C253.1,99.5,253.2,99.3,253.4,99.2z"
      />
      <path
        class="st3"
        d="M228.6,93.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.3,0.4,0.4s0.1,0.4-0.1,0.7c0.1,0.4,0.2,0.9,0.3,1.3
		c1.5-0.1,2.5,0.6,3.2,1.9c0.5-0.3,0.9-0.6,1.4-0.9c-1.8-0.9-2.6-2.1-1.5-3.8c0.9-1.3,2.1-1.4,4.8-0.7c0.2-0.5,0.3-1,0.5-1.6
		c-0.9,0.2-1.7,0.6-2.5,0.6s-1.6-0.3-2.5-0.5c-0.5,0.3-1,0.9-1.6,1.1c-0.6,0.3-1.4,0.3-2.3,0.4C228.7,92.5,228.6,92.8,228.6,93.2z"
      />
      <path
        class="st3"
        d="M180.1,108.8l-0.1-0.1c0.1,0.3-0.2,0.6-0.4,1c-0.6-0.1-1.2,0-1.3-0.5c-0.5,0.1-1,0.2-1.5,0.3
		c0.3,0.3,0.5,0.5,0.8,0.8c-0.5-0.1-1-0.1-1.5-0.2c0,0-0.1,0-0.1,0.1c0,0,0,0,0-0.1c-0.4-0.1-0.8-0.1-1.3-0.2c0-0.3-0.1-0.7-0.2-1.2
		c0.3-0.1,0.6-0.2,0.8-0.1c0.3,0.1,0.5,0.1,0.8,0.1c0.1-0.1,0.2-0.2,0.4-0.3c0,0,0,0,0-0.1c0.1-0.1,0.1-0.1,0.1-0.2
		c0,0-0.1,0.1-0.1,0.2l0,0l0,0l0.1-0.1c0.4-0.5,0.3-1,0-1.5c-0.4-0.5-0.9-1-1.5-1.6c1.4-0.3,0.9-1.3,1-1.9s-0.6-1.5-1.5-1.5
		c-0.8,0-1.4-0.1-2.2-0.2c-0.3-0.8,0.2-1.8-1-2.2l0,0h-0.1c-0.1,0.4-0.2,0.8-0.9,0.6c-0.2-0.4-0.1-0.8,0.4-1.1l0,0
		c-0.4,0-0.8-0.1-1.2-0.1c-0.8,0.1-1.5,0-2.1-0.4c0,1-0.1,2-0.1,3c0,0.2-0.1,0.5,0,0.6c1,1,0.2,2.4,0.7,3.5c0.3,0.6,0.2,1.3-0.3,2
		c-0.5,0.6-0.3,1.3,0.2,1.9c0.7,0.9,1.2,1.9,1.3,3.1c0.1,0.9-0.2,1.5-0.6,2.1c0.1,0,0.3,0.1,0.4,0.1c-0.3,0.3-0.5,0.5-0.7,0.6
		c-0.1,0-0.2,0-0.3-0.1c-0.1,0.1-0.2,0.2-0.4,0.3c-0.3,0.3-0.7,0.5-1,0.7c0.4,0.9,1.2,0.8,2,0.5l0.1,0.1c0-0.1,0.1-0.1,0.1-0.2
		c0.1,0,0.2,0,0.3,0v0.1c1.4-0.4,2.9-0.8,4.3-1.2c0.1-0.3,0.3-0.7,0.5-1l0,0c0-0.1,0-0.1,0.1-0.2l0,0c0.2-0.1,0.4-0.2,0.8-0.2l0,0
		l0,0c-0.2-0.3-0.3-0.5-0.5-0.9c0.4-0.2,0.7-0.5,1.2-0.8c0.1,0.2,0.3,0.4,0.2,0.5c-0.3,0.4-0.6,0.8-0.8,1.2c0,0,0,0,0,0.1h-0.1
		c-0.2,0.4-0.4,0.8-0.6,1.2c0.9-0.2,1.8-0.5,2.7-0.7c-0.1-0.1-0.1-0.1-0.2-0.2c0.1-0.1,0.3-0.3,0.4-0.3c0.2,0,0.4-0.1,0.5-0.2
		c-0.3-0.1-0.6-0.3-1-0.6c0.6-0.4,1-0.7,1.4-0.9c0.2-0.1,0.6-0.1,0.8,0c0.4-0.6,0.9-1,1.5-1.5c0.1-0.1,0.3-0.2,0.4-0.3
		c0-0.2-0.1-0.4-0.2-0.6c-0.3-0.5-0.1-1,0.4-1.6C180.8,108.5,180.4,108.6,180.1,108.8z M175.3,107.3c0.1,0.1,0.2,0.1,0.2,0.2
		s-0.1,0.2-0.2,0.4c-0.1-0.1-0.3-0.2-0.3-0.2C175.1,107.5,175.2,107.4,175.3,107.3z M171.5,105.9c0.1,0.1,0.1,0.3,0.2,0.4
		c-0.3,0.1-0.7,0.2-1,0.3c0-0.1-0.1-0.1-0.1-0.2C170.9,106.3,171.2,106.1,171.5,105.9z M167.9,100.6c1.3-0.3,1.9,0.2,2.1,1.1
		C168.7,102.2,168.5,102.1,167.9,100.6z M169.4,106.2c-0.1,0-0.4-0.2-0.4-0.2c0.1-0.3,0.3-0.5,0.5-0.7c0.1-0.1,0.4,0.1,0.8,0.2
		C169.9,105.8,169.7,106,169.4,106.2z M170.4,105.5c0.1,0,0.2,0,0.3,0c0,0.1-0.1,0.2-0.1,0.3h-0.2
		C170.3,105.7,170.4,105.6,170.4,105.5z M170.8,112.4c-0.1,0-0.1,0-0.2-0.1c0.1-0.2,0.2-0.4,0.3-0.6c0.1,0,0.2,0.1,0.3,0.1
		C171.1,111.9,171,112.1,170.8,112.4z M170.9,111.7L170.9,111.7h0.1H170.9z M171.6,109.8c-0.2,0.1-0.7-0.1-1.2-0.2
		c0.4-0.5,0.7-0.9,1-1.3C171.6,108.9,172.4,109.3,171.6,109.8z M173.1,115.4c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.2,0.2-0.4,0.3-0.7
		c0.1,0,0.2,0.1,0.3,0.1C173.3,115,173.2,115.2,173.1,115.4z M173,108.4c0-0.1,0.2-0.1,0.3-0.2c0,0.1,0.1,0.1,0.1,0.2
		c-0.1,0.1-0.3,0.1-0.4,0.2C173,108.6,172.9,108.5,173,108.4z M173.7,114.3c-0.1,0-0.2,0-0.4,0c0.1-0.4,0.1-0.8,0.2-1.2
		c0.1,0,0.2,0,0.3,0C173.7,113.5,173.7,113.9,173.7,114.3z M172.8,108.1c-0.6,0.2-1.3-0.1-1.5-0.8c0.7-0.4,1.4-0.7,2.2-1.1
		c0,0.2,0,0.4,0.1,0.6c0.1,0.1,0.2,0.1,0.3,0.2C173.5,107.3,173.3,107.9,172.8,108.1z M177.2,112.4c0-0.1,0-0.1,0-0.2h0.1
		C177.2,112.4,177.2,112.4,177.2,112.4z"
      />
      <path
        class="st3"
        d="M20.5,163.9c-0.1-0.1-0.1-0.3-0.1-0.4c-0.2,0.2-0.4,0.3-0.6,0.4c0.9,0.7,1.8,1.3,2.8,2
		c0.2-0.2,0.3-0.5,0.5-0.8C21.9,165,20.9,164.8,20.5,163.9z"
      />
      <polygon class="st3" points="61.1,173.3 61.1,173.4 61.2,173.3 	" />
      <path
        class="st3"
        d="M257.4,248.9c0-0.2-0.1-0.3-0.1-0.5c-0.1,0.1-0.2,0.1-0.2,0.2C257.2,248.7,257.3,248.8,257.4,248.9z"
      />
      <path
        class="st3"
        d="M52.9,309.3c-0.1-0.1-0.1-0.1-0.2-0.2c-1,0.1-1.9,0-2.7-0.3c0,0.2,0,0.3,0.1,0.5s0,0.4-0.3,0.7
		c0.1,0.1,0.1,0.3,0.2,0.4c0.4-0.2,0.7-0.5,1-0.6c0.8-0.3,1.5-0.4,2.1-0.2l0,0C53.1,309.5,53,309.4,52.9,309.3z"
      />
      <path
        class="st3"
        d="M8.6,155.8c0.6,0.4,1.2,0.8,1.7,1.2c0.1,0,0.1,0.1,0.2,0.1c0.1-0.2,0.3-0.4,0.5-0.5s0.4-0.2,0.5-0.3
		c0.2,0.1,0.2,0.1,0.3,0.1c0.1,0.1,0.2,0.3,0.2,0.4c-0.2,0.4-0.1,0.8-0.1,1.3c1.6,1.1,3.1,2.3,4.7,3.4c0.1-0.2,0.3-0.4,0.5-0.6
		c0.4-0.4,0.9-0.7,0.6-1.3c-0.1-0.4,0.4-0.8,1-0.8s1,0.4,0.8,0.8c-0.3,0.6,0.1,0.8,0.4,1.1s0.5,0.7,0.6,1.1c0.4-0.9,1.4-1.3,3.7-1.6
		l0,0h-0.1c-1,0.2-1.9-0.2-2.1-1c-0.2-0.7,0.5-1.6,1.4-1.8c0.1,0,0.1,0,0.2,0c-0.7-0.4-1.3-0.7-1.9-1c-0.3,0.1-0.7,0.3-1.1,0.4
		c-1,0.2-1.9-0.1-2.4-0.8c-0.3-0.5-0.7-0.9-1-1.3c0.6-0.5,1.2-1,1.8-1.4c-0.1-0.1-0.1-0.2-0.2-0.3c-0.4,0.1-1.1,0.1-1.3,0.3
		c-0.8,0.8-1.9,0.8-2.8,1c-1.4,0.3-2,0.1-2.7-1c-0.1-0.2-0.2-0.4-0.3-0.6c-0.9,0.7-1.7,1.3-2.5,1.9c-0.1-0.1-0.2-0.1-0.3-0.2
		c0.3-0.5,0.5-0.9,0.7-1.4c0-0.1-0.2-0.2-0.3-0.3c-0.1,0.2-0.1,0.5-0.3,0.6c-0.6,0.6-1.3,1.1-2,1.6c0.1,0,0.1,0,0.1,0
		C7.7,155.2,8.1,155.5,8.6,155.8z M12.6,155.2c0.1,0.4,0.2,0.8,0.3,1.4C12.1,156.3,12,155.8,12.6,155.2z"
      />
      <path
        class="st3"
        d="M90,297c-0.9,0.5-1.7,0.7-2.7,0.3c-0.2-0.1-0.5-0.1-0.8-0.1l0,0c0.3,0.2,0.7,0.4,1.2,0.7
		c-0.4,0.4-0.8,0.8-1.2,1c0,0.2,0,0.5,0,0.7c0.2,0.2,0.3,0.4,0.3,0.7c-0.1,0-0.2,0-0.2-0.1c0,0.3,0.2,0.7,0.5,0.9
		c0.8-0.7,1.8-1.2,3.1-1.3c-0.4-0.4-0.6-1.1-0.5-1.7C89.7,297.8,89.9,297.4,90,297C90,297.1,90,297.1,90,297
		C89.9,297.1,89.9,297,90,297z"
      />
      <path
        class="st3"
        d="M47.4,303.4c-0.7-0.5-0.7-1.2,0.2-1.6c0.7-0.2,1.1-0.9,2.1-0.7c0.7,0.1,1.6-0.4,2.2-1.2
		c-0.4-0.1-0.7-0.2-0.9-0.2c0.3-0.7,0.6-1.5,0.9-2.1c-0.4-0.3-0.6-0.6-0.8-0.7c0.3-0.3,0.5-0.7,0.8-0.9c0-0.1,0-0.2,0-0.3
		c-0.2,0-0.3,0-0.5-0.1c-0.8-0.3-1.3-1.2-1.8-1.8c0.1-0.1,0.1-0.1,0.2-0.2c-0.4,0-0.7-0.1-1.1-0.1c0-0.2,0-0.3,0.1-0.5
		c-0.1,0.1-0.3,0.1-0.4,0.1c-2.7,0.5-2.7,0.5-4.5-1.3c-0.3,0.2-0.6,0.5-0.9,0.8v0.1c0.3,0.4,0.6,0.7,0.9,1.1c1,1.2,1.1,2.3,0.3,3.4
		c0,0.3,0,0.6,0.1,0.9c0.1,0.2-0.3,0.6-0.6,0.9c-0.3-0.3-0.5-0.5-0.6-0.7c-0.1,0.1-0.2,0.2-0.3,0.3c0.4,0.9,1.1,0.3,1.7,0.3
		c0.3,0.4,0.6,0.8,1.1,1.3c0-0.6,0-0.9,0-1.3c0.1,0,0.2-0.1,0.4-0.1c0.3,0.6,0.7,1.2,0.9,1.8c0.2,0.5-0.2,0.8-0.6,0.9
		c-1-0.5-1.7-1.1-2.6-1.3c-1-0.1-1.2-0.6-1.3-1.1c-0.1,0.3-0.1,0.5,0,0.8c-0.4,0.2-0.8,0.3-1,0.5s-0.3,0.7-0.5,0.8
		c-0.4,0.1-0.8,0.3-1.1,0.5c0.1,0,0.1,0.1,0.2,0.1c-0.2,0.3-0.5,0.7-0.8,1.1c-0.3-0.1-0.6-0.1-0.9-0.1c0,0.3,0,0.6,0,1l0.1,0.1
		c0,0-0.1,0-0.1,0.1c0.1,2.4,0.2,4.9,0.3,7.3c0.4-0.4,0.8-0.8,1.2-1.1c0.2-0.2,0.5-0.4,0.7-0.6c-0.3-0.4-0.5-0.7-0.7-0.9
		c0.4-0.3,0.8-0.5,1-0.8c0.3-0.3,0.4-0.7,0.7-1c0.2,0,0.3,0.1,0.5,0.1c0.2,0.5,0.1,0.8-0.2,1.2c0.9,0,1.4,0.2,1.3,1.2
		c0.8-0.4,1.3-0.7,1.8-0.9c-0.3-0.6-0.3-1.2-0.2-1.7c-0.7-0.5-0.5-1.5-0.8-2.1c-0.4-0.9,0.9-1.5,1.4-2.2c1.1,0.8,1.7,1.6,0.8,2.8
		c-0.2,0.2,0,0.5,0,0.8c0.1,0.3,0.1,0.4-0.4,1.1c0.2,0.4,0.6,0.6,1.4,0.6c0.5-0.3,1-0.6,1.5-0.9c0.2-0.2,0.3-0.5,0.5-0.7
		c0.2-0.5,0.4-1,0.9-1.3c-0.3-0.1-0.6-0.3-0.8-0.5C48.5,304,47.9,303.7,47.4,303.4z M50.5,298.4c0.1,0,0.1,0,0.2,0v0.1
		C50.6,298.4,50.5,298.4,50.5,298.4L50.5,298.4z M50.3,297.1L50.3,297.1c0-0.1,0.1-0.2,0.1-0.3C50.4,296.9,50.4,297,50.3,297.1
		L50.3,297.1c0,0.2,0,0.5,0.1,0.9C50.1,297.6,49.8,297.4,50.3,297.1z M49.9,299.1L49.9,299.1L49.9,299.1L49.9,299.1z M45,296.1
		C44.9,296,44.9,296,45,296.1c-0.1-0.1,0-0.1,0-0.2c0,0,0.1,0,0.1,0.1C45.1,296,45,296,45,296.1z M44.5,302.7
		c-0.2,0.5-0.6,0.6-1.7,0.3c0.3-0.6,0.5-1.2,1.4-0.9C44.4,302.1,44.6,302.4,44.5,302.7z M47,299.3c0,0,0,0.1-0.1,0.1
		C46.9,299.4,46.9,299.3,47,299.3c0-0.1,0-0.1,0.1-0.1C47,299.2,47,299.3,47,299.3L47,299.3z M49.5,294.9c-0.7,0.6-1.1,0.4-1.5,0.1
		C48.5,294.2,48.9,294.7,49.5,294.9z M48.2,299.4c0.2,0.2,0.3,0.5,0.5,0.7c-0.1,0-0.1,0.1-0.2,0.1c-0.2-0.2-0.4-0.4-0.6-0.6
		C48,299.5,48.1,299.4,48.2,299.4z M45.6,294.5c0.3-0.6,0.9-0.6,1.5-0.7c0.1,0.1,0.2,0.2,0.3,0.3c-0.3,0.2-0.6,0.4-0.9,0.7
		C46.3,294.7,46,294.6,45.6,294.5z M46.8,295.5c0.3,0.6,0.6,1,0.9,1.6C46.3,296.7,46.3,296.7,46.8,295.5z M46.8,297.8L46.8,297.8
		v-0.1V297.8z"
      />
      <path
        class="st3"
        d="M95.1,300.7c-0.4-0.3-0.7-0.6-0.9-0.9c-0.4,0.3-0.8,0.6-1.3,0.7c0.6,0.4,1,1,1.4,1.7c0.3-0.2,0.6-0.4,0.9-0.6
		v-0.1C95.1,301.3,95.1,301,95.1,300.7z"
      />
      <path
        class="st3"
        d="M303.1,76.5c0.6,0.7,1.2,1.6,1.5,2.4c0.3-0.2,0.6-0.3,0.9-0.3c0.1,0,0.3,0,0.4,0v-0.9
		c-0.4,0.1-0.8-0.1-1.2-0.2c0.4-1.1,0.6-1.4,1.2-1.3v-4.6c-1.3-0.7-2.6-1.4-4.3-1.7c0,0-0.3,0.1-0.3,0.2c-0.1,0.5-0.1,1.1-0.1,1.6
		s0.1,1,0,1.5C301.1,74.8,302.2,75.5,303.1,76.5z M304.1,76.9c0.1,0,0.1,0,0.2,0l-0.1,0.1c-0.1,0-0.1,0-0.2,0
		C304,76.9,304,76.9,304.1,76.9z"
      />
      <path
        class="st3"
        d="M301.4,89.6c0.3,0.3,0.6,0.6,0.9,0.9c1-1.6,2.2-2.6,3.6-3l0,0c-0.8,0-1.5,0-2.3,0.1c-0.3,0.4-0.7,0.7-1.2,0.8
		c-0.7,0.1-1.5-0.2-1.9-0.7c-0.4,0.1-0.7,0.4-1,0c-2.2,0.1-4.3,0.1-6.5,0.2c-0.3,0-0.5,0-0.8,0c-0.3,0.8-0.4,1-0.9,1.2
		c-0.1,0.2-0.3,0.4-0.5,0.6c0.1,0.2,0.2,0.4,0.4,0.7c0.6,0,1.4,0,2.1,0c0.1-0.4,0.2-0.8,0.3-1.4c0.6-0.1,1.3-0.2,2.2-0.3
		c0.1-0.2,0.3-0.5,0.6-0.9c0.2,0.3,0.4,0.5,0.7,0.8c-0.2,0.1-0.4,0.2-0.5,0.3l0,0c-0.1,0-0.1,0.1-0.2,0.1l0,0
		c-0.5,0.3-0.7,0.7-0.7,1.3c0.4-0.1,1-0.1,1.6,0.1c-0.5,0.4-0.9,0.9-1.4,1.3c0,0.5-0.3,1-1.3,1.2c0,0,0,0-0.1,0.1
		c1.4,0.1,2.5,0.2,2.6,1.5v-0.1c0,0,0,0,0,0.1c0,0,0,0-0.1,0c-0.1,0.4-0.2,0.9-0.3,1.3c0.1,0,0.3,0,0.4,0c0-1.9,2-3.5,4-3.5
		c0.3,0,0.6-0.1,1-0.1c-0.1-0.4-0.2-0.7-0.2-1.1l0,0c-0.1,0.2-0.3,0.4-0.6,0.5c-0.2,0.1-0.8,0-0.9-0.2c-0.2-0.3-0.3-0.7-0.4-1.1
		c0,0,0,0-0.1,0l0,0c-0.4,0.2-0.7,0.5-1,0.4c-0.6-0.1-1.1-0.4-1.5-0.7c-0.1-0.1-0.1-0.5,0-0.7c0.1-0.1,0.6-0.2,0.8-0.1
		c0.6,0.3,1.2,0.7,1.7,1.1h0.1c0,0,0,0,0,0.1c0.2,0,0.4-0.1,0.5-0.1C300.8,90,301,89.8,301.4,89.6z M303.6,88.1
		c0.1,0.1,0.1,0.1,0.1,0.2l-0.1,0.1c0-0.1-0.1-0.1-0.1-0.2L303.6,88.1z M297.9,90.9c0.2,0.1,0.4,0.3,0.4,0.4l0,0
		c0.4,1.5,0.2,1.7-1.4,2.4c-0.4-0.6-0.4-1.1-0.1-1.5h-0.1c0.1-0.4,0.1-0.6,0.2-0.8C297.1,91.1,297.4,90.8,297.9,90.9z"
      />
      <path
        class="st3"
        d="M255.8,97.6c0.4,0.4,0.3,0.5-0.6,1.4c0.1,0.1,0.2,0.2,0.3,0.3c1.5-0.2,3.1-0.4,4.6-0.5
		c-0.3-0.1-0.5-0.3-0.6-0.5c0-0.2,0.4-0.7,0.7-0.7c0.3-0.1,0.7,0.3,1.2,0.5c-0.3,0.3-0.6,0.5-0.8,0.7c4.5-0.5,9-0.9,13.5-1.3
		c0.1-0.3,0.3-0.6,0.4-0.9c0.2,0.4,0.3,0.6,0.2,0.8c0.2,0,0.5,0,0.7-0.1c0-0.1,0.1-0.2,0.2-0.3c0.1,0.1,0.3,0.1,0.4,0.2v0.1
		c1.1-0.1,2.1-0.2,3.2-0.3c0-0.2,0.1-0.3,0.1-0.5c0.2-0.8,0.3-1.5-0.1-2.4c-1.3,0.5-2.6,1-3.7,1.5c0.1,0.1,0.1,0.2,0.2,0.4
		c-0.5,0.4-1,0.7-1.4,0.2c-0.1-0.1,0-0.6,0.2-0.7c0.3-0.2,0.6-0.2,0.8-0.1c0.2-1.1,1.1-1.9,2.7-2.4c-0.4-0.1-0.6-0.2-0.8-0.2
		c0.1-0.2,0.3-0.4,0.5-0.5c-0.2,0-0.3-0.1-0.5-0.1c0,0,0,0,0-0.1c-0.5,0.1-1.2,0.6-1.7,1.3c-0.2-0.1-0.5-0.2-0.8-0.3
		c0.3-0.3,0.5-0.5,0.9-0.8c-0.5-0.1-0.8-0.2-1.1-0.3c0-0.6,0-1.2,0-1.7c-0.8-0.2,0.3-0.9-0.4-1.2c-1.4,0.8-2.4,1.8-3,3.1
		c0.2-0.3,0.5-0.5,0.9-0.7c0.8-0.4,1.3-0.2,2.4,0.8c-0.4,0.4-0.6,0.9-1,1.2c-0.5,0.4-1.2,0.6-1.8,0.3c-0.2-0.1-0.5-0.3-0.6-0.6
		c0,0.1,0,0.1,0.1,0.2c0.1,0.5,0.2,1,0.4,1.8c-0.6-0.2-0.9-0.4-1.2-0.5c-0.5,0.4-0.9,1.6-1.8,0.5c-0.6-0.7-0.4-1.3,0.7-1.9
		c-1.6-0.1-1.9,0.1-2.5,1.1c-0.2,0.4-0.4,0.7-0.9,0.5s-0.4-0.6-0.1-0.9c0.1-0.1,0.2-0.2,0.2-0.2c-0.3-0.5-0.6-1-0.9-1.5
		c-0.7-1.2-1.4-1.2-2.6-0.2c-0.1,0.1-0.2,0.3-0.3,0.4c0.2,1.1,1,2.2-0.1,3.4c0-0.2-0.1-0.5-0.2-0.9c-0.5,0.6-0.8,1.1-1.2,1.5
		c0-0.3,0.1-0.7,0.1-1c0.1-0.7,0.1-1.3,0.1-2c-0.1,0-0.3-0.1-0.4-0.1c-0.2,0.3-0.5,0.6-0.7,1s-0.2,0.8-0.4,1.2c-0.4,1-1,1.3-2.1,1
		c-0.3-0.1-0.6-0.3-1-0.3c-0.5-0.1-1,0-1.2,0c-0.1,0-0.1,0.1-0.2,0.1C255,96.8,255.4,97.2,255.8,97.6z"
      />
      <path
        class="st3"
        d="M287.3,80.4C287.3,80.4,287.3,80.3,287.3,80.4C287.3,80.3,287.3,80.3,287.3,80.4L287.3,80.4
		c0.9-0.1,1.8-0.1,2.9-0.2c0.2,0.7,0.4,1.5,0.6,2.4c-0.1,0.1-0.3,0.2-0.6,0.3c-0.2-0.5-0.4-1-0.6-1.5c-0.4-0.2-0.9-0.3-1.4-0.5
		c-0.2,0.7-0.5,1.5-0.7,2.2c0.3,0.2,0.9-0.5,1.2,0.2c0.2,0.5,0.9,0.7,1.7,0.6c0.7-0.1,1.1,0.2,1.3,0.8c0.4,0.7,0.9,1.4,1.3,2h0.1
		c0.2,0,0.3,0,0.5,0c0.3-0.5,0.1-1.2,0.6-1.6c0.3,0,0.7,0,0.9,0.1c0.6,0.3,0.8,1.1,0.2,1.2c-0.2,0.1-0.3,0.2-0.5,0.3
		c1.4,0,2.7-0.1,4.1-0.1c-0.1-0.8,0.7-1.5,1.6-1.8c1.3-0.4,2.6,0.2,2.9,1.2c0.2,0.1,0.3,0.3,0.4,0.5c0.7,0,1.5-0.1,2.2-0.1v-3.8
		c-0.8,0.1-1.4-0.2-1.9-0.6c-0.4,0.7-1,0.9-1.8,0.7c-0.3-0.1-0.8,0.2-1.2,0.4c-0.5,0.2-1,0.4-1.6,0.7c0,0.2,0,0.6,0,1.1
		c-0.7-0.3-1.2-0.6-1.9-0.9c-0.2,0.4-0.3,0.7-0.5,1c-0.6-0.1-0.8-0.8-1.3-1c-0.3,0.4-0.8,0.7-1.3,0.7c-0.9,0.1-1.9-0.3-2-1
		c-0.2-0.7,0.6-1.7,1.5-1.9c-0.1-0.6-0.2-1.2-0.4-1.7c0-0.1-0.1-0.3,0-0.3c1-0.8,0.1-1.5,0-2.2c0-0.2-0.1-0.4-0.1-0.5
		c-1-0.2-1.3,0.5-1.8,0.9c-0.1-0.3-0.2-0.7-0.3-1c-1.4,0.4-1.4,0.4-2.4-0.5c-0.1,0.3-0.2,0.5-0.3,0.7c-0.1,0.5-0.5,0.8-1,0.8
		c-0.3,0-0.7-0.3-0.8-0.5c-0.2-0.4,0.1-0.8,0.6-1c0.3-0.2,0.6-0.4,0.8-0.8c-0.3,0-0.5,0-0.8,0c-0.2,0-0.5,0.1-0.7,0.2
		c-0.3,0.5-0.7,1-1,1.5c0.3,0.2,0.5,0.4,0.7,0.5c-0.4,0.6-1.5-0.3-1.7,0.8c0.3,0.1,0.7,0.3,1.2,0.5c-0.8,0.5-1.4,0.9-2.1,1.3
		C285.1,80,285.9,81.5,287.3,80.4z M304.2,82.4c0.1,0.2,0.2,0.4,0.4,0.6c0,0-0.1,0-0.1,0.1c-0.1-0.2-0.3-0.4-0.4-0.6
		C304.1,82.5,304.1,82.4,304.2,82.4z"
      />
      <path
        class="st3"
        d="M229.3,87.4c0.3-0.1,0.4-0.4,0.4-0.6c-0.3,0-0.6,0.1-0.9,0.1c-0.3,0-0.6,0.1-0.9,0.1c-0.2,0.3-0.5,0.5-0.8,0.7
		c0.1,0.4,0.2,0.8,0.3,1.1C227.8,88.2,228.4,87.7,229.3,87.4z"
      />
      <path
        class="st3"
        d="M274.3,90.2c0,0.1,0,0.1-0.1,0.2h0.1C274.3,90.2,274.3,90.2,274.3,90.2z"
      />
      <path
        class="st3"
        d="M9.5,152.6c0.4-0.3,0.7-0.6,1-0.9c0.4-0.4,0.2-0.7-0.5-0.7c0,0,0,0-0.1,0.1c0,0.2,0,0.3,0,0.5
		c-0.1,0-0.3,0-0.4,0l0,0c-0.2,0.2-0.3,0.4-0.5,0.6C9,152.1,9.3,152.4,9.5,152.6L9.5,152.6z"
      />
      <path
        class="st3"
        d="M294,93.1c0,0.1,0.1,0.1,0.2,0.2v-0.1C294.1,93.1,294.1,93.1,294,93.1L294,93.1z"
      />
      <path
        class="st3"
        d="M3.1,311.2c0.1-0.4,0.2-0.8,0.5-1.1c0.6-0.5,1.5-0.9,2.3-1.4c-0.5-1.2,0-2.6,0.7-3.8c-0.5-0.3-0.9-0.6-1.3-0.8
		c0.3,1-0.5,2-1.7,2.3c-0.1,0-0.1,0-0.2,0v0.1c0.2,0.7-0.1,1.4-0.9,1.9c-0.4,0.3-0.8,0.4-1.2,0.5c0.1,0.1,0.1,0.3,0.1,0.4
		c0.1,0.4,0,0.8-0.1,1.1c0.1,0,0.2,0.1,0.2,0.1c0.2,0.1,0.3,0.1,0.5,0.2c0,0,0,0,0,0.1C2.5,311,2.8,311.1,3.1,311.2z"
      />
      <path
        class="st3"
        d="M1.7,310.6c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0.2-0.2,0.3-0.3,0.5c0.3,0.1,0.6,0.2,0.9,0.4c0-0.1,0-0.2,0-0.3
		c0,0,0,0-0.1,0L1.9,311l0.1-0.1c0,0,0,0,0,0.1c0-0.1,0-0.1,0-0.2l0,0C2,310.8,1.8,310.7,1.7,310.6z"
      />
      <path
        class="st3"
        d="M0.5,305.2c0.2,0,0.3,0,0.4,0c-0.1-0.3,0-0.7,0.1-1C0.9,304.5,0.7,304.8,0.5,305.2z"
      />
      <path
        class="st3"
        d="M13.5,188.8c-0.8-0.5-1.7-2.3-1.8-3.5c0-0.2-0.2-0.4-0.3-0.7c0.2-0.3,0.6-0.8,0.9-1.2c0.3-0.4,0.6-0.8,1-1.1
		c0-0.3,0-0.7-0.1-0.9c-0.8,0.6-1.6,1.3-2.6,1.8c-0.5,0.3-1.3,0.4-1.9,0.5c-1.1,0.2-1.8-0.1-2.3-0.9c-0.3,0.9-1.1,1.6-2.2,1.9
		c-0.3,0.1-0.5,0.1-0.8,0.1c0.5,0.3,0.8,0.7,0.8,1.3c0.2,0.1,0.2,0.2,0.2,0.6c-0.1,0-0.2-0.1-0.3-0.1c0,0.3-0.1,0.7-0.3,1.2
		c-0.5-0.1-1.2-0.1-1-0.7c0.2-0.7,0-1.3-0.1-1.9c0-0.1,0-0.2,0.1-0.4c-0.9-0.2-1.7-0.8-1.9-1.6c-0.3-1.1,0.8-2.5,2.2-2.9
		c0.4-0.1,1-0.1,1.5,0c-0.5-0.6-0.4-1.3,0-2c1.2-2.2,4.2-3.1,6.6-1.9c0.3-0.2,0.6-0.3,1-0.4c1.5-0.3,2.9,0.4,3.2,1.7
		c0.2,1.1-0.5,2-1.7,2.5c0.1,0.6,0.1,1.2,0.2,1.8c1.7-1.3,4-1.7,6.1-0.9c1,0.4,1.8,1,2.2,1.8c0.3-0.2,0.6-0.4,0.9-0.6
		c-0.6-0.9-0.1-1.8,0.2-2.6c0.2,0.3,0.2,0.7,0.3,1c0.1,0.3,0.3,0.5,0.5,0.6c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.9,0.7-1.9,1.9-2.1
		c0.4-0.1,0.8,0,1.2,0.1c0-1.1,0-2.1-0.1-3.2c-0.3,0.3-0.6,0.5-0.9,0.6c0,0.2-0.1,0.3-0.3,0.5c0,0-0.1,0.1-0.2,0.1
		c-0.5,0.8-1.2,1.4-2.2,1.7c0,0.1,0,0.2,0.1,0.2c-0.1,0-0.1,0-0.2,0c0-0.1-0.1-0.2-0.1-0.2c-0.2,0-0.4,0.1-0.6,0.1
		c-1.5,0.2-3-0.5-3.6-1.6c-0.7-1.3-0.2-2.7,1.1-3.8c0.3-0.2,0.6-0.4,0.8-0.6c-0.1-0.8-0.1-1.5-0.2-2.3c-0.8,0.2-1.6,0.2-2.2,0.1
		c-0.2,0-0.5-0.1-0.7-0.2c-0.6-0.2-1.1-0.5-1.7-0.9c0-1.5,0.2-2.9,2-3.8c0.5-0.2,0.9-0.3,1.3-0.4c-0.4-0.3-0.8-0.6-1.2-0.9
		c-0.8,0.2-1.5-0.1-1.9-0.8c-0.1-0.2-0.2-0.5-0.3-0.7c-1.5-1.1-3-2.2-4.5-3.2c-0.1,0.2-0.1,0.4-0.3,0.7c-0.4-0.4-0.5-0.7-0.8-0.9
		c-0.7,0.4-1.1,1-1,1.7c-0.2,0-0.5,0.1-0.5,0.2c-0.3,1-1.4,1.3-2.2,1.9c-0.5,0.4-1.2,0.3-1.3,0.5c-0.5,0.8-0.9,0-1.3,0.1
		c-1,0.2-1.7-0.3-2.5-0.3c0,0.6-0.1,1.2-0.1,1.8c-0.1,0-0.2,0-0.3,0c-0.2-0.6-0.4-1.2-0.7-1.8c-0.2-0.4-0.2-1.2-0.9-1.2v10.2
		c0.1,0,0.2-0.1,0.2-0.1c0.5-0.1,1,0,1.1,0.5c0,0.3-0.3,0.7-0.5,1.3c-0.3-0.2-0.5-0.3-0.7-0.5v2.7c0,0,0-0.1,0.1-0.1s0.2,0,0.3,0
		L0,176.6c-0.1,0-0.2,0-0.3-0.1v8.8h0.1c0,0.1-0.1,0.1-0.1,0.2v5.6c0.3-0.3,0.3-0.7,0.6-1c0.9-0.3,1.8-0.6,2.7-0.9
		c0.1-0.2,0.2-0.5,0.4-1c0.2,0.7,0.7,0.9,1.2,1.1c0.1-1,0.9-1.9,2-2.3c0.6-0.2,1.2-0.3,1.8-0.3c-0.2-0.4-0.2-0.8-0.4-1.2
		c-0.1-0.2,0.3-0.7,0.6-0.8s0.8,0.1,1.1,0.3c0.2,0.1,0.3,0.3,0.3,0.5c0.1,0.3,0,1-0.1,1.7c0.4,0.2,0.7,0.5,0.9,0.8s0.3,0.6,0.5,0.9
		c0.2-0.2,0.3-0.3,0.4-0.4c0,0.2,0.2,0.5,0.1,0.6c-0.2,0.1-0.3,0.2-0.4,0.3c0.3,0.1,0.5,0.2,0.7,0.3C12.6,189.2,12.9,189,13.5,188.8
		C13.5,188.9,13.5,188.8,13.5,188.8L13.5,188.8z M18.4,176.7c0,0,0,0.1,0.1,0.1c-0.1,0-0.1,0-0.2,0.1
		C18.3,176.9,18.3,176.8,18.4,176.7C18.3,176.8,18.3,176.7,18.4,176.7z M15.7,173.3c0.6-0.1,1.2,0.2,1.4,0.7c0.1,0.5-0.4,1.2-1,1.3
		c-0.7,0.1-1.4-0.3-1.5-0.8S15,173.4,15.7,173.3z M13.9,168.8c-0.1,0.1-0.3,0-0.5,0c0.1-0.2,0.2-0.3,0.3-0.4c0.1-0.1,0.3,0,0.5,0
		C14.1,168.5,14,168.7,13.9,168.8z M12.5,164.3c1.5,0.1,1.6,0.4,0.7,1.4C12.6,165.4,12.5,164.9,12.5,164.3z M11.9,165.7L11.9,165.7
		c0.1,0,0.2,0.1,0.3,0.1l-0.1,0.1C12,165.8,12,165.8,11.9,165.7L11.9,165.7L11.9,165.7L11.9,165.7z M9.9,167.8H10c0,0,0,0.1,0.1,0.1
		c-0.1,0-0.1,0-0.2,0C9.8,167.9,9.8,167.9,9.9,167.8z M9.7,170.3c0,0.1,0,0.1,0,0.2C9.7,170.4,9.7,170.4,9.7,170.3L9.7,170.3z
    M8.5,171.7L8.5,171.7L8.5,171.7L8.5,171.7z M7,168.1c0.2,0,0.3,0,0.5-0.1c0.1,0.4,0.1,0.8,0.2,1.5C6.7,169,6.6,168.6,7,168.1z
    M5.9,171.6c0.2,0,0.4,0,0.7,0.1c-0.1,0.2-0.2,0.5-0.3,0.5c-0.2,0-0.4-0.1-0.6-0.2C5.7,172,5.8,171.7,5.9,171.6z M1,168.7
		c-0.3,0-0.5-0.2-0.7-0.3c0.1-0.2,0.2-0.6,0.4-0.6s0.5,0.2,0.8,0.3C1.3,168.4,1.2,168.7,1,168.7z M0.3,174.6l-0.1-0.1
		c0-0.1,0-0.2,0.1-0.2s0.2,0.1,0.2,0.1C0.5,174.5,0.4,174.6,0.3,174.6z M0.9,189.5c-0.1,0-0.2-0.1-0.2-0.1c0-0.1,0.1-0.1,0.1-0.2
		h0.1C1,189.4,1,189.4,0.9,189.5z"
      />
      <path
        class="st3"
        d="M2.4,313.7c0-0.1-0.1-0.1-0.1-0.2c0-0.2,0-0.5,0-0.7c-1,0.1-1.5-0.5-2-1.1c-0.1,0.1-0.3,0.1-0.4,0.2v0.7
		c0.2,0.1,0.3,0.2,0.5,0.4C1.2,313,1.9,313.2,2.4,313.7z"
      />
      <path
        class="st3"
        d="M9.4,303.3c0-0.1-0.1-0.1-0.1-0.2c-0.5,0.3-0.9,0.6-1.2,1.1c1,0.5,1.4,0.7,1.9,0.8
		C9.9,304.4,9.6,303.9,9.4,303.3z"
      />
      <path
        class="st3"
        d="M24.4,336.6l0.1,0.1l0.1-0.1c0,0-0.1,0-0.1-0.1C24.5,336.6,24.5,336.6,24.4,336.6z"
      />
      <path
        class="st3"
        d="M10.2,318c-0.1,0.8-0.3,1.7-0.4,2.5c0.4-0.2,0.9-0.3,1.4-0.2c0.2,0,0.3,0,0.5,0v-0.1c-0.2-1.2,0.2-2.2,1.5-2.9
		c0.2-0.1,0.4-0.2,0.6-0.3c-0.2-0.3-0.4-0.6-0.5-0.9C12.9,317,12,317.4,10.2,318z"
      />
      <path
        class="st3"
        d="M15.6,193.9c0,0.2,0.1,0.4,0.1,0.5c0.1-0.2,0.3-0.4,0.4-0.4c0.2,0,0.6,0.2,0.6,0.3s-0.1,0.2-0.2,0.4
		c0.2-0.1,0.5-0.3,0.7-0.4c0.1-0.2,0-0.5-0.1-0.8c-0.4-0.6-0.4-1.3-0.1-2.1c-0.7-0.5-1.1-1.1-1.3-1.9c0-0.1,0-0.2-0.1-0.3
		c-0.7-0.1-1.5-0.2-2.2-0.3l0,0h-0.1c-0.2,0.3-0.4,0.7-0.6,1c0.2,0.2,0.4,0.3,0.5,0.5c0.4,0.5,0.7,1.1,1.1,1.7
		c0.1,0.2,0.2,0.6,0.4,0.6C15.5,193,15.6,193.4,15.6,193.9z M14.8,191.8c0.2-0.2,0.6-0.1,0.9-0.2c-0.1,0.3-0.1,0.6-0.2,1
		C14.8,192.4,14.3,192.3,14.8,191.8z"
      />
      <path
        class="st3"
        d="M81.5,309.2c0.4,0.3,0.7,0.5,1,0.7c0.1-0.2,0.3-0.4,0.4-0.6c-0.4,0-0.8,0-1.1-0.2
		C81.7,309.1,81.6,309.2,81.5,309.2z"
      />
      <path
        class="st3"
        d="M5.8,339.2c0.1-0.1,0.2-0.2,0.3-0.3C6,339,5.8,339.1,5.8,339.2C5.7,339.1,5.8,339.2,5.8,339.2z"
      />
      <path
        class="st3"
        d="M102.6,309.5c0,0.1,0,0.2,0,0.3c0,0,0,0,0-0.1c0.1,0.1,0.2,0.1,0.4,0.2c-0.2,0.1-0.3,0.3-0.5,0.4
		c0,0,0,0,0.1,0c0.6-0.1,1.2-0.2,1.7-0.3c-0.1-0.2-0.1-0.5-0.1-0.8C103.7,309.2,103.2,309.3,102.6,309.5z"
      />
      <path
        class="st3"
        d="M85.5,305c0.2,0.3,0.3,0.7,0.4,1.1c-0.5-0.2-0.6-0.3-0.8-0.4c-0.3,0.3-0.6,0.6-0.8,0.9
		c0.2,0.1,0.3,0.3,0.4,0.5c0.2-0.2,0.4-0.3,0.6-0.5c1.1,0.7,2.2,1.4,3.7,1.2c0,0.1,0.1,0.1,0.1,0.2c0.2-0.5,0.5-1,0.7-1.4
		c-0.6-0.2-1.4-0.4-1.9-0.7C87.2,305.9,86.4,305.6,85.5,305z M85.2,306.1L85.2,306.1L85.2,306.1L85.2,306.1z M86.8,307.4
		c-0.2-0.2-0.4-0.3-0.3-0.4s0.2-0.2,0.3-0.3c0.1,0.1,0.2,0.1,0.2,0.2C86.9,307,86.8,307.1,86.8,307.4z M88.2,307.3
		c0.1,0,0.2,0.1,0.2,0.1c0,0.1-0.1,0.2-0.1,0.2c-0.1,0-0.2,0-0.2-0.1C88.1,307.5,88.1,307.4,88.2,307.3z"
      />
      <path
        class="st3"
        d="M8.7,335.6c-4-0.5-5-1.9-4-5.1c-1.8,0.2-3.2-0.1-3.9-1.4c-0.5-1-0.2-2,0.8-2.9c1.3-1.1,2.8-1.2,4.4-0.7
		c-0.2-0.7-0.3-1.4-0.4-2c-0.7,0.2-1.3,0.4-1.9,0.5c-0.7,0.1-1.3,0.1-2,0.1c-0.3,0.3-0.6,0.6-0.8,0.8c0.3,0.1,0.5,0.4,0.6,0.7
		c0.1,0.6-0.4,1.3-1.1,1.5c-0.1,0-0.2,0-0.3,0v7.8c0.1,0,0.3,0.1,0.4,0.1c0.4,0.2,1.1-0.2,1.5,0.4c0.1,0.2,1,0,1.6,0
		c0,0.3,0,0.6,0,0.9c0.3,0.4,1.4,0,0.9,0.9c0.6,0.5,1.2,1.1,1.8,1.6c0.6,0.3,0.9,0.4,1.1,0.6h2.9c-0.3-0.2-0.5-0.5-0.6-0.9
		C8.7,337.8,8.6,336.7,8.7,335.6z M4.6,324c0.1,0.1,0.3,0.2,0.4,0.2c-0.1,0.1-0.2,0.2-0.2,0.2c-0.1-0.1-0.3-0.2-0.4-0.3
		C4.4,324.1,4.6,324,4.6,324z"
      />
      <path
        class="st3"
        d="M47.2,157.3c1.3-1,2.2-0.9,2.9,0.3c0.1,0.2,0.2,0.5,0.4,0.6c0.1-0.1,0.3-0.2,0.5-0.3c0.5-0.1,1.2,0.2,1.3,0.6
		c0.1,0.2,0,0.4-0.2,0.6c0.4,0.3,0.9,0.5,1.6,0.2c0.1,0.3,0.4,0.6,0.5,0.9c0.1-0.2,0.3-0.5,0.4-0.7c2.7-0.7,3.4-0.3,3.8,2.2
		c0.5,0.2,1.1,0.4,1.9,0.6c-0.3,0.2-0.5,0.4-0.7,0.6c0.2,0,0.4,0,0.6,0c0.4-0.4,0.9-0.7,1.5-0.8c0.4-0.1,0.8-0.1,1.2,0
		c0-0.2,0-0.3,0-0.5c0.4-0.2,0.8-0.4,1.2-0.6c-0.6-1.3-1.2-2.6-1.7-3.9c-0.1,0-0.3,0.1-0.4,0.1c-0.2-0.3-0.3-0.7-0.3-1
		c-0.2-0.1-0.3-0.2-0.5-0.3h-0.1c-0.1-0.1-0.3-0.1-0.4-0.2v-0.1c-0.1,0-0.2-0.1-0.3-0.1c0.1,0,0.1-0.1,0.2-0.1
		c0,0.1,0.1,0.2,0.1,0.3c0,0,0,0,0.1,0c0.1,0.1,0.3,0.1,0.4,0.2c0,0,0.1,0,0.1,0.1c0.1,0,0.3,0,0.4,0c0-0.2,0-0.5,0-0.7
		c-0.5-1.1-1-2.3-1.5-3.4c-0.1,0.2-0.2,0.3-0.3,0.5c-0.2,0.3-0.7,0.6-1.1,0.8c-1-0.1-1.8-0.4-2.4-1c-0.2,0-0.3,0-0.5,0
		c0-0.1,0-0.2,0-0.3c0.1,0,0.2,0,0.3,0c0,0,0-0.1-0.1-0.1c-0.2-0.4-0.7-0.6-1-0.9c0.3-0.9,1.3-0.6,2-1c-0.1-0.4-0.2-0.8-0.3-1.3
		c-0.6,0.4-1.2,0.8-1.8,1.1c-0.3,0.2-0.7,0.2-1.1,0.2c-0.8,1-2.1,1.7-2.4,2.9c0,0.1,0,0.1-0.1,0.1c-1.5,0.4-1.9,2.2-3.7,2.2
		c0,0.4,0,0.7,0,1c-0.2,0-0.3-0.1-0.5-0.1c-0.1,0.2-0.2,0.4-0.4,0.6c0,0.3,0.1,0.6,0.1,1C46.9,157.4,47.1,157.4,47.2,157.3z
    M59.7,160.6C59.7,160.6,59.6,160.6,59.7,160.6l-0.2-0.1h0.1C59.7,160.6,59.7,160.6,59.7,160.6L59.7,160.6L59.7,160.6L59.7,160.6z
    M61.7,157.7c0.2,0.1,0.4,0.1,0.4,0.2c0,0.1,0,0.3-0.1,0.3c-0.2,0-0.3,0-0.4,0C61.6,158.1,61.7,158,61.7,157.7z M59.3,158
		c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1-0.1,0.2-0.1,0.3c-0.1-0.1-0.2-0.1-0.2-0.2C59.1,158.2,59.2,158.1,59.3,158z M59.2,158.8
		c2.2-0.1,2.7,0.1,3.1,1.8c-0.8,0.6-1.6,0.5-2.3,0.1C59.2,160.2,58.9,159.6,59.2,158.8z M54.3,154.3c0.9,0,1.4,0.4,1.9,1
		C54.6,155.9,54.2,155.8,54.3,154.3z"
      />
      <path
        class="st3"
        d="M200,107.5c0.3,0.2,0.5,0.7,0.5,1.2c1.2-0.3,2.3-0.5,3.5-0.8c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2,0-0.3,0-0.5-0.1
		c-1.1-0.8-1.2-2-1.6-3c0,0,0,0-0.1,0v-0.1c-0.1,0-0.2-0.1-0.2-0.1c0.1,0,0.1-0.1,0.2-0.1c0,0,0,0,0-0.1c0,0,0,0,0.1,0
		c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2c0,0,0,0,0,0.1l0,0c0,0.1,0,0.2,0,0.2s0,0,0.1,0l0,0
		c1.6-0.9,3.3-1.2,5.3-1.2c-0.1,0.3-0.3,0.6-0.3,0.9c0,0.2,0.3,0.5,0.5,0.9c0.4-0.6,0.6-1,0.9-1.4c0.3,0.1,0.6,0.1,0.9,0.2l0.1-0.1
		c0.2-0.2,0.6-0.2,0.9-0.4c0.1-0.5,0.2-1,0.4-1.4c0-0.1,0.1-0.2,0.2-0.3c-0.2-0.1-0.4-0.2-0.5-0.4c0-0.2,0.3-0.5,0.5-0.5
		s0.4,0.1,0.7,0.3c0.5-0.3,1-0.4,1.5-0.4c0.5-0.9,0.8-1.2,2.1-1.6l0,0c0,0,0,0,0.1,0l0,0l0,0c0.3,0.5-0.1,0.9-0.6,1.2
		c-0.3,0.2-0.6,0.3-0.9,0.5c0.2,0.1,0.5,0.2,0.7,0.4c1.2-0.1,2.1,0.6,2.6,1.8c0.3-0.1,0.6-0.3,0.9-0.4c0.8-0.4,1.6-0.6,2.4-0.3
		c0.4,0.2,0.9,0.1,1.4,0.1c0.6,0,1,0.2,1.1,0.4c0.2-0.7,1-1.2,1.9-1s1.3,0.9,0.9,1.7c0,0.1-0.1,0.2-0.2,0.2c1.3-0.2,2.6-0.5,4-0.7
		c0.2-0.4,0.3-0.9,0.5-1.4c-0.7-0.2-1.5-0.4-2.1-0.7c-0.6-0.3-1-0.9-1.5-1.3c-0.4-0.3-0.4-0.7-0.2-1.1c0.6-1.1,1.3-2,2.5-2.5
		c-0.1-0.2-0.1-0.4-0.2-0.6c0,0-0.1,0-0.1,0.1c-0.7,0.2-1.4,0.3-2.2,0.5c-0.6,1.2-1.5,2.3-3,2.9c-0.3-0.3-0.7-0.7-1.1-1.1
		c0.1-0.4,0.3-1.1,0.5-1.7c-0.7,0.2-0.4-0.3-0.4-0.6c-0.2,0-0.3,0-0.5-0.1c0.1-0.4,0.4-0.8,0.3-1.2c0-0.4-0.3-1-0.5-1
		c-1.2,0.1-1.7-0.9-2.6-1.3c-0.6,1.5-1.7,2.2-3.5,2.2c-0.7,0-1.4,0.6-2.2,0.3c0.1-0.2,0.2-0.4,0.3-0.6c0.3,0.1,0.6,0.2,1,0.3
		c-0.7-1.1-1.5-1.9-2.9-2.2c0.4,0.6,0.7,1.2,1,1.7c-1.3,0.9-1.3,0.9-2.5,0.2c-0.5,0.5-1.1,0.9-2,0.6c-0.7-0.2-1,0.1-0.8,1.1
		c-0.7,0.5-1.5,1-2.3,1.5c-0.2,0.1-0.4,0.3-0.4,0.5c-0.2,0.8-1,0.8-1.9,1.1c0.2-1,0.6-2-0.4-2.6c-1.9,1.2-2,1.3-3.1,3.1
		c-0.4,0-0.8-0.1-1.3-0.1c0.1,1,0.1,1.9,0.2,3c-0.7-0.1-1.1-0.2-1.6-0.3c-0.5,1.2-3,1.8-1.8,3.6c-0.4,0.3-0.7,0.5-1.1,0.8
		c-0.3-0.5-0.6-0.9-1-1.4c-0.1,0-0.3,0.1-0.4,0.1c0,0.4,0,0.8,0,1.1c0,0.6,0,1.2-0.7,1.5c-0.4-0.7-0.8-1.3-1.1-1.9
		c-0.5,0.1-1,0.2-1.4,0.2c-1.1,0.1-1.2,0.2-1.6,1.1c-0.1,0.3-0.5,0.5-0.8,0.7c0,0-0.2-0.1-0.3-0.1c0.2-0.1,0.3-0.3,0.6-0.5
		c-1.2-0.2-1.8,0.5-2.5,0.9c0.4,0.1,0.7,0.3,1.2,0.5c-0.3,0.1-0.5,0.2-0.6,0.2c0.4,0.2,0.9,0.4,1.5,0.7c0.2-0.6,0.3-1,0.5-1.5
		c0.6,0.2,1.2,0.4,1.7,0.7c0.4-0.3,0.8-0.5,0.9-0.6c0.8,0,1.2,0,1.7,0c0.5,0.6,0.9-0.2,1.3-0.3c0.3,0.3,0.7,0.5,1,0.8
		c0.1-0.9,0.8-1.9,1.7-2.3c1.1-0.4,2.2-0.5,3.2-0.1C198.6,106.6,199.4,107,200,107.5z M218.8,99.8c0.4,0.2,0.7,0.3,1.2,0.6
		c-0.7,0.2-1.2,0.4-1.7,0.6c-0.1-0.1-0.2-0.1-0.2-0.2C218.3,100.4,218.5,100.1,218.8,99.8z M209.3,95.7
		C209.3,95.7,209.3,95.6,209.3,95.7L209.3,95.7c0.1,0,0.1,0,0.2,0.1C209.4,95.7,209.3,95.7,209.3,95.7L209.3,95.7z M202.3,102
		c0.5,0.1,0.8,0.4,1.5,0.7c-0.6,0.5-0.9,0.9-1.3,1c-0.5,0.2-1.1-0.2-1.1-0.6C201.2,102.6,201.7,102,202.3,102z M196.6,104.9
		c0-0.1-0.1-0.1-0.1-0.2c0,0,0-0.1,0.1-0.1c0,0.1,0.1,0.1,0.1,0.2C196.6,104.8,196.6,104.8,196.6,104.9z"
      />
      <path
        class="st3"
        d="M224.9,114.3c-0.1-0.1-0.1-0.1-0.2-0.3c0,0,0,0-0.1,0c0,0-0.1,0-0.1-0.1c-0.2,0-0.5-0.1-0.7-0.1
		c0-0.1,0.1-0.2,0.1-0.3c0.2,0.1,0.4,0.3,0.6,0.4h0.1v0.1c0.2,0.1,0.5,0.2,0.7,0.4h0.1l0,0c1-0.2,1.6-0.7,2.1-1.4
		c0.2-0.3,0.4-0.7,0.7-0.9c1.3-1.4,3.6-2,5.5-1.5c0.2,0.1,0.3,0.1,0.5,0.2c0-0.2,0.2-0.4,0.5-0.5c0.1-0.1,0-0.4,0-0.6s0-0.4,0.1-0.8
		c0.7,0,1.3,0.1,1.9,0.1c0.3-0.7,1-1.3,1.8-1.5c1.3-0.3,2.6,0.4,2.8,1.5c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0.1,0.1
		c0.1,0.2,0.2,0.4,0.3,0.6c0.6,0.2,1.1,0.7,1.2,1.4c0-0.1,0-0.2,0.1-0.3c0.2-0.6,0.7-0.8,1.5-0.7c1.1,0,2,0.2,2.5,1
		c-0.6,0.4-1.1,0.4-1.6,0c-0.5,0.3-1,0.6-1.4,0.8c1-0.2,2-0.3,3.1-0.5c0.1,0,0.3,0,0.4-0.1c0-0.2,0.1-0.3,0.1-0.6
		c0.2,0.2,0.3,0.4,0.4,0.5c1.5-0.2,2.9-0.4,4.4-0.6c-0.2-0.2-0.5-0.4-0.5-0.4c0.1-0.2,0.3-0.4,0.6-0.5c0.1,0,0.3,0.2,0.5,0.3
		c-0.2,0.2-0.3,0.4-0.6,0.7c0.5-0.1,1.1-0.1,1.6-0.2c-0.1-0.1-0.2-0.2-0.2-0.2c0.6,0,0.8,0,0.8,0.2c0.3,0,0.6-0.1,1-0.1
		c0.1-0.6,0.4-1.1,0.8-1.6c1.1-1.4,2.8-2,4.8-1.8l0,0l0.1-0.1l0.1,0.1l0,0c0.1,0,0.2,0,0.3,0c0.8,0.1,1.6,0,2.5,0
		c0.1-0.6,0.2-1,0.2-1.5c0-0.3-0.2-0.7-0.4-0.9c-0.7-0.6-1-1-1.2-1.8c0,0,0,0-0.1,0c0-0.1,0-0.2,0-0.2c0-0.2-0.1-0.4-0.1-0.6
		c0.1,0,0.2,0.1,0.3,0.1h0.1l0,0c0.2,0.1,0.3,0.1,0.5,0.2c-0.2-0.5-0.4-1,0.2-1.5c1.6,0.4,2.1,1,1.8,2.1c-0.1,0.4-0.4,0.8,0.1,0.9
		c0.4,0.1,0.9-0.1,1.3-0.4c0.3-0.2,0.3-0.6,0.5-0.8c0.6-0.2,0.9,0.5,1.5,0c0.9-0.7,1.9-0.4,2.8,0.1c2,1.2,2.5,3.2,1.4,5.2
		c-0.1,0.2-0.2,0.3-0.3,0.5c2.3-0.2,4.7-0.4,7-0.7c0.8-1.2,1.9-1.6,3.7-1.4c0.5,0,0.9-0.1,1.5-0.2c0.1,0.4,0.2,0.7,0.4,1.1
		c2-0.2,4-0.4,6-0.6c0-0.2,0-0.4,0.1-0.6c-0.6-0.1-1.3-0.3-2.1-0.4c-0.2-0.4-0.4-0.9-0.6-1.4c0.4-0.6,0.8-1.1,1.2-1.7
		c-1.2-0.7-1.6,0.3-2.3,0.7c-0.9-0.5-1.8-0.9-2.8-1.5c0.2-0.3,0.4-0.5,0.7-0.9c-0.3,0-0.6,0-0.9,0c0.1-0.3,0.2-0.6,0.3-0.7
		c-0.4-0.4-0.8-0.8-1.1-1.2c-0.8,0.1-1.6,0.1-2.5,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0.2,0.9-0.4,1.7-1.5,2s-2.1-0.2-2.3-1
		c-0.1-0.4,0-0.8,0.3-1.1c-1.1,0.1-2.2,0.2-3.3,0.2c-4.2,0.4-8.5,0.8-12.7,1.2c0.2,0.5,0.3,1-0.4,1.5c-0.2-0.5,0-1,0.3-1.4
		c-3.1,0.3-6.2,0.7-9.3,1.1c0.2,0.2,0.2,0.4,0.3,0.6c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1-0.2-0.3-0.4-0.5-0.7c-1.8,0.2-3.5,0.5-5.3,0.7
		v0.1c-0.6,1.7-1.3,2.3-2.8,2.4c-0.1,0-0.2,0-0.3,0c0.1,0,0.2,0.1,0.3,0.1c-0.2,0.1-0.3,0.3-0.4,0.3c0,0-0.2-0.1-0.2-0.2
		s0.1-0.2,0.1-0.3c-0.9-0.1-1.6-0.6-2-1.7c-1.6,0.3-3.3,0.5-4.9,0.8c-0.6,0.9-1.8,1.3-3.9,1.4c-0.2,0-0.3,0.1-0.6,0.2
		c0,0.2,0,0.4,0,0.6s0.1,0.4,0.2,0.6c0.3-0.1,0.6-0.3,0.9-0.4c-0.6,0.8-1.2,1.5-1.9,2.3c-0.9,1.1-2.2,1.6-3.6,1.6
		c-0.8,0.3-1.7,0.4-2.5,0.1c-1.1-0.4-1.7-1.6-1.4-2.6c0.1-0.3,0.2-0.5,0.4-0.8c0-0.1,0-0.2-0.1-0.3c-1.1,0.5-2.1,1.2-3.2,0.9
		c-0.2,0.3-0.5,0.5-0.7,0.8c0-0.1,0-0.1,0-0.2c-0.2,0.4-0.5,0.7-0.7,1s-0.3,0.6-0.5,0.8c-0.1,0.1-0.1,0.2-0.2,0.3l0,0
		c1.7-0.4,3.4,0.5,3.7,1.9s-0.8,2.9-2.5,3.3c-1.8,0.4-3.5-0.5-3.8-1.9c-0.2-1,0.3-2,1.3-2.7c-0.1-0.1-0.3-0.1-0.5-0.3
		c0.1-0.2,0.3-0.2,0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.3c0.3-0.3,0.7-0.7,1-1.1c-0.4,0-0.7,0-1.2,0l-0.1,0.1c-0.5,0.4-1.1,0.6-1.7,0.2
		c-0.4-0.3-0.7-0.6-0.8-1.1c-2,0.4-4,0.8-6,1.2c-0.1,0.3-0.3,0.6-0.6,1.1c-0.2,0-0.5,0-0.7-0.1v0.1c-0.3,0.1-0.6,0.1-0.8,0.2
		c0-0.1,0-0.1,0-0.2c0.2,0,0.4-0.1,0.6-0.1c-0.4-0.1-0.7-0.3-0.9-0.5c-0.4,0.1-0.8,0.2-1.2,0.2c-0.8,0.8-1.5,1.7-1.4,2.9
		c0,0.2-0.4,0.4-0.5,0.5c0.4,0.5,0.9,0.9,1,1.4c0.1,0.6-0.4,1.2-0.7,1.9c-0.1,0-0.1,0-0.1-0.1l0,0c-0.6,0-1,0-1.2-0.1
		c-0.2,0.3-0.1,0.6,0.1,0.9c0.1,0,0.2,0,0.4,0c1.4,0.5,1.4,0.5,2.7,0.4c0.3,0.4,0.5,0.6,0.7,0.9c0.7-0.1,1.3-0.3,2-0.4l0.1-0.1
		c-0.1-0.1-0.2-0.2-0.2-0.4c-0.2-0.7,0.4-1.4,1.3-1.6c0.2,0,0.4-0.1,0.6,0c1.1-0.9,2.3-1.5,4-1.1c1,0.3,1.6,0.9,1.9,1.6
		c0.7-0.1,1.4-0.3,2.1-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0,0.2,0.1,0.2,0.1l0,0c0.5-0.1,1-0.2,1.5-0.3c1.1-0.2,2.2-0.5,3.4-0.7
		c0.1-0.2,0.2-0.3,0.4-0.5c0.4-0.4,0.8-0.7,1.3-1.1C224.9,114.2,224.9,114.3,224.9,114.3z M288.5,105.5c0,0.1,0.1,0.1,0.1,0.2
		s-0.1,0.1-0.2,0.2c-0.1-0.1-0.2-0.2-0.2-0.2C288.3,105.7,288.4,105.6,288.5,105.5z M282.7,105.8L282.7,105.8h-0.1H282.7z
    M281.2,104.5c0.1,0,0.2,0.1,0.2,0.1c-0.1,0.2-0.3,0.5-0.4,0.7c-0.1,0-0.2-0.1-0.3-0.1C280.9,105,281.1,104.8,281.2,104.5z
    M276.5,106.3c-0.2,0.4-0.4,0.8-1,0.5c0,0,0-0.1-0.1-0.1c-0.3,0-0.6-0.1-1-0.2c0.3-0.3,0.5-0.6,0.6-0.6c0.2,0,0.4,0.1,0.6,0.2
		C276,105.7,276.3,106,276.5,106.3z M274.6,103.2l0.1-0.1c0-0.2,0.1-0.5,0.1-0.7c0.1,0,0.2,0.1,0.4,0.1c-0.2,0.2-0.3,0.4-0.5,0.6
		C274.7,103.1,274.7,103.2,274.6,103.2C274.6,103.3,274.6,103.3,274.6,103.2c0,0.3,0,0.4,0,0.6c-0.1,0-0.2,0-0.3,0
		C274.4,103.6,274.5,103.5,274.6,103.2C274.6,103.3,274.6,103.2,274.6,103.2z M272.9,100.2c0.1,0,0.2,0.1,0.4,0.2
		c-0.2,0.1-0.3,0.2-0.4,0.3c-0.1-0.1-0.2-0.2-0.2-0.3C272.7,100.3,272.9,100.2,272.9,100.2z M267.3,101.3c0.1,0,0.1-0.1,0.2-0.1
		C267.5,101.2,267.4,101.2,267.3,101.3C267.3,101.4,267.3,101.4,267.3,101.3L267.3,101.3L267.3,101.3z M262.2,103
		c0.1,0.2,0.3,0.3,0.3,0.4s-0.2,0.2-0.3,0.3c-0.1-0.1-0.3-0.2-0.3-0.2C261.8,103.3,262,103.1,262.2,103z M254.2,106.5L254.2,106.5
		L254.2,106.5L254.2,106.5z M249.4,104.5c1-0.2,2,0.3,2.2,1.1c0.2,0.8-0.4,1.5-1.6,1.8c-0.9,0.2-1.8-0.2-2.1-1
		C247.7,105.7,248.4,104.8,249.4,104.5z M247.9,108.9c-0.2,0.2-0.5,0.4-0.7,0.6c-0.1-0.1-0.2-0.3-0.2-0.3c0.2-0.2,0.5-0.3,0.7-0.4
		C247.8,108.7,247.8,108.8,247.9,108.9z M246.7,104.4c0.3,0.2,0.7,0.3,0.7,0.4s-0.2,0.5-0.4,0.5s-0.6-0.1-0.7-0.3
		C246.3,105,246.5,104.8,246.7,104.4z M247,105.8c0.2,0.2,0.2,0.7,0.1,0.9c0,0.1-0.7,0.2-1,0.2c-0.4-0.1-0.6-0.4-1-0.7
		C246.1,105.4,246.6,105.3,247,105.8z M245.3,108.3c0-0.1,0.1-0.1,0.1-0.2c0,0,0.1,0,0.1,0.1c0.5-0.3,0.9-0.5,1.5-0.8
		c-0.2,0.8-0.5,1.3-0.8,1.6c0,0.2,0.1,0.4,0,0.7c-0.4-0.2-0.6-0.4-0.8-0.5c-0.3,0-0.7-0.1-1.1-0.3
		C244.6,108.7,244.9,108.5,245.3,108.3z M242.4,108.5l0.1,0.1l0,0c0-0.2,0.4-0.4,0.7-0.6c0.3,0.2,0.7,0.4,0.8,0.6s-0.4,0.5-0.7,0.8
		c-0.3-0.3-0.5-0.5-0.7-0.7c-0.2,0.2-0.4,0.4-0.6,0.7c-0.1,0-0.1-0.1-0.2-0.1C241.9,109,242.1,108.7,242.4,108.5z M239.1,105.4
		c0.2,0,0.4,0.2,0.7,0.3c-0.2,0.2-0.3,0.5-0.6,0.6c-0.1,0.1-0.4-0.2-0.8-0.4C238.7,105.7,238.9,105.4,239.1,105.4z M204.2,112.3
		c0-0.1,0-0.1,0-0.2c0.3-0.1,0.6-0.1,0.9-0.2c0,0.1,0,0.1,0,0.2C204.8,112.1,204.5,112.2,204.2,112.3z M207.3,111.8
		c0.2-0.1,0.4-0.2,0.6-0.2c0,0.1,0.1,0.1,0.1,0.2c-0.2,0-0.4,0.1-0.5,0.1C207.4,111.9,207.3,111.9,207.3,111.8z M207.9,113.1
		c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0.1C208,113,208,113.1,207.9,113.1z M208.4,113.7c0-0.1,0-0.1,0-0.2
		c0.1,0,0.1,0.1,0.1,0.1S208.4,113.6,208.4,113.7z M211.7,112.5L211.7,112.5c0.1-0.1,0.1,0,0.2,0
		C211.8,112.5,211.7,112.5,211.7,112.5z M211.2,112.1c-0.1-0.1-0.1-0.1-0.2-0.2c0.2-0.3,0.4-0.7,0.7-1.1c0.2,0.2,0.5,0.5,0.4,0.5
		C211.9,111.6,211.5,111.8,211.2,112.1z M215,115.1c-0.1,0-0.2,0-0.3,0c0.1-0.1,0.1-0.3,0.2-0.4c0.2,0,0.3,0.1,0.4,0.1
		C215.1,114.9,215.1,115.1,215,115.1z M215.9,113.7C215.8,113.8,215.8,113.8,215.9,113.7C215.8,113.8,215.8,113.7,215.9,113.7
		C215.8,113.7,215.9,113.7,215.9,113.7L215.9,113.7z M217.3,116.9c-0.1,0-0.2,0-0.3,0c0-0.1,0.1-0.3,0.1-0.4
		c0.1,0.1,0.3,0.1,0.3,0.1C217.5,116.7,217.4,116.8,217.3,116.9z"
      />
      <path
        class="st3"
        d="M226.3,105c-0.4,0.1-0.8,0.1-1.2,0.2c0.1,0.1,0.1,0.2,0.2,0.3C225.6,105.3,225.9,105.1,226.3,105z"
      />
      <path
        class="st3"
        d="M284.2,262.8c0,0.3-0.1,0.6-0.1,0.9c0.3,0.1,0.6,0.3,0.8,0.4c-0.2,0.1-0.4,0.1-0.6,0.2c0,0.1,0.1,0.1,0.1,0.2
		c0.2-0.1,0.4-0.3,0.6-0.4c0.5,0,1-0.3,0.8-0.6C285.5,263.1,285.2,262.4,284.2,262.8z"
      />
      <path
        class="st3"
        d="M283.6,265c0.1-0.1,0.1-0.1,0.2-0.2c-0.3-0.1-0.5-0.2-0.7-0.2C283.3,264.8,283.5,264.9,283.6,265z"
      />
      <path
        class="st3"
        d="M184.2,108.8C184.2,108.7,184.1,108.8,184.2,108.8C184.1,108.8,184.2,108.8,184.2,108.8L184.2,108.8z"
      />
      <path
        class="st3"
        d="M41.6,308.6c-0.3,0.4-0.8,0.7-1.1,1.2C41,309.5,41.4,309.1,41.6,308.6z"
      />
      <path
        class="st3"
        d="M209.1,90.5c0.5,0.4,1,0.8,1.7,1.3c-0.2-0.9-0.4-1.6-0.5-2.4c-0.1,0-0.1,0-0.2,0c-1.1,0.6-2.2,0.9-2.9,1.8
		c-0.6,0.7-1.2,1.4-2.1,2.4c1.3-0.3,2.1-0.6,3-0.8C208.5,92.1,207.9,91.1,209.1,90.5z"
      />
      <path
        class="st3"
        d="M114.8,145.5c-0.7,0.9-1.8,1.6-3.3,1.4c-0.6-0.1-1.2-0.4-1.6-0.8c-0.1,0.2-0.3,0.5-0.5,0.8
		c-0.3-0.2-0.6-0.4-0.6-0.5c0.1-0.3,0.4-0.5,0.6-0.7c0.1,0.1,0.2,0.1,0.4,0.2l0,0l0,0c-0.2-0.3-0.3-0.5-0.3-0.8V145
		c-0.5,0.4-1.3,0.7-2,0.5c-1.1-0.2-2.1-1.1-1.6-1.9c0.1-0.3,0.2-0.6,0.3-0.8c-1.8,0.9-3.6,1.7-5.4,2.6c0.7,0.2,0.4,0.7,0.4,1.1
		c0.4,0.2,0.9,0.3,1.3,0.6c0.7,0.5,1,1.1,0.7,1.9c-0.3,0.8-0.9,1.3-1.8,1.5s-1.8,0-2.2-0.7c-0.5-0.7-0.9-1.5-1.3-2.2
		c0.1,0,0.2-0.1,0.3-0.1c0.3,0.1,0.6,0.3,0.9,0.4c0.1-0.1,0.1-0.1,0.2-0.2c-0.2-0.3-0.5-0.6-0.7-0.9c0-0.1,0.1-0.1,0.1-0.2
		c-3.3,1.6-6.5,3.3-9.7,5.1c-0.6,0.3-1.2,0.7-1.7,1c0.1,0,0.3,0.1,0.4,0.1c0.4,0.8,1-0.1,1.6,0.1c0.4,0.3,0.9,0.7,1.4,1.1
		c0.3-0.2,0.7-0.4,1-0.6c0.1-0.8,0.9-1.5,1.9-1.7c1.3-0.3,2.4,0.4,2.6,1.5c0,0.2,0,0.4,0,0.6c0.2,0.2,0.4,0.4,0.7,0.6
		c-0.4,0.6-0.9,0.6-1.3,0.5c-0.2,0.2-0.5,0.4-0.9,0.5c0.2,0.3,0.3,0.6,0.5,0.9c0.2,0,0.5,0.1,0.8,0.1l0,0l0,0c0.2,0,0.5,0.1,0.8,0.1
		c-0.3,0.1-0.5,0.2-0.7,0.3l0,0c0,0,0,0-0.1,0c-0.4,0.2-0.8,0.3-1.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.3c0.2,0.4,0.4,0.8,0.6,1.3
		c-0.8,0-1.4,0-2,0c0,0.3,0,0.6,0.1,0.9c-0.9-0.1-1.8-0.3-2.8-0.4h0.1c0,0,0,0.1-0.1,0.1v-0.1c-0.4-0.1-0.9-0.4-1-0.3
		c-0.4,0.2-0.8,0.3-1.3,0.3c0.2,0.1,0.3,0.2,0.5,0.3c-0.7,0.3-1.1,0.1-1.4-0.2c-0.3,0.1-0.6,0.2-0.8,0.5c-0.6-0.6-1.1-1-0.7-2
		c-2,0.7-2.3-0.4-2.9-1.5c-0.5,0.3-0.8,0.6-1.3,0.9c-0.4,0-1-0.1-1.5-0.2c-0.2,0.3-0.4,0.6-0.7,1c-0.1-0.2-0.1-0.4-0.2-0.5
		c-3.2,2-6.3,4.1-9.5,6.1c-0.1,0.4-0.4,0.7-0.7,1c0,0.1,0,0.1,0.1,0.2c-0.2,0.1-0.3,0.2-0.5,0.2c-0.2,0.2-0.5,0.3-0.7,0.4
		c0,0,0,0,0,0.1c0.1,2.6,0.3,5.1,0.6,7.9c0.5-0.3,0.9-0.4,1.3-0.6c0.1-0.1,0.2-0.1,0.3-0.2c-0.1-0.2-0.1-0.4-0.2-0.6
		c0.3,0.1,0.6,0.2,0.8,0.3c0.1-0.1,0.2-0.1,0.3-0.2c-0.1,0-0.3-0.1-0.4-0.1c-1-0.2-1.1-0.8-0.3-1.5c0.2-0.2,0.4-0.3,0.5-0.5
		c-0.4-0.1-0.7-0.1-1.2-0.2c1-0.9,1.8-1.6,2.6-2.4c0.2,0,0.4,0.1,0.6,0.1c0,0,0,0-0.1,0c0.1,0,0.1-0.1,0.2-0.1l0,0h0.1
		c0.1-0.1,0.1-0.2,0.2-0.2s0.1,0.1,0.2,0.1c-0.1,0-0.2,0.1-0.4,0.1l0,0l0,0c0,0.1,0,0.1,0,0.2c0.2,0,0.4,0.1,0.6,0.2
		c0.1-0.1,0.3-0.1,0.5-0.1c0.1,0,0.1,0,0.2,0c0,0,0,0,0.1,0c-0.3-0.8-0.6-1.6,0-2.5c0.5-0.7,0.6-0.7,1.4,0c0.4-0.6,0.8-1.2,1.2-1.9
		c0.4-0.1,1-0.3,1.5-0.4c1.7-0.3,2.9,0.2,3.6,1.4c0.3,0.5,0.3,1.1,0.1,1.6c1-0.6,2.1-1.1,3.1-1.7c-0.3-0.2-0.3-0.6-0.7-0.7
		c-0.3,0.1-0.6,0.3-1,0.4c-0.2-0.4-0.5-0.7-0.4-1c0.1-0.6-0.3-1-0.9-1.1c-1.2-0.2-1.5-0.9-1.8-1.8c0.4,0,0.9,0,1.2,0.1
		c0.6,0.4,1.2,0.8,2.2,0.5c0.5-0.1,1.3,0.8,1.1,1.3c-0.3,0.2-0.6,0.4-0.9,0.6c0.2,0.2,0.4,0.4,0.7,0.8c0.5-0.6,1.1-1,2-0.7
		c0.2,0.1,0.7-0.3,0.9-0.5c-0.1-0.4-0.2-0.8-0.2-1.1l0.1-0.1c1,0.2,1.4,0.3,1.5,0.9c0,0.1,0.1,0.2,0.1,0.4c1.3-0.7,2.6-1.3,3.9-2
		c0-0.1,0-0.2,0-0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.4-0.2,0.7-0.4,1.1-0.6l0,0l0,0c1.1-0.5,2.1-1.1,3.2-1.6c-0.2-0.2-0.2-0.5,0-0.9
		c0.1-0.3-0.3-0.7-0.4-1c-0.2-0.6,0.3-1,1.1-1c1.6,0.2,1.6,0.2,2.3,1.4l0,0c0.6-0.3,1.2-0.6,1.7-0.8c0.1-0.1,0.1-0.2,0.3-0.4
		c0,0.1,0,0.2,0.1,0.3c0.5-0.2,1-0.4,1.4-0.7c-0.1-0.3-0.1-0.6-0.1-0.9c0.4,0.1,0.7,0.2,0.9,0.3c0-0.1,0-0.1,0-0.2
		c0-0.6,0.5-1,1.3-1.2c0.7-0.2,1.2-0.1,1.7,0.3c1.7-0.8,3.4-1.5,5.1-2.3c-0.5-0.2-0.8-0.6-0.9-1.1c-0.1-0.8,0.6-1.6,1.5-1.8
		c0.6-0.1,1.2,0.1,1.6,0.5c0.2-0.2,0.3-0.3,0.5-0.5c0.3-0.2,0.5-0.3,0.8-0.5c0-0.4-0.1-0.9-0.4-1.2
		C115.1,145.8,114.9,145.6,114.8,145.5z M81.1,162.2l0.2,0.1c0,0.1-0.1,0.2-0.1,0.3c-0.2,0-0.3-0.1-0.4-0.1
		C80.9,162.4,81,162.3,81.1,162.2z M88.7,161.4c-0.6-0.6-1.1-1,0-1.8c0.3,0,0.7,0,1.2,0c0.2,0.3,0.4,0.5,0.6,0.8
		C90.2,161.3,89.3,161.2,88.7,161.4z M95.6,157.7C95.6,157.7,95.6,157.6,95.6,157.7L95.6,157.7C95.7,157.6,95.7,157.7,95.6,157.7z
    M98.5,150.4c0.1,0,0.1-0.1,0.2-0.1s0.1,0,0.2,0C98.7,150.4,98.6,150.4,98.5,150.4z M99,151.1L99,151.1c-0.1-0.1-0.1-0.1-0.1-0.2
		H99C99.1,151,99.1,151.1,99,151.1z M101.8,154.4c0,0.1-0.1,0.1-0.1,0.2C101.7,154.5,101.8,154.4,101.8,154.4c0-0.1,0-0.2,0.1-0.3
		C101.9,154.2,101.9,154.3,101.8,154.4z M100.9,152c-0.1-0.2,0-0.5,0.1-0.5c0.2-0.1,0.6-0.1,0.8,0c0.2,0.2,0.3,0.5,0.5,0.7
		C101.6,152.7,101.2,152.6,100.9,152z M105.4,150.2c-0.1,0-0.1-0.1-0.2-0.1V150c0.1,0,0.1,0,0.2,0
		C105.4,150,105.4,150.1,105.4,150.2z M108.1,150.6c-0.9-0.1-0.8-0.7-0.8-1.2c0.7-0.4,1.4-0.5,1.7,0.2
		C109.2,149.9,108.6,150.6,108.1,150.6z M110.7,147.8c-0.1-0.1-0.1-0.1-0.2-0.2c0.1-0.1,0.2-0.3,0.3-0.4c0.2-0.1,0.4-0.1,0.6-0.2
		c0.1,0.1,0.1,0.2,0.2,0.3C111.3,147.5,111,147.6,110.7,147.8z"
      />
      <path
        class="st3"
        d="M105.7,113.1c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0.1C105.6,113.2,105.6,113.1,105.7,113.1z"
      />
      <path
        class="st3"
        d="M105.6,118.9c0-0.1-0.1-0.2-0.1-0.3c-0.2-0.8,0.4-1.6,1.4-1.7c0.5-0.1,1,0,1.4,0.3l0,0v-0.1
		c-0.1-0.5,0.2-1.1,0.7-1.4c0.2-0.3,0.2-0.6-0.2-0.9c-0.1-0.1,0.2-0.5,0.4-0.7c0.4-0.3,0.9-0.4,1.4-0.6c0-0.2,0-0.4-0.1-0.5
		c-1.8,0.6-3.7,1.2-5.5,1.8c-0.2,0.1-0.4,0.2-0.6,0.3c0.1,0.1,0.3,0.1,0.4,0.2c-0.7,0.6-1.4,1.2-2.1,1.8
		C103.1,118.3,104.7,118.4,105.6,118.9z"
      />
      <path
        class="st3"
        d="M225.7,93.2c0,0.6-0.1,1.2-0.1,1.7c0.5-0.4,0.9-0.8,1.4-1.1l0,0l0.1-0.1l0,0c0.1-0.1,0.2-0.2,0.3-0.2
		C226.9,93.1,226.5,92.6,225.7,93.2z M226.5,93L226.5,93L226.5,93L226.5,93z"
      />
      <path
        class="st3"
        d="M166.4,117.5c-0.1-0.2-0.1-0.6,0-1.1c-0.1,0-0.1-0.1-0.2-0.1l0,0c0.3,0.4,0,0.8,0.1,1.3
		C166.3,117.5,166.4,117.5,166.4,117.5z"
      />
      <path
        class="st3"
        d="M165.2,117.8c-0.1,0-0.2-0.1-0.2-0.1c0.1-0.2,0.3-0.4,0.4-0.5c-0.2-0.2-0.1-0.4,0.2-0.8c-0.1,0-0.1,0-0.2,0
		c-0.4-0.1-0.7-0.3-1-0.4c-1.8-0.2-2.3-0.7-2-2.2c0-0.1,0-0.3,0-0.4l0,0l-0.1-0.1h-0.1h0.1l0,0c0,0,0.1,0,0.1,0.1l0,0
		c0.3-0.2,0.6-0.4,0.9-0.5c1.3-0.5,2.4-0.1,2.7,0.8c0.9,0,1.6-0.5,2.2-1c0-1.2-0.3-2.2-1.3-3c-0.6-0.5-0.7-1-0.7-1.7
		c0.1-2.2-0.5-4.4-1.7-6.3c-0.4,0-1,0-1.4-0.1c-1.3-0.4-2.3,0.3-3.2,1c-0.5,0.4-0.3,0.8,0.2,1.2c0.6-0.2,1.3-0.9,1.9-0.2
		c0.2,0.2,0.3,0.7,0.2,1c-0.3,0.7-1,0.7-1.9,0.3c0.2,1.6-1.2,2.4-1.9,3.7c-0.9-0.6-1.9-1.2-2.7-1.9c-0.8-0.6-1.5-1.2-2.4-2
		c-0.1,0-0.2-0.1-0.4-0.1c0.1,0,0.1-0.1,0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.3,1.5-0.6,2.7-0.8,4c-0.1,0.4,0,0.8,0.1,1.1
		c0.1,0.1,0.1,0.3,0.1,0.4c0.2-0.1,0.4-0.1,0.6-0.2l0.1,0.1c1.6-0.3,3.2-0.6,4.9-0.4c-0.6,0.4-1.2,0.6-1.8,0.9
		c-0.2,0.4-0.3,0.9-0.6,1.4c0.5,0.2,1,0.6,1.4,0.6c1.2-0.2,1.4,0.3,1.5,1.1c0,0.3,0.2,0.7,0.3,0.9c-0.6,0.7-1.1,1.4-1.6,2
		c1.1,0.8,1.6,0.2,2.2-0.4c-0.6-0.5-0.7-0.8-0.5-1.3c0.2-0.4,0.5-0.6,1-0.6l-0.1-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0,0.1,0.1,0.3,0.1
		c-0.1,0.1-0.1,0.1-0.2,0.2c0.2,0,0.5,0,0.8,0c-0.3,0.6-0.5,1.1-0.8,1.7c0.7,0.2,1.4,0.3,1.5,1.1c0,0.1,0.4,0.1,0.6,0.2
		c0.3,0.1,0.6,0.2,0.9,0.4c0,0,0,0,0-0.1c0.4,0.1,0.7,0.2,1.1,0.3c0,0.1-0.1,0.2-0.1,0.3c-0.3-0.1-0.7-0.2-1-0.2
		c-0.4,0.3-0.8,0.6-1.3,1c0.6-0.1,1.1-0.1,1.6-0.1c-0.1,0.1-0.1,0.3-0.2,0.4C164,118.2,164.6,118,165.2,117.8z M167.6,112.4
		c0,0-0.1,0-0.1,0.1c0,0,0-0.1-0.1-0.1C167.4,112.3,167.5,112.3,167.6,112.4C167.6,112.3,167.6,112.4,167.6,112.4z M167.2,111.5
		c0.1,0,0.3,0.2,0.4,0.3c-0.2,0.1-0.3,0.3-0.5,0.4c-0.1,0-0.2-0.2-0.4-0.3C166.8,111.7,167,111.5,167.2,111.5z M163.5,107.7
		c-0.1,0-0.2,0-0.3,0c0-0.1,0.1-0.1,0.1-0.2c0.1,0,0.2,0,0.3,0C163.6,107.6,163.6,107.7,163.5,107.7z M164.7,109.6
		c0.3,0.3,0.3,0.3-0.5,0.9c-0.1-0.3-0.2-0.6-0.4-1.1C164.2,109.4,164.5,109.5,164.7,109.6z M163.3,103.6c0.1,0,0.3,0,0.5,0.1
		c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0-0.3-0.1-0.4-0.1C163.1,103.8,163.2,103.6,163.3,103.6z M159.1,108.9c-0.1-0.1-0.4-0.2-0.4-0.4
		c0-0.2,0.2-0.4,0.4-0.5s0.4,0.1,0.8,0.2C159.5,108.6,159.3,108.7,159.1,108.9z"
      />
      <path
        class="st3"
        d="M109.5,119c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2,0.5-0.7,1-1.4,1.1c-0.6,0.1-1.1-0.1-1.4-0.4
		c0.1,0.6,0.2,1.1,0.4,1.6l0,0c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0.1,0.2c0.6-0.1,1.1-0.1,1.5-0.1c-0.1,0.1-0.1,0.3-0.2,0.3
		c-0.5,0.5-1.4,0.8-1.7,1.5c1.4-0.5,2.8-1,4.3-1.5c0-0.1,0-0.1-0.1-0.2c-0.1-0.2-0.1-0.5-0.2-0.8c0.6,0.3,0.8,0.4,1.1,0.7
		c0.5-0.2,1-0.4,1.5-0.5c0.2-0.4,0.3-0.8,0.5-1.3c-1.4,0.1-2.8,0.2-4.3,0C109,119.4,109.3,119.2,109.5,119z M111.8,120.6
		c0.1,0,0.2,0.1,0.2,0.1s0,0.1-0.1,0.1s-0.2,0-0.3,0C111.7,120.7,111.7,120.6,111.8,120.6z"
      />
      <path
        class="st3"
        d="M75.3,154.4c-0.7,0.3-1.2,0.7-1.8,0.8c-0.5,0.1-1-0.1-1.8-0.2c-0.1,0-0.1,0-0.2,0l0.1,0.1c0,0,0-0.1,0.1-0.1
		s0.1,0.1,0.2,0.1c-0.1,0-0.2,0.1-0.2,0.1c0.2,0.2,0.3,0.3,0.4,0.4c0.6,0.5,1,1.1,1,1.7c0.7-0.5,1.4-0.9,2.1-1.3
		c-0.2-0.2-0.3-0.5,0-0.9C75.3,154.9,75.3,154.7,75.3,154.4z"
      />
      <path
        class="st3"
        d="M77.6,136.8c-1.8,0.9-3.5,1.8-5.3,2.7l0,0c0.5,0.5,0.4,1.3-0.2,1.8c-0.2,0.2-0.3,0.3-0.5,0.4v0.1
		c0.6-0.2,1.2-0.2,1.5-0.5c0.6-0.5,2-0.3,1.9-1.6c0.6,0.1,1.1,0.3,0.6,0.8c-0.6,0.6-0.6,1.1,0,1.7c0.3,0.3,0.4,0.8,0.5,1.3
		c-0.2,0.4-0.4,0.8-0.7,1.2c0.7-0.4,1.5-0.6,2.4-0.2c0.3,0.7,0.7,1.4,1,2.2c1.3-0.4,1.6-2.3,3.7-1.9c-0.1,0.3-0.3,0.6-0.4,0.9
		c-0.1,0.4-0.1,0.9,0.5,1c1.4,0.1,1.3,1,1.4,1.9c-1.2,0-1.6,0.7-1.8,1.6c0.4,0.3,0.8,0.6,1.3,0.9c0.2-0.1,0.4-0.2,0.6-0.3
		c0.1-0.5,0.6-0.9,1.2-1c0.2,0,0.4,0,0.6,0c0.5-0.3,1-0.6,1.5-0.9c0-0.1-0.1-0.1-0.1-0.2c-0.2,0-0.3,0-0.4-0.1
		c-0.4-0.2-0.7-0.6-1.1-0.8c0.2-0.7,0.7-0.9,1.3-0.8c0-0.1,0.1-0.1,0.1-0.2c0.3-0.4,0.9-0.7,1.5-1.1c0.7,0.5,1,1.2,1.1,1.8
		c1.5-0.8,3-1.6,4.5-2.4V145c-0.2,0-0.4,0-0.6,0c-0.1,0-0.2,0.1-0.3,0.1c-0.2-0.7-0.5-1.2-0.6-1.8c0-0.1,0-0.2,0-0.3
		c-0.2-0.1-0.4-0.2-0.5-0.4c-0.3-0.5-0.9-0.5-1.5-0.6c-0.7-0.1-1.3-0.4-1.7-0.7c-0.8,0.4-1.7,0.4-2.9-0.1c-0.7,0.6-1.5,1.3-2.6,0.8
		s-1-1.3-0.7-2.3c-1.4-0.5-1-1.5-0.6-2.5c-0.6,0-1.1,0-1.6-0.1c-0.5-0.2-0.9-0.1-1.4,0C78.7,137.5,78,137.3,77.6,136.8z M75.9,141.3
		c-0.1-0.1-0.1-0.1-0.2-0.2l0.1-0.1c0,0,0.1,0,0.1,0.1C75.9,141.1,75.9,141.2,75.9,141.3z M78.5,142.8c0,0-0.1,0-0.1-0.1
		c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2,0.1,0.2,0.1C78.7,142.7,78.6,142.7,78.5,142.8z M85.7,146.5c0.2-0.6,0.6-0.8,1.4-0.6
		C86.8,146.6,86.4,146.8,85.7,146.5z M86.1,143.7c0.5-0.1,1.1,0.2,1.2,0.6c0.1,0.4-0.4,1.1-0.9,1c-0.4,0-0.9-0.3-1.1-0.6
		S85.6,143.8,86.1,143.7z M83.3,144.4c-0.1,0-0.2,0-0.3,0l0.1-0.1c0.1,0,0.2,0,0.3,0C83.4,144.3,83.4,144.4,83.3,144.4z M83.1,141.8
		c0.1,0.1,0.2,0.2,0.3,0.3l-0.2,0.2c-0.1-0.1-0.3-0.1-0.4-0.2C82.9,142,83,141.9,83.1,141.8z M82.9,143.5l0.1,0.1
		c0,0.1-0.1,0.1-0.2,0.2c-0.1-0.1-0.1-0.1-0.2-0.2C82.7,143.6,82.8,143.5,82.9,143.5z"
      />
      <path
        class="st3"
        d="M226.7,91.1c-0.2-0.7-0.3-1.3-0.5-2c-0.5,0.6-1.2,1.1-2,1.4c-1.3,0.5-1.7,1.3-2,2.3c0.4,0.2,0.8,0.4,1.3,0.6
		C224.1,92.2,225,91.3,226.7,91.1z"
      />
      <path
        class="st3"
        d="M31.3,176.9c0-0.8-0.1-1.6-0.1-2.4c0-0.3-0.1-0.7-0.3-0.9c-0.8-0.6-1.6-1.2-2.5-1.8c-0.2,0.2-0.4,0.5-0.8,0.7
		c0,2.2,0.1,4.5,0.1,6.7c0.1,0,0.1,0,0.2,0.1c0,0.1,0,0.3-0.1,0.4c0.2,0.2,0.3,0.4,0.3,0.7c0.1,0.4-0.1,0.9-0.4,1.2
		c0,0.5,0,1.1,0,1.6l0.1,0.1c0.4-1.3,2-2,3.6-1.7c0-0.1,0-0.1,0-0.2c-0.1-0.3-0.2-0.6-0.3-0.8c-0.1-0.3-0.2-0.7-0.3-1.1
		c-0.5,0.5-1.1,0.8-1.8,0.4c-0.3-0.2-0.5-0.5-0.5-0.9l0,0l0,0c0-0.2,0-0.4,0.1-0.6c0.3-0.7,1.1-1,1.7-0.5c0.4,0.3,0.6,0.7,0.9,1.1
		c0-0.1,0.1-0.1,0.1-0.2c0-0.2,0-0.5,0-0.7l0,0c-0.1,0-0.2,0-0.3,0c-0.1-0.1-0.3-0.1-0.4-0.2c0-0.1,0-0.1-0.1-0.2
		c-0.1-0.1-0.2-0.2-0.3-0.4c0.1,0,0.1-0.1,0.2-0.1c0,0.2,0.1,0.3,0.1,0.5l0.1,0.1c0.2,0.1,0.3,0.1,0.5,0.2c0.1,0,0.1,0,0.2,0l0,0
		C31.3,177.7,31.3,177.3,31.3,176.9h-0.1c0,0,0-0.1-0.1-0.1H31h0.1l0,0C31.1,176.8,31.1,176.8,31.3,176.9
		C31.2,176.9,31.2,176.9,31.3,176.9z M30.6,180.4L30.6,180.4L30.6,180.4L30.6,180.4z M28.9,172.5L28.9,172.5L28.9,172.5L28.9,172.5z
    M29,175.3c0.1,0,0.4,0,0.4,0.1c0.2,0.4-0.1,0.7-0.6,0.8C28.4,175.9,28.5,175.6,29,175.3z M28.9,177.3c0-0.1-0.1-0.1-0.1-0.2
		c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0.1,0.2,0.1,0.2S29,177.2,28.9,177.3z M29.5,176.4c-0.1,0-0.2-0.1-0.2-0.2c0.1-0.1,0.2-0.1,0.2-0.2
		c0.1,0.1,0.2,0.2,0.2,0.2C29.7,176.4,29.6,176.4,29.5,176.4z"
      />
      <path
        class="st3"
        d="M18,317.3C18,317.3,18.1,317.3,18,317.3c-0.1-0.7-0.7-1.3-0.6-2.2c0.2-1.5,2.5-2.8,4.1-2.5
		c1.4,0.2,2.4,1.1,2.5,2.2c0,0,0,0,0.1,0c0,0,0,0.1-0.1,0.1c0,0.3,0,0.6-0.1,0.9c-0.1,0.2-0.2,0.4-0.3,0.6c0.8-0.2,1.6-0.4,2-1.4
		c0.6,1,1.8,1,2.9,1c0.2,0,0.6-0.4,0.8-0.6c0.1-0.2,0.1-0.6,0.2-1.2c0.3,0.3,0.5,0.5,0.7,0.8c0,0,0,0,0-0.1
		c-0.1-2.4-0.1-4.8-0.2-7.2c-0.2-0.4-0.2-0.9,0-1.4c0-0.8,0-1.6,0-2.4c-0.1,0.1-0.2,0.1-0.4,0.2c-0.1-0.1-0.3-0.2-0.4-0.2
		c-0.3,0.2-0.6,0.5-1.1,0.8c-1.3,0.7-1.6,1.9-0.7,2.9c0.7,0.7,1.4,1.5,1.9,2.4c0.8,1.2-0.1,2.7-1.8,3.4c-1.5,0.6-3.2,0.1-3.9-1
		c-0.7-1.3,0-2.8,1.7-3.4c0-0.1,0-0.1,0-0.2c0,0,0,0.1,0.1,0.1c0.2-0.1,0.5-0.2,0.7-0.2c-0.4-0.2-0.5-0.5-0.2-1c0,0,0,0,0.1,0
		c-0.4-0.5-0.5-1-0.5-1.7c0-1.2-0.4-2.3-1.2-3.3c-0.3-0.3-0.5-0.7-0.7-1.1c-0.2,0-0.3,0-0.5,0c-0.8-0.2-1.1-0.6-1.1-1.2
		c-1.3-0.2-1.2-1.6-2.4-1.8c-0.1,0-0.2-0.2-0.2-0.4c0,0,0,0,0-0.1c-0.6,0.1-1.2,0.3-1.8,0.4c-0.1,0-0.1,0-0.2,0
		c-0.2,0.6-0.5,1.3-1.1,1.9c-0.3,0.4-0.7,0.8-1,1.2v0.1c0.3-0.1,0.6-0.3,0.9-0.4c-0.1,0-0.3-0.1-0.4-0.2c0.3-0.3,0.5-0.6,0.9-1
		c0.2,0.3,0.5,0.5,0.4,0.7c-0.1,0.1-0.1,0.2-0.2,0.3c0.2,0,0.4,0,0.7,0c0.7,0.2,1.4,0.2,2.1,0c0.7-0.1,1.3,0.1,1.4,0.6
		c0.1,0.4,0.1,0.9-0.1,1.3c-0.6,1.1-2.3,0.8-3.2,1.5c-0.3,0.2-0.9,0.2-1.4,0.2c-0.2,0-0.4,0-0.5-0.1c-0.2-0.2-0.4-0.2-0.6-0.3
		c0,1.2-0.1,2.4-0.1,3.6c0.8,0.5,1.6,0.9,2.5,1.3c0.9,0.5,1.4,1.1,1.3,2s-0.7,1.7-1.8,2.1c-0.4,0.1-0.8,0.2-1.2,0.4
		c1.2,0.4,1.3,0.7,1.4,1.9c-0.6,0.2-1.2-0.1-1.8,0.1c0.1,0.2,0.1,0.5,0.1,0.7c0,0.1,0.1,0.3,0.1,0.4c0.5,0,0.9,0.2,1.4,0.4
		C17.5,317.1,17.7,317.2,18,317.3L18,317.3z M22.2,310.1c-0.1,0-0.2-0.1-0.2-0.2c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.1,0.1,0.2,0.2
		C22.4,310.1,22.2,310.2,22.2,310.1z M17.5,305.9c-0.2-0.8,0.5-1.7,1.5-1.9c0.9-0.2,1.8,0.2,2.1,0.9h0.1c1.5-0.3,2.9,0.4,3.1,1.5
		s-0.7,2.2-2.2,2.6l0,0l0,0c0,0,0,0-0.1,0c-1.5,0.3-2.8-0.4-3-1.6c0-0.1,0-0.2,0-0.3C18.2,307,17.6,306.6,17.5,305.9z"
      />
      <path
        class="st3"
        d="M11.6,302.1c0-0.1,0.1-0.3,0.2-0.4l0,0c-0.4,0.4-1,0.7-1.6,1c0.1,0.3,0.2,0.5,0.4,0.8
		C11,303.1,11.5,302.7,11.6,302.1z"
      />
      <path
        class="st3"
        d="M34.6,184.3c-0.3-0.2-0.5-0.5-0.7-0.7c0,0.8,0.6,1.3,0.9,2c0,0,0,0,0,0.1c0-0.2-0.1-0.3-0.1-0.5
		C34.6,184.9,34.2,184.7,34.6,184.3z"
      />
      <path
        class="st3"
        d="M225.1,95.7c0.1,0,0.4-0.1,0.4-0.1c0-0.2,0-0.3,0-0.5c-0.1,0.1-0.3,0.2-0.3,0.3
		C225.1,95.5,225.2,95.6,225.1,95.7z"
      />
      <path
        class="st3"
        d="M37.4,313.9c-0.2-3.7-0.3-7.4-0.5-11.1c-0.1,0-0.1-0.1-0.2-0.1c-0.2,0-0.4,0.1-0.7,0.1c-0.3,0.1-0.6-0.1-1-0.3
		c-0.2,0-0.3,0-0.5,0c0,0.3-0.1,0.6-0.1,0.8l0,0c0,0.1,0,0.2-0.1,0.3c0,0.2,0,0.3-0.1,0.5c-0.4-0.2-0.5-0.4-0.6-0.6
		c-0.2-0.6-0.6-1.2-0.7-1.9c-0.1-0.6-1-0.5-0.9-0.7c0.2-0.3,0.2-0.5,0.1-0.6c-0.2,0-0.4-0.1-0.5-0.1s-0.1,0-0.2,0s-0.2-0.1-0.2-0.2
		c-0.4-0.2-0.7-0.6-0.8-1.2c0-0.2-0.1-0.3-0.1-0.5c0.1,2.3,0.1,4.7,0.2,7c0.9-0.7,2.7-0.5,3.3,0.4c0.1,0.2,0.1,0.5,0.3,0.7
		c0.1,0.1,0.3,0.2,0.5,0.4c-0.4,0.4-0.8,0.7-1.2,1c-0.9,0.7-2,0.8-2.9,0.4c0,1.8,0.1,3.7,0.1,5.5c0,0.2,0,0.3,0,0.5h0.1
		c0.5-0.1,1.1,0.2,1.2,0.6c0.1,0.5-0.3,1-1,1.1c-0.1,0-0.2,0-0.3,0c0,0.1,0,0.3,0,0.4c0.2-0.1,0.4-0.3,0.7-0.3
		c2.3-0.5,2.6-0.5,3.9,1c0.5,0.5,0.6,1.2,1.1,1.7c0.9,0.9,1.2,2,1.3,3.2c-0.1-2.3-0.2-4.6-0.3-6.8C37.4,314.8,37.4,314.4,37.4,313.9
		z M31.3,303.1c-0.2,0-0.6-0.2-0.7-0.3c0-0.1,0-0.2,0.1-0.4c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0.1-0.1,0.1-0.2,0.2-0.2
		c0.3,0.1,0.6,0.2,1,0.4C31.6,302.8,31.4,303.1,31.3,303.1z M35.1,309.8c-0.3-0.5-0.5-0.8-0.8-1.1C35.3,308.7,35.7,308.9,35.1,309.8
		z M36.5,306.4c-0.2,0-0.4-0.1-0.5-0.2c0.1-0.1,0.2-0.3,0.3-0.3c0.2,0,0.4,0.1,0.7,0.2C36.7,306.2,36.6,306.4,36.5,306.4z"
      />
      <path
        class="st3"
        d="M13.5,304.3c0,0.2,0,0.5-0.1,0.9c-0.2-0.2-0.3-0.3-0.4-0.4l0,0l0,0c-0.2-0.2-0.3-0.3-0.5-0.4
		c-0.2,0.1-0.3,0.3-0.5,0.4c-0.6-0.1-0.8-0.2-1-0.3c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.1,0,0.2,0c1.2,0,2.1,0.4,2.4,1.4
		c0.1,0.3,0.3,0.8,0.6,1c0,0,0,0,0.1,0c0-1.1,0.1-2.2,0.1-3.3c-0.3,0-0.6,0-0.9,0.1C13.6,304.2,13.5,304.3,13.5,304.3z"
      />
      <path
        class="st3"
        d="M28.6,326.7c-1.3,0.9,0,1.6,0.1,2.8c-0.4-0.5-0.6-0.7-0.7-0.9c-0.1-0.4-0.3-0.8-0.3-1.2c0-0.9-0.5-1.2-1.4-1.3
		c-0.3,0-0.6-0.1-0.9-0.2c-0.1,0.3-0.2,0.5-0.3,0.6c0.5,0.1,0.8,0.5,0.8,0.9c0,0.6-0.5,1.2-1.3,1.4c-0.8,0.2-1.6-0.2-1.7-0.9
		c-0.1-0.7,0.5-1.3,1.4-1.4c0.2,0,0.4,0,0.5,0c-0.7-0.4-1.4-0.7-2.1-1.1c-0.8,0.8-1.9,1.3-3.2,1.4c0,0.7,0.2,1.4,0.4,2.1
		c1,0.2,1.9,0.6,2.4,1.3c0.9,1.4,0.3,2.8-0.8,3.8c0.2,0.3,0.5,0.5,1,0.6s0.6,0.9,1.3,0.5c0.5,1.2,1.9,0.8,2.9,0.8
		c0.7,0,1.4-0.5,1.2-1.4c-0.9-0.2-2-0.1-2.2-1.2c0-0.1-0.4-0.2-0.6-0.3c-0.3-0.1-0.6-0.1-0.9-0.2c-0.8-0.3-1.3-1-0.9-1.5
		c0.4-0.4,1-0.6,1.6-0.6c0.8-0.1,1,0.3,1,1.1c0,0.2,0,0.5-0.1,0.7c0.6,0,1.3,0,1.9,0c0.5,0,1.1,0,1.7,0c0-1.2,0.1-2.3,0.1-3.5
		c0.2-0.1,0.4-0.2,0.6-0.3c0-0.6,0-1.2,0-1.8C29.8,326.7,29.2,326.8,28.6,326.7z M25.8,330.6c-0.1-0.3-0.2-0.6-0.4-0.9
		c0.1,0,0.1-0.1,0.2-0.1c0.2,0.3,0.3,0.5,0.5,0.8C26,330.5,25.9,330.6,25.8,330.6z"
      />
      <path
        class="st3"
        d="M65.3,160.5c-0.1-0.4-0.1-0.8,0-1.1c-0.2-0.4-0.3-0.7-0.5-1.1c-0.2,0.1-0.3,0.1-0.5,0.1
		C64.6,159.1,64.9,159.8,65.3,160.5C65.2,160.5,65.2,160.5,65.3,160.5z"
      />
      <path
        class="st3"
        d="M7.5,312.8c0,0.6-0.2,1.1-0.6,1.5c0.1,0.1,0.3,0.3,0.6,0.4c0.7-0.7,1.5-1.3,2.2-2c-0.6-0.5,0.3-1.6-1-2.2
		C8.5,311.4,8.2,312.2,7.5,312.8z"
      />
      <path
        class="st3"
        d="M66.1,157.8c0.2-0.2,0.5-0.4,0.8-0.6c0.8-0.5,1.3-1.4,2-2.2c0.5,0,1,0,1.5,0c0,0,0,0,0-0.1h-0.1
		c-0.8-0.2-1.2-1.1-0.9-1.8c-0.4-0.1-0.8-0.2-1.1-0.3c-0.6-0.1-1.3,0-2.2-0.1c1.1,1.5,0.2,3-0.2,4.4c0,0.1-0.1,0.2-0.1,0.3
		C65.9,157.5,65.9,157.6,66.1,157.8C66,157.8,66.1,157.8,66.1,157.8z"
      />
      <path
        class="st3"
        d="M79.5,183c0.3,0.5,1,0.7,1.2,0.6c-0.1-0.1-0.2-0.3-0.3-0.5c0-0.1,0-0.2,0-0.3c-0.1,0-0.2,0.1-0.2,0.1
		c-0.2-0.8-0.2-1.5,0.5-1.9c0.4-0.3,0.7-0.4,0.8-0.9c0-0.3,0.3-0.5,0.5-0.7c-0.3,0-0.6-0.1-0.8-0.4c-0.2-0.2-0.4-0.5-0.5-0.6
		c-0.1-0.6,0-1.1,0.7-1.4l0,0c0,0,0-0.1-0.1-0.1c-0.2,0.1-0.5,0.2-0.8,0.2c-2.1,0.4-3.9-0.7-4.2-2.5c-0.1-0.5,0-0.9,0-1.5
		c-0.4,0.2-0.7,0.3-1,0.4c-1.5,0.5-2.9,0.3-3.9-0.7c-0.6,0.4-1.2,0.7-1.8,1.1c0.5-0.1,1,0,1.5,0.2l0,0c0.2-0.2,0.6-0.2,1-0.4
		c0.5,0.3,1.1,0.7,1.7,1c-0.5,1.1-0.7,1.4-1.3,1.5c0,0.4-0.2,0.7-0.4,1c-0.7,0.9-1.7,1.2-3,0.9c0,0.1,0,0.2,0,0.3
		c-0.1,0.9-0.6,1.5-1.6,1.9c-0.8-0.4-1.3-0.8-1.5-1.2c-0.2,0.2-0.4,0.4-0.6,0.7c-0.4-0.6-0.7-0.9-0.9-1.2c-0.2,0.1-0.4,0.2-0.6,0.2
		c0,0.2-0.2,0.4-0.4,0.6c-0.1-0.2-0.1-0.3-0.2-0.4h-0.1c-0.7,0.5-1.1,1.1-1.1,2c0.5-0.4,0.9-0.8,1.3-1.2c0.4,0.4,0.9,0.7,1.3,0.9
		c0.7-0.6,1.8-0.7,2.7-0.2c0.6,0.4,0.8,1,0.6,1.6c0.4,0.5,0.7,1.1,1.1,1.6c0.3-0.4,0.7-0.7,0.8-1.2c0-0.1,0.7-0.2,0.9-0.2
		c0.1,0,0.2,0.1,0.3,0.3c0.1-0.1,0.3-0.3,0.4-0.4c-0.8,0.1-1.3,0.2-1.8,0.2c-0.1-0.4-0.2-0.8-0.3-1.3c1,0.3,1.3-0.3,1.8-0.8
		c0.7-0.7,1.7-0.9,2.4-0.6c0-0.1,0-0.2,0-0.3c-0.3-0.2-0.5-0.4-0.8-1c-0.4,0-0.8,0.1-1.4,0.2c1.1-0.9,2.3-0.9,3.4-1.2
		c0.2,0,0.4,0,0.6,0.1c0,0,0,0,0.1,0h0.1c-0.1-0.1-0.2-0.1-0.3-0.1c0.3,0,0.5-0.1,0.8-0.1c0.2,0,0.4,0.1,0.6,0.2l0,0
		c0-0.1,0.1-0.1,0.1-0.2c0,0,0,0.1,0,0.2c0,0,0,0-0.1,0c0,0,0,0.1-0.1,0.1c0.8,0.1,1.5,0.7,1.6,1.5c0.2,1-0.4,1.8-1.4,2.2
		c0.2,0.1,0.7-0.2,0.9,0.1C78.3,181.9,79.1,182.3,79.5,183z M69.6,178.5c0.1,0.1,0.2,0.2,0.2,0.3c0,0-0.2,0.1-0.3,0.2
		c-0.1-0.1-0.1-0.2-0.2-0.2C69.4,178.6,69.5,178.6,69.6,178.5z M69.1,180.5c0.4-0.2,0.6-0.2,0.7-0.3c0,0.1,0,0.1,0,0.2
		C69.7,180.5,69.6,180.5,69.1,180.5z M70.4,179.3C70.3,179.3,70.3,179.3,70.4,179.3c-0.1-0.1,0-0.1,0-0.2
		C70.4,179.2,70.4,179.2,70.4,179.3C70.4,179.2,70.4,179.3,70.4,179.3z M75.9,174.3c-0.1-0.1-0.2-0.1-0.2-0.2c0-0.1,0.1-0.1,0.2-0.2
		c0.1,0,0.2,0.1,0.2,0.1C76.1,174.1,76,174.2,75.9,174.3z M77.9,176.9c0,0,0.1,0,0.1,0.1l-0.1,0.1c0,0-0.1,0-0.1-0.1
		S77.8,176.9,77.9,176.9z M77.6,177.9c0-0.1,0-0.1,0-0.2c0.2,0,0.4,0,0.5,0v0.1C78,177.8,77.8,177.9,77.6,177.9z M78.2,180.4
		c0,0,0-0.1-0.1-0.1c0,0,0-0.1,0.1-0.1l0.1,0.1C78.3,180.3,78.3,180.3,78.2,180.4z M79.4,179.2l0.1,0.2c-0.2,0.6-0.7,0.2-1.1,0.1
		C78.8,179.4,79.1,179.3,79.4,179.2z"
      />
      <path
        class="st3"
        d="M221.6,95.3c0,0.1,0,0.1,0,0.2c0.1,0,0.1-0.1,0.2-0.1C221.7,95.4,221.6,95.4,221.6,95.3z"
      />
      <path
        class="st3"
        d="M60.7,176.3c0.1,0,0.2-0.1,0.3-0.1c0.5-0.1,1.1,0,1.5,0.2c0.7-0.2,1.4,0.1,2.2,0.7c0.5-0.2,0.9-0.4,1.4-0.6
		c-0.4-0.5-0.4-1.1-0.6-1.8c-0.3,0.3-0.8,0.5-1.2,0.6c-0.6,0.1-1.2,0.1-1.7-0.1c-0.2,0.3-0.6,0.5-0.9,0.5c-0.3,0-0.7,0-0.9-0.1
		C60.8,175.8,60.7,176,60.7,176.3z M64,175.6c0.3,0.3,0.6,0.6,0.9,1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.3-0.3-0.7-0.6-1-1
		C63.8,175.7,63.9,175.6,64,175.6z"
      />
      <path
        class="st3"
        d="M62.4,153c-0.3-0.7-0.6-1.4-1-2.1c-0.2,0.1-0.3,0.1-0.5,0.2c0.4,0.8,0.7,1.6,1.1,2.4
		C62.1,153.3,62.3,153.2,62.4,153z"
      />
      <path
        class="st3"
        d="M64,156.6c-0.2,0.1-0.3,0.1-0.5,0.1c0.2,0.4,0.4,0.9,0.6,1.3C64.1,157.6,64,157.2,64,156.6z"
      />
      <path
        class="st3"
        d="M26.5,174.5c0.2,0.1,0.4,0.3,0.5,0.5c0-0.6,0-1.2,0-1.8c-0.1,0.1-0.2,0.2-0.3,0.4c-0.2-0.1-0.3-0.2-0.5-0.3
		c0.1-0.1,0.2-0.1,0.3-0.2c-0.4,0.2-0.8,0.3-1.2,0.5c0.1,0.2,0.2,0.5,0.3,0.7C25.9,174.2,26.2,174.3,26.5,174.5z"
      />
      <path
        class="st3"
        d="M17.9,335.2c0.1,0.4,0.2,0.7,0.2,1c0.3-0.2,0.5-0.3,0.7-0.4c0,0,0,0,0.1,0c0.1-0.1,0.1-0.1,0.2-0.2
		c0.2-0.2,0.4-0.4,0.6-0.7c-0.3,0.1-0.5,0.1-0.8,0.1C18.6,335,18.3,335.1,17.9,335.2z"
      />
      <path
        class="st3"
        d="M244.1,112.3c-0.4-0.1-0.7-0.3-0.8-0.5c0,0.2,0,0.4,0,0.6C243.6,112.4,243.9,112.3,244.1,112.3z"
      />
      <path
        class="st3"
        d="M32.5,176.4c0,0.4,0,0.8,0.1,1.2c0.8-0.5,1.7-0.7,2.9-0.7c-0.6-0.4-1.2-0.9-1.8-1.3c-0.3-0.2-0.7-0.4-1.2-0.8
		c0,0.2,0,0.4,0,0.6l0,0v0.1l0,0C32.5,175.9,32.5,176.1,32.5,176.4z"
      />
      <path
        class="st3"
        d="M226.5,115.3c0.3,0,0.5-0.1,0.8-0.1c-0.1-0.3-0.1-0.5-0.2-0.7c-0.5,0.3-0.7,0.5-0.9,0.5
		C226.2,115,226.3,115.1,226.5,115.3z"
      />
      <path
        class="st3"
        d="M120.2,118c-1.9-0.8-3.5-0.2-4.5,1.8c1.5-0.5,3.1-1,4.6-1.5C120.3,118.2,120.2,118.1,120.2,118z M118,118.9
		C118,118.9,117.9,118.9,118,118.9v-0.2C118,118.7,118,118.8,118,118.9C118,118.8,118,118.9,118,118.9z"
      />
      <path
        class="st3"
        d="M198.1,112.3c-0.1,0.2-0.3,0.4-0.4,0.6c0.8-0.2,1.3-0.5,1.7-0.9C199,112.1,198.6,112.2,198.1,112.3z"
      />
      <path
        class="st3"
        d="M206.6,108.7c-0.4,0.1-0.8,0.2-1.3,0.3c0.2,0,0.4,0.1,0.5,0.3c0.4-0.1,0.8-0.2,1.2-0.3c0,0-0.1,0-0.1-0.1
		C206.8,108.9,206.7,108.8,206.6,108.7z"
      />
      <path
        class="st3"
        d="M165.2,117.8c0.3-0.1,0.6-0.2,1-0.3c-0.2-0.1-0.4-0.2-0.6-0.2C165.5,117.5,165.4,117.7,165.2,117.8z"
      />
      <path
        class="st3"
        d="M209.8,108.3c0,0.1-0.1,0.1-0.1,0.1c0.1,0,0.3-0.1,0.4-0.1c0.1-0.2,0.2-0.3,0.3-0.5c-0.1,0-0.3,0.1-0.4,0.1
		C209.9,108.1,209.9,108.2,209.8,108.3z"
      />
      <path
        class="st3"
        d="M173.9,117L173.9,117c0.1-0.1,0.2-0.1,0.3-0.1c0.7-0.2,1.3-0.4,2-0.5c-0.2-0.1-0.4-0.2-0.6-0.4
		c-1.6,0.4-3.1,0.9-4.7,1.3c0,0.2,0.1,0.3,0.1,0.5C172,117.6,172.9,117.3,173.9,117z"
      />
      <path
        class="st3"
        d="M154.8,110.7c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0-0.2,0C154.7,110.6,154.8,110.6,154.8,110.7z"
      />
      <path
        class="st3"
        d="M212.9,107.8c0.8-0.2,1.7-0.3,2.5-0.5c0.1-0.1,0.1-0.3,0.1-0.4c-1,0.2-2,0.4-3,0.6
		C212.7,107.6,212.8,107.7,212.9,107.8z"
      />
      <path
        class="st3"
        d="M221.2,104.4c0.3,0,0.5-0.1,0.8-0.1c0.1-0.3,0.2-0.5,0.2-0.8c0,0,0,0.1-0.1,0.1
		C221.9,103.9,221.6,104.2,221.2,104.4z"
      />
      <path
        class="st3"
        d="M216.5,105.3c1-0.2,2-0.4,3.1-0.6l0,0c-0.1-0.1-0.1-0.3-0.1-0.5c-0.7,0.1-1.2,1-2,0.4c-0.4-0.4-0.7-0.9-1-1.3
		c-1.5,1.3-2.8,1.5-3.8,0.9c-0.5,0.1-1.1,0.1-1.7,0.2c0,0.7-0.4,1.3-1.3,1.6l0,0c0.2,0.2,0.4,0.4,0.5,0.7c1.8-0.4,3.6-0.7,5.4-1.1
		c0,0,0,0,0-0.1c0.3-0.1,0.6-0.2,1-0.3C216.4,105.3,216.4,105.3,216.5,105.3z M211.6,105.5c0,0-0.1,0-0.1-0.1l0.1-0.1
		c0,0,0.1,0,0.1,0.1C211.7,105.4,211.7,105.5,211.6,105.5z"
      />
      <path
        class="st3"
        d="M93.9,295.3c-1.2,0.7-2.6,0.7-3.7,0.2c-0.5-0.3-1-0.6-1.5-1c0-1,0.2-1.9,0.7-2.8c-0.3-0.2-0.6-0.4-0.9-0.7
		c-0.1-0.1-0.3-0.1-0.4-0.2c0.1,0,0.2,0,0.2,0c-0.4-0.4-0.7-0.8-1.2-1.2c-0.1,0-0.2,0-0.3,0c0,0.4,0,0.8-0.1,1.2
		c-0.9,0.3-0.9,0.3-1.9,0.2c-0.2,0-0.5,0.1-0.7,0.1l0,0c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.2-0.2,0.3-0.2,0.5c-0.1,0.2-0.5,0.4-0.8,0.6
		c-0.2,0.1-0.6,0.1-0.6,0.2c-0.3,1-1.4,1.3-2.3,1.6c0,0.1,0,0.1,0,0.2c0.2-0.1,0.5-0.2,0.6-0.1c0.8,0.2,1.1,0.7,1.5,1.3
		c-0.1,0-0.1,0.1-0.2,0.1c0.2,0.1,0.3,0.2,0.4,0.4c0.1,0.3,0.4,0.6,0.6,0.8c0.6-0.5,0.7-0.4,1,0.2c0,0,0,0,0.1,0v0.1
		c0.2-0.1,0.4-0.1,0.7-0.2c-0.2-0.2-0.3-0.4-0.4-0.6c0-0.1-0.1-0.3-0.1-0.4c-0.2,0.1-0.4,0.3-0.7,0.4c0.3-0.4,0.4-0.6,0.7-0.7
		c0.1-0.6,0.4-1.2,0.8-1.5c1.1-0.8,3.1-0.4,3.5,0.7c0.2,0.4,0.2,0.9,0.3,1.3c0.5,0.1,1,0.3,1.6,0.4c-0.1,0.3-0.2,0.5-0.3,0.7l0,0
		l0,0c0.5-0.2,0.9-0.5,1.4-0.7c1.2-0.4,2.5-0.2,3.1,0.6c0.4-0.5,1-0.9,1.7-1.1c0.1,0,0.1,0,0.2-0.1c0-0.2,0-0.4,0-0.6
		c-0.9,0.2-1.6,0.4-2.4,0.7C93.9,295.7,93.9,295.5,93.9,295.3z M82.3,293.1c-0.1,0-0.1-0.1-0.2-0.1c0.1-0.1,0.1-0.1,0.2-0.2
		c0.1,0.1,0.2,0.1,0.3,0.2C82.5,293,82.4,293.1,82.3,293.1z"
      />
      <path
        class="st3"
        d="M276.9,265.9c0.1,0,0.3,0.1,0.4,0.1c0-0.1,0.1-0.1,0.1-0.2c-0.1-0.1-0.2-0.2-0.3-0.2
		C277.1,265.7,277,265.8,276.9,265.9z"
      />
      <path
        class="st3"
        d="M305.9,264.1c-1.7-1.1-3.4-2.2-5.1-3.3c-0.1,0.1-0.2,0.3-0.3,0.4c1.7,1.1,3.4,2.2,5.1,3.3
		C305.7,264.5,305.8,264.3,305.9,264.1z"
      />
      <path
        class="st3"
        d="M54.7,163.1c0.3,0,0.6-0.1,0.9-0.1c-0.4-0.1-0.8-0.3-1.1-0.5C54.5,162.7,54.6,162.9,54.7,163.1z"
      />
      <path
        class="st3"
        d="M99.2,306.7c0,0.2,0.1,0.4,0.2,0.6c0,0.2,0.1,0.4,0.1,0.5c0.6-0.2,1.3-0.2,2,0.1c0.2,0.1,0.4,0.2,0.6,0.4
		c0.1-0.2,0.2-0.3,0.4-0.5c-0.7-0.5-1.4-1.1-2.2-1.5C99.8,306,99.2,306.4,99.2,306.7z"
      />
      <path
        class="st3"
        d="M237.1,101.7C237.1,101.8,237.1,101.8,237.1,101.7c0.5,0,1.1-0.1,1.6-0.1c-0.4-0.3-0.8-0.5-1.2-0.8
		C237.3,101.2,237,101.5,237.1,101.7z"
      />
      <path
        class="st3"
        d="M31,326.9c0,0.4,0,0.9,0,1.3c0.2-0.1,0.5-0.3,0.7-0.4C31.6,327.3,31.3,327.1,31,326.9z"
      />
      <path
        class="st3"
        d="M300.6,263c0,0.2,0,0.4,0,0.6c0,0,0,0,0.1-0.1c0.2-0.1,0.3-0.2,0.5-0.3c-0.2-0.1-0.4-0.3-0.6-0.4
		C300.6,262.9,300.6,262.9,300.6,263z"
      />
      <path
        class="st3"
        d="M264.7,108.5c0,0.3-0.1,0.6,0,0.8c0,0.1,0,0.1,0.1,0.2c0.3,0,0.6-0.1,0.9-0.1
		C265.3,109.2,265,108.8,264.7,108.5z"
      />
      <path
        class="st3"
        d="M38.8,317.6c0.1,1.2,0.1,2.5,0.2,3.7c0.1,0,0.2,0.1,0.3,0.2c-0.1-0.9-0.1-1.6-0.1-2.3c0.1,0,0.2-0.1,0.3-0.1
		c0.1,0.2,0.3,0.4,0.5,0.6c0.2-0.3,0.3-0.6,0.4-0.8c-0.1-0.2-0.1-0.3-0.2-0.3C39.7,318.3,39.2,318,38.8,317.6z"
      />
      <path
        class="st3"
        d="M295.1,265.1c1.6,1.1,3.2,2.3,4.9,3.4c0-0.3-0.1-0.6-0.2-0.8c-1.3-0.9-2.5-1.8-3.8-2.7
		C295.7,265.1,295.5,265.1,295.1,265.1z"
      />
      <path
        class="st3"
        d="M300,258.8c0-0.2,0-0.4,0.1-0.5c-0.1,0-0.1,0-0.2,0c-1,0.3-1.3,0.7-1,1.6c0.1,0.2,0.2,0.4,0.3,0.6
		c0.4-0.3,0.9-0.7,1.3-1C300.3,259.3,300.1,259,300,258.8z"
      />
      <path
        class="st3"
        d="M101.4,293.6C101.5,293.6,101.5,293.6,101.4,293.6c0.2-0.4,0.3-0.9,0.5-1.3c-0.6-0.1-1.1-0.1-1.6-0.2
		c0.2-0.2,0.3-0.4,0.3-0.5c-0.5,0-1.2,0-2.1,0c0.6,0.8,0.6,1.6,0.2,2.5c-0.2,0.5-0.4,1-0.5,1.5c0.3,0.1,0.6,0.1,0.9,0.2
		C99.9,295.2,100.4,294.2,101.4,293.6z"
      />
      <path
        class="st3"
        d="M26.1,300.6c0,0.1,0,0.1,0,0.2c0.2,0,0.4,0,0.6,0c1.8-0.1,2.7,0.3,3,1.3c0.1,0.2,0.1,0.5,0.1,0.7h0.1
		c0-1.4-0.1-2.8-0.1-4.2c-0.3,0.2-0.6,0.3-0.9,0.5C28.1,299.8,27.3,300.5,26.1,300.6z"
      />
      <path
        class="st3"
        d="M42.8,296.2c0.2-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.3-0.2,0.4-0.3c-0.1-0.6-0.3-1.2-0.9-1.6
		c-0.2-0.2-0.4-0.3-0.5-0.5c-0.2,0.1-0.4,0.1-0.6,0.2c0.1-0.4,0.1-0.8,0.2-1.2c-0.8,0.1-1.1,0.6-1.6,1.1c0.1,0.3,0,0.6,0,0.9
		c1.1,0.3,1.7,1,2.5,1.5c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0.1,0.1,0.1,0.2C42.9,296,42.9,296.1,42.8,296.2
		C42.7,296.1,42.8,296.2,42.8,296.2z"
      />
      <path
        class="st3"
        d="M18,317.3c0.6,1,0.9,2,0.2,3.3c0.8-0.3,1.6-0.3,2.3-0.2c0.1-0.7,0.3-1.3,0.4-2c0-0.1,0.2-0.3,0.4-0.4
		c0.1-0.1,0.2-0.2,0.3-0.3c-0.7,0.2-1.5,0.3-2.2,0.1C19,317.7,18.5,317.5,18,317.3C18.1,317.3,18.1,317.3,18,317.3
		C18.1,317.3,18.1,317.3,18,317.3z"
      />
      <path
        class="st3"
        d="M29.2,316.3c0.2,0,0.4,0.1,0.6,0.1c-0.1-0.1-0.3-0.2-0.4-0.3C29.3,316.2,29.3,316.3,29.2,316.3z"
      />
      <path
        class="st3"
        d="M30.1,316.5c0-0.1,0-0.2,0-0.3c0,0.1-0.1,0.1-0.2,0.2C30,316.5,30,316.5,30.1,316.5z"
      />
      <path
        class="st3"
        d="M41.6,291.1c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0,0.2,0,0.2,0C41.6,291.2,41.6,291.1,41.6,291.1z"
      />
      <path
        class="st3"
        d="M93.1,290.3c0.9,0.1,1.6,0.5,2,1.1c0.6-0.6,0.4-1.3-0.1-1.9c-0.8,0.2-1.7,0.2-2.3,0.8
		C92.8,290.3,93,290.3,93.1,290.3z"
      />
      <path
        class="st3"
        d="M78.9,294.7c0.1,0.5,0.1,0.9,0.2,1.4l0,0l0.1,0.1c0.3-0.3,0.6-0.5,0.8-0.6c-0.1-0.1-0.2-0.3-0.4-0.6
		C79.4,294.9,79.2,294.8,78.9,294.7z"
      />
      <path
        class="st3"
        d="M84.1,291v-0.1C84,290.9,84,290.9,84.1,291C84,291,84,291,84.1,291z"
      />
      <path
        class="st3"
        d="M60.2,182.4c-0.1,0.1-0.3,0.1-0.4,0.2c0.2,0.1,0.3,0.2,0.5,0.4c0.2,0,0.3,0,0.5,0c0.3-0.4,0.5-0.8,0.8-1.4
		c-0.5,0.3-0.9,0.5-1.2,0.7C60.3,182.3,60.2,182.4,60.2,182.4z"
      />
      <path
        class="st3"
        d="M97.9,157.3c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.2-0.1-0.2-0.1C97.8,157.1,97.9,157.2,97.9,157.3z"
      />
      <path
        class="st3"
        d="M20.6,298C20.6,298,20.7,298,20.6,298c0.1-0.2,0-0.2,0-0.3c-0.2,0-0.4,0.1-0.6,0.1
		C20.2,297.9,20.4,298,20.6,298z"
      />
      <path
        class="st3"
        d="M123.7,149.9c0.2-0.2,0.5-0.4,0.7-0.6c-1.1-0.3-2.1-0.5-3-0.7c0,0.9,0,1.9,0,3c1,0,2.1,0,3.2,0
		c0.1-0.2,0.1-0.4,0.2-0.6C124.5,150.7,124.1,150.4,123.7,149.9z"
      />
      <path
        class="st3"
        d="M282,263.8c0.2,0.2,0.5,0.4,0.7,0.5c0.1,0,0.2-0.1,0.3-0.1c0.3-0.1,0.6-0.3,0.9-0.5c-0.5-0.1-0.9-0.2-1.5-0.3
		C282.3,263.6,282.2,263.7,282,263.8z"
      />
      <path
        class="st3"
        d="M297,270.3L297,270.3c0.1-0.2,0.2-0.4,0.3-0.6c-0.2,0.1-0.3,0.2-0.5,0.2C296.8,270.1,296.9,270.2,297,270.3z"
      />
      <path
        class="st3"
        d="M298.7,101.1C298.7,101.2,298.7,101.2,298.7,101.1c0.5-0.1,0.9-0.2,1.4-0.3c0.2-0.3,0.4-0.6,0.6-0.9
		C299.7,100,299.3,100.6,298.7,101.1z"
      />
      <path
        class="st3"
        d="M181.3,108.3c0.1,0.1,0.2,0.2,0.3,0.3c0.1-0.1,0.1-0.3,0.2-0.5C181.6,108.2,181.5,108.3,181.3,108.3z"
      />
      <path
        class="st3"
        d="M288.5,251.6c0.3-0.2,0.4-0.3,0.3-0.5c-0.2-0.1-0.3-0.2-0.5-0.3C288.2,251.1,288.1,251.4,288.5,251.6z"
      />
      <path
        class="st3"
        d="M241.7,258L241.7,258c-0.1,0-0.2,0.1-0.2,0.2C241.6,258.1,241.7,258.1,241.7,258z"
      />
      <path
        class="st3"
        d="M113.9,117.5c0.3-0.7,0-1-0.7-1.3c0,0.5,0,0.9-0.1,1.2c-0.1,0.3-0.2,0.5-0.4,0.7c0.3,0,0.6,0.1,0.8,0.2
		C113.7,118.1,113.8,117.8,113.9,117.5z"
      />
      <path
        class="st3"
        d="M107.9,112.4c0.5-0.2,1-0.3,1.4-0.5c-0.5-0.3-1.1-0.5-1.5-0.9c-0.1,0.4-0.2,0.6-0.3,0.8l0,0
		C107.8,112,108,112.2,107.9,112.4z"
      />
      <path
        class="st3"
        d="M60.9,134.6l-0.1,0.1C60.8,134.7,60.8,134.7,60.9,134.6C60.9,134.7,60.9,134.7,60.9,134.6z"
      />
      <path
        class="st3"
        d="M77.5,135.4c0.1-0.2,0.3-0.4,0.6-0.6c0.4-0.3,1.2-0.5,0.7-1.3c-1.7-0.5-1.5,1.4-2.9,1.5
		c0.2,0.3,0.4,0.6,0.6,0.9C76.9,135.7,77.2,135.5,77.5,135.4z"
      />
      <path
        class="st3"
        d="M67.9,175C68,175,68,175,67.9,175c0.1,0,0.1,0,0.1-0.1C68,174.9,68,175,67.9,175z"
      />
      <path
        class="st3"
        d="M68.6,133.8c0.3-0.3,0.8-0.6,1.1-0.9c-0.2-0.2-0.4-0.4-0.6-0.6c-0.3-0.2-0.5-0.4-0.6-0.7
		c-0.1-0.1-0.2-0.2-0.4-0.4c-0.7,0.5-1.5,0.6-2.1,1.2c0.7,0.1,1.4,0.3,1.9,0.7C68.2,133.3,68.4,133.5,68.6,133.8z"
      />
      <path
        class="st3"
        d="M62.8,132.9c0.1-0.1,0.2-0.1,0.4-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.2-0.3-0.6-0.5-0.9
		c-1.2,0.3-0.6,1.2-1.1,1.7c0.1,0.1,0.3,0.1,0.4,0.2C62.1,133.3,62.4,133.1,62.8,132.9z"
      />
      <path
        class="st3"
        d="M68.9,137.4c-0.1,0.2-0.3,0.4-0.4,0.6c0.1-0.1,0.2-0.1,0.4-0.2c0.6,0.4,1.2,0.7,1.8,1.1c1.8-1,3.7-1.9,5.5-2.8
		c-0.5-0.1-1-0.1-1.5-0.2c-0.1,0.3-0.1,0.6-0.2,1c-0.6-0.2-1.1-0.4-1.7-0.6c-0.2,0.2-0.4,0.4-0.6,0.7c-0.5-0.2-0.8-0.6-1.5-0.4
		c-0.6,0.1-0.9,0.1-1.4-0.3C69.2,136.6,69.1,137,68.9,137.4z"
      />
      <path
        class="st3"
        d="M17.8,336.9c0,0,0.1,0,0.1-0.1l0,0C17.9,336.8,17.8,336.8,17.8,336.9z"
      />
      <path
        class="st3"
        d="M269.4,135.1c-1.2,0.2-2.3,0.5-3.5,0.7c-0.1,0.3,0,0.7,0.2,1c0.5-0.1,0.7-1,1.4-0.4c0.2-0.2,0.3-0.3,0.5-0.5
		c0,0,0,0,0-0.1h-0.1h0.1l0,0h0.1v0.1c0.7,0.1,1.3,0,1.7-0.6C269.6,135.3,269.5,135.2,269.4,135.1z"
      />
      <path
        class="st3"
        d="M300.2,127.5c-0.4-0.1-0.7-0.3-0.8-0.7c0,0,0,0,0-0.1c-0.7,0.1-1.5,0.3-2.2,0.4c0.1,0.1,0.1,0.2,0.2,0.3
		c0.2,0.3,0.6,0.7,1,0.7c0.1,0,0.2,0,0.3,0.1c0.6-0.1,1.1-0.2,1.7-0.3v-0.1C300.2,127.7,300.2,127.6,300.2,127.5z"
      />
      <path
        class="st3"
        d="M281.4,139c0.2-0.2,0.5-0.4,0.9-0.6c-1.8-0.1-2.6-1-3.6-1.6c0,0.9,0.3,1.7,0.6,2.4c0.2-0.1,0.3-0.1,0.5-0.1
		c0,0.1,0,0.2,0,0.3C280.3,139.2,280.9,139.1,281.4,139z"
      />
      <path
        class="st3"
        d="M277.1,135.4c-0.2-0.2-0.4-0.5-0.6-0.7c-0.2-0.3-0.4-0.6-0.6-0.9c-0.4,0.1-0.8,0.2-1.3,0.2c0.1,0,0.1,0,0.2,0
		c-0.3,0.6-0.9,0.6-1.5,0.8c-0.1-0.1-0.2-0.2-0.3-0.3c0.1-0.1,0.2-0.2,0.3-0.3c-1.1,0.2-2.2,0.4-3.2,0.6c0.5,0,1,0.1,1.5,0.1
		c0,0.5-0.1,1-0.1,1.4c-0.4-0.1-0.7-0.2-1-0.3c-0.1,0.3-0.4,0.5-0.4,0.8C272.4,136.4,274.7,135.9,277.1,135.4L277.1,135.4z"
      />
      <path
        class="st3"
        d="M41.4,158.8c-0.1,0.1-0.1,0.2-0.2,0.3c0.2,0,0.3,0,0.5,0.1C41.6,159,41.5,158.9,41.4,158.8z"
      />
      <path
        class="st3"
        d="M15.9,195.1c0.1-0.1,0.2-0.1,0.3-0.2c-0.2-0.1-0.3-0.2-0.4-0.3C15.8,194.8,15.9,195,15.9,195.1z"
      />
      <path
        class="st3"
        d="M291.9,128.9c0.2,0.1,0.5,0.3,0.7,0.5c0.2,0,0.4,0,0.6,0c0.4-0.1,0.7-0.1,1.1-0.2c0-0.4,0-0.9-0.1-1.3
		c-1.6,0.3-3.2,0.6-4.8,0.9c0.2,0.2,0.4,0.5,0.5,0.9c0,0.1,0,0.2,0.1,0.3h0.1c0.1,0,0.2,0,0.2,0c0.2,0,0.5-0.1,0.7-0.1
		C291,129.4,291.3,129.1,291.9,128.9z"
      />
      <path
        class="st3"
        d="M283.7,130c0.4,0.3,0.9,0.3,1.4,0.1c0-0.2,0.1-0.5,0.2-0.7c-1.6,0.3-3.3,0.6-4.9,0.9c0,0,0,0,0.1,0
		c-0.6,1.1-0.7,1.2-1.5,1.1c-0.9,0-1.5,0.3-2.1,0.9v0.1c1.2-0.2,2.3-0.5,3.5-0.7c0.1-0.1,0.1-0.2,0.2-0.3c0.7-0.2,1.1-0.5,1.6-1
		C282.6,130.3,283.4,130.6,283.7,130z"
      />
      <path
        class="st3"
        d="M7.3,328.6c0.9-0.1,1.7-0.1,2.6-0.2c0.1-0.3,0.1-0.6,0.2-0.8c-0.6-0.3-1.1-0.6-1.6-1c-0.4,0-0.8-0.1-1.2-0.1
		C7.2,327.1,7.3,327.9,7.3,328.6z"
      />
      <path
        class="st3"
        d="M302.4,128.9c-0.3,0.1-0.6,0.1-0.8,0c-0.6,0.1-1.2,0.2-1.8,0.3c0.3,0.4,0.6,0.8,1.2,0.9c0.1,0,0.1,0.1,0.2,0.3
		c0.7-0.1,1.4-0.3,2-0.4c0.2-0.5,0.5-1.1,0.9-1.6c-0.3,0.1-0.7,0.1-1,0.2C302.8,128.8,302.6,128.9,302.4,128.9z"
      />
      <path
        class="st3"
        d="M305.9,126.5c-0.1,0-0.3,0-0.4,0c-0.1,0.1-0.1,0.2-0.1,0.4c0.1,0,0.3-0.1,0.4-0.2
		C305.8,126.7,305.9,126.5,305.9,126.5z"
      />
      <path
        class="st3"
        d="M305.3,126.9c-0.1,0-0.2,0.1-0.2,0.1C305.1,127,305.1,127,305.3,126.9C305.2,127,305.3,127,305.3,126.9z"
      />
      <path
        class="st3"
        d="M233.8,142.1c-0.2,0.1-0.5,0.1-0.7,0.1c0.4,0.4,0.7,0.8,1.2,1.2C234.2,143,234.1,142.5,233.8,142.1z"
      />
      <path
        class="st3"
        d="M289.7,132.5c-0.1-0.4-0.1-0.8-0.2-1.2c-0.2,0.2-0.5,0.3-0.7,0.4c0.2,0.1,0.5,0.1,0.4,0.2
		C288.9,132.5,289.1,132.6,289.7,132.5z"
      />
      <path
        class="st3"
        d="M302.8,131.4c-0.8,0.2-1.7,0.4-2.5,0.5c0.3,0.1,0.6,0.1,0.9,0.2c0.1,0.3,0.1,0.7,0.2,1.1
		c0.5-0.2,0.9-0.4,1.3-0.5C302.7,132.3,302.8,131.8,302.8,131.4z"
      />
      <path
        class="st3"
        d="M272.9,131.8c-1.5,0.3-3,0.6-4.5,0.9c-0.1,0.1-0.2,0.3-0.4,0.4c-0.4,0.5-0.7,0.9-1.1,1.3l-0.1,0.1
		c1.4-0.3,2.8-0.5,4.1-0.8l0,0c0.6-0.5,1-0.5,1.3-0.2c1.1-0.2,2.3-0.4,3.4-0.7c0-0.5,0.1-1,0.4-1.6c-0.8,0.2-1.7,0.3-2.5,0.5
		c0.5,0.2,0.4,0.5,0.1,1.4C273.4,132.6,273.1,132.2,272.9,131.8z"
      />
      <path
        class="st3"
        d="M299.9,130.7h-0.1c0,0,0,0-0.1,0.1C299.8,130.7,299.9,130.7,299.9,130.7z"
      />
      <path
        class="st3"
        d="M277.5,133.7c0.3,0.3,0.5,0.5,0.7,0.7c0.7-0.4,0.9-0.8,0.9-1.2c-0.7,0.1-1.4,0.3-2.1,0.4
		c0.1,0.2,0.1,0.3,0.2,0.4C277.4,133.9,277.4,133.8,277.5,133.7z"
      />
      <path
        class="st3"
        d="M125.5,140c0-0.1,0-0.2,0-0.2c-0.1,0.5-0.2,1-0.3,1.6c0.8,0.3,1.7,0.5,2.6,0.8c-0.1-0.3-0.2-0.7-0.2-1
		C126.6,141.2,125.7,140.7,125.5,140z"
      />
      <path
        class="st3"
        d="M225.1,136.6c0,0.5,0,0.9,0,1.4c0.4-0.1,0.8-0.2,1.1-0.3C225.7,137.4,225.4,137.1,225.1,136.6z"
      />
      <path
        class="st3"
        d="M247.9,135.2c-0.3-0.1-0.5-0.3-0.6-0.5c-0.2,0-0.3,0-0.5,0c0.2,0.2,0.4,0.4,0.5,0.6
		C247.6,135.3,247.7,135.3,247.9,135.2L247.9,135.2z"
      />
      <path
        class="st3"
        d="M231,136.8c-0.1,0.1-0.1,0.2-0.2,0.3l0,0c0,0,0,0,0,0.1c0.4,0.2,0.8,0.3,1.5,0.6c-1.1,0.2-1.4,0-1.5-0.6
		c0,0,0,0-0.1,0l0,0c-0.9,1-2.1,1.2-3.3,1c0,0.4,0,0.7,0,1.1c1.8-0.3,3.6-0.7,5.4-1.1c-0.1-0.3-0.1-0.5-0.2-0.8
		c-0.5-0.1-1-0.3-1.6-0.4l0,0C231.1,136.8,231.1,136.8,231,136.8z M231.5,138.3c-0.1,0-0.2,0-0.3-0.1
		C231.3,138.2,231.4,138.2,231.5,138.3L231.5,138.3z"
      />
      <path
        class="st3"
        d="M145.4,127.4c0.4-0.1,0.8-0.1,1.3-0.2c-0.2-0.2-0.2-0.4-0.4-0.5c-0.3,0.1-0.6,0.2-0.9,0.3
		c-0.1,0.1-0.1,0.1-0.2,0.2C145.3,127.3,145.4,127.3,145.4,127.4z"
      />
      <path
        class="st3"
        d="M223,138.1c0.2-0.5,0.3-0.9,0.5-1.4c-0.7,0.2-1.1,0.6-1.5,1C222.4,137.8,222.7,137.9,223,138.1z"
      />
      <path
        class="st3"
        d="M125.9,137.9c-0.1,0.4-0.2,0.8-0.3,1.2c0.3-0.5,1.1-1,2.2-1.2c0-0.1-0.1-0.3-0.1-0.4
		C127.2,137.7,126.6,137.8,125.9,137.9z"
      />
      <path
        class="st3"
        d="M146.2,135.4C146.2,135.4,146.1,135.4,146.2,135.4C146.1,135.4,146.1,135.4,146.2,135.4
		c-0.6,0-1.2,0.1-1.8,0.1s-0.7-0.4-0.7-0.9s0.5-0.9,1-1c-1-0.2-1.8-0.8-2.2-1.7c-1.4,0-2.5-0.8-2.8-2c-0.1-0.3-0.1-0.6,0-0.9
		c-0.9,0.3-1.7,0.6-2.6,0.9c0,0.1,0,0.2,0,0.2c-0.2,0.6-0.5,1.1-0.9,1.4l0,0c-0.1,0.1-0.3,0.3-0.5,0.4h-0.1
		c-0.5,0.3-1.2,0.5-1.9,0.6c-0.4,0-0.7,0.1-1.1,0.2c-0.7,0.2-1.4,0.4-2.2,0.7c0.4,0.1,0.8,0.2,1.2,0.3c0.8,0.1,1.5,0.2,2.3-0.3
		c1-0.6,2.4-0.1,2.4,0.8c-0.1,1.2,0.6,1.9,1.1,2.8c0,0.1,0,0.2,0,0.6c-2-0.6-3.8-1.1-5.6-1.7c-0.1,0.3-0.2,0.5-0.2,0.7
		c1.1-0.2,2.3,0.1,3.1,0.7c1.4,1.1,1.8,1.7,1.4,3.4c0.4-0.1,0.8-0.3,1.1-0.4c-0.2-2,1.1-3.3,3.2-3.8c1.6-0.4,3.1,0.1,3.9,1.1l0,0
		c-0.1-0.3-0.1-0.6-0.3-1.2c0.6,0.3,0.9,0.4,1.3,0.6c0.1,0,0.2,0.1,0.2,0.1c0.5-0.2,1-0.4,1.5-0.5c0-0.1,0.1-0.1,0.1-0.2l0.1,0.1
		c0.2-0.1,0.5-0.2,0.7-0.3c-0.2-0.3-0.6-0.4-0.9-0.5C146.6,135.9,146.4,135.6,146.2,135.4z M136.7,133c-0.3,0.1-0.5,0.2-0.8,0.3
		c0-0.1-0.1-0.2-0.1-0.3c0.3-0.1,0.6-0.1,0.9-0.2C136.7,132.8,136.8,133,136.7,133z M138.3,132.3
		C138.3,132.4,138.3,132.4,138.3,132.3c-0.1,0-0.2,0-0.2,0S138.2,132.3,138.3,132.3z M141.1,135.8c-0.6,0.1-1.4,0.5-2,0.4
		c-0.5-0.1-0.8-0.7-1.2-1.2c0.6-0.3,1.2-0.5,1.7-0.7s1.1-0.5,1.7-0.8C141.2,134.3,141.2,135,141.1,135.8z"
      />
      <path
        class="st3"
        d="M137.3,141.6c-0.6,0.2-1.3,0.5-1.9,0.8v0.1c0.7-0.2,1.3-0.3,1.8-0.3C137.1,142,137.2,141.8,137.3,141.6z"
      />
      <path
        class="st3"
        d="M232.1,144.4c0,0.2,0.1,0.3,0.1,0.5c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0v-0.1c0.3-0.1,0.6-0.2,0.9-0.4
		c0,0.1,0.1,0.2,0.1,0.2c0.4-0.1,0.8-0.2,1.2-0.2c-0.2-0.2-0.3-0.5-0.4-0.8C233.5,143.8,232.8,144.1,232.1,144.4z"
      />
      <path
        class="st3"
        d="M140.8,148.5c-0.6,0.7-1.3,1.2-2.2,1.5c0.2,0,0.4,0.1,0.6,0.2c-0.7,1.3-1.2,1.6-1.9,1.4
		c-0.6-0.2-0.8-0.7-0.5-1.2l0,0c-0.2,0-0.4,0-0.5,0c-0.2,0-0.3,0-0.5,0c0,0.6,0,1.2,0,1.8c0.8,0.5,1.7,0.9,2.6,1.3
		c-0.2-0.7,0.2-0.9,0.8-1.1c-0.2,0.3-0.4,0.6-0.7,1.2c0.5,0.2,1,0.4,1.5,0.5c0.1-0.2,0.3-0.5,0.4-0.8c0.1-0.4,0-0.9,0.1-1.3
		c0.2-0.7,0.5-1.3,0.1-2c-0.1-0.1-0.1-0.3,0-0.4C141.1,149.1,141,148.8,140.8,148.5z M139.8,150.8c0-0.1-0.1-0.1-0.1-0.2
		c0.1,0,0.2-0.1,0.3-0.1l0.1,0.1C140,150.7,139.9,150.8,139.8,150.8z"
      />
      <path
        class="st3"
        d="M227.4,140.4c-0.1,0.3-0.3,0.7-0.6,0.9c-0.6,0.4-0.9,0.8-0.8,1.2c1.2-0.2,2.4-0.5,3.6-0.7
		c0.2-0.2,0.4-0.4,0.6-0.5c-0.2-0.3-0.4-0.6-0.6-0.9c0.3-0.2,0.6-0.3,0.9-0.5C229.4,140.1,228.4,140.2,227.4,140.4z M229.5,140.6
		c0,0.2-0.2,0.3-0.3,0.4c-0.1-0.1-0.4-0.1-0.4-0.2c0-0.1,0.1-0.3,0.3-0.4C229.3,140.5,229.6,140.6,229.5,140.6z"
      />
      <path
        class="st3"
        d="M150.7,142.1c0.3,0.8-0.1,1.3-0.8,1.8c0.2,0.5,0.3,1,0.4,1.5c0.4-0.2,0.8-0.3,1.2-0.4c0.9-0.2,1.8-0.1,2.7-0.2
		c0.1-0.8,0.3-1.5,0.4-2.3c-1.9-0.1-3.2-0.5-4.1-1.2C150.5,141.6,150.6,141.9,150.7,142.1z M153.3,144.5L153.3,144.5l-0.1,0.1
		L153.3,144.5z"
      />
      <path
        class="st3"
        d="M148,137.6c0.1,0.1,0.2,0.2,0.3,0.3c0.5,0.6,1.1-0.3,1.5-0.2c0.1-0.3,0.3-0.6,0.5-0.9
		C149.5,137.1,148.8,137.4,148,137.6z"
      />
      <path
        class="st3"
        d="M282.7,128.3c0,0.1,0,0.2,0.1,0.2c0,0,0,0,0,0.1c0.6-0.1,1.1-0.2,1.7-0.3c-0.1,0-0.3,0-0.4-0.1
		C283.7,128.1,283.2,128.3,282.7,128.3C282.8,128.3,282.8,128.3,282.7,128.3C282.8,128.3,282.8,128.3,282.7,128.3z"
      />
      <path
        class="st3"
        d="M248.7,130.1c0.2,0.1,0.3,0.1,0.5,0.2c0-0.1,0.1-0.3,0.1-0.4c0.2,0,0.3,0.1,0.5,0.1c0.2-0.3,0.4-0.6,0.6-0.9
		c-1.2,0-2,1.4-3.2,0.6c-0.5,0.2-0.9,0.2-1.4,0.1c0.4,0.7,0.6,1.4,0.5,2.2c0.2,0,0.3,0,0.5,0.1c-0.1-0.6,0.4-1.4,0.9-1.3
		C248.6,131,248.3,130.3,248.7,130.1z"
      />
      <path
        class="st3"
        d="M276.5,139.2c-0.6-0.6-0.6-0.6,0.1-1c0.2-0.1,0.5-0.2,0.5-0.3c0.1-0.2,0.1-0.5,0.1-0.7
		c-0.1-0.1-0.2-0.2-0.2-0.4c-0.2,0-0.4,0.1-0.6,0.1l0,0c0,0,0,0-0.1,0c-1.8,0.4-3.6,0.7-5.4,1.1c0.3,0.3,0.5,0.7,0.8,0.9
		c-0.3,0.2-0.5,0.4-0.7,0.5c0.1,0.3-0.2,0.7-0.1,1c0.3-0.1,0.5-0.2,0.8-0.4c0.4-0.2,0.8-0.5,1.3-0.6c2.3-0.5,2.6-0.5,3.7,0.5
		c0.3-0.1,0.6-0.1,0.9-0.2c-0.1-0.4-0.1-0.8-0.2-1.1C277,138.9,276.7,139.1,276.5,139.2z M272.4,139.7c-0.5-0.4-0.5-0.8,0-1.3
		C272.9,138.8,273,139.2,272.4,139.7z"
      />
      <path
        class="st3"
        d="M304.7,234.5L304.7,234.5c-0.3-0.1-0.6-0.3-0.8-0.4c-0.3,0.1-0.5,0.3-0.8,0.5c-0.1,0.1,0,0.3,0,0.5
		c0-0.1,0.1-0.1,0.1-0.2c0.1,0.2,0.3,0.3,0.3,0.4c0,0.1-0.1,0.2-0.2,0.2h-0.1c0.1,0.3,0.1,0.7-0.3,1c-0.2-0.2-0.3-0.4-0.6-0.6
		c-0.1,0.3-0.2,0.6-0.3,0.9c0.1,0.1,0.3,0.2,0.4,0.3c0.4,0.2,0.7,0.4,1,0.6c0.4,0.3,0.8,0.5,1.3,0.8c0.1-0.1,0.1-0.1,0.2-0.2v-0.1
		l0,0c0-0.3,0-0.6,0-0.9c0.5,0.3,0.4,0.6,0,0.9c0,0,0,0,0,0.1c0,0,0,0.1-0.1,0.1c0,0.1,0,0.2-0.1,0.3c0.4,0.2,0.7,0.4,1.1,0.7v-2.3
		c0,0,0-0.1-0.1-0.1c-0.1-0.2-0.2-0.5-0.4-0.6c-0.6-0.2-0.6-0.6-0.7-1.1C304.8,234.7,304.8,234.6,304.7,234.5z M304.5,234.4
		L304.5,234.4l-0.1,0.1L304.5,234.4z M304.6,236.2c-0.2,0.1-0.5,0.1-0.7,0c-0.6-0.4-0.5-0.9,0-1.4h-0.1h0.2l0,0c0.6,0.1,1,0.4,1,0.9
		C305,235.8,304.8,236.1,304.6,236.2z"
      />
      <path
        class="st3"
        d="M124.7,128.2c-0.1,0.4-0.2,0.8-0.4,1.2c-0.1,0.4-0.4,0.7-0.6,1c0.6,0.1,1.3,0.2,1.9,0.3
		C125.5,128.6,125.4,128.6,124.7,128.2z"
      />
      <path
        class="st3"
        d="M180,125.4c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.3-0.2-0.3-0.2c0.1-0.1,0.2-0.2,0.3-0.4c0,0,0,0,0-0.1
		c-0.1-0.4-0.2-0.9-0.3-1.3c-1.2,0.5-1.3,0.6-1.1,1.8c-1.3,0.3-2.4,0.1-3.3-0.4c-0.4,0.5-0.7,0.8-0.8,1.2c-0.2,0.8-0.8,1.2-1.4,1.5
		c0,0.2,0,0.4,0,0.6c0.4-0.1,0.9-0.3,1.3-0.4v-0.1c0,0,0.1,0,0.1,0.1c1.7-0.5,3.5-1,5.2-1.5c0-0.1,0-0.1,0.1-0.2
		c0.1,0,0.1,0.1,0.1,0.1c0.3-0.1,0.6-0.2,0.8-0.2C180.3,125.8,180.1,125.6,180,125.4z M175.3,126.4L175.3,126.4L175.3,126.4
		L175.3,126.4z M178.3,126.1c0,0-0.1,0-0.1-0.1l0.1-0.1c0,0,0.1,0,0.1,0.1C178.4,126,178.4,126.1,178.3,126.1z"
      />
      <path
        class="st3"
        d="M92.7,163.7c-0.1,0.4-0.5,0.9-1,0.9c-0.3,0-0.6-0.1-0.9-0.2c0,0.1-0.1,0.3-0.2,0.5l0,0l0,0l0,0
		c-0.6,0.2-0.9,0.6-0.7,1c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.2-0.2,0.4-0.3c0.2,0.1,0.4,0.1,0.5,0.2c0-0.3,0-0.6,0.1-0.8
		s0.5-0.3,0.8-0.3c0.7,0,0.6,0.4,0.6,0.8c0.2-0.1,0.4-0.1,0.7-0.2l0,0c0.1-0.1,0.1-0.2,0.2-0.2c0,0.1-0.1,0.2-0.1,0.3l0,0
		c0.1,0.1,0.2,0.2,0.2,0.3c0.2-0.1,0.5-0.3,0.5-0.3c-0.2-0.4-0.4-0.9-0.6-1.3C93.1,164.1,92.9,163.9,92.7,163.7z"
      />
      <path
        class="st3"
        d="M187.1,129.6c-0.2-0.2-0.4-0.5-0.7-0.8c0.2,0.4,0.4,0.8,0.6,1.1c0.5,1,1,1.3,1.8,1.1c0-0.1,0-0.2,0.1-0.4
		c-0.8-1-0.8-1,0.2-1.7v-0.1C188.5,129.1,188,129.3,187.1,129.6z"
      />
      <path
        class="st3"
        d="M97.3,141c0.2,0.1,0.3,0.2,0.4,0.4c0-0.3,0-0.7,0.2-1.1c-0.5-0.1-1-0.1-1.5-0.2c-0.8-0.2-1.4-0.7-1.7-1.3
		c-0.3,0.3-0.3,0.6-0.4,1.3c0,0.3,0,0.5,0,0.8C95.3,140.4,96.5,140.4,97.3,141z"
      />
      <path
        class="st3"
        d="M179.3,127.6c-0.4,0.1-0.9,0.3-1.3,0.4l0,0h-0.1c-0.4,0.1-0.8,0.3-1.2,0.4c0,0.1,0.1,0.1,0.1,0.2
		c0,0.1-0.2,0.3-0.3,0.4c-0.4,0.1-0.6-0.1-0.7-0.3c-0.5,0.1-0.9,0.3-1.4,0.4c0,0.1,0,0.1,0,0.2c0.4,0,0.7,0,1.2,0
		c-0.1,0.9-0.2,1.6-0.3,2.4c0.1,0,0.2,0.1,0.3,0.1c0.4-0.2,0.7-0.5,1.2-0.8c-0.1-0.2-0.3-0.4-0.4-0.9c1.2-0.5,1.7-0.5,1.8,0
		c0.1,0.4,0,0.8-0.6,1c-0.3,0.1-0.5,0.1-0.6,0.1c0.3,0.3,0.5,0.5,0.6,0.8c0.7-0.5,1.4-1,1.4-1.9c1.3-0.5,1-1.2,0.6-1.9
		C179.4,127.9,179.3,127.8,179.3,127.6z"
      />
      <path
        class="st3"
        d="M186.4,127.8L186.4,127.8c0.5-0.1,0.9-0.1,1.4-0.2c-0.3-0.4-0.6-0.8-0.9-1.2c-0.4,0-0.8,0.1-1.3,0.1
		c-0.1,0.1-0.3,0.4-0.5,0.6c-0.7,0.6-1.3,0.7-1.8,0c0-0.1-0.1-0.1-0.1-0.2c0,0.3,0.1,0.5,0,0.8c-0.1,0.7-1,0.3-1.5,0.7
		c1.7,0.4,2.7,0,3.4-1.1c0.3-0.6,0.8-0.8,1.3-0.5C186.9,127.1,186.8,127.5,186.4,127.8z"
      />
      <path
        class="st3"
        d="M121.8,131.5L121.8,131.5c-0.4,0.1-0.8,0.1-1.2,0c-1.1-0.1-2-0.7-2.4-1.6c-0.7,0.4-1.5,0.4-2.4,0.3
		c0,0.2,0,0.4,0.1,0.6c0.5,0.2,1,0.5,1.3,1c0.2,0.2,0.3,0.6,0.6,0.7c0.7,0.4,1.4,0.8,2.2,0.8c0.2-0.4,0.5-0.7,1-1.1
		C121.4,132.1,121.7,132,121.8,131.5z"
      />
      <path
        class="st3"
        d="M89.9,166.7c-0.3,0.4-0.1,0.5,0.1,0.6c0-0.1,0-0.2,0-0.3l0,0C90,166.8,89.9,166.7,89.9,166.7L89.9,166.7z"
      />
      <path
        class="st3"
        d="M170,120.4c0-0.1,0-0.2-0.1-0.2s-0.2,0-0.3,0.1s-0.2,0.3-0.2,0.4c0,0,0.2,0.1,0.3,0.1
		C169.8,120.7,169.9,120.6,170,120.4z"
      />
      <path
        class="st3"
        d="M224.7,126.9c0-0.1,0.1-0.3,0.1-0.4c-0.1,0.1-0.2,0.2-0.4,0.2C224.5,126.7,224.6,126.8,224.7,126.9z"
      />
      <path
        class="st3"
        d="M235,125.1c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0.1-0.2,0.1C234.9,125,235,125.1,235,125.1z"
      />
      <path
        class="st3"
        d="M233.8,118.5c-0.1-0.2-0.2-0.3-0.4-0.5c-0.1,0-0.2,0.1-0.3,0.1C233.4,118.2,233.6,118.4,233.8,118.5z"
      />
      <path
        class="st3"
        d="M98.5,137C98.6,137,98.5,136.9,98.5,137c-0.1-0.1-0.3-0.1-0.4-0.1c0.1,0,0.1,0.1,0.2,0.1
		C98.4,137.1,98.5,137.1,98.5,137z"
      />
      <path
        class="st3"
        d="M100.5,136.7c0.2-0.3,0.5-0.5,0.8-0.6c-0.3-0.1-0.5-0.3-0.8-0.6c-0.5,0.3-1,0.6-1.5,0.9c0,0.1,0,0.2,0.1,0.3
		C99.6,136.7,100,136.7,100.5,136.7z"
      />
      <path
        class="st3"
        d="M225.5,133.7c-0.5,0.2-1,0.4-1.3,0.6c-0.2,0.9-0.4,1.7-0.6,2.4c0.5-0.1,0.9-0.2,1.5-0.3c0-0.1-0.1-0.1-0.1-0.1
		C224.6,135.4,224.8,134.4,225.5,133.7z"
      />
      <path
        class="st3"
        d="M506.1,42.8c-0.3,0.4-0.6,0.7-1,1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.2-0.1,0.3-0.2,0.5
		c-0.2,0.4-0.5,0.8-0.7,1.2C505.6,45.2,506.2,44.5,506.1,42.8z"
      />
      <path
        class="st3"
        d="M366.3,115.1c-0.1,0.1-0.3,0.1-0.4,0.2c0.2,0.1,0.3,0.2,0.5,0.4c0.2,0,0.3,0,0.5,0c0.3-0.4,0.5-0.8,0.8-1.4
		c-0.5,0.3-0.9,0.5-1.2,0.7C366.5,115,366.4,115.1,366.3,115.1z"
      />
      <path
        class="st3"
        d="M540.5,76.1c-0.1-0.6-0.2-1.1-0.7-1.6c-0.3,0-0.5,0.1-0.7,0.2C539.5,75.3,539.9,75.7,540.5,76.1z"
      />
      <path
        class="st3"
        d="M552.3,185.5c0.3,0.1,0.5,0.3,0.7,0.4c0.4-0.7,0.6-0.8,1.3-0.9c-0.1-0.2-0.3-0.4-0.4-0.7
		C553.4,184.7,552.9,185,552.3,185.5C552.3,185.4,552.3,185.4,552.3,185.5z"
      />
      <path
        class="st3"
        d="M328,262.3c0.5-0.4,1-0.7,1.5-1.1c-0.2-0.2-0.3-0.3-0.3-0.6c-0.1-0.7,0.5-1.3,1.4-1.4c0.2,0,0.4,0,0.5,0
		c-0.7-0.4-1.4-0.7-2.1-1.1c-0.8,0.8-1.9,1.3-3.2,1.4c0,0.2,0,0.4,0,0.6c1.1,0.7,1.3,1,0.7,1.5C327.1,261.7,327.6,261.9,328,262.3z"
      />
      <path
        class="st3"
        d="M559.3,180.1c0.1,0,0.3,0.1,0.4,0.1c-0.1-0.1-0.3-0.2-0.4-0.3C559.3,180,559.3,180,559.3,180.1z"
      />
      <path
        class="st3"
        d="M526.3,64.5C526.3,64.5,526.2,64.5,526.3,64.5c-0.8,0.8-1.1,1.8-1.3,2.8c0.7-0.1,1.5-0.3,2.1-0.8
		c-0.1-0.2-0.2-0.3-0.4-0.5C526.3,65.6,526.2,65,526.3,64.5z"
      />
      <path
        class="st3"
        d="M392.1,102.4c-0.1,0.1-0.2,0.1-0.4,0.1c0.6,0,1.2,0,1.7,0c-0.2-0.1-0.3-0.3,0.2-0.8
		C392.9,102.1,392.5,102.2,392.1,102.4z"
      />
      <path
        class="st3"
        d="M386,226.8c0.1,0,0.1-0.1,0.2-0.1C386.1,226.7,386.1,226.7,386,226.8L386,226.8z"
      />
      <path
        class="st3"
        d="M330.6,269.3l0.1,0.1l0.1-0.1c0,0-0.1,0-0.1-0.1C330.7,269.3,330.6,269.3,330.6,269.3z"
      />
      <path
        class="st3"
        d="M347.8,239.9c-1.6-0.8-3.3-1.7-4.9-2.5c-0.8-0.4-1.5-0.8-2.3-1.3c0,0,0,0,0,0.1l0,0c0,0.1,0,0.2-0.1,0.3
		c0,0.2,0,0.3-0.1,0.5c-0.4-0.2-0.5-0.4-0.6-0.6c-0.1-0.3-0.2-0.5-0.3-0.8c-0.2-0.1-0.5-0.3-0.7-0.4c0.1-0.2,0.3-0.3,0.4-0.5
		c0-0.1,0-0.1,0-0.2c-0.1-0.6-1-0.5-0.9-0.7c0.2-0.3,0.2-0.5,0.1-0.6c-0.2,0-0.4-0.1-0.5-0.1s-0.1,0-0.2,0s-0.2-0.1-0.2-0.2
		c-0.4-0.2-0.7-0.6-0.8-1.2c-0.1-0.2-0.1-0.5-0.2-0.7c0,0,0,0-0.1,0c-0.5,0.4-0.9,0.6-1.4,0.8c-0.7,0.8-1.5,1.5-2.7,1.5
		c0,0.1,0,0.1,0,0.2c0.2,0,0.4,0,0.6,0c1.8-0.1,2.7,0.3,3,1.3c0.1,0.2,0.1,0.5,0.1,0.7c0.2,0.1,0.4,0.2,0.5,0.3
		c0.1,0.3,0.1,0.5-0.2,0.7c0.3,0.1,0.6,0.2,0.8,0.3c3.1,1.6,6.1,3.1,9.1,4.7c0.3-0.2,0.7-0.4,0.9-0.7
		C347.3,240.6,347.5,240.2,347.8,239.9C347.7,239.9,347.7,239.9,347.8,239.9z M337.4,235.8c-0.2,0-0.6-0.2-0.7-0.3
		c0-0.1,0-0.2,0.1-0.4c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0.1-0.1,0.1-0.2,0.2-0.2c0.3,0.1,0.6,0.2,1,0.4
		C337.8,235.5,337.6,235.8,337.4,235.8z M342.7,239.1c-0.2,0-0.4-0.1-0.5-0.2c0.1-0.1,0.2-0.3,0.3-0.3c0.2,0,0.4,0.1,0.7,0.2
		C342.9,239,342.8,239.1,342.7,239.1z"
      />
      <path
        class="st3"
        d="M355,233.9c0.2-0.1,0.5-0.1,0.9-0.1c-1.2-0.6-2.4-1.2-3.6-1.7c0.1,0.2,0.2,0.4,0.3,0.6
		C353.4,233.1,354.2,233.5,355,233.9z"
      />
      <path
        class="st3"
        d="M385,227.4v0.1l0.1-0.1C385.1,227.4,385.1,227.4,385,227.4z"
      />
      <path
        class="st3"
        d="M528.1,70.4c0.4,0.1,0.8,0.2,1.1,0.4c0.1-0.3,0.2-0.7,0.4-1c-0.2,0-0.4,0-0.6,0
		C528.6,69.9,528.4,70.2,528.1,70.4z"
      />
      <path
        class="st3"
        d="M533.1,23.8c0.1-0.3,0.2-0.4,0.2-0.5c-0.1-1.4,0.4-2.6,2.2-3.2c0.5-0.2,0.5-0.7,0.2-1.2
		c-0.5,0.1-1.3,0.2-1.4,0.4c-0.2,0.8-1.2,1-1.5,1.7c-0.4,1-1.4,1.8-2.4,2.2c-1.3,0.5-1.7,1.3-2,2.3c0.4,0.2,0.8,0.4,1.3,0.6
		C530.3,24.9,531.3,23.9,533.1,23.8z"
      />
      <path
        class="st3"
        d="M359.4,236c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0s0.1-0.1,0.2-0.1c-0.2-0.1-0.3-0.2-0.4-0.2
		C359.5,235.9,359.4,235.9,359.4,236z"
      />
      <path
        class="st3"
        d="M388.4,102.5C388.4,102.5,388.5,102.5,388.4,102.5c0.7,0.1,1.3,0.1,1.9,0.1c-0.1,0-0.2-0.1-0.3-0.1
		c0.1-0.1,0.1-0.2,0.2-0.3c-0.4-0.6-1-0.9-1.9-1c-0.7-0.1-0.9-0.5-1-1c-0.1,0-0.2,0.1-0.3,0.1c-0.1-0.2-0.2-0.4-0.2-0.6
		c-0.2,0.2-0.4,0.3-0.6,0.5c-0.9,0.6-1.9,0.7-2.8,0.5c0.1,0.5,0.1,0.9,0,1.2c0.1,0.2,0.2,0.4,0.3,0.7c1.1,0,2.3,0,3.4,0
		c0.4-0.5-0.7-0.8-0.2-1.3l0,0c-0.1,0-0.2,0-0.3,0c0-0.1,0.1-0.1,0.1-0.2c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0.1,0l0,0
		C388,101.3,388,102,388.4,102.5z M385.8,101.9l-0.1-0.1c0.1,0,0.2-0.1,0.2-0.1s0.1,0,0.1,0.1C386,101.8,385.9,101.8,385.8,101.9z"
      />
      <path
        class="st3"
        d="M476.2,53.1c0-0.1,0-0.2-0.1-0.2s-0.2,0-0.3,0.1c-0.1,0.1-0.2,0.3-0.2,0.4c0,0,0.2,0.1,0.3,0.1
		C476,53.4,476.1,53.3,476.2,53.1z"
      />
      <path
        class="st3"
        d="M330,248.5c-0.1,0.2-0.2,0.4-0.3,0.6c0.7-0.2,1.4-0.4,1.8-1c-0.5-0.3-1-0.6-1.5-0.9c0,0.1,0.1,0.3,0.1,0.4
		c0,0,0,0,0.1,0c0,0,0,0.1-0.1,0.1C330.2,247.9,330.1,248.2,330,248.5z"
      />
      <path
        class="st3"
        d="M390.2,223.7C390.2,223.6,390.2,223.6,390.2,223.7C390.2,223.6,390.2,223.6,390.2,223.7
		C390.2,223.6,390.2,223.6,390.2,223.7C390.1,223.6,390.1,223.6,390.2,223.7z"
      />
      <path
        class="st3"
        d="M562.7,182.2c0.1-0.1,0.2-0.3,0.4-0.4c0.1,0.2,0.2,0.3,0.2,0.4c0.2-0.1,0.4-0.3,0.5-0.4
		c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1,0.1-0.2,0.2-0.3,0.3c-1-0.9-2.1-1.3-3.4-1.2c0.8,0.3,1.4,0.8,1.9,1.3
		C562.1,181.7,562.4,181.9,562.7,182.2z"
      />
      <path
        class="st3"
        d="M379,100.5c0.1-0.1,0.3-0.1,0.5-0.1c0.1,0,0.1,0,0.2,0c0,0,0,0,0.1,0c-0.3-0.7-0.6-1.5-0.2-2.3
		c-1.8-0.1-3.6-0.1-5.4-0.2c-0.1,0-0.1,0-0.2,0.1c-0.8,0.6-1.8,0.8-2.9,0.6c-0.3-0.1-0.5-0.2-0.7-0.3c-0.4,0.6-1,1-1.7,1.2
		c-1.5,0.3-2.9-0.5-3.1-1.7l0,0c-0.3,0-0.6,0-0.9,0c0.2,0.9-0.4,1.8-1.3,2.4c-0.4,0.2-0.8,0.4-1.1,0.4c-0.5,0.9-1.5,1.5-2.1,2.4
		l-0.1,0.1c1.2,0,2.4-0.1,3.6-0.1c0.2,0,0.3,0,0.5,0c0.2-0.2,0.4-0.4,0.7-0.4c0.4-0.1,0.8-0.2,1-0.6c0-0.1,0.6-0.2,0.8-0.2
		c0.8,0.1,1.4,0.5,1.6,1.1c2.2,0,4.5-0.1,6.7-0.1l0,0c1-0.9,1.8-1.6,2.6-2.4c0.2,0,0.4,0.1,0.6,0.1c0,0,0,0-0.1,0
		c0.1,0,0.1-0.1,0.2-0.1l0,0h0.1c0.1-0.1,0.1-0.2,0.2-0.2s0.1,0.1,0.2,0.1c-0.1,0-0.2,0.1-0.4,0.1l0,0l0,0c0,0.1,0,0.1,0,0.2
		C378.6,100.4,378.8,100.4,379,100.5z M368.8,100.4c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.1,0.2-0.2,0.2-0.2c0.1,0,0.2,0.1,0.3,0.2
		C369,100.3,368.9,100.3,368.8,100.4z"
      />
      <path
        class="st3"
        d="M527.3,37.2c0.1,0.1,0.2,0.3,0.2,0.4c0.7-0.4,0.8-0.9,0.8-1.4c0,0,0,0.1-0.1,0.1
		C528.1,36.6,527.7,37,527.3,37.2z"
      />
      <path
        class="st3"
        d="M311.9,271.9c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0.1-0.3,0.2-0.4,0.2C311.9,271.8,311.9,271.9,311.9,271.9z"
      />
      <path
        class="st3"
        d="M399.2,96.7c-0.1,0-0.3,0-0.4,0c-0.2,0.3-0.5,0.6-0.9,0.6c-0.3,0-0.6-0.1-0.9-0.2c0,0.1,0,0.1-0.1,0.2
		c0.9,0,1.8,0.1,2.7,0.1c-0.1-0.2-0.2-0.3-0.3-0.4C399.4,96.9,399.3,96.8,399.2,96.7z"
      />
      <path
        class="st3"
        d="M382.3,100.1c0,0.1-0.1,0.2-0.1,0.3c0.2,0,0.4,0,0.5,0C382.5,100.3,382.4,100.3,382.3,100.1z"
      />
      <path
        class="st3"
        d="M384.8,103.8c-0.3,0-0.7,0-1,0c0,0.1,0,0.2,0,0.4C384.1,104,384.5,103.9,384.8,103.8z"
      />
      <path
        class="st3"
        d="M381.2,99.2c-0.2,0.3-0.3,0.6-0.5,0.9c0.3-0.1,0.6-0.2,0.9-0.3c0,0.2,0.1,0.4,0.1,0.6c0-0.2,0.1-0.3,0.3-0.4
		C381.8,99.7,381.5,99.5,381.2,99.2z"
      />
      <path
        class="st3"
        d="M548.6,180c-0.2-0.2-0.4-0.4-0.7-0.6c-0.1,0-0.1,0.1-0.2,0.1c-0.1-0.1-0.2-0.2-0.3-0.2
		c0.1-0.1,0.1-0.1,0.2-0.2c-0.2-0.2-0.4-0.3-0.5-0.5c-0.3-0.5-1-0.6-1.2-0.5c0,0.1,0,0.2-0.1,0.2c0.2,0.1,0.4,0.3,0.6,0.4l0,0
		c0,0,0,0,0,0.1c0.5,0.4,1,0.8,1.5,1.2C548.1,180.1,548.4,180,548.6,180z"
      />
      <path
        class="st3"
        d="M325.6,250.5c-0.3-0.1-0.6-0.2-1-0.3c0.8,0.5,1.6,1,2.4,1.5c0-0.2,0.1-0.3,0.1-0.5c0-0.1,0.2-0.3,0.4-0.4
		c0.1-0.1,0.2-0.2,0.3-0.3C327.1,250.6,326.4,250.7,325.6,250.5z"
      />
      <path
        class="st3"
        d="M393,105.6c0.1,0,0.1-0.1,0.1-0.1c0.2-0.1,0.2-0.5,0.3-0.8c0.2-0.1,0.4-0.2,0.7-0.2c-0.1-0.2-0.3-0.4-0.4-0.6
		c-1.8,0-3.6,0-5.4,0c0.8,0.4,1.3,1,1.6,1.8c1.6,0.5,2,0.6,2.6,0.4c-0.1,0-0.1-0.1-0.2-0.1c0.1-0.1,0.2-0.2,0.3-0.3
		C392.7,105.5,392.8,105.6,393,105.6z"
      />
      <path
        class="st3"
        d="M391.6,237.7c0.2,0.3,0.3,0.7,0.4,1.1c-0.5-0.2-0.6-0.3-0.8-0.4c-0.3,0.3-0.6,0.6-0.8,0.9
		c0.2,0.1,0.3,0.3,0.4,0.5c0.2-0.2,0.4-0.3,0.6-0.5c1.1,0.7,2.2,1.4,3.7,1.2c0,0.1,0.1,0.1,0.1,0.2c0.2-0.5,0.5-1,0.7-1.4
		c-0.6-0.2-1.4-0.4-1.9-0.7C393.3,238.6,392.5,238.3,391.6,237.7z M391.4,238.8L391.4,238.8L391.4,238.8L391.4,238.8z M392.9,240.1
		c-0.2-0.2-0.4-0.3-0.3-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0.1,0.2,0.1,0.2,0.2S393,239.8,392.9,240.1z M394.3,240
		c0.1,0,0.2,0.1,0.2,0.1c0,0.1-0.1,0.2-0.1,0.2c-0.1,0-0.2,0-0.2-0.1C394.2,240.2,394.3,240.1,394.3,240z"
      />
      <path
        class="st3"
        d="M387.7,241.9c0.4,0.3,0.7,0.5,1,0.7c0.1-0.2,0.3-0.4,0.4-0.6c-0.4,0-0.8,0-1.1-0.2
		C387.9,241.8,387.8,241.9,387.7,241.9z"
      />
      <path
        class="st3"
        d="M408.8,242.2c0,0.1,0,0.2,0,0.3c0,0,0,0,0-0.1c0.1,0.1,0.2,0.1,0.4,0.2c-0.2,0.1-0.3,0.3-0.5,0.4
		c0,0,0,0,0.1,0c0.6-0.1,1.2-0.2,1.7-0.3c-0.1-0.2-0.1-0.5-0.1-0.8C409.9,241.9,409.4,242,408.8,242.2z"
      />
      <path
        class="st3"
        d="M531.7,69.9c-0.1,0-0.3,0-0.4,0c0,0.3,0,0.5,0,0.8c0.4-0.1,0.8-0.2,1.1-0.3C532.1,70.3,531.9,70.1,531.7,69.9z
		"
      />
      <path
        class="st3"
        d="M313.4,259.2c0,0.1,0,0.3,0,0.4c0.8,0.5,1.6,1,2.4,1.6c0.1,0,0.2,0,0.3,0c0.1-0.3,0.1-0.6,0.2-0.8
		c-0.6-0.3-1.1-0.6-1.6-1C314.2,259.2,313.8,259.2,313.4,259.2z"
      />
      <path
        class="st3"
        d="M587,196.5c-0.5-0.1-1.1-0.2-1.3,0.4c-0.5-0.3-1-0.6-1.5-0.9c-0.1,0.2-0.2,0.5-0.3,0.8
		c-0.1,0.7-0.4,1.3-0.9,1.8c0.1,0,0.3,0.1,0.4,0.1c0.2-0.3,0.6-0.6,1-0.8c0.5-0.2,1-0.2,1.5-0.1c0-0.2,0.1-0.5,0.1-0.7
		c0.8,0.8,1.6,0.9,2.5,0.6c-0.1-0.4,0-0.7,0.6-0.8c0.3-0.1,0.6-0.3,0.9-0.5c-0.5-0.1-0.9-0.2-1.5-0.3
		C588.3,196.6,587.7,196.7,587,196.5z"
      />
      <path
        class="st3"
        d="M579.4,200.4c-0.7,0.1-1.3,0.1-2-0.1c-0.5,0.2-1,0.4-1.7,0.7c1.7,0.4,3.3,0,4.3,1.1c-0.3,0.8-0.3,1.2,0.1,1.3
		c0.2-0.1,0.4-0.2,0.7-0.3c-0.1-0.1-0.2-0.3-0.3-0.4c0.1-0.1,0.1-0.3,0.2-0.3c0.5-0.3,1.1-0.6,1.6-0.8c0.1,0,0.1-0.1,0.2-0.1
		c0-0.1,0.1-0.1,0.1-0.2v0.1c0.3-0.1,0.5-0.2,0.7-0.4c-1.4,0-2.8,0.1-4.2,0.1C579.2,201,579.3,200.7,579.4,200.4z"
      />
      <path
        class="st3"
        d="M611.7,168.7c-0.6-0.2-0.6-0.6-0.7-1.1c0-0.1-0.1-0.3-0.1-0.4c0,0,0,0-0.1,0c-0.3-0.1-0.5-0.2-0.7-0.4
		c-0.3,0.1-0.5,0.3-0.8,0.5c-0.1,0.1,0,0.3,0,0.5c0-0.1,0.1-0.1,0.1-0.2c0.1,0.2,0.3,0.3,0.3,0.4c0,0.1-0.1,0.2-0.2,0.2h-0.1
		c0.1,0.3,0.1,0.7-0.3,1c-0.2-0.2-0.3-0.4-0.6-0.6c-0.1,0.3-0.2,0.6-0.4,1c1.1,0.4,1.9,1,2.4,1.9c0.1,0,0.2,0,0.3,0.1
		c0,0.1-0.1,0.2-0.1,0.2h-0.1c0,0.1,0.1,0.3,0.1,0.4c0,0.2,0.1,0.3,0.2,0.5c0.3,0.1,0.5,0.2,0.8,0.3c0,1.4-0.3,2.1-1,2.2
		c-0.1,0.2-0.1,0.3-0.3,0.5c-0.2,0.3-0.4,0.6-0.7,0.8c0.8,0.1,1.6,0.2,2.4,0.4v-2.7c-0.1,0-0.2,0-0.3,0c0.1-0.3,0.1-0.7,0.2-1.1
		c0,0,0,0,0.1,0v-3.6c0,0,0-0.1-0.1-0.1C611.9,169.1,611.9,168.7,611.7,168.7z M610.6,167.1L610.6,167.1l-0.1,0.1L610.6,167.1z
    M610.1,168.9c-0.6-0.4-0.5-0.9,0-1.4H610h0.2l0,0c0.6,0.1,1,0.4,1,0.9c0,0.2-0.1,0.4-0.3,0.5C610.6,169,610.3,169,610.1,168.9z
    M611.2,170.6L611.2,170.6c0,0.1,0,0.1-0.1,0.1c0,0.2-0.1,0.4-0.1,0.5c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.1,0.3-0.3,0.4-0.4
		C611.1,170.7,611.1,170.6,611.2,170.6C611.1,170.6,611.2,170.6,611.2,170.6c0-0.3,0-0.6,0-0.9C611.7,170,611.6,170.3,611.2,170.6z"
      />
      <path
        class="st3"
        d="M576.1,199.5c-0.1,0.1-0.1,0.2-0.2,0.3c0.3,0.1,0.5,0.1,0.8,0.2l0,0C576.5,199.9,576.3,199.7,576.1,199.5z"
      />
      <path
        class="st3"
        d="M590.4,195.5c0,0.3-0.1,0.6-0.1,0.9c0.3,0.1,0.6,0.3,0.8,0.4c-0.2,0.1-0.4,0.1-0.6,0.2c0,0.1,0.1,0.1,0.1,0.2
		c0.2-0.1,0.4-0.3,0.6-0.4c0.5,0,1-0.3,0.8-0.6C591.6,195.8,591.4,195.1,590.4,195.5z"
      />
      <path
        class="st3"
        d="M572.8,189.1c-1.6-0.3-3.5-0.3-4.6-1.5l0,0c0.1,0.4-0.1,0.8-0.3,1.1c0,0,0.1,0,0.1,0.1
		c0.4,0.3,0.6,0.8,0.8,1.2c0.1,0.6-0.2,1.1-1,1.3c-0.2,0.1-0.4,0.1-0.6,0.2c-0.3,0.5-0.8,1-1.4,1.1c-0.6,0.1-1.2-0.3-1.3-0.9
		c0-0.1,0-0.2,0-0.4c-0.1-0.2-0.2-0.4-0.2-0.6c0.4-0.3,0.7-0.4,1.1-0.4c0.1-0.1,0.3-0.1,0.4-0.1c0.4,0,0.8,0,1.1,0.2
		c0.2-0.3,0-0.6-0.2-0.8h-0.1c-0.9,0.2-1.8-0.2-2.2-0.8c-0.1,0.3-0.1,0.7-0.2,1c0.1,0.1,0.1,0.2,0.2,0.3c-0.1,0-0.2,0-0.3,0.1
		c-0.5,2.2-1.1,4.3-1.7,6.4c0.7-0.2,1.3,0.3,1.9,0.3c0.2,0-0.3,0.7,0.3,0.3c0.1-0.1,0.2-0.4,0.1-0.5c0-0.2-0.2-0.3,0-0.6
		c0.4,0.2,0.8,0.4,1.3,0.6c0.4-0.4,0.8-0.8,1.3-1.3c0.5,0.1,1.1,0.1,1.7,0.2c0.5-0.2,0.9-0.5,1.4-0.7c-0.1-0.2-0.1-0.5-0.1-0.8
		c0-1.5,1.5-2.2,2.4-3.3c0.2-0.3,0.6-0.5,0.9-0.7c0.1-0.1,0.1-0.2,0.2-0.2C573.6,189.5,573.5,189.2,572.8,189.1z"
      />
      <path
        class="st3"
        d="M607.7,185c-2-0.8-3-2.6-2.7-4.4c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1-0.1-0.2-0.2-0.2-0.3c0.2-0.1,0.4-0.2,0.5-0.3
		l0,0c0.1-0.5,0.3-0.9,0.6-1.4c-0.2,0-0.3-0.1-0.4-0.1c-0.1-0.4-0.2-0.5-0.3-0.9c-0.6,0.4-1.1,0.6-1.5,0.9c0.1,0.1,0.1,0.2,0.2,0.4
		c0.3,0.1,0.7,0.3,1.1,0.4c-0.4,0.4-0.7,0.6-1.1,0.7c-0.1,0.4-0.3,0.7-0.4,1.1c-0.2-0.3-0.2-0.6-0.3-0.9l0,0l0,0l0,0l0,0
		c-0.2-0.6-1-0.9-1.8-0.9c-0.1,0-0.1,0-0.1,0c-0.2,0.3-0.5,0.7-0.8,1c-0.4,0.4-0.5,0.8-0.5,1.3c0,0.4-0.1,0.7-0.2,1.1
		c0.4,0.3,0.8,0.6,1.2,0.9c0.2-0.1,0.3-0.1,0.5-0.1c1.1-0.2,2.2,0.4,2.4,1.3c0.1,0.5-0.1,1-0.5,1.5c0.4,0.3,0.9,0.4,1.4,0.6
		c1.1,0.3,1.8,0.8,1.7,1.7c0.9,0.4,1.6,0.7,2.3,1c0,0.2-0.1,0.4-0.2,0.5c0.4,0.2,0.7,0.4,0.7,0.7c0.1,0.6-0.5,1.2-1.2,1.4
		c-0.8,0.2-1.5-0.2-1.6-0.8c0-0.2,0-0.4,0.1-0.5c-0.1,0-0.1,0-0.2,0c-1,0.3-1.3,0.7-1,1.6c0.2,0.6,0.6,1.1,1.1,1.6s0.7,0.9,0.7,1.5
		c0,0.2,0,0.4,0,0.6c0,0,0,0,0.1-0.1c1.2-0.7,2.3-0.6,2.9,0.4c0.6,0.9,0.4,1.8-0.5,2.6c-0.4,0.4-0.9,0.7-0.6,1.3c0,0,0,0,0,0.1
		c1.3,0.1,2.5,0.1,3.5-0.8v-1c-0.1-0.1-0.1-0.2-0.2-0.3c-0.4,0.3-1,0.6-1.5,0.2c-0.2-0.2-0.2-0.6-0.1-0.7c0.4-0.3,0.9-0.4,1.3-0.6
		c0.1-0.3,0.3-0.6,0.5-0.9V185C610.7,185.5,609.2,185.5,607.7,185z M601.4,179.9c0,0-0.1,0-0.1-0.1s0-0.2,0.1-0.3
		c0.1,0,0.2,0.1,0.2,0.1C601.6,179.7,601.5,179.8,601.4,179.9z M603.1,182.5c0-0.2-0.1-0.3-0.1-0.5c0.1,0,0.1,0,0.2,0
		c0.1,0.2,0.1,0.3,0.2,0.5C603.3,182.4,603.2,182.5,603.1,182.5z M611.8,186.2c0.1,0.6-0.4,1.1-1.1,1.2c-0.6,0.1-1.2-0.2-1.4-0.7
		c-0.1-0.5,0.4-1.2,1-1.3C611,185.3,611.7,185.6,611.8,186.2z"
      />
      <path
        class="st3"
        d="M562.3,202.1c-0.2-0.3-0.4-0.6-0.6-0.9c-0.6,0.1-0.8,0.4-0.9,0.8c0.2,0.2,0.2,0.4,0.1,0.8
		c-0.2,0-0.4,0-0.6-0.1c-0.2,0.5-0.4,1-0.7,1.5c0.2-0.5,0.3-1,0.4-1.4c0,0-0.1,0-0.1,0.1c-0.8-1-1.5-2-2.3-3.1
		c1.1-1.1,2.4-1.3,3.7-1.6c0.7-2.6,1.4-5.2,2-7.8c-1.1,0.1-1.9-0.3-2.7-0.8c-0.4-0.1-0.6-0.4-0.4-0.9c0.4,0.1,0.6,0.2,0.7,0.5
		c0.5-0.4,0.9-0.9,1.8-0.8c0.1,0,0.4-0.4,0.6-0.7l0,0c0.2-0.1,0.4-0.1,0.6-0.2c0.2-0.9,0.4-1.8,0.5-2.7c-0.5,0-1,0-1.6,0h-0.1
		c-0.1,0.1-0.3,0.2-0.4,0.3c0.1,0.1,0.3,0.2,0.4,0.4c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1-0.1-0.3-0.3-0.4-0.4c-0.2,0.1-0.4,0.1-0.7,0.2
		c-0.2,0.2-0.4,0.4-0.6,0.5l0,0c0.1,0.5,0.1,0.9,0.3,1.3c0.2,0.4-0.5,0.9-1.1,0.8c-0.4-0.1-0.9-0.3-1.2-0.5
		c-0.2-0.1-0.4-0.3-0.4-0.6c-0.1,0-0.2,0-0.2,0l0,0c-0.1,0.1-0.2,0.1-0.2,0.2c0-0.1-0.1-0.1-0.1-0.2c-0.6,0-1.2-0.1-1.7-0.4
		c-0.2,0.2-0.4,0.3-0.6,0.5c-0.1,0-0.2,0.1-0.2,0.1c0.2,0,0.5-0.1,0.9-0.1c-0.5,0.4-1.1,0.7-1.7,0.8v0.1c0,0.7-0.2,1.4-0.6,2
		c-0.1,0.1-0.2,0.2-0.3,0.3c0.5-0.1,1,0,1.6,0.3c0.7,0.3,1.5,0.4,2.5,0.6c-1,0.9-1.8,1.6-2.6,2.3c-2-0.2-2.7-0.7-3.1-1.9
		c-0.2,0-0.5-0.1-0.7-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.4,0c-0.5,1.8-1.1,3.5-1.8,5.3c0.5,0,1,0,1.4,0.2
		c0.1-0.7,0.7-0.9,1.9-1.2c0.2,0,0.4-0.1,0.5-0.1c1.3,0,2.6,0.1,3.9,0.1c0,0.1,0,0.2,0,0.3c-0.3,0-0.5,0-0.8,0.1l-0.1,0.1
		c0.4,0.1,0.9,0.2,1.3,0.2c0,0.1,0,0.1,0,0.2c-0.3,0-0.5,0.1-0.9,0.1c-0.2,0.3-0.4,0.6-0.6,0.9c-0.3,0.5-0.6,0.7-1.3,0.8
		s-1.4,0.3-2.1,0.5c-0.1-0.3-0.1-0.4-0.1-0.7c-0.1,0-0.1,0-0.2,0c0,0.1,0.1,0.2,0.1,0.2c0.4,1.4-0.6,2.5-2.9,3.3
		c0.7,0.7,1.6,0.8,2.5,0.5c0.9-0.4,1.6-0.2,2.4,0c0.8,0.3,1.7,0.4,2.5,0.6c0.7,0.9,1,1.8,0.4,3.1c1.6-0.5,3-0.8,4.5-1.3
		c-0.1,1.4-0.1,1.4,1,1.6c0.3-0.5,0.7-1,0.9-1.5c0.1-0.3,0.2-0.8,0.1-0.9C562.4,203.6,562.6,202.7,562.3,202.1z M550.9,193.3
		c0,0.3-0.3,0.5-0.7,0.6c0.1-0.2,0.1-0.4,0.2-0.6l-0.1-0.1c0.1,0,0.1,0,0.2,0c0.1-0.1,0.1-0.3,0.2-0.5
		C550.9,192.9,550.9,193.1,550.9,193.3c0-0.1,0.1-0.1,0.1-0.1S551,193.3,550.9,193.3z M551.4,195c-0.1-0.1-0.2-0.2-0.2-0.2
		s0.1-0.1,0.2-0.2c0.1,0.1,0.1,0.1,0.1,0.2S551.4,194.9,551.4,195z M552.1,193.3L552.1,193.3l0.1-0.1L552.1,193.3z M555.4,198.6
		C555.4,198.7,555.4,198.7,555.4,198.6C555.4,198.7,555.4,198.7,555.4,198.6c-0.1,0.2-0.2,0.2-0.3,0.3c-0.1,0-0.1-0.1-0.2-0.1
		C555.1,198.8,555.2,198.8,555.4,198.6C555.4,198.7,555.4,198.7,555.4,198.6C555.4,198.7,555.4,198.7,555.4,198.6c0-0.1,0-0.1,0-0.2
		c0.1,0,0.1,0,0.2,0.1C555.6,198.5,555.5,198.6,555.4,198.6z M560.7,192.3c0,0,0,0.1,0.1,0.1l-0.1,0.1
		C560.7,192.4,560.6,192.4,560.7,192.3C560.6,192.3,560.6,192.2,560.7,192.3z M560.4,190.6l-0.1,0.1L560.4,190.6L560.4,190.6z
    M559.4,189.1c0.1,0.1,0.2,0.1,0.2,0.2c-0.3,0.2-0.5,0.3-0.8,0.5c-0.1-0.1-0.1-0.1-0.2-0.2C558.9,189.4,559.2,189.2,559.4,189.1z
    M560.6,195.9c0.6,0.4,1,0.9,0.4,1.6c-1.9,0.2-2.4-0.1-2.9-1.6C559,195.4,559.9,195.5,560.6,195.9z M557.3,192.6
		c0.9,0,1,0.5,1.2,1.2C557.6,193.6,557.2,193.3,557.3,192.6z"
      />
      <path
        class="st3"
        d="M591.8,176.1c0.1,0.3,0.6,0.5,0.1,0.8c0.2,0.1,0.3,0.3,0.5,0.4c0.2-0.5,0.5-0.9,0.9-1.4l0.1-0.1
		c-0.2-0.4-0.5-0.8-0.8-1.2C591.5,175.1,591.6,175.6,591.8,176.1z"
      />
      <path
        class="st3"
        d="M533.7,70.8c0,0.7,0,1.4,0,2c0,0.1,0,0.2-0.1,0.3c0.6-0.7,1.1-1.4,1.7-2.1c0.1-0.1,0.1-0.2,0.2-0.3
		C534.9,70.9,534.3,70.8,533.7,70.8z"
      />
      <path
        class="st3"
        d="M309.8,256.6c-0.3,0-0.5,0.1-0.8,0.1c0.6,0.4,1.2,0.8,1.8,1.2c0.4,0,0.8,0.1,1.3,0.3c-0.2-0.7-0.3-1.4-0.4-2
		C311,256.3,310.4,256.5,309.8,256.6z M310.9,257.2c-0.1-0.1-0.3-0.2-0.4-0.3c0.1,0,0.2-0.1,0.3-0.1c0.1,0.1,0.3,0.2,0.4,0.2
		C311.1,257.1,311,257.1,310.9,257.2z"
      />
      <path
        class="st3"
        d="M595.9,65.2c-0.1-0.4-0.1-0.8-0.2-1.2c-0.2,0.2-0.5,0.3-0.7,0.4c0.2,0.1,0.5,0.1,0.4,0.2
		C595,65.2,595.2,65.3,595.9,65.2z"
      />
      <path
        class="st3"
        d="M515.3,23.2c0.5,0.4,1,0.8,1.7,1.3c-0.2-1-0.4-1.7-0.5-2.5c-1.1,0.7-2.4,0.9-3,1.9c-0.6,0.7-1.2,1.4-2.1,2.4
		c1.3-0.3,2.1-0.6,3-0.8C514.6,24.8,514,23.8,515.3,23.2z"
      />
      <path
        class="st3"
        d="M527.7,28c0,0.1,0,0.1,0,0.2c0.1,0,0.2-0.1,0.2-0.1S527.8,28.1,527.7,28z"
      />
      <path
        class="st3"
        d="M308.5,258.3c0.1-0.1,0.3-0.2,0.5-0.2c-0.1-0.1-0.2-0.1-0.3-0.2C308.6,258.1,308.5,258.2,308.5,258.3
		C308.4,258.3,308.5,258.3,308.5,258.3z"
      />
      <path
        class="st3"
        d="M347.5,91.5c-0.1,0.1-0.1,0.2-0.2,0.3c0.2,0,0.3,0,0.5,0.1C347.7,91.8,347.6,91.6,347.5,91.5z"
      />
      <path
        class="st3"
        d="M313.4,261.1c0,0.1,0,0.1,0,0.2c0.1,0,0.2,0,0.3,0C313.6,261.2,313.5,261.2,313.4,261.1z"
      />
      <path
        class="st3"
        d="M570.2,36.1c0.1,0,0.2-0.1,0.3-0.1c-0.2-0.2-0.3-0.4-0.5-0.6C570.1,35.7,570.2,35.9,570.2,36.1z"
      />
      <path
        class="st3"
        d="M586,72.9c1-0.3,1.2-1.3,2.5-1.8c-1.8-0.1-2.6-1-3.6-1.6c0,0.9,0.3,1.7,0.6,2.4c0.2-0.1,0.3-0.1,0.5-0.1
		c0,0.3-0.1,0.6-0.1,0.9C585.9,72.7,586,72.8,586,72.9z"
      />
      <path
        class="st3"
        d="M612.1,59.2c-0.1,0-0.3,0-0.4,0c-0.1,0.1-0.1,0.2-0.1,0.4c0.1,0,0.3-0.1,0.4-0.2C612,59.4,612,59.2,612.1,59.2
		z"
      />
      <path
        class="st3"
        d="M532.1,75c0.2-0.3,0.5-0.6,0.7-0.9C532.4,74.4,532.2,74.7,532.1,75z"
      />
      <path
        class="st3"
        d="M323.6,247.9c0.1-1.3,2-2.5,3.5-2.5c-0.5-0.3-1-0.6-1.5-0.9c-0.2-0.1-0.3-0.9-0.3-0.9c0.6-0.3,1.4-0.8,1.9-0.6
		c0.8,0.2,1.5,0.6,2.2,1c0-0.7,0.5-1.4,1.2-1.9c-0.1-0.1-0.2-0.1-0.3-0.2c-0.3-0.2-0.4-0.5-0.6-0.9c-0.4,0.3-0.9,0.6-1.5,0.7l0,0
		l0,0c0,0,0,0-0.1,0c-1.5,0.3-2.8-0.4-3-1.6c0-0.1,0-0.2,0-0.3c-0.8,0-1.4-0.4-1.5-1.1c-0.2-0.8,0.5-1.7,1.5-1.9
		c0.9-0.2,1.8,0.2,2.1,0.9h0.1c1.5-0.3,2.9,0.4,3.1,1.5c0.1,0.4,0,0.7-0.1,1c0.5-0.3,1-0.5,1.3-0.4l0.1,0.1
		c-0.2-0.4-0.2-0.8-0.2-1.2c0-1.2-0.4-2.3-1.2-3.3c-0.3-0.3-0.5-0.7-0.7-1.1c-0.2,0-0.3,0-0.5,0c-0.8-0.2-1.1-0.6-1.1-1.2
		c-1.3-0.2-1.2-1.6-2.4-1.8c-0.1,0-0.2-0.2-0.2-0.4c0,0,0,0,0-0.1c-0.6,0.1-1.2,0.3-1.8,0.4c-0.1,0-0.1,0-0.2,0
		c-0.2,0.6-0.5,1.3-1.1,1.9c-0.4,0.4-0.8,0.9-1.1,1.4c0.3-0.2,0.7-0.3,1-0.5c-0.1,0-0.3-0.1-0.4-0.2c0.3-0.3,0.5-0.6,0.9-1
		c0.2,0.3,0.5,0.5,0.4,0.7c-0.1,0.1-0.1,0.2-0.2,0.3c0.2,0,0.4,0,0.7,0c0.7,0.2,1.4,0.2,2.1,0c0.7-0.1,1.3,0.1,1.4,0.6
		c0.1,0.4,0.1,0.9-0.1,1.3c-0.6,1.1-2.3,0.8-3.2,1.5c-0.3,0.2-0.9,0.2-1.4,0.2c-0.2,0-0.4,0-0.5-0.1c-0.6-0.5-1.4-0.4-2.1-0.3
		c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.2,0,0.5-0.1,0.9c-0.2-0.2-0.3-0.3-0.4-0.4l0,0l0,0c-0.2-0.2-0.3-0.3-0.5-0.4
		c-0.2,0.1-0.3,0.3-0.5,0.4c-0.6-0.1-0.8-0.2-1-0.3c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.1,0,0.2,0c1.2,0,2.1,0.4,2.4,1.4
		c0.1,0.3,0.3,0.8,0.6,1c1,0.6,2.1,1.2,3.2,1.7c0.9,0.5,1.4,1.1,1.3,2s-0.7,1.7-1.8,2.1c-0.4,0.1-0.8,0.2-1.2,0.4
		c1.2,0.4,1.3,0.7,1.4,1.9c-0.6,0.2-1.2-0.1-1.8,0.1c0,0.1,0,0.2,0,0.2c0.8,0.5,1.6,1,2.4,1.5C324,249.2,323.5,248.7,323.6,247.9z
    M328.4,242.5c0.1,0,0.1,0.1,0.2,0.2c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0-0.2-0.1-0.2-0.2C328.2,242.6,328.3,242.5,328.4,242.5z"
      />
      <path
        class="st3"
        d="M447,81.2c-0.6,0.7-1.3,1.2-2.2,1.5c0.2,0,0.4,0.1,0.6,0.2c-0.2,0.4-0.4,0.7-0.6,0.9c0.3,0,0.6,0,0.9,0.1
		c0.4,0,0.7,0,1.1,0.1c0.1-0.5,0.2-0.9-0.1-1.3c-0.1-0.1-0.1-0.3,0-0.4C447.3,81.8,447.2,81.5,447,81.2z M445.9,83.5
		c0-0.1-0.1-0.1-0.1-0.2c0.1,0,0.2-0.1,0.3-0.1l0.1,0.1C446.1,83.4,446,83.5,445.9,83.5z"
      />
      <path
        class="st3"
        d="M443.8,43.8c0.8,0,1,0.5,1,0.9s-0.3,0.8-0.5,1.2c0.4,0.1,0.8,0.3,1.2,0.4c-0.1-0.1-0.3-0.2-0.5-0.3
		c-0.1,0-0.1-0.5,0-0.7c0.3-0.3,0.6-0.2,0.9,0.1c0.1,0.1,0.2,0.2,0.4,0.4c0.4-0.4,0.7-0.8,1.1-1.1c-0.4-1-1.2-1.1-2.4-0.8
		c0-0.6,0-1.1-0.1-1.6c-0.5,0.1-1,0.2-1.7,0.4c0,0.2-0.1,0.3-0.1,0.5C443.3,43.6,443.5,43.8,443.8,43.8z M446,44.8L446,44.8
		L446,44.8L446,44.8z"
      />
      <path
        class="st3"
        d="M306,266.4c-0.1-0.1-0.2-0.2-0.4-0.2c-0.4,0.3-0.9,0.5-1.3,0c-0.2-0.2-0.2-0.6-0.1-0.7c0.1,0,0.1-0.1,0.2-0.1
		c-0.2-0.1-0.3-0.2-0.5-0.3c0,0.5-0.3,1-0.8,1.5c-0.4,0.4-0.9,0.7-0.6,1.3c0,0,0,0,0,0.1c1.3,0.1,2.5,0.1,3.5-0.8v0.4
		c0.2,0,0.4,0.1,0.6,0.1c0.4,0.2,1.1-0.2,1.5,0.4c0.1,0.1,0.3,0.1,0.6,0.1c-0.7-0.5-1.5-1-2.2-1.5
		C306.3,266.6,306.1,266.5,306,266.4z"
      />
      <path
        class="st3"
        d="M600.2,25.7C600.2,25.8,600.1,25.8,600.2,25.7c0,0.1,0,0.2,0.1,0.2v-0.1C600.3,25.8,600.3,25.8,600.2,25.7z"
      />
      <path
        class="st3"
        d="M457.8,59.5c0,0.1,0,0.2,0,0.3c0.1-0.1,0.1-0.2,0.2-0.2C458,59.6,457.9,59.6,457.8,59.5z"
      />
      <path
        class="st3"
        d="M449.4,50c-0.1-0.3-0.3-0.5-0.5-0.8c0.1,0.3,0.3,0.6,0.4,0.9C449.3,50.1,449.4,50.1,449.4,50z"
      />
      <polygon class="st3" points="457.7,62 457.6,62 457.7,62.1 	" />
      <path
        class="st3"
        d="M481.1,57.6c-0.5-0.3-0.9-0.6-1.2-1l-0.1-0.1c0.1,0.6-0.4,0.8-1.2,0.9c-0.2-0.4-0.5-0.9-0.7-1.4l0,0
		c0,0,0,0,0-0.1l0,0l0,0c0.3-0.2,0.5-0.4,0.6-0.6c-0.4-0.4-0.8-0.8-0.9-1.5c0.8-0.5,1.7-1,2.6-1.4c0.2-0.1,0.7,0.3,1,0.2
		c0.9-0.3,1.8-0.7,2.6-1c0-0.3,0-0.5-0.1-0.7c-0.2,0.2-0.4,0.4-0.6,0.7c-0.4-0.3-0.6-0.4-1-0.7c0.4-0.5,0.8-0.9,1.2-0.9
		c0.5-0.7,0.9-1.3,0.7-2.1c-0.2-0.2-0.5-0.5-1-0.9c0.1-0.1,0.3-0.3,0.4-0.3c0.2,0,0.4-0.1,0.5-0.2c-0.3-0.1-0.6-0.3-1-0.6
		c0.6-0.4,1-0.7,1.4-0.9c0.2-0.1,0.6-0.1,0.8,0c0.4-0.6,0.9-1,1.5-1.5c0.1-0.1,0.3-0.2,0.4-0.3c0-0.2-0.1-0.4-0.2-0.6
		c-0.3-0.5-0.1-1,0.4-1.6c-0.4,0.1-0.7,0.3-1.1,0.4l-0.1-0.1c0.1,0.3-0.2,0.6-0.4,1c-0.6-0.1-1.2,0-1.3-0.5c-0.5,0.1-1,0.2-1.5,0.3
		c0.3,0.3,0.5,0.5,0.8,0.8c-0.5-0.1-1-0.1-1.5-0.2c0,0-0.1,0-0.1,0.1c0,0,0,0,0-0.1c-0.4-0.1-0.8-0.1-1.3-0.2c0-0.3-0.1-0.7-0.2-1.2
		c0.3-0.1,0.6-0.2,0.8-0.1c0.3,0.1,0.5,0.1,0.8,0.1c0.1-0.1,0.2-0.2,0.4-0.3c0,0,0,0,0-0.1c0.1-0.1,0.1-0.1,0.1-0.2
		c0,0-0.1,0.1-0.1,0.2l0,0l0,0l0.1-0.1c0.4-0.5,0.3-1,0-1.5c-0.4-0.5-0.9-1-1.5-1.6c1.4-0.3,0.9-1.3,1-1.9c0.1-0.6-0.6-1.5-1.5-1.5
		c-0.8,0-1.4-0.1-2.2-0.2c-0.3-0.8,0.2-1.8-1-2.2l0,0h-0.1c-0.1,0.4-0.2,0.8-0.9,0.6c-0.2-0.4-0.1-0.8,0.4-1.1l0,0
		c-0.4,0-0.8-0.1-1.2-0.1c-0.8,0.1-1.5,0-2.1-0.4c0,1-0.1,2-0.1,3c0,0.2-0.1,0.5,0,0.6c1,1,0.2,2.4,0.7,3.5c0.3,0.6,0.2,1.3-0.3,2
		c-0.5,0.6-0.3,1.3,0.2,1.9c0.7,0.9,1.2,1.9,1.3,3.1c0.1,0.9-0.2,1.5-0.6,2.1c0.1,0,0.3,0.1,0.4,0.1c-0.3,0.3-0.5,0.5-0.7,0.6
		c-0.1,0-0.2,0-0.3-0.1c-0.1,0.1-0.2,0.2-0.4,0.3c-0.3,0.3-0.7,0.5-1,0.7c0.4,0.9,1.2,0.8,2,0.5l0.1,0.1c0-0.1,0.1-0.1,0.1-0.2
		c0.1,0,0.2,0,0.3,0c0,0.1-0.1,0.3-0.1,0.4c0.4,0.6,0.5,1.2,0.4,1.8c-0.4,0-0.8,0.1-1.2,0c-0.3-0.1-0.5-0.4-0.8-0.5
		c-1.4-0.5-1.4-0.5-1.3-1.9c-0.1,0-0.1-0.1-0.2-0.1l0,0c0.3,0.4,0,0.8,0.1,1.3c-0.3-0.1-0.5-0.2-0.6-0.3c-0.1,0.2-0.2,0.3-0.4,0.5
		c-0.1,0-0.2-0.1-0.2-0.1c0.1-0.2,0.3-0.4,0.4-0.5c-0.2-0.2-0.1-0.4,0.2-0.8c-0.1,0-0.1,0-0.2,0c-0.4-0.1-0.7-0.3-1-0.4
		c-1.8-0.2-2.3-0.7-2-2.2c0-0.1,0-0.3,0-0.4l0,0l-0.1-0.1h-0.1h0.1l0,0c0,0,0.1,0,0.1,0.1l0,0c0.3-0.2,0.6-0.4,0.9-0.5
		c1.3-0.5,2.4-0.1,2.7,0.8c0.9,0,1.6-0.5,2.2-1c0-1.2-0.3-2.2-1.3-3c-0.6-0.5-0.7-1-0.7-1.7c0.1-2.2-0.5-4.4-1.7-6.3
		c-0.4,0-1,0-1.4-0.1c-1.3-0.4-2.3,0.3-3.2,1c-0.5,0.4-0.3,0.8,0.2,1.2c0.6-0.2,1.3-0.9,1.9-0.2c0.2,0.2,0.3,0.7,0.2,1
		c-0.3,0.7-1,0.7-1.9,0.3c0.2,1.6-1.2,2.4-1.9,3.7c-0.9-0.6-1.9-1.2-2.7-1.9c-0.8-0.6-1.5-1.2-2.4-2c-0.1,0-0.2-0.1-0.4-0.1
		c0.1,0,0.1-0.1,0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.3,1.5-0.6,2.7-0.8,4c-0.1,0.4,0,0.8,0.1,1.1c0.1,0.1,0.1,0.3,0.1,0.4
		c0.2-0.1,0.4-0.1,0.6-0.2c0.5,0.3,1,0.6,1.4,0.9l0,0c0.1,0.1,0.2,0.2,0.3,0.3c0-0.1,0-0.3,0-0.4l0,0c0.5-0.1,0.7-0.9,1.5-0.4
		c-0.2,0.4-0.4,0.9-0.6,1.5c0.5,0.2,1,0.6,1.4,0.6c1.2-0.2,1.4,0.3,1.5,1.1c0,0.3,0.2,0.7,0.3,0.9c-0.6,0.7-1.1,1.3-1.6,2
		c1.1,0.8,1.6,0.2,2.2-0.4c-0.6-0.5-0.7-0.8-0.5-1.3c0.2-0.4,0.5-0.6,1-0.7l-0.1-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0,0.1,0.1,0.3,0.1
		c-0.1,0.1-0.1,0.1-0.2,0.2c0.2,0,0.5,0,0.8,0c-0.3,0.6-0.5,1.1-0.8,1.7c0.7,0.2,1.4,0.3,1.5,1.1c0,0.1,0.4,0.1,0.6,0.2
		c0.3,0.1,0.6,0.2,0.9,0.4c0,0,0,0,0-0.1c0.4,0.1,0.7,0.2,1.1,0.3c0,0.1-0.1,0.2-0.1,0.3c-0.3-0.1-0.7-0.2-1-0.2
		c-0.4,0.3-0.8,0.6-1.3,1c0.6-0.1,1.1-0.1,1.6-0.1c-0.3,0.5-0.5,0.8-0.7,1.2c0.6,0.5,1.4,0.6,1.5,1.4c0,0.3,0.7,0.8,1,0.7
		c1-0.2,1.5,0.5,2.4,0.6c-0.1-1.2,1-1.6,1.9-2.2c0.1,0.2,0.2,0.3,0.2,0.5c0.1,0,0.2,0,0.4,0l0,0l0,0c-0.4-0.6-0.1-1.1,0.6-1.6
		c0.2,0.7-0.2,1.1-0.6,1.6c0,0,0,0,0,0.1l0,0c1.1,1-0.2,2.2,0,3.3c-0.5,0.4-0.6,0.8-0.7,1.3c0.2,0,0.3,0,0.6,0
		c0.2,0.1,0.4,0.1,0.9,0.3c-0.2,0.4-0.3,0.8-0.5,1c-0.3,0.3-0.7,0.4-1.1,0.4c0.1,0.1,0.3,0.2,0.4,0.2c0.4-0.1,0.8-0.2,1.2-0.3
		c0.1-0.1,0.3-0.2,0.5-0.3l0.1,0.1c0.3-0.1,0.6-0.1,0.8-0.2C479.5,58.4,480.2,58,481.1,57.6z M483.3,45C483.4,45,483.4,45,483.3,45
		c0.1,0.1,0,0.1,0,0.2C483.3,45.1,483.3,45,483.3,45z M481.5,40c0.1,0.1,0.2,0.1,0.2,0.2c0,0.1-0.1,0.2-0.2,0.4
		c-0.1-0.1-0.3-0.2-0.3-0.2C481.3,40.3,481.4,40.1,481.5,40z M473.7,45.1c0,0-0.1,0-0.1,0.1c0,0,0-0.1-0.1-0.1
		C473.6,45,473.7,45,473.7,45.1C473.7,45,473.7,45.1,473.7,45.1z M473.3,44.2c0.1,0,0.3,0.2,0.4,0.3c-0.2,0.1-0.3,0.3-0.5,0.4
		c-0.1,0-0.2-0.2-0.4-0.3C473,44.4,473.1,44.2,473.3,44.2z M469.7,40.4c-0.1,0-0.2,0-0.3,0c0-0.1,0.1-0.1,0.1-0.2c0.1,0,0.2,0,0.3,0
		C469.8,40.3,469.7,40.4,469.7,40.4z M470.8,42.3c0.3,0.3,0.3,0.3-0.5,0.9c-0.1-0.3-0.2-0.6-0.4-1.1
		C470.4,42.1,470.7,42.2,470.8,42.3z M469.5,36.3c0.1,0,0.3,0,0.5,0.1c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0-0.3-0.1-0.4-0.1
		C469.3,36.5,469.3,36.3,469.5,36.3z M465.3,41.6c-0.1-0.1-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.5c0.2-0.1,0.4,0.1,0.8,0.2
		C465.7,41.3,465.5,41.4,465.3,41.6z M471.8,52.5c0,0-0.1,0-0.1-0.1c0.1-0.1,0.2-0.1,0.3-0.2l0.1,0.1
		C472,52.4,471.9,52.4,471.8,52.5z M479.2,48.1c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.2,0.2-0.4,0.3-0.7c0.1,0,0.2,0.1,0.3,0.1
		C479.5,47.7,479.3,47.9,479.2,48.1z M479.1,41.4c0-0.1,0-0.2,0-0.2c0.1-0.1,0.2-0.1,0.3-0.2c0,0.1,0.1,0.1,0.1,0.2
		C479.4,41.3,479.3,41.3,479.1,41.4z M479.6,45.8c0.1,0,0.2,0,0.3,0c0,0.4,0,0.8-0.1,1.2c-0.1,0-0.2,0-0.4,0
		C479.5,46.6,479.6,46.2,479.6,45.8z M480.3,52.2C480.2,52.2,480.2,52.2,480.3,52.2C480.2,52.2,480.2,52.2,480.3,52.2
		c-0.1,0.1-0.1,0.2-0.1,0.2v-0.1C480.1,52.2,480.2,52.2,480.3,52.2C480.2,52.2,480.3,52.1,480.3,52.2
		C480.3,52.1,480.3,52.2,480.3,52.2z M479.9,50.6c-0.1-0.3,0.1-0.6,0.1-0.9c0.1,0,0.2,0,0.3,0c0.3,0.6,0.6,1.2,0.9,1.8
		C480.2,51.7,480.1,51.1,479.9,50.6z M483.6,48.7c-0.7,1-1.3,0.4-1.9,0C482.6,47.8,483,48.6,483.6,48.7z M480.3,47.1
		c0-0.1,0-0.1,0.1-0.2l0,0c0.2-0.1,0.4-0.2,0.8-0.2l0,0l0,0c-0.2-0.3-0.3-0.5-0.5-0.9c0.4-0.2,0.7-0.5,1.2-0.8
		c0.1,0.2,0.3,0.4,0.2,0.5c-0.3,0.4-0.6,0.8-0.8,1.2c0,0,0,0,0,0.1h-0.1c-0.2,0.5-0.5,0.9-0.7,1.4v-0.1c-0.2,0.2-0.4,0.3-0.4,0.5
		c-0.1-0.1-0.2-0.1-0.4-0.2C479.9,48,480,47.6,480.3,47.1L480.3,47.1z M479.6,38.8c0,0.2,0,0.4,0.1,0.6c0.1,0.1,0.2,0.1,0.3,0.2
		c-0.4,0.4-0.6,1-1.1,1.2c-0.6,0.2-1.3-0.1-1.5-0.8C478.2,39.5,478.9,39.2,479.6,38.8z M477.7,38.6c0.1,0.1,0.1,0.3,0.2,0.4
		c-0.3,0.1-0.7,0.2-1,0.3c0-0.1-0.1-0.1-0.1-0.2C477.1,39,477.4,38.8,477.7,38.6z M474.1,33.3c1.3-0.3,1.9,0.2,2.1,1.1
		C474.9,34.9,474.6,34.8,474.1,33.3z M475.6,38.9c-0.1,0-0.4-0.2-0.4-0.2c0.1-0.3,0.3-0.5,0.5-0.7c0.1-0.1,0.4,0.1,0.8,0.2
		C476.1,38.5,475.8,38.7,475.6,38.9z M476.6,38.2c0.1,0,0.2,0,0.3,0c0,0.1-0.1,0.2-0.1,0.3h-0.2C476.5,38.4,476.5,38.3,476.6,38.2z
    M476.5,42.3c0.4-0.5,0.7-0.9,1-1.3c0.2,0.5,1,0.9,0.2,1.4C477.5,42.6,477.1,42.4,476.5,42.3z M477.6,55.9h-0.1c0,0,0,0,0-0.1
		c0,0,0.1,0,0.1-0.1C477.6,55.8,477.6,55.9,477.6,55.9z M477.2,44.3h-0.1H477.2L477.2,44.3z M477,45.1c-0.1,0-0.1,0-0.2-0.1
		c0.1-0.2,0.2-0.4,0.3-0.6c0.1,0,0.2,0.1,0.3,0.1C477.2,44.6,477.1,44.9,477,45.1z M477.7,58.1c-0.1,0-0.2,0-0.3,0l0.1-0.1
		c0.1,0,0.2,0,0.3,0C477.8,58,477.7,58.1,477.7,58.1z"
      />
      <path
        class="st3"
        d="M580.5,22.9c0,0.1,0,0.1-0.1,0.2h0.1C580.5,22.9,580.5,22.9,580.5,22.9z"
      />
      <path
        class="st3"
        d="M493.3,62.3c-0.2-0.2-0.4-0.5-0.7-0.8c0.2,0.4,0.4,0.8,0.6,1.1c0.5,1,1,1.3,1.8,1.1c0-0.1,0-0.2,0.1-0.4
		c-0.8-1-0.8-1,0.2-1.7v-0.1C494.7,61.8,494.1,62,493.3,62.3z"
      />
      <path
        class="st3"
        d="M434.9,52.7c-0.1-0.6,0.2-0.8,1.6-0.9c0.3-1.4,0.3-1.4-0.9-2.2c-0.5,0.2-0.9,0.4-1.4,0.7c0,0,0.1,0,0.1,0.1
		c0.1,0.1-0.1,0.5-0.2,0.5c-0.3,0.1-0.7,0.3-1,0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.3,0.2-0.7,0.3-1,0.5c-0.4,0.2-0.6,0.7-0.9,1
		c0.6,0.9,2.2,1.6,3.5,1.6c0.4,0,0.7,0,1,0.1c0.1-0.1,0.2-0.2,0.3-0.4c0.1-0.1,0.3-0.2,0.4-0.3c-0.2-0.3-0.3-0.6-0.5-0.8
		C435.4,52.6,435.2,52.7,434.9,52.7z"
      />
      <path
        class="st3"
        d="M448.4,59.1c0.3-0.1,0.6-0.1,1-0.1c0-0.1,0.1-0.3,0.3-0.4c0.5-0.4,1.1-0.8,1.8-1.3l0.1,0.1c0-0.2,0-0.4,0-0.7
		c0-0.1,0-0.2,0-0.3c-0.2,0.1-0.3,0.1-0.5,0.2c-0.7,0.2-1.3,0.1-1.7-0.4c0.5-0.7,1-1.4,1.5-2.2c-1.8-0.5-1.7-1.5-1.3-2.6
		c0.1-0.2,0.1-0.3,0.2-0.5c0-0.1-0.1-0.2-0.1-0.2c-1.2-0.1-1.1,1.4-2.3,1.4c-0.2-0.2-0.5-0.5-0.7-0.8c-0.2,0.9-1.1,1.7-2.2,1.6
		c-0.7-0.1-1,0.2-1.4,0.5c-0.9,0.6-2,0.7-2.8,0.2c-0.9-0.7-1.8-0.7-3-0.7c0,0.1,0,0.3,0,0.5c0.3,0.1,0.6,0.3,0.9,0.7
		c-0.1,0.6-0.5,1-1,1.3c0.1,0.2,0.1,0.4,0.1,0.6c0.1,0.9,0.7,1.3,1.4,1.8c0.6,0.4,1,0.8,1.6,1.2c0.4,0.3,0.7,0.5,1.1,0.7
		c1.4,0.7,2,1.9,1.6,3.2c-0.2,0.6-0.5,1.1-0.9,1.4l0,0c-0.1,0.1-0.3,0.3-0.5,0.4h-0.1c-0.5,0.3-1.2,0.5-1.9,0.6
		c-0.4,0-0.7,0.1-1.1,0.2c-0.7,0.2-1.4,0.4-2.2,0.7c0.4,0.1,0.8,0.2,1.2,0.3c0.8,0.1,1.5,0.2,2.3-0.3c1-0.6,2.4-0.1,2.4,0.8
		c-0.1,1.2,0.6,1.9,1.1,2.8c0,0.1,0,0.2,0,0.6c-2-0.6-3.8-1.1-5.6-1.7c-0.1,0.3-0.2,0.5-0.2,0.7c1.1-0.2,2.3,0.1,3.1,0.7
		c0.9,0.7,1.4,1.2,1.5,2c0.4-0.1,0.7-0.1,1.1-0.2c0.3-1.3,1.5-2.3,3.2-2.7h0.1c0.1-0.2,0.2-0.3,0.3-0.5c0-0.1,0.1-0.1,0.1-0.2
		c-0.6,0.2-1.2,0.4-1.7,0.3s-0.8-0.7-1.2-1.2c0.6-0.3,1.2-0.5,1.7-0.7s1.1-0.5,1.7-0.8c-0.1,0.7-0.1,1.2-0.2,1.9
		c0.6-0.9,1.2-1.9,1.8-2.8c-0.2-0.2-0.4-0.5-0.5-0.8c-1.4,0-2.5-0.8-2.8-2C445.4,61.1,446.6,59.5,448.4,59.1z M441.9,57.3
		c-0.4,0.3-0.8,0.5-1.2,0.1c-0.1-0.1,0-0.3,0.1-0.4c0.2-0.3,0.3-0.3,1.3,0C441.9,57.2,441.9,57.3,441.9,57.3z M442.9,65.7
		c-0.3,0.1-0.5,0.2-0.8,0.3c0-0.1-0.1-0.2-0.1-0.3c0.3-0.1,0.6-0.1,0.9-0.2V65.7z M448,55.2c0.1,0,0.1,0.1,0.2,0.1
		c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1-0.1-0.1-0.1-0.2-0.2C447.8,55.3,447.9,55.2,448,55.2z M448,58.4c0,0,0.2,0.1,0.5,0.3
		c-0.3,0.2-0.4,0.3-0.6,0.3c-0.1,0-0.3-0.1-0.4-0.1C447.6,58.7,447.8,58.5,448,58.4z M446.9,56.3L446.9,56.3v0.2V56.3
		C446.9,56.3,446.9,56.3,446.9,56.3z M444.4,65.1L444.4,65.1L444.4,65.1c-0.1,0-0.1-0.1-0.1-0.1S444.4,65,444.4,65.1L444.4,65.1z
    M444.4,58.2c0-0.7,0.6-1,1.3-1.2c0.8,0.5,1,1.2,1.2,1.9c0.1,0.5-0.3,0.7-1,0.8C445.4,59.1,444.9,58.6,444.4,58.2z"
      />
      <path
        class="st3"
        d="M439.4,50.1c1.2-0.8,2.4-1.2,3.8-0.6c0-0.3-0.1-0.5-0.1-0.9c-0.6-0.2-1.2-0.5-1.8-0.8
		c-0.2,0.2-0.3,0.5-0.5,0.7l0,0c0.1,0,0,0.3-0.1,0.4c-0.1,0-0.2,0.1-0.4,0.1c-0.3,0.3-0.8,0.6-1.2,0.9c-0.2,0.1-0.4,0.1-0.6,0.2
		c0.1,0.1,0.2,0.3,0.3,0.4C439,50.4,439.2,50.3,439.4,50.1z"
      />
      <path
        class="st3"
        d="M507.4,50.2c-0.4-0.4-0.6-1-1.5-0.7c0.1,0.4,0.3,0.8,0.2,1.2c-0.1,0.4-0.5,0.7-0.8,1.1
		c1.3,0.7,2.2-0.3,3.2-0.7C507.8,51,507.7,50.5,507.4,50.2z"
      />
      <path
        class="st3"
        d="M443,45.7c-0.2-0.2-0.1-0.6-0.1-0.9c-0.1,0.7-0.4,1.3-0.7,1.8c0.1,0,0.2,0.1,0.3,0.1
		C442.6,46.3,443.1,45.8,443,45.7z"
      />
      <path
        class="st3"
        d="M492.6,60.5C492.5,60.5,492.5,60.5,492.6,60.5c0.5-0.1,0.9-0.1,1.4-0.2c-0.3-0.4-0.6-0.8-0.9-1.2
		c-0.4,0-0.8,0.1-1.3,0.1c-0.1,0.1-0.3,0.4-0.5,0.6c-0.7,0.6-1.3,0.7-1.8,0c0-0.1-0.1-0.1-0.1-0.2c0,0.3,0.1,0.5,0,0.8
		c-0.1,0.7-1,0.3-1.5,0.7c1.7,0.4,2.7,0,3.4-1.1c0.3-0.6,0.8-0.8,1.3-0.5C493.1,59.8,493,60.2,492.6,60.5z"
      />
      <path
        class="st3"
        d="M486.1,58.1c-0.1,0-0.1,0.1-0.2,0.1s-0.3-0.2-0.3-0.2c0.1-0.1,0.2-0.2,0.3-0.4c0,0,0,0,0-0.1
		c-0.1-0.4-0.2-0.9-0.3-1.3c-1.2,0.5-1.3,0.6-1.1,1.8c-1.3,0.3-2.4,0.1-3.3-0.4c-0.4,0.5-0.7,0.8-0.8,1.2c-0.2,0.8-0.8,1.2-1.4,1.5
		c0.1,0.5,0,1-0.4,1.6c0.5-0.7,1.1-1.4,1.7-2.2c0.3-0.4,0.9-0.6,1.3-0.9c-0.1,0.5-0.1,1-0.2,1.5c0,0.1-0.1,0.3-0.1,0.4l0,0
		c0.4-0.5,0.8-1,1.3-1.4c0.3-0.3,0.8-0.3,1.2-0.5c-0.1,0.4,0,1-0.2,1.3s-0.5,0.6-0.7,0.9c0,0.1,0.1,0.1,0.1,0.2
		c0,0.1-0.2,0.3-0.3,0.4c-0.1,0-0.1,0-0.2,0c-0.3,0.4-0.6,0.8-0.9,1.2c-0.1,0.5-0.1,1-0.2,1.5c0.1,0,0.2,0.1,0.3,0.1
		c0.4-0.2,0.7-0.5,1.2-0.8c-0.1-0.2-0.3-0.4-0.4-0.9c1.2-0.5,1.7-0.5,1.8,0c0.1,0.4,0,0.8-0.6,1c-0.3,0.1-0.5,0.1-0.6,0.1
		c0.3,0.3,0.5,0.5,0.6,0.8c0.7-0.5,1.4-1,1.4-1.9c1.3-0.5,1-1.2,0.6-1.9c-0.3-0.6-0.1-1.2,0.2-2c0.5,0.4,0.9,0.6,1.1,0.8
		c0.3-0.3,0.5-0.6,0.8-0.9c-0.2,0-0.3,0-0.5,0C486.8,58.7,486.4,58.5,486.1,58.1z M484.5,58.6c0,0,0.1,0,0.1,0.1l-0.1,0.1
		c0,0-0.1,0-0.1-0.1C484.4,58.7,484.4,58.7,484.5,58.6z M484.1,60.8c-0.1,0-0.3-0.1-0.4-0.1c0.1-0.2,0.3-0.5,0.4-0.7
		c0.1,0.1,0.3,0.1,0.5,0.2C484.4,60.4,484.3,60.6,484.1,60.8z"
      />
      <path
        class="st3"
        d="M405.3,239.5c0,0.2,0.1,0.4,0.2,0.6c0,0.2,0.1,0.4,0.1,0.5c0.6-0.2,1.3-0.2,2,0.1c0.2,0.1,0.4,0.2,0.6,0.4
		c0.1-0.2,0.2-0.3,0.4-0.5c-0.7-0.5-1.4-1.1-2.2-1.5C406,238.8,405.3,239.1,405.3,239.5z"
      />
      <path
        class="st3"
        d="M485.5,55.4c-0.4,0.3-0.3,0.5,0.1,0.7v0.1c0.1,0,0.2-0.1,0.3-0.1c0.5-0.2,0.4-0.5,0.2-0.8
		C486,55.3,485.6,55.3,485.5,55.4z"
      />
      <path
        class="st3"
        d="M400.1,94.9L400.1,94.9c-0.1-0.1-0.2,0-0.3,0c0,0.1,0,0.2,0.1,0.2v0.1C399.9,95.2,400,95,400.1,94.9z"
      />
      <path
        class="st3"
        d="M334.9,103.7c2.4-0.1,4.8-0.2,7.2-0.3c-0.1-0.2-0.3-0.4-0.3-0.6c0.7-0.1,1.2-0.2,1.8-0.3
		c0.1,0.3,0.1,0.6,0.2,0.8c0.4,0,0.7,0,1.1,0c-0.2-0.8-0.2-1.5,0.1-2.2c-0.3-0.1-0.5-0.3-0.6-0.6c-0.1-0.5,0.4-1.1,1-1.3
		c0.3-0.1,0.7,0,0.9,0.1c0.2-0.2,0.4-0.3,0.7-0.5c0.6-0.4,1.1-0.9,1.4-1.4c-0.7,0-1.4,0-2,0v0.1c-0.4,0-0.7-0.1-1-0.1s-0.6,0-0.8,0
		c-0.1,0-0.1,0.1-0.1,0.1c-0.1,0.2-0.2,0.4-0.3,0.5c0.1,0.1,0.2,0.2,0.3,0.3c0.3,0.5,0.1,0.9-0.8,1.6c0.1,0.5,0,0.9-0.4,1.3
		s-0.9,0.8-1.4,1c-1,0.4-1.8,0.2-2.6-0.5c-0.1,0.1-0.1,0.2-0.2,0.3c-0.4-0.4-0.5-0.6-0.4-0.9c-0.1-0.1-0.2-0.1-0.4-0.2
		c-0.4,0.4-0.8,0.9-1.4,1.4c-0.6-0.6-1.5-0.9-1.7-1.7c-0.1-0.4-0.3-0.3-1.1,0C334.6,102,335,102.9,334.9,103.7z"
      />
      <path
        class="st3"
        d="M508.2,54.1c-0.1,0.1-0.1,0.2-0.2,0.4c0,0.1,0,0.1,0,0.2c0.3,0.5-0.1,0.4-0.4,0.5c-0.1,0.1-0.1,0.2-0.2,0.3
		l0,0c0,0,0,0,0,0.1c0,0,0.2,0.2,0.3,0.4c0.1,0.2,0.3,0.4,0.5,0.8c-0.2,0.1-0.4,0.3-0.7,0.5c0,0,0,0,0,0.1c0.2-0.1,0.4-0.1,0.6-0.2
		c0.3-0.9,0.6-1.8,0.8-2.7c-0.2,0-0.4-0.1-0.6-0.2C508.3,54.1,508.3,54.1,508.2,54.1z"
      />
      <path
        class="st3"
        d="M366.3,95.6c-0.2,0-0.4,0-0.6,0l0,0C365.9,95.5,366.1,95.6,366.3,95.6L366.3,95.6z"
      />
      <path
        class="st3"
        d="M349,95.5c-0.5,0-1.1,0-1.6,0c-0.1,0-0.3,0-0.4,0c-0.2,0-0.3,0-0.5,0c-0.1,0.2-0.1,0.4-0.3,0.6l0,0
		c0.8,0,1.7,0,2.5,0C348.8,95.9,348.9,95.7,349,95.5z"
      />
      <path
        class="st3"
        d="M424.7,77.6c-0.3,0-0.5,0-0.8,0.1c0,0.4,0,0.7-0.1,1.1c0,0.2,0,0.5,0.1,0.7c0.9,0,1.8,0.3,2.8,0.8
		c-0.1-0.6-0.3-1.2-0.4-1.7C425.5,78.6,424.9,78.2,424.7,77.6z"
      />
      <path
        class="st3"
        d="M441.2,83.5c0.6,0,1.2,0.1,1.7,0.1c0-0.2,0-0.4,0.1-0.6l0,0c-0.2,0-0.4,0-0.5,0c-0.4,0-0.7-0.1-1.1-0.1
		C441.2,83.1,441.2,83.3,441.2,83.5z"
      />
      <path
        class="st3"
        d="M392.1,97.1c0-0.1,0-0.1,0-0.2c0-0.2-0.1-0.3-0.2-0.5c-0.1,0-0.2,0-0.3,0c-0.1,0.2-0.2,0.4-0.3,0.5
		c-0.8,0.3-0.9-0.2-1.1-0.5c-0.2,0-0.4,0-0.5,0c-0.2,0.1-0.4,0.2-0.7,0.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.6,0-1.3-0.1-1.9-0.1
		c0.2,0.2,0.4,0.5,0.5,0.8C388.9,97,390.5,97,392.1,97.1z"
      />
      <path
        class="st3"
        d="M361.1,95.5c-0.1,0-0.2,0-0.4,0c0,0.1,0.1,0.2,0.1,0.3c0.3,0,0.6-0.1,0.9-0.1
		C361.5,95.6,361.3,95.6,361.1,95.5z"
      />
      <path
        class="st3"
        d="M313.3,268.9c-2.4-1.6-4.9-3.2-7.3-4.7v0.7c2.3,1.5,4.7,3.1,7,4.6C313.1,269.2,313.2,269.1,313.3,268.9z"
      />
      <path
        class="st3"
        d="M332.7,107.2c0.3,0.2,0.5,0.6,0.8,0.9c2.5-0.2,5-0.4,7.3-0.6c0-0.3,0.1-0.6,0.2-0.9c0.4-0.7,1-1.4,1.6-2.1
		c-2.9,0.1-5.7,0.2-8.6,0.4c-0.2,0.2-0.5,0.3-0.8,0.5c0.1,0,0.1,0.1,0.1,0.1c-0.2,0.3-0.4,0.5-0.6,0.7c-0.2-0.1-0.3-0.2-0.5-0.3
		c0.1-0.1,0.2-0.1,0.3-0.2c-0.4,0.2-0.8,0.3-1.2,0.5c0.1,0.2,0.2,0.5,0.3,0.7C332.1,106.9,332.4,107,332.7,107.2z M335,105.2
		L335,105.2L335,105.2L335,105.2z"
      />
      <path
        class="st3"
        d="M612.1,8.8V4.2c-1.3-0.7-2.6-1.4-4.3-1.7c0,0-0.3,0.1-0.3,0.2c-0.1,0.5-0.1,1.1-0.1,1.6s0.1,1,0,1.5
		c-0.3,1.5,0.8,2.3,1.7,3.3c0.6,0.7,1.2,1.6,1.5,2.4c0.3-0.2,0.6-0.3,0.9-0.3c0.1,0,0.3,0,0.4,0v-0.9c-0.4,0.1-0.8-0.1-1.2-0.2
		C611.2,9,611.5,8.7,612.1,8.8z M610.2,9.7c-0.1,0-0.1,0-0.2,0c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0
		C610.3,9.7,610.3,9.7,610.2,9.7z"
      />
      <path
        class="st3"
        d="M479.6,39.4c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C479.6,39.6,479.6,39.5,479.6,39.4z"
      />
      <path
        class="st3"
        d="M309.6,269c0.1,0.2,0.4,0.2,0.7,0.2c-0.2-0.2-0.5-0.3-0.7-0.5C309.6,268.8,309.6,268.9,309.6,269z"
      />
      <path
        class="st3"
        d="M306,110.6c1.8-0.2,3.7-0.4,5.5-0.6c1.5-1.5,3.8-1.9,5.9-1c0.3-0.2,0.6-0.3,1-0.4c0.9-0.2,1.8,0,2.4,0.5
		c1.4-0.1,2.8-0.3,4.2-0.4c0-0.9,0.5-1.8,1.4-2.6c0.3-0.2,0.6-0.4,0.8-0.6c0-0.1,0-0.2,0-0.3c-6.7,0.4-13.5,0.9-20.2,1.4
		c0,0.1-0.1,0.2-0.1,0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.2,0-0.4,0-0.6,0.1v0.5v2.6c0,0,0,0,0.1,0c0,0,0,0-0.1,0.1L306,110.6L306,110.6
		z M321.9,106c0.6-0.1,1.2,0.2,1.4,0.7c0.1,0.5-0.4,1.2-1,1.3c-0.7,0.1-1.4-0.3-1.5-0.8C320.7,106.7,321.2,106.1,321.9,106z
    M306.4,107c0.1,0,0.2,0.1,0.2,0.1c0,0.1-0.1,0.1-0.1,0.2l-0.1-0.1C306.4,107.2,306.4,107.1,306.4,107z M306.2,109.1
		c0.1,0,0.2,0,0.3,0l-0.1,0.1c-0.1,0-0.2,0-0.3-0.1C306.2,109.2,306.2,109.1,306.2,109.1z"
      />
      <path
        class="st3"
        d="M314.8,268.3c-0.1,0-0.3,0-0.4-0.1c0.1,0.2,0.3,0.4,0.4,0.5C314.8,268.6,314.8,268.5,314.8,268.3z"
      />
      <path
        class="st3"
        d="M608.4,15.1c-0.3-0.1-0.8,0.2-1.2,0.4c-0.5,0.2-1,0.4-1.6,0.7c0,0.2,0,0.6,0,1.1c-0.7-0.3-1.2-0.6-1.9-0.9
		c-0.2,0.4-0.3,0.7-0.5,1c-0.6-0.1-0.8-0.8-1.3-1c-0.3,0.4-0.8,0.7-1.3,0.7c-0.9,0.1-1.9-0.3-2-1c-0.2-0.7,0.6-1.7,1.5-1.9
		c-0.1-0.6-0.2-1.2-0.4-1.7c0-0.1-0.1-0.3,0-0.3c1-0.8,0.1-1.5,0-2.2c0-0.2-0.1-0.4-0.1-0.5c-1-0.2-1.3,0.5-1.8,0.9
		c-0.1-0.3-0.2-0.7-0.3-1c-1.4,0.4-1.4,0.4-2.4-0.5c-0.1,0.3-0.2,0.5-0.3,0.7c-0.1,0.5-0.5,0.8-1,0.8c-0.3,0-0.7-0.3-0.8-0.5
		c-0.2-0.4,0.1-0.8,0.6-1c0.3-0.2,0.6-0.4,0.8-0.8c-0.3,0-0.5,0-0.8,0c-0.2,0-0.5,0.1-0.7,0.2c-0.3,0.5-0.7,1-1,1.5
		c0.3,0.2,0.5,0.4,0.7,0.5c-0.4,0.6-1.5-0.3-1.7,0.8c0.3,0.1,0.7,0.3,1.2,0.5c-0.8,0.5-1.4,0.9-2.1,1.3c1,0.1,1.8,1.6,3.2,0.4l0,0
		c0,0,0,0,0.1,0v0.1c0.9-0.1,1.8-0.2,2.9-0.3c0.2,0.7,0.4,1.5,0.6,2.4c-0.1,0.1-0.3,0.2-0.6,0.3c-0.2-0.5-0.4-1-0.6-1.5
		c-0.4-0.2-0.9-0.3-1.4-0.5c-0.2,0.7-0.5,1.5-0.7,2.2c0.3,0.2,0.9-0.5,1.2,0.2c0.2,0.5,0.9,0.7,1.7,0.6c0.7-0.1,1.1,0.2,1.3,0.8
		c0.4,0.7,0.9,1.4,1.3,2c-0.3,0.5-0.6,0.8-0.8,1.2c-0.3,0.9-0.4,1.1-0.9,1.3c-0.1,0.2-0.3,0.4-0.5,0.6c0.1,0.2,0.2,0.4,0.4,0.7
		c0.6,0,1.4,0,2.1,0c0.1-0.4,0.2-0.8,0.3-1.4c0.6-0.1,1.3-0.2,2.2-0.3c0.1-0.2,0.3-0.5,0.6-0.9c0.2,0.3,0.4,0.5,0.7,0.8
		c-0.2,0.1-0.4,0.2-0.5,0.3l0,0c-0.1,0-0.1,0.1-0.2,0.1l0,0c-0.5,0.3-0.7,0.7-0.7,1.3c0.4-0.1,1-0.1,1.6,0.1
		c-0.5,0.4-0.9,0.9-1.4,1.3c0,0.5-0.3,1-1.3,1.2c0,0,0,0-0.1,0.1c1.4,0.1,2.5,0.2,2.6,1.5v-0.1c0,0,0,0,0,0.1c0,0,0,0-0.1,0
		c-0.2,0.7-0.4,1.5-0.6,2.2c0.3,0,0.5-0.1,0.8-0.2c-0.6-2.1,1.7-4.2,3.9-4.2c0.3,0,0.6-0.1,1-0.1c-0.1-0.4-0.2-0.7-0.2-1.1l0,0
		c-0.1,0.2-0.3,0.4-0.6,0.5c-0.2,0.1-0.8,0-0.9-0.2c-0.2-0.3-0.3-0.7-0.4-1.1c0,0,0,0-0.1,0l0,0c-0.4,0.2-0.7,0.5-1,0.4
		c-0.6-0.1-1.1-0.4-1.5-0.7c-0.1-0.1-0.1-0.5,0-0.7c0.1-0.1,0.6-0.2,0.8-0.1c0.6,0.3,1.2,0.7,1.7,1.1h0.1c0,0,0,0,0,0.1
		c0.2,0,0.4-0.1,0.5-0.1c0.1-0.2,0.4-0.4,0.7-0.6c0.3,0.3,0.6,0.6,0.9,0.9c1-1.6,2.2-2.6,3.6-3l0.1-0.1v-5c-0.8,0.1-1.4-0.2-1.9-0.6
		C609.9,15.1,609.3,15.3,608.4,15.1z M601.4,18.9c-0.9,0.3-0.8,1.1-1.4,1.4c-0.6,0-0.9-0.2-1-0.7l0,0l0,0l0,0l0,0
		c1.2-0.3,0.6-1.4,1.3-2.1c0.3,0,0.7,0,0.9,0.1C601.9,18,602,18.7,601.4,18.9z M604.1,23.6c0.2,0.1,0.4,0.3,0.4,0.4l0,0
		c0.4,1.5,0.2,1.7-1.4,2.4c-0.4-0.6-0.4-1.1-0.1-1.5h-0.1c0.1-0.4,0.1-0.6,0.2-0.8C603.3,23.8,603.6,23.5,604.1,23.6z M609.8,21.1
		c0-0.1-0.1-0.1-0.1-0.2l0.1-0.1C609.8,20.9,609.9,20.9,609.8,21.1C609.9,21,609.9,21.1,609.8,21.1z M608.5,21
		c-0.7,0.1-1.5-0.2-1.9-0.7c-0.4,0.1-0.7,0.4-1,0c-0.2-0.4-0.5-0.8-0.6-1.2c-0.1-0.8,0.6-1.6,1.6-1.9c1.3-0.4,2.6,0.2,2.9,1.2
		c0.3,0.2,0.4,0.5,0.5,0.8C610.1,20,609.4,20.8,608.5,21z M610.7,15.7c0,0-0.1,0-0.1,0.1c-0.1-0.2-0.3-0.4-0.4-0.6
		c0.1,0,0.1-0.1,0.2-0.1C610.5,15.3,610.6,15.5,610.7,15.7z"
      />
      <path
        class="st3"
        d="M441,84.2c1.1,0.7,2.2,1.3,3.5,1.8c-0.2-0.7,0.2-0.9,0.8-1.1c-0.2,0.3-0.4,0.6-0.7,1.2c0.5,0.2,1,0.4,1.5,0.5
		c0.1-0.2,0.3-0.5,0.4-0.8c0.1-0.4,0-0.9,0.1-1.3C444.8,84.4,442.9,84.3,441,84.2L441,84.2z"
      />
      <path
        class="st3"
        d="M554.8,62.8c0.2,0.1,0.3,0.1,0.5,0.2c0-0.1,0.1-0.3,0.1-0.4c0.2,0,0.3,0.1,0.5,0.1c0.2-0.3,0.4-0.6,0.6-0.9
		c-1.2,0-2,1.4-3.2,0.6c-0.5,0.2-0.9,0.2-1.4,0.1c0.4,0.7,0.6,1.4,0.5,2.2c0.2,0,0.3,0,0.5,0.1c-0.1-0.6,0.4-1.4,0.9-1.3
		C554.8,63.7,554.5,63,554.8,62.8z"
      />
      <path
        class="st3"
        d="M553.5,67.4c-0.2,0-0.3,0-0.5,0c0.3,0.3,0.5,0.6,0.8,0.8c0.1-0.1,0.2-0.3,0.3-0.4
		C553.8,67.8,553.6,67.6,553.5,67.4z"
      />
      <path
        class="st3"
        d="M533.2,26.5c0.1-0.1,0.2-0.2,0.3-0.2c-0.5-0.5-0.9-1-1.7-0.3c0,0.6-0.1,1.2-0.1,1.7
		C532.2,27.3,532.7,26.9,533.2,26.5L533.2,26.5L533.2,26.5L533.2,26.5z M532.6,25.8L532.6,25.8L532.6,25.8L532.6,25.8z"
      />
      <path
        class="st3"
        d="M538.3,77.1c0.1,0.5,0.3,0.9,0.4,1.3c0.1,0,0.2,0,0.2,0c0.5-0.3,0.9-0.6,1.2-0.7c0.5-0.1,0.7-0.2,1-0.4
		c-0.4-0.3-0.5-0.7-0.6-1C539.6,76.5,539,76.8,538.3,77.1z M538.9,77.7c0,0-0.1-0.2-0.2-0.3c0.3-0.1,0.6-0.2,0.9-0.4
		c0,0.1,0.1,0.2,0.1,0.3C539.5,77.5,539.2,77.6,538.9,77.7z"
      />
      <path
        class="st3"
        d="M541.5,68c-0.1-0.1-0.1-0.1-0.1-0.2c-0.2,0.3-0.4,0.6-0.7,0.8c0.3,0,0.7,0,1,0c0.9,0.1,1.5,0.5,1.8,1.2v0.1
		c0.2,0.1,0.4,0.2,0.7,0.3c0.3-0.3,0.5-0.6,0.8-0.8c-0.4-0.4-1-0.6-1.4-0.9C543,68,542.3,67.9,541.5,68z"
      />
      <path
        class="st3"
        d="M406.7,69.4c0.2-0.3,0.5-0.5,0.8-0.6c-0.3-0.1-0.5-0.3-0.8-0.6c-0.5,0.3-1,0.6-1.5,0.9c0,0.1,0,0.2,0.1,0.3
		C405.7,69.4,406.2,69.4,406.7,69.4z"
      />
      <path
        class="st3"
        d="M558.5,50.7c-0.4-0.1-0.9-0.2-0.9-0.7c-0.5,0.4-1.1,0.8-2,0.2c0,0,0-0.1,0-0.2c-0.4,0.2-0.8,0.5-1.3,0.8
		c0.5,0.3,0.9,0.8,1.1,0.7c1.2-0.3,1.3,0.4,1.4,0.7c-0.3,1.2-0.6,2.1-0.8,3.1c0.7-0.1,1.1-0.4,1.5-0.3c0.3,0,0.5,0.4,0.8,0.8
		c0.4-0.9,0.8-1.7,1.2-2.5c-0.5-0.5-1-1-1.5-1.5c0.4-0.4,0.7-0.7,1-1c0,0,0,0,0-0.1C559,50.8,558.7,50.8,558.5,50.7L558.5,50.7z
    M557.2,51.5c-0.2-0.3-0.4-0.6-0.6-0.8c0.1,0,0.2-0.1,0.3-0.1c0.2,0.3,0.3,0.6,0.5,0.9C557.4,51.4,557.3,51.4,557.2,51.5z
    M557.7,51.8L557.7,51.8L557.7,51.8L557.7,51.8z"
      />
      <path
        class="st3"
        d="M409.5,68c0.1,0.1,0,0.3-0.1,0.5c1,0.1,1.9,0.7,2.1,1.6c0.1,0.4,0,0.8-0.1,1.2c0.3,0.1,0.5,0.2,0.6,0.4
		c1,0,2,0,3,0c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.6,0.3-1.1,1-1.3c0.7-0.2,1.3,0,1.6,0.6c0.1-0.5,0.3-1.1,0.5-1.8
		c-0.2-0.2-0.4-0.4-0.6-0.7c-0.1-0.2-0.2-0.3-0.3-0.5c-0.3,0.1-0.6,0.2-0.9,0.2c-0.5,0-1.1-0.1-1.8-0.1c-0.3,0.6-0.8,1.3-1.9,1.2
		c-0.6-0.1-0.9-0.5-0.9-1c-0.1-1.1,1.1-1.1,2-1.5c-0.3-0.3-0.5-0.4-0.8-0.6h-0.1c-0.2,0-0.3,0-0.5,0c0.2,0,0.3,0,0.5,0
		c0,0,0,0,0.1,0.1c0.6,0,0.6-0.5,0.8-0.9c0.5-0.9,1.4-1.5,2.6-1.6c0.8,0,1.4,0.2,1.9,0.6c0.1-0.1,0.2-0.2,0.3-0.3
		c0.9-0.6,2-0.7,3-0.5c0-0.2,0-0.4,0-0.6c-1.4,0-2.7-0.1-3.4-1.2c-0.6,1.2-2.1,2-3.6,1.8c-0.2,0-0.4,0-0.5-0.1
		c-1.2-0.7-2.1-0.6-3.1,0.6c-0.3,0.3-0.9,0.3-1.6,0.4c0.1,0.3,0.2,0.6,0.1,1c-0.1,0.1-0.2,0.1-0.4,0.2v0.1c0,0.4-0.4,0.8-0.7,1.2
		C408.6,67.1,409.1,67.5,409.5,68z M411.4,65.5c-0.3-0.5-0.5-0.8-0.7-1.2C411.6,64.3,411.6,64.7,411.4,65.5z"
      />
      <path
        class="st3"
        d="M510.1,53.7c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.1-0.4-0.2-0.6-0.2C509.9,53.5,510,53.6,510.1,53.7z"
      />
      <path
        class="st3"
        d="M375.1,70.1c-0.1,0.2-0.3,0.4-0.4,0.6c0.1-0.1,0.2-0.1,0.4-0.2c0.6,0.4,1.2,0.8,1.8,1.1
		c0.6-0.1,1.3,0.1,1.7,0.6c0.5,0.5,0.4,1.3-0.2,1.8c-0.2,0.2-0.3,0.3-0.5,0.4v0.1c0.6-0.2,1.2-0.2,1.5-0.5c0.6-0.5,2-0.3,1.9-1.6
		c0.6,0.1,1.1,0.3,0.6,0.8c-0.6,0.6-0.6,1.1,0,1.7c0.3,0.3,0.4,0.8,0.5,1.3c-0.2,0.4-0.4,0.8-0.7,1.2c0.7-0.4,1.5-0.6,2.4-0.2
		c0.3,0.7,0.7,1.4,1,2.2c1.3-0.4,1.6-2.3,3.7-1.9c-0.1,0.3-0.3,0.6-0.4,0.9c-0.1,0.4-0.1,0.9,0.5,1c1.4,0.1,1.3,1,1.4,1.9
		c-1.2,0-1.6,0.7-1.8,1.6c0.5,0.3,1,0.7,1.6,1.2c-0.2,0.3-0.5,0.5-1.1,1.1c1.4-0.1,2.6,0.7,3.5-0.5c0,0.5,0.5,0.6,1,0.7
		c0.4,0.8,1-0.1,1.6,0.1l0,0c-0.4-1.1-0.8-2.3-1.2-3.4c-0.2-0.2-0.4-0.4-0.5-0.6c-0.2,0-0.3,0-0.4-0.1c-0.4-0.2-0.7-0.6-1.1-0.8
		c0.2-0.6,0.7-0.8,1.2-0.8c-0.1-0.2-0.1-0.4-0.2-0.6c-0.3,0.3-0.6,0.3-1.1,0.1c0.2-0.5,0.4-0.7,0.9-0.7c-0.1-0.2-0.1-0.4-0.2-0.5
		c-0.4,0-0.9-0.3-1.1-0.6c-0.2-0.3,0.1-0.8,0.6-1c-0.2-0.6-0.4-1.1-0.6-1.7c-0.5,0.3-1,0.4-1.6,0.1c-1.1-0.5-1-1.3-0.7-2.3
		c-1.4-0.5-1-1.5-0.6-2.5c-0.6,0-1.1,0-1.6-0.1c-0.5-0.2-0.9-0.1-1.4,0c-0.9,0.3-1.7-0.1-2-0.6c-0.3-0.6-0.1-1.2,0.6-1.9
		c0.4-0.3,1.2-0.5,0.7-1.3c-1.7-0.5-1.5,1.4-2.9,1.5c0.3,0.4,0.5,0.7,0.8,1.2c-0.8-0.1-1.4-0.2-2.1-0.3c-0.1,0.3-0.1,0.6-0.2,1
		c-0.6-0.2-1.1-0.4-1.7-0.6c-0.2,0.2-0.4,0.4-0.6,0.7c-0.5-0.2-0.8-0.6-1.5-0.4c-0.6,0.1-0.9,0.1-1.4-0.3
		C375.4,69.3,375.3,69.7,375.1,70.1z M391.4,82.5c0.8-0.1,1.5,0.2,1.6,0.8c0.1,0.6-0.4,1.2-1.2,1.4c-0.8,0.1-1.5-0.3-1.6-0.8
		C390.1,83.3,390.7,82.6,391.4,82.5z M389.5,77.1c-0.1,0-0.2,0-0.3,0l0.1-0.1c0.1,0,0.2,0,0.3,0C389.6,77.1,389.5,77.1,389.5,77.1z
    M389.3,74.5c0.1,0.1,0.2,0.2,0.3,0.3l-0.2,0.2c-0.1-0.1-0.3-0.1-0.4-0.2C389.1,74.7,389.2,74.6,389.3,74.5z M389,76.2l0.1,0.1
		c0,0.1-0.1,0.1-0.2,0.2c-0.1-0.1-0.1-0.1-0.2-0.2C388.8,76.3,388.9,76.2,389,76.2z M384.8,75.2c0.1,0,0.2,0.1,0.2,0.1
		c-0.1,0.1-0.2,0.1-0.3,0.2c0,0-0.1,0-0.1-0.1C384.6,75.3,384.7,75.3,384.8,75.2z M382.1,73.7c0,0.1,0,0.2-0.1,0.3
		c-0.1-0.1-0.1-0.1-0.2-0.2l0.1-0.1C382,73.7,382.1,73.7,382.1,73.7z"
      />
      <path
        class="st3"
        d="M372.3,85.5c0.2,0.3,0.3,0.6,0.4,0.9c0.6,0,1.1,0,1.7,0.1c0.4,0,0.7,0,1.1,0c0-0.2,0-0.4,0.1-0.6
		c-0.4-0.1-0.8-0.2-1.1-0.3C373.8,85.5,373.1,85.5,372.3,85.5z"
      />
      <path
        class="st3"
        d="M375.2,95.7c0,0.3-0.1,0.5-0.2,0.8c2.2,0.1,4.4,0.1,6.7,0.2c0.1-0.2,0.3-0.5,0.5-0.7
		C379.9,95.9,377.6,95.8,375.2,95.7z"
      />
      <path
        class="st3"
        d="M531.3,28.4c0.1,0,0.4-0.1,0.4-0.1c0-0.2,0-0.3,0-0.5c-0.1,0.1-0.3,0.2-0.3,0.3
		C531.3,28.2,531.3,28.3,531.3,28.4z"
      />
      <path
        class="st3"
        d="M611,47.1c-0.7-0.3-1.4-0.5-1.9-1L609,46c-0.4,1.4-2.5,2.5-4,2.2c-1.8-0.3-2.9-1.7-2.4-3.3
		c0.2-0.7,0.7-1.2,1.3-1.6c0-0.2,0-0.4,0-0.6c-0.2,0-0.4-0.1-0.6-0.1c-1.1,1-2.7,1.4-4,0.8c-1.1-0.5-1.6-1.7-1.2-2.7
		c-0.1,0.1-0.2,0.1-0.3,0.2c0.1-0.7,0.1-1.2,0.2-1.8c-0.6-0.1-1.3-0.3-2.1-0.4c-0.2-0.4-0.4-0.9-0.6-1.4c0.4-0.6,0.8-1.1,1.2-1.7
		c-1.2-0.7-1.6,0.3-2.3,0.7c-0.9-0.5-1.8-0.9-2.8-1.5c0.2-0.3,0.4-0.5,0.7-0.9c-0.3,0-0.6,0-0.9,0c0.1-0.3,0.2-0.6,0.3-0.7
		c-0.5-0.5-0.9-1-1.4-1.4c-0.3-0.2-0.7-0.4-1.1-0.5c-0.5-0.1-1-0.2-1.6-0.3c-0.1,0.2-0.3,0.4-0.5,0.6c0.5,0.1,0.9,0.5,1.1,1
		c0.2,0.9-0.4,1.7-1.5,2s-2.1-0.2-2.3-1c-0.1-0.6,0.2-1.2,0.8-1.6c-0.2-0.1-0.3-0.3-0.2-0.7c0.2-0.7,0.3-1.3,0.5-2
		c0.2-0.8,0.3-1.5-0.1-2.4c-1.3,0.5-2.6,1-3.7,1.5c0.1,0.1,0.1,0.2,0.2,0.4c-0.5,0.4-1,0.7-1.4,0.2c-0.1-0.1,0-0.6,0.2-0.7
		c0.3-0.2,0.6-0.2,0.8-0.1c0.2-1.1,1.1-1.9,2.7-2.4c-0.4-0.1-0.6-0.2-0.8-0.2c0.1-0.2,0.3-0.4,0.5-0.5c-0.2,0-0.3-0.1-0.5-0.1
		c0,0,0,0,0-0.1c-0.5,0.1-1.2,0.6-1.7,1.3c-0.2-0.1-0.5-0.2-0.8-0.3c0.3-0.3,0.5-0.5,0.9-0.8c-0.5-0.1-0.8-0.2-1.1-0.3
		c0-0.6,0-1.2,0-1.7c-0.8-0.2,0.3-0.9-0.4-1.2c-1.4,0.8-2.4,1.8-3,3.1c0.2-0.3,0.5-0.5,0.9-0.7c0.8-0.4,1.3-0.2,2.4,0.8
		c-0.4,0.4-0.6,0.9-1,1.2c-0.5,0.4-1.2,0.6-1.8,0.3c-0.2-0.1-0.5-0.3-0.6-0.6c0,0.1,0,0.1,0.1,0.2c0.1,0.5,0.2,1,0.4,1.8
		c-0.6-0.2-0.9-0.4-1.2-0.5c-0.5,0.4-0.9,1.6-1.8,0.5c-0.6-0.7-0.4-1.3,0.7-1.9c-1.6-0.1-1.9,0.1-2.5,1.1c-0.2,0.4-0.4,0.7-0.9,0.5
		s-0.4-0.6-0.1-0.9c0.1-0.1,0.2-0.2,0.2-0.2c-0.3-0.5-0.6-1-0.9-1.5c-0.7-1.2-1.4-1.2-2.6-0.2c-0.1,0.1-0.2,0.3-0.3,0.4
		c0.2,1.1,1,2.2-0.1,3.4c0-0.2-0.1-0.5-0.2-0.9c-0.5,0.6-0.8,1.1-1.2,1.5c0-0.3,0.1-0.7,0.1-1c0.1-0.7,0.1-1.3,0.1-2
		c-0.1,0-0.3-0.1-0.4-0.1c-0.2,0.3-0.5,0.6-0.7,1s-0.2,0.8-0.4,1.2c-0.4,1-1,1.3-2.1,1c-0.3-0.1-0.6-0.3-1-0.3c-0.5-0.1-1,0-1.2,0
		c-0.1,0-0.1,0.1-0.2,0.1c0.5,0.3,0.9,0.8,1.3,1.2c0.4,0.4,0.3,0.5-0.6,1.4c1.1,1.2,1.1,1.3,0.5,2.5c-1.1-0.5-1.4-1.2-1.2-2.2
		c-1-0.1-1.7-0.4-2.2-0.7c-0.1,0.5-0.2,1-0.3,1.5c1.1,0.4,0.7-0.8,1.3-1c0.8,0.2,0.7,0.9,0.8,1.6c-1,0.2-2,1.2-2.8-0.2h-0.1
		c0.1,0.2,0.1,0.4,0.3,0.5c0.1,0.1,0,0.5-0.1,0.5c-0.2,0.1-0.7,0.3-0.8,0.2c-0.4-0.3-0.9-0.5-1.4-0.6c-0.1,0-0.2,0-0.3,0
		c-0.8,0.3-0.7,1.4-1.8,1.5c-0.1,0-0.2,0.2-0.3,0.4c-0.6,1.7-1.3,2.3-2.8,2.4c-0.1,0-0.2,0-0.3,0c0.1,0,0.2,0.1,0.3,0.1
		c-0.2,0.1-0.3,0.3-0.4,0.3c0,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.1-0.3c-1.1-0.1-1.8-0.8-2.2-2.2c0-0.1-0.1-0.2-0.3-0.4
		c-0.6,0.3-1.3,0.6-2,0.9c-0.7-0.7,0.2-1,0.7-1.6c-0.7-0.5-1.5-1-2.4-1.6c-0.2,0.4-0.4,0.7-0.4,0.9c0.6,3-0.6,4.2-4.2,4.4
		c-0.2,0-0.3,0.1-0.6,0.2c0,0.2,0,0.4,0,0.6c0,0.2,0.1,0.4,0.2,0.6c0.3-0.1,0.6-0.3,0.9-0.4c-0.6,0.8-1.2,1.5-1.9,2.3
		c-0.9,1.1-2.2,1.6-3.6,1.6c-0.8,0.3-1.7,0.4-2.5,0.1c-1.1-0.4-1.7-1.6-1.4-2.6c0.1-0.3,0.2-0.5,0.4-0.8c0-0.1,0-0.2-0.1-0.3
		c-1.1,0.5-2.1,1.2-3.2,0.9c-0.2,0.3-0.5,0.5-0.7,0.8c0-0.1,0-0.1,0-0.2c-0.2,0.4-0.5,0.7-0.7,1s-0.3,0.6-0.5,0.8
		c-0.1,0.1-0.1,0.2-0.2,0.3l0,0c1.7-0.4,3.4,0.5,3.7,1.9s-0.8,2.9-2.5,3.3c-1.8,0.4-3.5-0.5-3.8-1.9c-0.2-1,0.3-2,1.3-2.7
		c-0.1-0.1-0.3-0.1-0.5-0.3c0.1-0.2,0.3-0.2,0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.3c0.3-0.3,0.7-0.7,1-1.1c-0.4,0-0.7,0-1.2,0l-0.1,0.1
		c-0.5,0.4-1.1,0.6-1.7,0.2c-0.5-0.4-1-0.9-0.6-1.6c0.3-0.5,0.5-1.1,0.7-1.7c0.2-0.6,0.5-0.9,1.1-0.9c0.4,0,0.9,0.4,1,0.7
		s0.3,0.7,0.4,1c0.1-0.2,0.2-0.3,0.3-0.3c0.3,0,0.6,0.2,1,0.4c0.7-0.1,0.6-0.2,0.6-1c0-0.4,0.3-0.8,0.4-1c-0.2-0.2-0.5-0.4-0.6-0.7
		c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.1-0.3-0.1-0.5c-0.7,0.1-1.2,1-2,0.4c-0.4-0.4-0.7-0.9-1-1.3c-1.5,1.3-2.8,1.5-3.8,0.9
		c-0.5,0.1-1.1,0.1-1.7,0.2c0,0.7-0.4,1.3-1.3,1.6l0,0c0.8,0.7,0.6,1.5,0.2,2.4c-0.3,0.5-0.8,0.8-1.4,1l0,0c0.6,0.4,0.5,0.8-0.3,1.9
		c-0.2,0-0.5,0-0.7-0.1v0.1c-0.3,0.1-0.6,0.1-0.8,0.2c0-0.1,0-0.1,0-0.2c0.2,0,0.4-0.1,0.6-0.1c-0.7-0.2-1-0.4-1-1
		c0-0.5,0.3-0.8,0.8-1h0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.4-0.3-0.7-0.8-1.2-1.2c-0.1,0-0.2,0-0.4,0c-0.2,0.1-0.4,0.2-0.7,0.3
		c-0.5,0.1-1-0.1-1.3-0.4c-0.2,0-0.3,0-0.5-0.1c-1.1-0.8-1.2-2-1.6-3c0,0,0,0-0.1,0V37c-0.1,0-0.2-0.1-0.2-0.1
		c0.1,0,0.1-0.1,0.2-0.1c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0c-0.1,0.1-0.1,0.1-0.2,0.2c0,0,0,0,0,0.1
		l0,0c0,0.1,0,0.2,0,0.2s0,0,0.1,0l0,0c1.6-0.9,3.3-1.2,5.3-1.2c-0.1,0.3-0.3,0.6-0.3,0.9c0,0.2,0.3,0.5,0.5,0.9
		c0.4-0.6,0.6-1,0.9-1.4c0.3,0.1,0.6,0.1,0.9,0.2l0.1-0.1c0.2-0.2,0.6-0.2,0.9-0.4c0.1-0.5,0.2-1,0.4-1.4c0-0.1,0.1-0.2,0.2-0.3
		c-0.2-0.1-0.4-0.2-0.5-0.4c0-0.2,0.3-0.5,0.5-0.5s0.4,0.1,0.7,0.3c0.5-0.3,1-0.4,1.5-0.4c0.5-0.9,0.8-1.2,2.1-1.6l0,0
		c0,0,0,0,0.1,0l0,0l0,0c0.3,0.5-0.1,0.9-0.6,1.2c-0.3,0.2-0.6,0.3-0.9,0.5c0.2,0.1,0.5,0.2,0.7,0.4c1.2-0.1,2.1,0.6,2.6,1.8
		c0.3-0.1,0.6-0.3,0.9-0.4c0.8-0.4,1.6-0.6,2.4-0.3c0.4,0.2,0.9,0.1,1.4,0.1c0.6,0,1,0.2,1.1,0.4c0.2-0.7,1-1.2,1.9-1
		s1.3,0.9,0.9,1.7c-0.1,0.3-0.4,0.5-0.7,0.9c0.2,0.1,0.4,0.3,0.6,0.5c0.1,0.1,0.3,0.3,0.4,0.5c1-0.5,2.1-0.9,3.2-1.4
		c0.2-0.6,0.5-1.4,0.8-2.3c-0.7-0.2-1.5-0.4-2.1-0.7s-1-0.9-1.5-1.3c-0.4-0.3-0.4-0.7-0.2-1.1c0.7-1.3,1.6-2.5,3.5-2.7
		c1.7-0.2,2.8,0.5,3.5,1.9c0.5-0.3,0.9-0.6,1.4-0.9c-1.8-0.9-2.6-2.1-1.5-3.8c0.9-1.3,2.1-1.4,4.8-0.7c0.2-0.5,0.3-1,0.5-1.6
		c-0.9,0.2-1.7,0.6-2.5,0.6s-1.6-0.3-2.5-0.5c-0.5,0.3-1,0.9-1.6,1.1c-0.6,0.3-1.4,0.3-2.3,0.4c0,0.4-0.5,1,0.3,1.6
		c0.4,0.2-0.5,1.4-1.4,1.7c-0.7,0.2-1.4,0.3-2.2,0.5c-0.6,1.2-1.5,2.3-3,2.9c-0.3-0.3-0.7-0.7-1.1-1.1c0.1-0.4,0.3-1.1,0.5-1.7
		c-0.7,0.2-0.4-0.3-0.4-0.6c-0.2,0-0.3,0-0.5-0.1c0.1-0.4,0.4-0.8,0.3-1.2c0-0.4-0.3-1-0.5-1c-1.2,0.1-1.7-0.9-2.6-1.3
		c-0.6,1.5-1.7,2.2-3.5,2.2c-0.7,0-1.4,0.6-2.2,0.3c0.1-0.2,0.2-0.4,0.3-0.6c0.3,0.1,0.6,0.2,1,0.3c-0.7-1.1-1.5-1.9-2.9-2.2
		c0.4,0.6,0.7,1.2,1,1.7c-1.3,0.9-1.3,0.9-2.5,0.2c-0.5,0.5-1.1,0.9-2,0.6c-0.7-0.2-1,0.1-0.8,1.1c-0.7,0.5-1.5,1-2.3,1.5
		c-0.2,0.1-0.4,0.3-0.4,0.5c-0.2,0.8-1,0.8-1.9,1.1c0.2-1,0.6-2-0.4-2.6c-1.9,1.2-2,1.3-3.1,3.1c-0.4,0-0.8-0.1-1.3-0.1
		c0.1,1,0.1,1.9,0.2,3c-0.7-0.1-1.1-0.2-1.6-0.3c-0.5,1.2-3,1.8-1.8,3.6c-0.4,0.3-0.7,0.5-1.1,0.8c-0.3-0.5-0.6-0.9-1-1.4
		c-0.1,0-0.3,0.1-0.4,0.1c0,0.4,0,0.8,0,1.1c0,0.6,0,1.2-0.7,1.5c-0.4-0.7-0.8-1.3-1.1-1.9c-0.5,0.1-1,0.2-1.4,0.2
		c-1.1,0.1-1.2,0.2-1.6,1.1c-0.1,0.3-0.5,0.5-0.8,0.7c0,0-0.2-0.1-0.3-0.1c0.2-0.1,0.3-0.3,0.6-0.5c-1.2-0.2-1.8,0.5-2.5,0.9
		c0.4,0.1,0.7,0.3,1.2,0.5c-0.3,0.1-0.5,0.2-0.6,0.2c0.4,0.2,0.9,0.4,1.5,0.7c0.2-0.6,0.3-1,0.5-1.5c0.6,0.2,1.2,0.4,1.7,0.7
		c0.4-0.3,0.8-0.5,0.9-0.6c0.8,0,1.2,0,1.7,0c0.5,0.6,0.9-0.2,1.3-0.3c0.3,0.3,0.7,0.5,1,0.8c0.1-0.9,0.8-1.9,1.7-2.3
		c1.1-0.4,2.2-0.5,3.2-0.1c0.8,0.3,1.5,0.8,2.2,1.3c0.5,0.4,0.6,1.3,0.3,2.1c0.5-0.2,1-0.4,1.7-0.7c-0.3,0.5-0.6,0.7-0.9,0.9
		c0.6,0.2,1,0.6,1.5,0.9c0.1-0.1,0.1-0.2,0.2-0.3c0.1,0,0.1,0,0.2,0.1c0.3-0.2,0.6-0.4,0.9-0.6c0.4-0.3,0.9-0.5,1.4-0.8
		c0.5,0.1,0.7,0.4,0.4,1c-0.1,0.2-0.3,0.5-0.5,0.7c-0.9,0.9-1.6,1.8-1.6,3c0,0.2-0.4,0.4-0.5,0.5c0.4,0.5,0.9,0.9,1,1.4
		c0.1,0.6-0.4,1.2-0.7,1.9c-0.1,0-0.1,0-0.1-0.1l0,0c-0.6,0-1,0-1.2-0.1c-0.2,0.3-0.1,0.6,0.1,0.9c0.1,0,0.2,0,0.4,0
		c1.4,0.5,1.4,0.5,2.7,0.4c0.7,0.9,1,1.2,0.8,1.6c0.2,0.1,0.3,0.1,0.5,0.2c0.5-0.5,1-1,1.4-1.5c-0.1-0.1-0.2-0.2-0.2-0.4
		c-0.2-0.7,0.4-1.4,1.3-1.6c0.2,0,0.4-0.1,0.6,0c1.1-0.9,2.3-1.5,4-1.1c1.6,0.5,2.1,1.5,2.1,2.9c0.1,0,0.2,0.1,0.2,0.1
		c0.4,0,0.6,0,0.9,0c0.6-0.2,1.1-0.7,1.6-1c0.2,0.2,0.4,0.5,0.3,0.6c-0.3,0.5-0.6,0.9-1,1.4c0,0.1,0,0.1,0,0.2
		c0.1,0.1,0.3,0.2,0.4,0.3c0.3-0.2,0.6-0.3,1.1-0.6c-0.4,0.5-0.6,0.7-0.8,0.8c0.5,0.3,0.9,0.7,1.4,1c0.3,0.2,0.9-0.1,0.9-0.5
		c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.9-0.1-1.7,0.3-2.4c0,0,0,0-0.1,0l0.1-0.1c0.4-0.7,1-1.2,1.8-1.6c0.1-0.3,0.2-0.6,0.5-0.9
		c0.4-0.4,0.8-0.7,1.3-1.1h0.1c-0.1-0.1-0.1-0.1-0.2-0.3c0,0,0,0-0.1,0c0,0-0.1,0-0.1-0.1c-0.2,0-0.5-0.1-0.7-0.1
		c0-0.1,0.1-0.2,0.1-0.3c0.2,0.1,0.4,0.3,0.6,0.4h0.1v0.1c0.2,0.1,0.5,0.2,0.7,0.4h0.1l0,0c1-0.2,1.6-0.7,2.1-1.4
		c0.2-0.3,0.4-0.7,0.7-0.9c1.3-1.4,3.6-2,5.5-1.5c0.2,0.1,0.3,0.1,0.5,0.2c0-0.2,0.2-0.4,0.5-0.5c0.1-0.1,0-0.4,0-0.6
		c0-0.2,0-0.4,0.1-0.8c0.7,0,1.3,0.1,1.9,0.1c0.3-0.7,1-1.3,1.8-1.5c1.3-0.3,2.6,0.4,2.8,1.5c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0.1,0.1
		c0.1,0.2,0.2,0.4,0.3,0.6c0.6,0.2,1.1,0.7,1.2,1.4c0-0.1,0-0.2,0.1-0.3c0.2-0.6,0.7-0.8,1.5-0.7c1.1,0,2,0.2,2.5,1
		c-0.6,0.4-1.1,0.4-1.6,0c-0.5,0.3-1,0.6-1.5,0.9c-0.4-0.1-0.8-0.3-0.9-0.5c0.1,0.8-0.3,1.5-1,2c-0.1,0.4-0.5,0.9-1.2,1.2
		c-0.6,0.3-1.5,0.3-2-0.2c-0.3-0.3-0.5-0.6-0.7-0.9c-0.6,0-1.1,0-1.7,0c0,0.1,0,0.3,0,0.4c0,0.2-0.1,0.3-0.1,0.5l0,0
		c0.2,0.1,0.5,0.3,0.6,0.5c0.6,0.7,0.3,1.8-0.4,2.6c0.3,0.1,0.5,0.4,0.8,0.6c0.7,0.1,1.3,0.6,1.4,1.1c0.1,0.8-0.6,1.7-1.6,1.9
		c-0.5,0.1-1,0-1.4-0.2c-1.5,0.3-2.1-0.1-2.8-1.5c-0.6,0.1-1.3,0.3-1.9,0.3l0,0c0.1,0.2,0.2,0.4,0.2,0.6c0,0.3,0,0.7-0.2,0.9
		c0.5,0.2,1,0.4,1.4,0.7c0.9,0.7,1.4,1.7,2.1,2.6c0.2-0.3,0.4-0.7,0.5-1l0,0c0,0,0,0,0-0.1c-0.1,0-0.2,0-0.2-0.1
		c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0-0.1s0.1-0.1,0.1-0.2c0,0.1-0.1,0.2-0.1,0.2l0,0c0,0.1,0,0.1,0,0.2c0,0,0,0,0.1,0l0,0
		c1.2-0.2,2.3-0.8,3.5-0.3c0.6,0.3,1,0.6,0.8,1.2c-0.1,0.5-0.3,0.9-0.4,1.4c-0.4-0.2-1-0.2-1.7-0.2c-1,0-1.9-0.1-2.9-0.1l0,0
		c-0.2-0.1-0.4-0.2-0.6-0.3c-1,1.4-2.3,2.5-4.3,2.6c-0.2,0-0.4,0-0.6,0c-0.4,0.4-1,0.7-1.7,0.9c-0.4,0.1-0.9,0.1-1.3,0
		c0.2,0.6,0,1.2-0.4,1.8c0.2,0.3,0.2,0.7,0.2,1.1c0,0.4,0,0.8,0.1,1.1c1.2-0.7,2.6-0.8,3.8-0.2c0,0,0,0,0.1,0h0.1
		c0.5,0.2,0.9,0.5,1.2,0.9c0.1,0,0.1,0.1,0.2,0.1c0,0.1,0,0.1,0,0.2c0.1,0.3,0.1,0.5,0.1,0.8c0.3-0.4,0.6-0.9,1-1.3
		c0-0.1,0.1-0.1,0.1-0.2c-0.2,0-0.4,0.1-0.7,0.1v-0.1c0.3-0.1,0.6-0.1,0.9-0.2c0.5-0.4,0.9-0.2,1.2,0.9c0.2-0.3,0.4-0.5,0.6-0.8
		c0-0.6-0.1-1.1-0.8-1.4c-0.7,0-1.3,0-1.8-0.1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2-0.1-0.3-0.2-0.5-0.4c-0.5-0.2-0.8-0.6-1-1.1
		c-0.2-0.8,0.3-1.9,1.2-2.4c1.2-0.7,2.5-0.6,4.1,0.4c2.5-1.4,5-2,7.5-1.2c0.4,0.3,0.8,0.6,1.1,1c0.1,0.1,0.2,0.1,0.2,0.2
		c0.3-0.3,0.5-0.6,0.8-0.9c0.6,0.2,1.2,0.3,1.6,0.4c0.4-0.3,0.7-0.4,0.9-0.7c0.3-0.3,0.6-0.8,0.5-1.1c-0.3-0.7-0.1-1.5-0.6-2
		c0.4-0.6,0.7-1.1,1-1.6c-0.2-0.1-0.4-0.1-0.5-0.1s-0.2,0.1-0.3,0.1c-0.9,0.2-1.8-0.4-1.9-1.2c-0.1-0.4,0.1-0.8,0.4-1.2
		c0-0.2,0-0.4,0-0.6c-0.3,0.3-0.6,0.4-0.9,0.7c-0.3-1.1-1.4-0.3-2.1-0.5c-0.5,0.4-0.6,1.1-1.5,1.3c-0.2-1.1,0.9-1.7,1.3-2.5
		c-0.2-0.1-0.4-0.2-0.7-0.4c-0.3,0.3-0.5,0.5-0.8,0.7s-0.8,0.3-1,0.2s-0.3-0.5-0.3-0.8c0.2-0.5,0.5-1,0.8-1.6c0.1,0,0.2,0.1,0.3,0.1
		c0-0.1,0.1-0.3,0.2-0.4c0.6,0.2,1,0.3,0.8,0.8c0.2,0.1,0.4,0.1,0.6,0.1c1.1-0.3,1.4,0.2,1.7,0.8c-0.2,0.4-0.3,0.7-0.6,1.3
		c0.7-0.4,1.1-0.6,1.5-0.7c0.4-0.1,0.9-0.2,1.4-0.3c-0.1-0.3-0.2-0.5-0.2-0.7c-0.1-0.1-0.2-0.1-0.4-0.2c0.1-0.1,0.1-0.2,0.2-0.3l0,0
		l0,0c0.1-0.2,0.3-0.4,0.4-0.5c0.2-0.1,0.5,0.1,0.9,0.2c0-0.2,0-0.3,0-0.5l0,0v-0.1c-0.5-0.2-1.2,0-1.2-0.8c0.7,0,1.1,0.3,1.2,0.8
		h0.1l0,0c1-0.2,1.3-0.3,1.6,0.1c0.2-0.9,0.4-1.8,0.6-2.8c1.4-0.1,2.6,0.5,2.9,1.3c0.1,0.2,0.1,0.5,0.1,0.8c0.5,0.6,1.6,0.2,1.9,1
		c-1.8,0.2-2.3,0-1.9-1c0,0,0,0.1-0.1,0.1c-0.2,0.3-0.5,0.6-0.8,0.8c0.4,0.4,0.6,0.8,0.7,1.3c0,0,0,0,0.1,0l-0.1,0.1
		c0.5-0.3,0.9-0.5,1.4-0.8c0.6,0.5,1.1,0.9,1.5,1.3c0.3-0.4,0.7-0.7,1-1.1c0.2,0.1,0.5,0.2,0.5,0.3c0.4,0.8,1.5,1.2,1.7,2.1
		c0,0.1,0.2,0.3,0.3,0.3c1.3-0.4,1.2,0.6,1.7,0.9c-0.2,0.1-0.4,0.2-0.5,0.3l0,0l0,0c-0.4,0.3-0.3,0.4-0.2,1c0.4-0.2,0.9-0.1,1.3-0.6
		c0.6-0.7,1-0.7,1.6-0.2c0.2-0.1,0.3-0.1,0.5-0.2c-0.2-0.4-0.2-0.6-0.4-0.9c0,0-0.3,0-0.5,0.1l0,0l-0.1,0.1c0,0.1,0,0.3-0.1,0.4
		c-0.1,0-0.2,0-0.2-0.1c0.1-0.1,0.2-0.2,0.3-0.3v-0.1c0,0,0,0,0.1,0c0.1-0.5,0.2-1.1,0.3-1.6c-0.1-0.1-0.1-0.2-0.2-0.4
		c-0.3-1,0.4-1.9,1.6-2.2c0.4-0.1,0.9-0.1,1.2,0c0.2-0.1,0.4-0.1,0.6-0.1c1.5-0.2,3.1,0.4,3.7,1.5c0,0,0,0.1,0.1,0.1
		c0.1-0.2,0.3-0.3,0.5-0.4c-0.3-0.2-0.5-0.3-0.8-0.6c-1.5-1.4-1.8-3.7-0.6-5.5c0.2-0.4,0.5-0.7,0.9-1.3c-2.5,0.3-4.3-0.4-5.6-2.1
		c0,0.3-0.1,0.6,0,0.8c0.3,0.8,0.4,1.6,0.2,2.3c0,0,0,0.1,0.1,0.1h-0.1c-0.2,0.6-0.5,1.2-1.1,1.8c-0.4,0.4-0.5,0.8-0.4,1.3
		c0,0.5-0.1,1-0.3,1.3c0.1,0.1,0.2,0.2,0.3,0.3c-0.2,0-0.3-0.1-0.4-0.1c-0.3,0.5-0.8,0.8-1.4,1c0.3,0.2,0.5,0.6,0.2,0.9
		c-0.5,0.6-0.3,1,0,1.5c-0.1,0.1-0.3,0.1-0.4,0.2c-0.4-0.9-0.8-1.7-1.2-2.5c-0.3,0-0.6-0.1-0.8-0.2c-0.1,0-0.2-0.1-0.4-0.1
		c-0.1,0-0.2,0.1-0.3,0.1c-0.1-0.1-0.1-0.2-0.2-0.4c-0.9-0.4-1.5-1-1.2-2.2c0-0.2-0.1-0.4-0.2-0.7l0,0c-0.3-0.2-0.6-0.4-0.8-0.6
		c-0.1,0.4-0.1,0.8-0.3,1.5c-0.5-0.5-0.9-0.8-0.9-1c0.1-0.6-0.1-1-0.4-1.4c-0.3-0.5,0.1-0.9,0.8-0.9c0.2,0,0.3,0,0.4,0
		c-0.2-1,0.1-1.9,0.8-2.8c1.1-1.4,2.8-2,4.8-1.8l0,0l0.1-0.1l0.1,0.1l0,0c0.1,0,0.2,0,0.3,0c0.8,0.1,1.6,0,2.5,0
		c0.1-0.6,0.2-1,0.2-1.5c0-0.3-0.2-0.7-0.4-0.9c-0.7-0.6-1-1-1.2-1.8c0,0,0,0-0.1,0c0-0.1,0-0.2,0-0.2c0-0.2-0.1-0.4-0.1-0.6
		c0.1,0,0.2,0.1,0.3,0.1h0.1l0,0c0.2,0.1,0.3,0.1,0.5,0.2c-0.2-0.5-0.4-1,0.2-1.5c1.6,0.4,2.1,1,1.8,2.1c-0.1,0.4-0.4,0.8,0.1,0.9
		c0.4,0.1,0.9-0.1,1.3-0.4c0.3-0.2,0.3-0.6,0.5-0.8c0.6-0.2,0.9,0.5,1.5,0c0.9-0.7,1.9-0.4,2.8,0.1c2,1.2,2.5,3.2,1.4,5.2
		c-0.2,0.4-0.5,0.7-0.8,1.2c1.6-0.3,3-0.2,4.3,0.4c0.2,0.1,0.4,0,0.7-0.1l0,0h0.1c0.2-0.4,0.5-0.8,0.8-1.3c0.1,0.4,0.2,0.7,0.2,1.1
		c0,0,0,0,0.1,0l0,0c0,0,0,0,0,0.1c0.5-0.1,0.8-0.2,1-0.7c0.9-1.9,2-2.4,4.2-2.2c0.5,0,0.9-0.1,1.5-0.2c0.2,0.7,0.5,1.6,0.7,2.5
		c0.2,1.3-0.6,2.5-2,3c-1.5,0.6-3.1,0.3-3.9-0.7c-0.3-0.4-0.6-0.9-0.8-1.4c-0.1,0.1-0.3,0.2-0.4,0.4c-0.1-0.2-0.2-0.4-0.3-0.7
		c0,0,0,0-0.1,0c0,0,0,0,0-0.1c-0.3,0.1-0.7,0.1-1,0.2c0,0,0,0,0,0.1l0,0c1,1,1.6,2.2,1.8,3.5c0.1,0.7,0,1.3-0.2,1.8h0.1
		c0.2,0.2,0.4,0.4,0.6,0.6c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1-0.2-0.3-0.4-0.4-0.6c-0.6,1.3-1.8,2.3-2.8,2.8c-0.6,0.3-1.3,0.4-1.9,0.5
		c-0.2,0.1-0.3,0.3-0.5,0.4c-0.1,0-0.1-0.1-0.2-0.1c0.1-0.1,0.2-0.2,0.2-0.3c-0.4,0-0.8,0-1.2-0.1c0.3,0.5,0.7,0.9,1,1.5
		c-1,0.6-2,1.3-3.1,2c-0.3-0.3-0.6-0.6-0.9-0.9c-0.1,0.2-0.3,0.3-0.4,0.4c-0.4,0.3-0.8,0.5-1.1,0.8c0,0.2,0,0.4,0,0.6
		c1.2-0.1,2.3,0.2,3.2,0.9c0.5,0.4,1.1,0.7,1.6,1.1c0.7,0.5,0.7,1.3-0.2,1.6c0,0-0.1,0-0.1,0.1c-0.2,0.9-0.7,1.7-1.9,2.2
		c-0.5,0.2-1.1,0.4-1.6,0.4c-0.2,0.5-0.4,1-0.6,1.4c0.1,0.2,0.2,0.4,0.2,0.6c0.2,0.2,0.3,0.3,0.4,0.4c-0.2,0.3-0.4,0.5-0.6,0.8
		c-0.1,0.3-0.3,0.5-0.6,0.7c-0.4,0.5-0.7,0.9-1.1,1.3c-0.8,0.7-1.3,1.5-0.8,2.4c0.5-0.1,0.7-1,1.4-0.4c0.2-0.2,0.3-0.3,0.5-0.5
		c0,0,0,0,0-0.1h-0.1h0.1l0,0h0.1v0.1c0.7,0.1,1.3,0,1.7-0.6c-0.2-0.2-0.4-0.3-0.6-0.5c0.9,0.1,1.7,0.2,2.6,0.2c0,0.5-0.1,1-0.1,1.4
		c-0.4-0.1-0.7-0.2-1-0.3c-0.2,0.3-0.5,0.6-0.5,1c0,0.1,0.1,0.2,0.2,0.3c0.6,0.4,1,1,1.5,1.5c-0.3,0.2-0.5,0.4-0.7,0.5
		c0.1,0.3-0.2,0.7-0.1,1c0.3-0.1,0.5-0.2,0.8-0.4c0.4-0.2,0.8-0.5,1.3-0.6c2.7-0.5,2.7-0.5,4.4,1.2c0.1-0.1,0.2-0.1,0.3-0.2
		c-0.1-0.6-0.2-1.2-0.3-1.8c-0.4,0.2-0.6,0.4-0.9,0.5c-0.6-0.6-0.6-0.6,0.1-1c0.2-0.1,0.5-0.2,0.5-0.3c0.1-0.2,0.1-0.5,0.1-0.7
		c-0.1-0.1-0.2-0.3-0.2-0.4c0-0.5,0.1-0.9,0.1-1.4c-0.2-0.2-0.4-0.5-0.6-0.7c-1.3-1.6-1.2-3,0.5-4.6c0.2-0.2,0.4-0.3,0.5-0.4
		c-0.4-0.9-1.1-0.3-1.7-0.3c-0.3-0.4-0.6-0.8-1.1-1.4c0,0.6,0,1,0.1,1.3c-0.1,0-0.2,0.1-0.4,0.1c-0.3-0.6-0.7-1.2-0.9-1.9
		c-0.2-0.5,0.2-0.8,0.6-1c1,0.5,1.8,1.2,2.7,1.3c1.2,0.2,1.3,0.8,1.4,1.5c0.8,0.4,1.6,0.7,2.4,1c-0.6,1.1-0.7,1.2-1.5,1.1
		c-0.9,0-1.5,0.3-2.1,0.9c0,0.6,0.1,1.2,0.4,1.6c0.1-0.1,0.2-0.2,0.2-0.3c0.3,0.3,0.5,0.5,0.7,0.7c0.9-0.5,1-1.1,0.8-1.6
		c0.4-0.2,0.8-0.3,1.1-0.5c0.2-0.2,0.3-0.7,0.5-0.7c0.7-0.2,1.1-0.5,1.6-1c0.4-0.3,1.2-0.1,1.5-0.6c0.4,0.3,0.9,0.3,1.4,0.1
		c0-0.4,0.2-0.8,0.6-1.2c0.2-0.3,0.5-0.5,0.8-0.8l0,0c-0.8,0.3-1.6,0.4-2.4,0.1c-0.4-0.1-0.9,0-1.4,0.1l0,0c0,0,0,0-0.1,0
		c0,0.1,0,0.2,0.1,0.2c0.2,0.4,0.6,0.9,0,1.2c-0.9,0.4-0.8-0.5-1.2-0.7c0.1-0.6,0.7-0.7,1.2-0.8c0,0,0,0,0-0.1l0,0
		c-0.7-0.6-1.5-1.3-2.3-2c0.2-0.3,0.5-0.7,0.8-1.1c1,0.3,2.4-0.3,2.7,1c0.9-0.3,1.7-0.7,2.5-0.1c0.8,0.6,0.3,1.4,0.1,2.1l0,0
		l-0.1,0.1c0.4,0,0.7-0.1,1.1-0.1c1.3,0,2.1,0.5,2.4,1.6c0,0.1,0,0.2,0.1,0.3h0.1c0.2,0,0.4,0.1,0.6,0.2c0.1-0.1,0.3-0.2,0.4-0.3
		c-0.1-0.3,0.1-0.7,0.8-0.9c0.2,0.1,0.5,0.3,0.7,0.5c0.5,0,1,0,1.5,0.2c0.1-0.2,0.1-0.2,0.1-0.3c0-0.5,0-1-0.1-1.5
		c-0.2,0-0.4,0-0.6,0c-1.8,0.1-2.7-0.3-3-1.3s0.2-1.8,1.7-2.7c1.3-0.8,1.6-2,0.6-3c-0.7-0.8-1.4-1.6-1.9-2.5c-0.8-1.3,0-2.8,1.7-3.5
		c1.5-0.6,3.2-0.1,3.9,1c0.7,1.3,0,2.9-1.6,3.6c-0.5,0.2-1,0.3-1.6,0.5c1.1,0.7,1.4,1.5,1.4,2.6c0,1.2,0.4,2.4,1.2,3.4
		c0.4,0.5,0.7,1.2,1.1,1.7c0.2,0.3,0.6,0.7,1,0.7c1.5,0.1,1.4,1.7,2.7,2c0.1,0,0.2,0.2,0.2,0.4c0,0.1-0.1,0.2-0.1,0.4
		c-0.4-0.1-0.8-0.2-1.2-0.3c-0.2,0.3-0.4,0.6-0.7,1c0.8,0.2,1.4,0.3,2.2,0.5c0.1,0.3,0.1,0.7,0.2,1.1c0.5-0.2,0.9-0.4,1.3-0.5
		c0-1.5,0.3-3,1.4-4.3c0.4-0.5,0.8-0.9,1.1-1.4c-0.5,0.2-0.9,0.5-1.4,0.6c-0.1,0.6-0.7,1.2-1.5,1.4c-1,0.2-2-0.3-2.2-1.1
		c0-0.1,0-0.2,0-0.3c-0.4-0.1-0.7-0.3-0.8-0.7s-0.1-0.9,0.1-1.3c0.6-1.1,2.3-0.8,3.2-1.5c0.3-0.2,0.9-0.2,1.4-0.2
		c0.2,0,0.4,0,0.5,0.1c0.4,0.3,0.9,0.4,1.4,0.4V56c-0.1,0-0.2,0-0.4-0.1c-0.5-0.2-0.7-0.6-0.5-1.1c0.2-0.4,0.5-0.7,0.9-0.8v-0.3l0,0
		c-1-0.6-2.1-1.2-3.2-1.8c-0.9-0.5-1.4-1.2-1.3-2.1c0.1-0.9,0.7-1.7,1.8-2.1c0.9-0.3,1.8-0.6,2.8-0.9v-0.5c-0.3-0.1-0.6-0.2-0.9-0.3
		C611.1,46.3,611.1,46.7,611,47.1z M524.9,38.1C524.9,38.1,525,38.1,524.9,38.1v0.2C524.8,38.3,524.8,38.2,524.9,38.1
		C524.8,38.1,524.9,38.1,524.9,38.1z M522.6,37.9c0,0.1,0,0.1,0.1,0.2c-0.3,0.1-0.6,0.2-0.9,0.3c0-0.1,0-0.2-0.1-0.2
		C521.9,38.1,522.3,38,522.6,37.9z M525,32.5c0.4,0.2,0.7,0.3,1.2,0.6c-0.7,0.2-1.2,0.4-1.7,0.6c-0.1-0.1-0.2-0.1-0.2-0.2
		C524.4,33.1,524.7,32.8,525,32.5z M515.4,28.4C515.4,28.4,515.5,28.3,515.4,28.4L515.4,28.4L515.4,28.4c0.1,0,0.1,0,0.2,0.1
		C515.5,28.4,515.5,28.4,515.4,28.4L515.4,28.4z M508.4,34.7c0.5,0.1,0.8,0.4,1.5,0.7c-0.6,0.5-0.9,0.9-1.3,1
		c-0.5,0.2-1.1-0.2-1.1-0.6C507.4,35.3,507.9,34.7,508.4,34.7z M502.8,37.6c0-0.1-0.1-0.1-0.1-0.2c0,0,0-0.1,0.1-0.1
		c0,0.1,0.1,0.1,0.1,0.2C502.8,37.5,502.8,37.6,502.8,37.6z M510.4,45c0-0.1,0-0.1,0-0.2c0.3-0.1,0.6-0.1,0.9-0.2c0,0.1,0,0.1,0,0.2
		C511,44.8,510.7,44.9,510.4,45z M513.4,44.5c0.2-0.1,0.4-0.2,0.6-0.2c0,0.1,0.1,0.1,0.1,0.2c-0.2,0-0.4,0.1-0.5,0.1
		S513.5,44.6,513.4,44.5z M514.1,45.8C514.1,45.8,514,45.8,514.1,45.8c-0.1-0.1-0.1-0.2,0-0.2C514.1,45.6,514.2,45.6,514.1,45.8
		C514.2,45.7,514.1,45.8,514.1,45.8z M514.6,46.4c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0.1,0.1,0.1C514.6,46.3,514.6,46.3,514.6,46.4z
    M517.8,38C517.8,38,517.9,38,517.8,38v0.2C517.8,38.2,517.7,38.2,517.8,38C517.7,38.1,517.7,38,517.8,38z M517.8,45.2L517.8,45.2
		c0.1-0.1,0.1,0,0.2,0C517.9,45.2,517.9,45.2,517.8,45.2z M517.3,44.8c-0.1-0.1-0.1-0.1-0.2-0.2c0.2-0.3,0.4-0.7,0.7-1.1
		c0.2,0.2,0.5,0.5,0.4,0.5C518,44.3,517.7,44.5,517.3,44.8z M516.1,41.6c0.2-0.9,0.7-1.4,1.5-1.5c0.8-0.2,1.4,0.1,1.8,0.8
		C518.4,41.4,517.4,41.4,516.1,41.6z M521.1,47.9c-0.1,0-0.2,0-0.3,0c0.1-0.1,0.1-0.3,0.2-0.4c0.2,0,0.3,0.1,0.4,0.1
		C521.3,47.6,521.2,47.8,521.1,47.9z M522,46.4C522,46.5,522,46.5,522,46.4C522,46.5,522,46.4,522,46.4S522.1,46.4,522,46.4
		C522.1,46.4,522,46.4,522,46.4z M523.2,49.6c0-0.1,0.1-0.3,0.1-0.4c0.1,0.1,0.3,0.1,0.3,0.1c0,0.1-0.1,0.2-0.1,0.3
		C523.4,49.6,523.3,49.6,523.2,49.6z M524.3,50.2l-0.2-0.1c0.1-0.1,0.2-0.3,0.3-0.4c-0.2,0.3-0.5,0.5-0.7,0.8
		c-0.1-0.1-0.2-0.1-0.4-0.2c0.3-0.3,0.7-0.6,1-1c0.1,0,0.2,0.1,0.2,0.1l-0.1,0.1c0.1,0,0.2,0.1,0.3,0.2
		C524.6,50,524.5,50.1,524.3,50.2z M545.4,39.1c-0.1,0.1-0.4-0.2-0.8-0.4c0.3-0.3,0.5-0.5,0.7-0.6c0.2,0,0.4,0.2,0.7,0.3
		C545.8,38.6,545.6,38.9,545.4,39.1z M549.4,42.1c-0.3-0.3-0.5-0.5-0.7-0.7c-0.2,0.2-0.4,0.4-0.6,0.7c-0.1,0-0.1-0.1-0.2-0.1
		c0.2-0.2,0.4-0.5,0.6-0.7l0.1,0.1l0,0c0-0.2,0.4-0.4,0.7-0.6c0.3,0.2,0.7,0.4,0.8,0.6C550.1,41.4,549.7,41.7,549.4,42.1z
    M544.1,49.6c-0.1-0.2-0.1-0.4-0.2-0.6c0.1,0,0.2,0,0.3-0.1c0.1,0.2,0.1,0.4,0.2,0.6C544.3,49.6,544.2,49.6,544.1,49.6z
    M545.2,50.4C545.2,50.4,545.1,50.4,545.2,50.4l-0.1-0.2h0.1C545.2,50.3,545.2,50.3,545.2,50.4z M539.7,53.8
		c-0.1-0.1-0.2-0.1-0.2-0.2c0-0.1,0.1-0.3,0.2-0.5c0.2,0.3,0.4,0.4,0.3,0.4C539.9,53.6,539.8,53.7,539.7,53.8z M533.7,64
		c-0.2-0.1-0.3-0.1-0.6-0.2c0.2-0.2,0.3-0.4,0.5-0.5c0.1,0,0.4,0.1,0.4,0.2C533.9,63.7,533.8,63.9,533.7,64z M534.8,65
		c-0.2-0.2-0.3-0.2-0.3-0.3c0,0,0.1-0.2,0.2-0.2c0.1,0,0.3,0.1,0.4,0.1C535.1,64.7,534.9,64.8,534.8,65z M542.4,60.3L542.4,60.3
		L542.4,60.3L542.4,60.3z M549.4,59.1c0-0.1,0-0.1-0.1-0.2h0.1V59C549.4,59,549.4,59.1,549.4,59.1z M548.9,56.6
		c0.1,0,0.1,0.1,0.2,0.1c0,0,0,0,0.1,0l0,0c0.1,0,0.2,0,0.4,0l0,0h0.1h-0.1c0,0,0,0,0.1,0c-0.1-0.2-0.1-0.4-0.2-0.5
		c-0.2-0.3-0.5-0.7,0-0.9c0.3-0.2,0.8-0.3,1.2-0.2c1.3,0.4,2.6,0.8,3.3,1.9c-0.9,1.1-1.4,1.2-2.1,0.3c-0.6-0.7-1.3-0.7-2.1-0.6l0,0
		c0,0,0,0-0.1,0c0.2,0.3,0.4,0.7,0.6,1c-0.8-0.1-1.5-0.2-1-1l0,0l0,0c-0.1,0-0.1,0-0.2,0C548.9,56.8,548.9,56.7,548.9,56.6z
    M548.8,54.5L548.8,54.5L548.8,54.5L548.8,54.5z M549.3,47.6c-0.1,0-0.5-0.1-0.5-0.2c0-0.2,0.2-0.4,0.4-0.5
		c0.1-0.1,0.4,0.1,0.7,0.2C549.6,47.3,549.4,47.6,549.3,47.6z M550.2,46.7c-0.1,0-0.2,0-0.2-0.1s0-0.2,0.1-0.3
		c0.1,0,0.2,0.1,0.2,0.1C550.3,46.5,550.2,46.6,550.2,46.7z M550.6,47.4c0-0.1-0.1-0.2-0.1-0.3l0.1-0.1c0.1,0.1,0.1,0.1,0.2,0.2
		C550.7,47.3,550.6,47.4,550.6,47.4z M551.8,47.8c-0.1,0-0.2-0.1-0.3-0.1l0.1-0.1c0.1,0,0.2,0,0.3,0
		C551.9,47.6,551.9,47.7,551.8,47.8z M552.2,48.1L552.2,48.1L552.2,48.1L552.2,48.1z M552.9,37.2c0.3,0.2,0.7,0.3,0.7,0.4
		c0,0.1-0.2,0.5-0.4,0.5s-0.6-0.1-0.7-0.3C552.4,37.7,552.7,37.5,552.9,37.2z M553.2,38.5c0.2,0.2,0.2,0.7,0.1,0.9
		c0,0.1-0.7,0.2-1,0.2c-0.4-0.1-0.6-0.4-1-0.7C552.3,38.2,552.8,38.1,553.2,38.5z M552.3,41.6c0,0.2,0.1,0.4,0,0.7
		c-0.4-0.2-0.6-0.4-0.8-0.5c-0.3,0-0.7-0.1-1.1-0.3c0.3-0.2,0.7-0.4,1-0.6c0-0.1,0.1-0.1,0.1-0.2c0,0,0.1,0,0.1,0.1
		c0.5-0.3,0.9-0.5,1.5-0.8C552.9,40.8,552.6,41.3,552.3,41.6z M553.4,42.1c-0.1-0.1-0.2-0.3-0.2-0.3c0.2-0.2,0.5-0.3,0.7-0.4
		c0.1,0.1,0.1,0.1,0.2,0.2C553.8,41.7,553.6,41.9,553.4,42.1z M553.9,45c-0.1-0.2,0.1-0.5,0.2-1.1c0.6,0.7,0.9,1,1.2,1.4
		C554.4,45.8,554.2,45.3,553.9,45z M555.9,46.2c0,0-0.1,0-0.2,0c0.1-0.1,0.2-0.3,0.3-0.4c0,0.1,0.1,0.2,0.1,0.2
		C556.1,46.1,556,46.1,555.9,46.2z M556.2,40.2c-0.9,0.2-1.8-0.2-2.1-1c-0.2-0.8,0.5-1.7,1.5-1.9s2,0.3,2.2,1.1
		C558,39.1,557.3,39.8,556.2,40.2z M573.4,46c0.1,0,0.2,0,0.4,0c-0.1,0.3-0.1,0.7-0.2,1c-0.1,0-0.2,0-0.4,0
		C573.3,46.6,573.4,46.3,573.4,46z M560.4,39.2L560.4,39.2L560.4,39.2L560.4,39.2z M559.4,35.6c-0.1,0.1-0.3,0.2-0.4,0.2
		c-0.2-0.3-0.4-0.6-0.7-1.1C559.3,34.8,559.3,35.2,559.4,35.6z M558.9,43.8c-0.2-0.2-0.5-0.4-0.5-0.4c0.1-0.2,0.3-0.4,0.6-0.5
		c0.1,0,0.3,0.2,0.5,0.3C559.3,43.3,559.1,43.5,558.9,43.8z M560.2,45.8c-0.1-0.1-0.1-0.1-0.1-0.2l0.1-0.1c0.1,0.1,0.1,0.2,0.2,0.2
		C560.3,45.7,560.3,45.8,560.2,45.8z M560.9,44c-0.2-0.2-0.4-0.4-0.7-0.7C561.2,43.2,561.2,43.2,560.9,44z M566.5,31.6
		c-0.3,0-0.8-0.3-0.8-0.6c0-0.2,0.4-0.7,0.7-0.7c0.3-0.1,0.7,0.3,1.2,0.5C567.1,31.2,566.8,31.6,566.5,31.6z M568.3,36.3
		c-0.1-0.1-0.3-0.2-0.3-0.2c0-0.1,0.2-0.2,0.3-0.4c0.1,0.2,0.3,0.3,0.3,0.4C568.6,36.1,568.4,36.2,568.3,36.3z M568.2,35.3
		c-0.3-0.6,0-1.1,0.3-1.6c0,0,0,0,0-0.1c0,0,0,0,0.1-0.1v0.1l0,0C568.6,34.3,568.9,34.8,568.2,35.3z M569.8,33.2
		C569.8,33.2,569.8,33.3,569.8,33.2L569.8,33.2L569.8,33.2L569.8,33.2L569.8,33.2L569.8,33.2C569.9,33.1,569.8,33.2,569.8,33.2z
    M572.1,31.9L572.1,31.9L572.1,31.9L572.1,31.9z M573.5,34C573.5,34,573.5,34.1,573.5,34C573.5,34.1,573.5,34,573.5,34
		C573.5,33.9,573.6,33.9,573.5,34C573.6,33.9,573.6,33.9,573.5,34z M581.7,29.7c0.1,0.1,0.3,0.1,0.4,0.2c0,0.1-0.1,0.2-0.1,0.4
		c-0.2-0.1-0.4-0.1-0.4-0.2C581.5,30,581.6,29.9,581.7,29.7z M579.1,33.4c-0.1-0.1-0.2-0.2-0.2-0.3l0.2-0.2c0.1,0,0.2,0.1,0.4,0.2
		C579.3,33.2,579.2,33.3,579.1,33.4z M580,30.9c0.3-0.6,0.5-1.1,0.7-1.6C581.1,30.1,581.1,30.1,580,30.9z M580.6,30.6
		c0.1,0.1,0.2,0.2,0.2,0.2c0,0.1-0.1,0.2-0.3,0.5c-0.1-0.2-0.3-0.3-0.3-0.4C580.3,30.8,580.5,30.7,580.6,30.6z M580.8,36L580.8,36
		l0.1-0.2c0-0.2,0.1-0.5,0.1-0.7c0.1,0,0.2,0.1,0.4,0.1c-0.2,0.2-0.3,0.4-0.5,0.6C580.8,35.8,580.8,35.9,580.8,36L580.8,36
		c0,0.2,0,0.3,0,0.5c-0.1,0-0.2,0-0.3,0C580.6,36.3,580.7,36.2,580.8,36z M581.6,39.5C581.6,39.5,581.6,39.4,581.6,39.5
		c-0.4-0.1-0.7-0.2-1.1-0.3c0.3-0.3,0.5-0.6,0.6-0.6c0.2,0,0.4,0.1,0.6,0.2c0.3-0.2,0.6,0.1,0.8,0.3
		C582.5,39.4,582.2,39.8,581.6,39.5z M583.6,32.4L583.6,32.4l-0.1-0.2c0.1,0,0.1,0,0.2,0.1C583.7,32.3,583.7,32.3,583.6,32.4z
    M587.2,38.1c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.2,0.3-0.5,0.4-0.7c0.1,0,0.2,0.1,0.2,0.1C587.5,37.6,587.3,37.8,587.2,38.1z
    M588.9,38.6L588.9,38.6L588.9,38.6L588.9,38.6z M576,62.8c-0.1,0-0.1,0-0.2,0v-0.1C575.9,62.7,576,62.7,576,62.8
		C576,62.7,576,62.8,576,62.8z M576.2,64.1L576.2,64.1c0,0.1-0.1,0.2-0.1,0.3C576.2,64.2,576.2,64.2,576.2,64.1L576.2,64.1
		c0-0.2,0-0.5-0.1-0.9C576.4,63.5,576.8,63.8,576.2,64.1z M576.7,62L576.7,62L576.7,62L576.7,62z M582.5,69.5
		C582.6,69.5,582.6,69.5,582.5,69.5c0.1,0.1,0,0.1,0,0.2C582.5,69.7,582.4,69.7,582.5,69.5C582.4,69.5,582.5,69.5,582.5,69.5z
    M579.5,61.8C579.5,61.8,579.5,61.7,579.5,61.8C579.6,61.7,579.6,61.8,579.5,61.8L579.5,61.8C579.5,61.9,579.5,61.9,579.5,61.8
		C579.5,61.9,579.5,61.9,579.5,61.8z M578.1,60.9c0.2,0.2,0.4,0.4,0.6,0.6c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2-0.2-0.3-0.5-0.5-0.7
		C577.9,61,578,60.9,578.1,60.9z M577,66.4c0.7-0.7,1.1-0.4,1.6-0.1C578.1,67.1,577.7,66.6,577,66.4z M578.6,72.4
		c-0.5-0.4-0.5-0.8,0-1.3C579,71.5,579.2,71.9,578.6,72.4z M581,66.8c-0.3,0.6-0.9,0.6-1.5,0.8c-0.1-0.1-0.2-0.2-0.3-0.3
		c0.3-0.2,0.6-0.4,0.9-0.7C580.3,66.6,580.6,66.7,581,66.8z M579.7,63.4L579.7,63.4L579.7,63.4L579.7,63.4z M579.8,65.8
		c-0.3-0.6-0.6-1.1-0.9-1.7C580.2,64.5,580.2,64.5,579.8,65.8z M583.9,65.5c0-0.1-0.1-0.1-0.1-0.2s0.1-0.1,0.2-0.2
		c0.1,0.1,0.1,0.1,0.2,0.2C584,65.4,584,65.4,583.9,65.5z M582.3,59.1c-0.2-0.1-0.4-0.5-0.3-0.7c0.2-0.5,0.6-0.6,1.7-0.3
		C583.4,58.8,583.2,59.4,582.3,59.1z M585.4,56.3c-1.2,0.3-2.4-0.2-3-1c0,0.3,0.1,0.5,0.2,0.8c0.4,0.7-0.5,1.3-1,1.9v0.1
		c0,0-0.1,0-0.1-0.1c-0.1,0.1-0.2,0.2-0.2,0.3c-1.1-0.8-1.7-1.6-0.8-2.9c0.1-0.2,0-0.6,0-0.8c-0.1-0.4-0.1-0.4,0.5-1.2
		c0.6,0.1,1,0.4,1.2,0.7c0-1.1,0.9-2.1,2.2-2.4c0.3-0.1,0.7-0.1,1-0.1c0.2-0.2,0.5-0.5,0.6-0.8c0.3,0.4,0.5,0.7,0.7,1
		c-0.1,0-0.1,0.1-0.2,0.1c0.5,0.3,0.9,0.7,1.1,1.3C587.9,54.5,586.9,56,585.4,56.3z M587.8,54.9c-0.1,0-0.2,0-0.2-0.1v-0.1
		c0.1,0,0.2,0,0.2,0C587.9,54.7,587.9,54.8,587.8,54.9z M588.3,57.1c-0.1-0.1-0.1-0.2-0.2-0.2c0.3-0.2,0.7-0.4,1-0.6
		c0.1,0.1,0.2,0.2,0.3,0.3C589.1,56.8,588.7,56.9,588.3,57.1z M589.2,49.4c-0.1,0-0.2-0.1-0.3-0.2c0.1-0.1,0.3-0.3,0.4-0.4
		c0.1-0.1,0.3,0,0.8,0.1C589.5,49.2,589.3,49.3,589.2,49.4z M596.4,42C596.4,42,596.5,42,596.4,42l0.1,0.2c-0.1,0-0.1,0-0.2-0.1
		C596.4,42.1,596.4,42,596.4,42z M595.6,40.5c0.1,0,0.3,0,0.4,0.1c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0-0.2,0-0.3,0
		C595.4,41,595.5,40.8,595.6,40.5z M595.4,44.6c0.6-0.1,1.1,0.3,1.1,0.7s-0.4,1-0.9,1.1s-1.1-0.2-1.2-0.6
		C594.3,45.2,594.7,44.7,595.4,44.6z M594.7,38.2c0,0.1,0.1,0.1,0.1,0.2c0,0.1-0.1,0.1-0.2,0.2c-0.1-0.1-0.2-0.2-0.2-0.2
		C594.5,38.4,594.6,38.3,594.7,38.2z M593.2,45c0.1,0.2,0.2,0.4,0.4,0.6c-0.1,0.1-0.2,0.1-0.2,0.2c-0.2-0.2-0.3-0.3-0.5-0.5
		C593,45.2,593.1,45.1,593.2,45z M593.3,47.1c1.5-0.3,3,0.5,3.2,1.8s-0.8,2.6-2.4,2.9c-1.4,0.3-3.1-0.5-3.2-1.6
		C590.7,48.7,591.7,47.5,593.3,47.1z M591.3,51c0.3,0.5,0.5,0.8,0.8,1.1C591.2,52.1,590.8,51.9,591.3,51z M592.2,57.7L592.2,57.7
		c-0.1-0.2-0.1-0.3,0-0.4l0.1,0.1C592.2,57.5,592.2,57.6,592.2,57.7z M594.9,58.4c0.7-0.1,0.7-0.1,1,0.4
		C595.5,58.7,595.2,58.5,594.9,58.4z M596.1,55.4c-0.9,0.8-2.8,0.7-3.5-0.3c-0.1-0.2-0.1-0.5-0.3-0.7c-0.1-0.2-0.3-0.2-0.5-0.4
		c0.4-0.4,0.8-0.7,1.2-1.1c1-0.8,2.3-0.9,3.1-0.2C597,53.4,597,54.6,596.1,55.4z M597.7,55.2L597.7,55.2L597.7,55.2L597.7,55.2
		C597.7,55.3,597.7,55.3,597.7,55.2z M597.3,55.2c0,0.1-0.1,0.2-0.1,0.3c-0.1,0-0.2,0-0.3,0c0-0.1,0-0.2,0.1-0.2
		C597.1,55.2,597.2,55.2,597.3,55.2z M597.7,46.6c-0.1,0-0.3-0.1-0.4-0.1c0-0.1,0.1-0.3,0.2-0.5c0.2,0.1,0.3,0.2,0.3,0.3
		C597.9,46.3,597.8,46.5,597.7,46.6z M597.8,45.2c-0.3-0.6-0.1-1,0.6-1.2C598.6,44.6,598.3,44.8,597.8,45.2z M602.4,57.1
		c0-0.1-0.1-0.1-0.1-0.2l0.1-0.1l0.1,0.1C602.4,57,602.4,57,602.4,57.1z M605.4,56.2c-1.5,0.3-2.9-0.4-3.1-1.6c0-0.1,0-0.1,0-0.2
		c-0.1,0-0.2,0-0.3,0c0.1-0.3,0.1-0.7,0.2-1c0.1,0,0.2,0,0.3,0c0.3-0.7,1.1-1.3,2.1-1.5c1.5-0.3,2.8,0.4,3,1.7
		C607.7,54.8,606.8,56,605.4,56.2z"
      />
      <path
        class="st3"
        d="M400.9,71.4c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0,0.2,0,0.3,0C401,71.5,401,71.5,400.9,71.4z"
      />
      <path
        class="st3"
        d="M368.9,65.6c0.1-0.1,0.2-0.1,0.4-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.2-0.3-0.6-0.5-0.9
		c-1.2,0.3-0.6,1.2-1.1,1.7c0.1,0.1,0.3,0.1,0.4,0.2C368.3,66,368.6,65.8,368.9,65.6z"
      />
      <path
        class="st3"
        d="M374.8,66.5c0.3-0.3,0.8-0.6,1.1-0.9c-0.2-0.2-0.4-0.4-0.6-0.6c-0.3-0.2-0.5-0.4-0.6-0.7
		c-0.1-0.1-0.2-0.2-0.4-0.4c-0.7,0.5-1.5,0.6-2.1,1.2c0.7,0.1,1.4,0.3,1.9,0.7C374.4,66,374.6,66.2,374.8,66.5z"
      />
      <path
        class="st3"
        d="M406,71.7c0.1,0,0.2,0,0.3,0c0-0.1-0.1-0.2-0.1-0.3c-0.2-0.5,0-1.1,0.3-1.6c-0.5,0.1-1,0.2-1.5,0.4
		C405.4,70.6,405.8,71.1,406,71.7z"
      />
      <path
        class="st3"
        d="M588.6,197.7c0,0.1,0.1,0.1,0.1,0.2c0.2,0,0.3,0.1,0.5,0.2c0.3-0.2,0.5-0.4,0.8-0.6
		C589.3,197.1,589,197.4,588.6,197.7z"
      />
      <path
        class="st3"
        d="M594.7,184.3c0.3-0.2,0.4-0.3,0.3-0.5c-0.2-0.1-0.3-0.2-0.5-0.3C594.3,183.8,594.2,184.1,594.7,184.3z"
      />
      <path
        class="st3"
        d="M423.9,57.4c-0.8,0.6-1.6,0.8-2.4,0.6c0.1,0.4,0.2,0.8,0.3,1.1c1.5-0.2,2.6,0,3.2,0.5c0.5-0.5,1.1-0.8,1.9-1
		c0.3-0.1,0.7-0.1,1.2-0.1c-0.9-2,0-3.7,1.2-5.4c-0.7-0.3-1.4-0.5-1.9-0.9c-0.4-0.4-0.6-1-1-1.6c-2.1-0.9-3.9-0.1-4.7,2.4
		c1.6,0,2.9,0.4,3.3,1.8C425.2,55.9,424.8,56.8,423.9,57.4z M424.1,51.6c0,0-0.1,0-0.1-0.1l0.1-0.1
		C424.1,51.4,424.2,51.5,424.1,51.6C424.2,51.5,424.2,51.6,424.1,51.6z"
      />
      <path
        class="st3"
        d="M541.2,57.8c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0.1-0.2,0.1C541.1,57.7,541.1,57.8,541.2,57.8z"
      />
      <path
        class="st3"
        d="M533.6,48.5c-0.2-0.5-0.3-0.9-0.4-1.3c-0.5,0.3-0.7,0.5-0.9,0.5c0.3,0.3,0.5,0.6,0.7,0.8
		C533.2,48.5,533.4,48.5,533.6,48.5z"
      />
      <path
        class="st3"
        d="M427.9,64.2L427.9,64.2c-0.4,0.1-0.8,0.1-1.2,0c-1.1-0.1-2-0.7-2.4-1.6c-0.7,0.4-1.5,0.4-2.4,0.3
		c0,0.2,0,0.4,0.1,0.6c0.5,0.2,1,0.5,1.3,1c0.2,0.2,0.3,0.6,0.6,0.7c0.7,0.4,1.4,0.8,2.2,0.8c0.2-0.4,0.5-0.7,1-1.1
		C427.5,64.8,427.9,64.7,427.9,64.2z"
      />
      <path
        class="st3"
        d="M531.6,47.1L531.6,47.1c0,0.1,0.2,0.1,0.3,0.2c0,0-0.1-0.1-0.1-0.2C531.8,47.1,531.7,47.1,531.6,47.1
		C531.7,47.1,531.7,47.1,531.6,47.1z"
      />
      <path
        class="st3"
        d="M411.7,51.6c0-0.1-0.1-0.2-0.1-0.3c-0.2-0.8,0.4-1.6,1.4-1.7c0.5-0.1,1,0,1.4,0.3l0,0v-0.1
		c-0.1-0.5,0.2-1.1,0.7-1.4c0.2-0.3,0.2-0.6-0.2-0.9c-0.1-0.1,0.2-0.5,0.4-0.7c0.4-0.3,0.9-0.4,1.4-0.6c0.1-1.5-1.7-1.5-2.6-2.4
		c-0.1,0.4-0.2,0.6-0.3,0.8l0,0c0.6,0.3,0.6,0.6-0.1,0.8c-0.9,0.3-1.4,0.4-1.9,0.4c0,0.1,0.1,0.2,0.1,0.3c0.1,0.7-0.4,1.4-1.3,1.6
		c0.1,0.1,0.3,0.1,0.4,0.2c-0.7,0.6-1.4,1.2-2.1,1.8C409.3,51,410.9,51.1,411.7,51.6z"
      />
      <polygon class="st3" points="565.9,54.6 566.1,54.6 566,54.5 	" />
      <path
        class="st3"
        d="M605.6,199.7c-0.2-0.3,0-0.8,0-1.2c-0.5-0.3-1.3,0.6-1.5-0.2c-0.1-0.3,0.1-0.4,1.1-0.7c0-0.2-0.2-0.5-0.1-0.7
		c0.8-1.2,0.2-2-0.6-3c-1.1-1.4-1.3-3.3,0.5-4.6c0.2-0.1,0.4-0.3,0.5-0.4c-0.3-0.6-0.7-0.6-1.3-0.5c0,0,0,0.1-0.1,0.1
		c0,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0.1c-0.3-0.5-0.6-0.9-1.1-1.6c0,0.7,0,1.1,0,1.6c-0.6-0.4-0.9-0.9-1-1.5h-0.1
		c-0.9,0.2-1.8-0.3-2.1-1c-0.3,0.1-0.5,0.1-0.8,0.1c-0.7,0-1.4,0.6-2.4,1.1c0.6,0.2,0.9,0.4,1.2,0.5c-0.1,0.2-0.2,0.4-0.3,0.6
		c0.1,0.1,0.2,0.2,0.2,0.3c-0.1,0-0.1,0.1-0.2,0.1c0-0.1-0.1-0.2-0.1-0.3c-0.5,0.8-1,1.6,0.1,2.3c-0.4,0.6-0.9,1.2-1.3,1.7
		c-0.3,0.4-0.6,0.8-1,1.1c-0.9,0.7-1.3,1.5-0.8,2.4c0.3,0,0.5-0.2,0.8-0.4c-0.2-0.7,0.2-1.3,1.2-1.8c0.5,0.4,1,0.7,1.5,1
		c0.1-0.2,0.2-0.4,0.2-0.6c0.4,0,1,0.1,1.9,0.1c0,0.2,0.1,0.7,0.2,1.1c-0.7,0.1-1.3,0.1-1.5,0.3c-0.2,0.3-0.2,0.8,0,1.1
		c0.1,0.2,0.3,0.4,0.6,0.6h0.1v0.1c0.1,0.1,0.3,0.3,0.4,0.4c0.2,0.4-0.4,0.7-0.4,1.2c0.1,1.1,0.4,1.6,1.7,1.6h0.1
		c0.2-0.5,0.7-0.9,1.4-1c1-0.2,1.9,0.2,2.1,0.9c0.1,0.5-0.2,1.1-0.8,1.5c0.1,0,0.2,0,0.2,0c0,0.3-0.1,0.5-0.2,0.8l0,0
		c0.9,0.1,1.7,0.1,2.7,0.2C606,202.2,606.5,200.8,605.6,199.7z M597.6,188.3L597.6,188.3L597.6,188.3L597.6,188.3z M601.2,187.7
		c0.1,0,0.2,0.1,0.2,0.2c-0.1,0-0.2,0.1-0.3,0.1s-0.2-0.1-0.3-0.1C601,187.8,601.1,187.7,601.2,187.7z M598.1,190
		c-0.1-0.1-0.2-0.2-0.2-0.3c0.1,0,0.2-0.1,0.3-0.1s0.2,0.1,0.2,0.2C598.2,189.9,598.2,190,598.1,190z M598.5,189.2
		c0-0.1-0.1-0.2-0.1-0.2c0-0.1,0.1-0.1,0.2-0.2c0,0.1,0.1,0.1,0.1,0.2C598.7,189.1,598.6,189.2,598.5,189.2z M599.4,188.1
		c0,0-0.2-0.1-0.2-0.2c0.2-0.2,0.4-0.5,0.6-0.7c0.2,0.1,0.3,0.2,0.5,0.3C599.9,187.7,599.7,187.9,599.4,188.1z M602.3,197.7
		c-0.4,0.1-0.8,0.2-1.4,0.3c-0.3-0.4-0.6-0.7-0.7-1c-0.3-0.7,0.3-1.5,1.2-1.8s1.9,0.1,2.2,0.8C603.8,196.6,603.3,197.4,602.3,197.7z
    M603,191.6c-0.6,0.3-1.3,0.5-1.9,0.1c-0.3-0.2-0.5-0.6-0.8-0.9c0.4-0.9,1.1-1.2,2-1.2c0.7,0,1.2,0.3,1.4,0.9
		C603.8,191,603.5,191.4,603,191.6z"
      />
      <path
        class="st3"
        d="M530.6,59.4c0.1,0.1,0.2,0.1,0.3,0.2c0-0.1,0.1-0.3,0.1-0.4C530.9,59.2,530.7,59.3,530.6,59.4z"
      />
      <path
        class="st3"
        d="M367.3,105.3c0.1,0,0.1,0,0.1,0c0.1-0.6,0.5-1.1,1.1-1.5l0,0c-0.9,0-1.8,0-2.7,0c0.3,0.4,0.9,0.7,0.8,1.2
		c-0.7,0.4-1.4,0.3-2-0.2c-0.3-0.3-0.5-0.6-0.7-1c-1.7,0-3.3,0.1-5,0.1c0.1,0.3,0.3,0.4,0.8,0.6c0.4,0.1,0.9,0.2,1.3,0.2v-0.1h0.1
		H361c1.2,0.2,2.5,0.5,3.3,1.4c0.3,0.4,0.9,0.3,1.4-0.2C366.3,105.7,366.9,105.3,367.3,105.3z"
      />
      <path
        class="st3"
        d="M603.1,203L603.1,203c0.1-0.2,0.2-0.4,0.3-0.6c-0.2,0.1-0.3,0.2-0.5,0.2C603,202.8,603,202.9,603.1,203z"
      />
      <path
        class="st3"
        d="M539.6,50.7c-0.1,0-0.2,0.1-0.3,0.1c0.2,0.1,0.4,0.2,0.6,0.4C539.8,51.1,539.7,50.9,539.6,50.7z"
      />
      <path
        class="st3"
        d="M554.2,50.2c0.1,0,0.1,0,0.2,0c0-0.1,0-0.1,0-0.2C554.3,50.1,554.3,50.1,554.2,50.2z"
      />
      <path
        class="st3"
        d="M415.7,51.8c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2,0.5-0.7,1-1.4,1.1c-0.6,0.1-1.1-0.1-1.4-0.4
		c0.1,0.6,0.2,1.1,0.4,1.6l0,0c0,0.1,0,0.2,0,0.3s0,0.2,0.1,0.2c0.6-0.1,1.1-0.1,1.5-0.1c-0.1,0.1-0.1,0.3-0.2,0.3
		c-0.6,0.6-1.6,0.9-1.7,1.9c0.7,0.2,1.7,0.1,1.9,0.5c0.6,0.9,1.5,0.9,2.4,1.2c1.1,0.3,1.7,1.2,1.8,2.2c0.4-0.9,0.9-1,2.6-1.2
		c0-0.4-0.1-0.8-0.1-1.2c-0.3-0.1-0.7-0.3-1-0.5c-0.4,0.3-0.7,0.6-1.1,0.7c-0.7,0.3-1.4,0-1.2-0.6c0.1-0.5,0-0.8-0.2-1.1
		c-0.2-0.1-0.4-0.3-0.5-0.6c0-0.2,0-0.4,0-0.5c-0.1-0.3-0.2-0.7-0.3-1c-0.1-0.2-0.1-0.5-0.2-0.8c0.7,0.4,1,0.5,1.3,1
		c0.1,0,0.2-0.1,0.3-0.1c0.2,0,0.5,0,0.7,0.1c0.1-0.2,0.1-0.4,0.2-0.6c0.2-0.5,0.4-1,0.6-1.5c-1.4,0.1-2.8,0.2-4.3,0
		C415.2,52.1,415.4,51.9,415.7,51.8z M417.9,53.3c0.1,0,0.2,0.1,0.2,0.1s0,0.1-0.1,0.1s-0.2,0-0.3,0
		C417.8,53.4,417.9,53.3,417.9,53.3z"
      />
      <path
        class="st3"
        d="M451.6,60.1c0.4-0.1,0.8-0.1,1.3-0.2c-0.2-0.3-0.3-0.4-0.4-0.6l0,0c-0.4,0.2-0.8,0.3-1,0.7
		C451.5,60,451.5,60,451.6,60.1z"
      />
      <path
        class="st3"
        d="M311.1,242c0.3-0.2,0.7-0.4,1-0.6c-0.5-1.2,0-2.6,0.7-3.8c-0.5-0.3-0.9-0.6-1.3-0.8c0.3,1-0.5,2-1.7,2.3
		c-0.1,0-0.1,0-0.2,0v0.1c0.1,0.6,0,1.1-0.5,1.6C309.8,241.2,310.4,241.6,311.1,242z"
      />
      <path
        class="st3"
        d="M480.5,61.9L480.5,61.9L480.5,61.9c0.1-0.1,0.3-0.3,0.4-0.5l0,0C480.7,61.6,480.6,61.7,480.5,61.9z"
      />
      <path
        class="st3"
        d="M306.7,237.9c0.2,0,0.3,0,0.4,0c-0.1-0.3,0-0.7,0.1-1C307,237.2,306.9,237.5,306.7,237.9z"
      />
      <path
        class="st3"
        d="M308.2,244.1c0-0.1,0-0.2,0-0.3c0,0,0,0-0.1,0l-0.1-0.1l0.1-0.1c-0.2-0.1-0.4-0.3-0.7-0.4
		c-0.1,0.1-0.1,0.3-0.2,0.4C307.6,243.8,307.9,244,308.2,244.1z"
      />
      <path
        class="st3"
        d="M458.6,68c-0.1-0.2-0.1-0.4-0.2-0.5c0.5-0.8,0.9-1.3,1.1-1.8c0.1-0.4,0.4-0.7,0.6-1c-0.4-0.1-0.7-0.4-0.9-0.7
		c-0.3-0.3-0.4-0.7-0.4-1.1c-0.1,0-0.2,0-0.3,0c-0.1,0.5-0.2,1-0.3,1.4c-0.9,0.8-1.9,0.3-2.8,0.3l-0.1,0.1c-0.2,0.4-0.5,0.7-0.8,1.2
		c-0.1-0.1-0.1-0.2-0.2-0.3c-0.4,0.2-0.8,0.4-1.3,0.6c-0.3,0.1-0.7,0.1-1,0.1c0,0.1-0.1,0.1-0.1,0.2l0,0c0.5,0.4,0.5,0.9,0.4,1.5
		l0,0l0,0c0.4-0.2,0.8-0.4,1.1-0.6c0.6,0.3,1.2,0.6,1.7,0.9s0.5,1,0.1,1.2c-0.5,0.3-1,0.2-1.2-0.2c-0.2-0.4-0.6-0.5-1.1-0.6
		c-0.3-0.1-0.5-0.4-0.7-0.6c0,0,0,0-0.1,0c0,0,0,0,0-0.1c-0.5,0-1,0.1-1.5,0.1c-0.4,0.6-0.8,1.1-1.2,1.7c0.3,0.2,0.5,0.4,0.8,0.7
		c-0.1-0.3-0.1-0.7-0.3-1.2c0.6,0.3,0.9,0.4,1.3,0.6s0.7,0.5,1.2,0.7c0.2-0.5,0.4-0.8,0.7-1.3c0.5,0.5,0.9,1,1.3,1.4
		c0.5,0.6,1.1-0.3,1.5-0.2c0.2-0.5,0.5-1,1-1.4C457.5,68.6,458,68.2,458.6,68z M455.8,67.4c-0.5,0.3-0.9,0.2-1.2-0.2
		c-0.3-0.3-0.1-0.7,0.3-0.9c0.4-0.2,0.9-0.2,1.5-0.3C456.5,66.7,456.3,67.1,455.8,67.4z"
      />
      <path
        class="st3"
        d="M306,98.8v1v1.4c0.1,0,0.1,0.1,0.2,0.1c0,0.4,0,0.7-0.2,0.8v1.9v1.3c0.1-0.1,0.3-0.2,0.4-0.2
		c0.5-0.1,1,0,1,0.4c5.6-0.5,11.2-0.9,16.9-1.3c1-0.1,1.9-0.1,2.9-0.2c0-0.3,0-0.6-0.1-0.9c-0.8,0.2-1.6,0.2-2.2,0.1
		c-0.2,0-0.5-0.1-0.6-0.2c-0.6-0.2-1.1-0.5-1.7-0.9c0-1.5,0.2-2.9,2-3.8c1.5-0.8,2.7-0.3,3.9,0.5c0.2-0.3,0.5-0.7,0.8-1.1
		c-0.6-0.1-1.2-0.2-1.6-0.4c-2.6,0-5.1,0.1-7.7,0.1c-0.1,0.2-0.3,0.5-0.6,0.8c-0.4-0.2-0.6-0.5-0.6-0.8c-3.5,0.1-7,0.2-10.6,0.3v0.1
		c-0.1,0-0.2,0-0.3,0v-0.1c-0.6,0-1.2,0.1-1.8,0.1L306,98.8L306,98.8z M319.8,101.1c0.1-0.1,0.3,0,0.5,0c-0.1,0.2-0.1,0.3-0.2,0.4
		s-0.3,0-0.5,0C319.7,101.3,319.7,101.1,319.8,101.1z M318.1,98.4L318.1,98.4c0.1,0,0.2,0.1,0.3,0.1l-0.1,0.1
		C318.2,98.5,318.1,98.5,318.1,98.4L318.1,98.4C318,98.4,318,98.4,318.1,98.4C318,98.4,318.1,98.4,318.1,98.4z M316,100.6h0.1
		c0,0,0,0.1,0.1,0.1C316.1,100.7,316.1,100.7,316,100.6C316,100.6,316,100.6,316,100.6z M315.9,103c0,0.1,0,0.1,0,0.2
		C315.9,103.1,315.8,103.1,315.9,103C315.8,103,315.9,103,315.9,103z M314.7,104.4L314.7,104.4L314.7,104.4L314.7,104.4z
    M313.2,100.8c0.2,0,0.3,0,0.5-0.1c0.1,0.4,0.1,0.8,0.2,1.5C312.9,101.7,312.8,101.3,313.2,100.8z M312.1,104.4
		c0.2,0,0.4,0,0.7,0.1c-0.1,0.2-0.2,0.5-0.3,0.5c-0.2,0-0.4-0.1-0.6-0.2C311.9,104.7,312,104.4,312.1,104.4z M306.9,100.5
		c0.2,0,0.5,0.2,0.8,0.3c-0.2,0.2-0.4,0.5-0.5,0.5c-0.3,0-0.5-0.2-0.7-0.3C306.6,100.9,306.7,100.6,306.9,100.5z"
      />
      <path
        class="st3"
        d="M307.6,241.7c0,0.1,0.1,0.2,0.1,0.3c0.6,0.4,1.3,0.8,1.9,1.1c0.1-0.1,0.1-0.2,0.2-0.3l0.1-0.1
		c-0.6-0.4-1.3-0.8-1.9-1.2C307.8,241.6,307.7,241.6,307.6,241.7z"
      />
      <path
        class="st3"
        d="M315.6,236c0-0.1-0.1-0.1-0.1-0.2c-0.5,0.3-0.9,0.6-1.2,1.1c1,0.5,1.4,0.7,1.9,0.8
		C316.1,237.1,315.8,236.6,315.6,236z"
      />
      <path
        class="st3"
        d="M315.6,85.3c0.4-0.3,0.7-0.6,1-0.9c0.4-0.4,0.2-0.7-0.5-0.7c0,0,0,0-0.1,0.1c0,0.2,0,0.3,0,0.5
		c-0.1,0-0.3,0-0.4,0l0,0c-0.2,0.2-0.3,0.4-0.5,0.6C315.2,84.8,315.5,85.1,315.6,85.3L315.6,85.3z"
      />
      <path
        class="st3"
        d="M329.7,111.7c-0.1,0-0.1,0-0.2,0c0-0.1-0.1-0.2-0.1-0.2c-0.2,0-0.4,0.1-0.6,0.1c-1.5,0.2-3-0.5-3.6-1.6
		c-0.1-0.2-0.2-0.5-0.3-0.7c-1.3,0.1-2.6,0.2-3.9,0.4c0.2,0.2,0.3,0.5,0.4,0.8c0.2,1.1-0.5,2-1.7,2.5c0.1,0.6,0.1,1.2,0.2,1.8
		c1.7-1.3,4-1.7,6.1-0.9c1,0.4,1.8,1,2.2,1.8c0.3-0.2,0.6-0.4,0.9-0.6c-0.6-0.9-0.1-1.8,0.2-2.6c0.2,0.3,0.2,0.7,0.3,1
		c0.1,0.3,0.3,0.5,0.5,0.6c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.9,0.7-1.9,1.9-2.1c0.6-0.1,1.2,0,1.6,0.3l0.1-0.1c0.1,0,0.2,0.1,0.3,0.1
		c0,0.1,0,0.3-0.1,0.4c0.2,0.2,0.3,0.4,0.3,0.7c0.1,0.7-0.3,1.3-0.9,1.7c0,0.2,0.1,0.3,0.2,0.5c0.1,0.3,0.3,0.6,0.5,0.8
		c0.4-1.3,2-2.1,3.7-1.6c-0.1-0.3-0.3-0.7-0.4-1s-0.2-0.7-0.3-1.1c-0.5,0.5-1.1,0.8-1.8,0.4c-0.3-0.2-0.5-0.5-0.5-0.9l0,0l0,0
		c0-0.2,0-0.4,0.1-0.6c0.3-0.7,1.1-1,1.7-0.5c0.4,0.3,0.6,0.7,0.9,1.1c0.2-0.3,0.4-0.6,0.7-0.9c-0.3,0-0.5,0-0.6,0s-0.2,0-0.3,0
		c-0.1-0.1-0.3-0.1-0.4-0.2c0-0.1,0-0.1-0.1-0.2s-0.2-0.2-0.3-0.4c0.1,0,0.1-0.1,0.2-0.1c0,0.2,0.1,0.3,0.1,0.5l0.1,0.1
		c0.2,0.1,0.3,0.1,0.5,0.2c0.1,0,0.1,0,0.2,0c0.7-0.1,0.4-0.5,0.4-0.9c0,0,0-0.1-0.1-0.1v-0.1v0.1c-0.1-0.1-0.3-0.1-0.4-0.2
		c0,0,0-0.1-0.1-0.1h-0.1h0.1l0,0h0.1c0.1,0.1,0.3,0.1,0.4,0.2c0,0.1,0,0.1,0,0.2c0.1,0.2,0.3,0.4,0.5,0.7c0.9-0.7,2-1.1,3.5-1.1
		c-0.5-0.5-0.8-1.1-0.9-1.7c-1.8,0.1-3.5,0.3-5.3,0.4c0,0.3-0.2,0.5-0.6,0.6c-0.2-0.2-0.3-0.4-0.2-0.5c-0.5,0-1,0.1-1.6,0.1
		c-0.3,0.3-0.6,0.5-1,0.6c0,0.2-0.1,0.3-0.3,0.5c0,0-0.1,0.1-0.2,0.1c-0.5,0.8-1.2,1.4-2.2,1.7C329.6,111.5,329.7,111.6,329.7,111.7
		z M324.4,109.6L324.4,109.6c0-0.1,0.1-0.1,0.1-0.2c0,0,0,0.1,0.1,0.1C324.6,109.6,324.5,109.6,324.4,109.6z M336.7,113.1
		L336.7,113.1L336.7,113.1L336.7,113.1z M338.7,108.2L338.7,108.2l-0.1,0.1L338.7,108.2z M335.7,108.8c0.1,0.1,0.2,0.2,0.2,0.2
		c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2-0.1-0.2-0.2C335.5,108.9,335.6,108.8,335.7,108.8z M335.2,109.5c0,0.1,0.1,0.2,0.1,0.2
		c0,0.1-0.1,0.1-0.2,0.2c0-0.1-0.1-0.1-0.1-0.2C335.1,109.7,335.2,109.6,335.2,109.5z"
      />
      <path
        class="st3"
        d="M340.8,117c-0.3-0.2-0.5-0.5-0.7-0.7c0,0.8,0.6,1.3,0.9,2c0,0,0,0,0,0.1c0-0.2-0.1-0.3-0.1-0.5
		C340.8,117.6,340.3,117.4,340.8,117z"
      />
      <path
        class="st3"
        d="M318,122L318,122c0.4,0,0.7-0.1,1-0.2c0.1-0.1,0.4-0.2,0.6-0.2c0,0,0,0,0-0.1l0,0c-0.8-0.5-1.7-2.3-1.8-3.5
		c0-0.2-0.2-0.4-0.3-0.7c0.2-0.3,0.6-0.8,0.9-1.2c0.3-0.4,0.6-0.8,1-1.1c0-0.3,0-0.7-0.1-0.9c-0.8,0.6-1.6,1.3-2.6,1.8
		c-0.5,0.3-1.3,0.4-1.9,0.5c-1.1,0.2-1.8-0.1-2.3-0.9c-0.3,0.9-1.1,1.6-2.2,1.9c-0.3,0.1-0.5,0.1-0.8,0.1c0.5,0.3,0.8,0.7,0.8,1.3
		c0.2,0.1,0.2,0.2,0.2,0.6c-0.1,0-0.2-0.1-0.3-0.1c0,0.3-0.1,0.7-0.3,1.2c-0.5-0.1-1.2-0.1-1-0.7c0.2-0.7,0-1.3-0.1-1.9
		c0-0.1,0-0.2,0.1-0.4c-0.9-0.2-1.7-0.8-1.9-1.6c-0.3-1.1,0.8-2.5,2.2-2.9c0.4-0.1,1-0.1,1.5,0c-0.5-0.6-0.4-1.3,0-2
		c0.1-0.2,0.2-0.3,0.3-0.5c-1.7,0.2-3.4,0.4-5.1,0.5v0.1v2.4c-0.3-0.1-0.6-0.2-0.9-0.3c-0.1,0.4-0.2,0.7-0.3,1.1
		c-0.7-0.3-1.4-0.5-1.9-1l-0.1-0.1c-0.4,1.4-2.5,2.5-4,2.2c-1.8-0.3-2.9-1.7-2.4-3.3c-2.1,0.2-4.1,0.5-6.2,0.7
		c-0.1,0.3-0.5,0.6-0.8,0.7c-0.4,0.1-0.9-0.1-1.1-0.4c-3,0.4-6,0.8-9,1.2c0,0.2-0.1,0.4-0.2,0.6h0.1c0.2,0.2,0.4,0.4,0.6,0.6
		c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1-0.2-0.3-0.4-0.4-0.6c-0.6,1.3-1.8,2.3-2.8,2.8c-0.6,0.3-1.3,0.4-1.9,0.5c-0.2,0.1-0.3,0.3-0.5,0.4
		c-0.1,0-0.1-0.1-0.2-0.1c0.1-0.1,0.2-0.2,0.2-0.3c-0.4,0-0.8,0-1.2-0.1c0.3,0.5,0.7,0.9,1,1.5c-1,0.6-2,1.3-3.1,2
		c-0.3-0.3-0.6-0.6-0.9-0.9c-0.1,0.2-0.3,0.3-0.4,0.4c-0.4,0.3-0.8,0.5-1.1,0.8c0,0.2,0,0.4,0,0.6c1.2-0.1,2.3,0.2,3.2,0.9
		c0.5,0.4,1.1,0.7,1.6,1.1c0.7,0.5,0.7,1.3-0.2,1.6c0,0-0.1,0-0.1,0.1c-0.2,0.9-0.7,1.7-1.9,2.2c-0.5,0.2-1.1,0.4-1.6,0.4
		c-0.2,0.5-0.4,1-0.6,1.4c0.1,0.2,0.2,0.4,0.2,0.6l0.1,0.1c0.4-0.1,0.7-0.1,1.1-0.2c0-0.2,0-0.4-0.1-0.7c0.2,0.2,0.3,0.4,0.4,0.6
		c2.4-0.4,4.7-0.9,7.1-1.3c-0.4-0.9-1.1-0.3-1.7-0.3c-0.3-0.4-0.6-0.8-1.1-1.4c0,0.6,0,1,0.1,1.3c-0.1,0-0.2,0.1-0.4,0.1
		c-0.3-0.6-0.7-1.2-0.9-1.9c-0.2-0.5,0.2-0.8,0.6-1c1,0.5,1.8,1.2,2.7,1.3c1.2,0.2,1.3,0.8,1.4,1.5c0.1,0,0.1,0.1,0.2,0.1
		c1.1-0.2,2.2-0.4,3.3-0.6c0.2-0.4,0.7-0.4,1.1-0.5c0,0,0,0,0-0.1l0,0c-0.7-0.6-1.5-1.3-2.3-2c0.2-0.3,0.5-0.7,0.8-1.1
		c1,0.3,2.4-0.3,2.7,1c0.9-0.3,1.7-0.7,2.5-0.1c0.7,0.6,0.4,1.2,0.1,1.9c1.5-0.3,3-0.6,4.5-0.9c-0.2-0.2-0.3-0.4-0.4-0.7
		c-0.3-1,0.2-1.8,1.7-2.7c1.3-0.8,1.6-2,0.6-3c-0.7-0.8-1.4-1.6-1.9-2.5c-0.8-1.3,0-2.8,1.7-3.5c1.5-0.6,3.2-0.1,3.9,1
		c0.7,1.3,0,2.9-1.6,3.6c-0.5,0.2-1,0.3-1.6,0.5c1.1,0.7,1.4,1.5,1.4,2.6c0,1.2,0.4,2.4,1.2,3.4c0.1,0.1,0.1,0.2,0.2,0.3
		c1.1-0.2,2.1-0.4,3.2-0.6c0.7-1,2.2-0.7,3.1-1.5c0.3-0.2,0.9-0.2,1.4-0.2c0.2,0,0.4,0,0.5,0.1c0.3,0.2,0.6,0.3,0.9,0.4
		c0.2,0,0.3-0.1,0.5-0.1v-0.2c0.5-0.3,0.5-0.9,0.8-1.2c0.9-0.3,1.8-0.6,2.7-0.9c0.1-0.2,0.2-0.5,0.4-1c0.2,0.7,0.7,0.9,1.2,1.1
		c0.1-1,0.9-1.9,2-2.3c0.6-0.2,1.2-0.3,1.8-0.3c-0.2-0.4-0.2-0.8-0.4-1.2c-0.1-0.2,0.3-0.7,0.6-0.8c0.3-0.1,0.8,0.1,1.1,0.3
		c0.2,0.1,0.3,0.3,0.3,0.5c0.1,0.3,0,1-0.1,1.7c0.4,0.2,0.7,0.5,0.9,0.8c0.2,0.3,0.3,0.6,0.5,0.9c0.2-0.2,0.3-0.3,0.4-0.4
		c0,0.2,0.2,0.5,0.1,0.6C318.2,121.7,318.1,121.9,318,122z M269.9,130.1c-0.1,0-0.1,0-0.2,0V130C269.8,130,269.8,130,269.9,130.1
		C269.9,130,269.9,130.1,269.9,130.1z M270.5,129.3L270.5,129.3L270.5,129.3L270.5,129.3z M272.2,129c-0.2-0.2-0.3-0.5-0.5-0.7
		c0.1,0,0.1-0.1,0.2-0.1c0.2,0.2,0.4,0.4,0.6,0.6C272.4,128.9,272.3,129,272.2,129z M273.4,129.1l-0.1,0.1
		C273.3,129.2,273.4,129.1,273.4,129.1L273.4,129.1c0-0.1,0-0.1,0-0.1V129.1z M276.1,126.4c-0.2-0.1-0.4-0.5-0.3-0.7
		c0.2-0.5,0.6-0.6,1.7-0.3C277.2,126,277.1,126.7,276.1,126.4z M279.3,123.6c-1.2,0.3-2.4-0.2-3-1c0,0.3,0.1,0.5,0.2,0.8
		c0.4,0.7-0.5,1.3-1,1.9v0.1c0,0-0.1,0-0.1-0.1c-0.1,0.1-0.2,0.2-0.2,0.3c-1.1-0.8-1.7-1.6-0.8-2.9c0.1-0.2,0-0.6,0-0.8
		c-0.1-0.4-0.1-0.4,0.5-1.2c0.6,0.1,1,0.4,1.2,0.7c0-1.1,0.9-2.1,2.2-2.4c0.3-0.1,0.7-0.1,1-0.1c0.2-0.2,0.5-0.5,0.6-0.8
		c0.3,0.4,0.5,0.7,0.7,1c-0.1,0-0.1,0.1-0.2,0.1c0.5,0.3,0.9,0.7,1.1,1.3C281.7,121.8,280.7,123.2,279.3,123.6z M281.7,122.2
		c-0.1,0-0.2,0-0.2-0.1V122c0.1,0,0.2,0,0.2,0S281.7,122.1,281.7,122.2z M282.2,124.4c-0.1-0.1-0.1-0.2-0.2-0.2
		c0.3-0.2,0.7-0.4,1-0.6c0.1,0.1,0.2,0.2,0.3,0.3C282.9,124.1,282.6,124.2,282.2,124.4z M283,116.7c-0.1,0-0.2-0.1-0.3-0.2
		c0.1-0.1,0.3-0.3,0.4-0.4s0.3,0,0.8,0.1C283.3,116.5,283.2,116.6,283,116.7z M287.1,114.4c1.5-0.3,3,0.5,3.2,1.8s-0.8,2.6-2.4,2.9
		c-1.4,0.3-3.1-0.5-3.2-1.6C284.5,116,285.5,114.8,287.1,114.4z M285.2,118.3c0.3,0.5,0.5,0.8,0.8,1.1
		C285,119.4,284.6,119.2,285.2,118.3z M286,125l-0.1-0.1c0-0.1,0-0.2,0.1-0.3l0.1,0.1C286.1,124.8,286.1,124.9,286,125z
    M288.7,125.7c0.7-0.1,0.7-0.1,1,0.4C289.3,125.9,289.1,125.8,288.7,125.7z M290,122.7c-0.9,0.8-2.8,0.7-3.5-0.3
		c-0.1-0.2-0.1-0.5-0.3-0.7c-0.1-0.2-0.3-0.2-0.5-0.4c0.4-0.4,0.8-0.7,1.2-1.1c1-0.8,2.3-0.9,3.1-0.2
		C290.8,120.7,290.8,121.9,290,122.7z M291.6,122.5h0.1v0.1L291.6,122.5C291.6,122.6,291.6,122.6,291.6,122.5z M291.2,122.5
		c0,0.1-0.1,0.2-0.1,0.3c-0.1,0-0.2,0-0.3,0c0-0.1,0-0.2,0.1-0.2C291,122.5,291.1,122.5,291.2,122.5z M291.5,113.8
		c-0.1,0-0.3-0.1-0.4-0.1c0-0.1,0.1-0.3,0.2-0.5c0.2,0.1,0.3,0.2,0.3,0.3C291.7,113.6,291.6,113.8,291.5,113.8z M296.2,124.4
		c0-0.1-0.1-0.1-0.1-0.2l0.1-0.1l0.1,0.1C296.3,124.3,296.2,124.3,296.2,124.4z M299.2,123.5c-1.5,0.3-2.9-0.4-3.1-1.6
		c0-0.1,0-0.1,0-0.2c-0.1,0-0.2,0-0.3,0c0.1-0.3,0.1-0.7,0.2-1c0.1,0,0.2,0,0.3,0c0.3-0.7,1.1-1.3,2.1-1.5c1.5-0.3,2.8,0.4,3,1.7
		C301.6,122.1,300.6,123.2,299.2,123.5z M306,122.7v0.6c-0.1,0-0.2,0-0.4-0.1c-0.5-0.2-0.7-0.6-0.5-1.1c0.2-0.4,0.5-0.7,0.9-0.8v1
		c0,0.1,0.1,0.2,0.1,0.2C306,122.6,306,122.6,306,122.7z M306,118.4L306,118.4l-0.1,1.9h0.1c0,0.1-0.1,0.2-0.1,0.3v0.4l0,0
		c-1-0.6-2.1-1.2-3.2-1.8c-0.9-0.5-1.4-1.2-1.3-2.1s0.7-1.7,1.8-2.1c0.9-0.3,1.8-0.6,2.8-0.9v3.9c0.1,0,0.2,0.1,0.3,0.1
		C306.2,118.2,306.1,118.4,306,118.4z M307.1,122.2c-0.1,0-0.2-0.1-0.2-0.1c0-0.1,0.1-0.1,0.1-0.2h0.1
		C307.2,122.1,307.1,122.1,307.1,122.2z"
      />
      <path
        class="st3"
        d="M539.1,70.8c-0.4,0.3-0.7,0.7-1,1.1c0.5-0.1,0.9-0.2,1.4-0.3c-0.1-0.1-0.2-0.3-0.3-0.4
		C539.1,71.1,539.1,71,539.1,70.8z"
      />
      <path
        class="st3"
        d="M531.6,66.4c-0.5,0.2-1,0.4-1.3,0.6c-0.2,0.8-0.4,1.5-0.5,2.1c0.3,0,0.6,0,0.9,0c0.2,0,0.3-0.1,0.5-0.1
		c0-0.1-0.1-0.1-0.1-0.1C530.8,68.1,531,67.2,531.6,66.4z"
      />
      <path
        class="st3"
        d="M455.6,61.4c-0.1,0.1-0.1,0.2-0.2,0.3c0,0.1,0.1,0.2,0.1,0.2C455.5,61.7,455.6,61.5,455.6,61.4z"
      />
      <path
        class="st3"
        d="M375.3,116.5c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0-0.3,0.1-0.4,0.1C375.1,116.4,375.2,116.4,375.3,116.5z"
      />
      <path
        class="st3"
        d="M316.6,89.9c0.1-0.2,0.3-0.4,0.5-0.5s0.4-0.2,0.5-0.3c0.2,0.1,0.2,0.1,0.3,0.1c0.1,0.1,0.2,0.3,0.2,0.4
		c-0.4,1.1,0.4,2.2-0.4,3.5c-0.4-0.4-0.5-0.7-0.8-0.9c-0.7,0.4-1.1,1-1,1.7c-0.2,0-0.5,0.1-0.5,0.2s-0.1,0.2-0.2,0.4
		c0.2,0.2,0.5,0.3,0.8,0.3c1.6,0,3.2,0,4.8-0.1c0.5,0,1.1,0,1.6,0c0.1-0.3,0.3-0.6,0.7-0.9c0.4-0.4,0.9-0.7,0.6-1.3
		c-0.1-0.4,0.4-0.8,1-0.8s1,0.4,0.8,0.8c-0.3,0.6,0.1,0.8,0.4,1.1c0.2,0.3,0.4,0.6,0.6,1h0.1c0.4-0.8,1.4-1.2,3.7-1.5l0,0h-0.1
		c-1,0.2-1.9-0.2-2.1-1c-0.2-0.7,0.5-1.6,1.4-1.8c0.1,0,0.1,0,0.2,0c-0.7-0.4-1.3-0.7-1.9-1c-0.3,0.1-0.7,0.3-1.1,0.4
		c-1,0.2-1.9-0.1-2.4-0.8c-0.3-0.5-0.7-0.9-1-1.3c0.2-0.1,0.3-0.2,0.5-0.4c-1.1,0-2.1,0-3.2,0c-0.6,0.1-1,0.1-1.4,0
		c-0.3,0-0.7,0-1,0c-0.8,0-1.7,0-2.5,0c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1-0.1-0.2-0.1-0.3-0.2l0,0c-0.4,0-0.8,0-1.3,0
		c-0.3,0.2-0.6,0.4-0.8,0.7V88C314.3,88.5,315.4,89.2,316.6,89.9z M320.7,94c0,0.1,0.1,0.1,0.1,0.2l-0.1,0.1
		c-0.1-0.1-0.1-0.1-0.1-0.2L320.7,94z M318.8,88c0.1,0.4,0.2,0.8,0.3,1.4C318.3,89,318.2,88.6,318.8,88z"
      />
      <path
        class="st3"
        d="M309.6,96.6c-0.2,0-0.4-0.1-0.6-0.2c0,0.1,0,0.1,0,0.2C309.2,96.6,309.4,96.6,309.6,96.6z"
      />
      <path
        class="st3"
        d="M353.3,90c1.3-1,2.2-0.9,2.9,0.3c0.1,0.2,0.2,0.5,0.4,0.6c0.1-0.1,0.3-0.2,0.5-0.3c0.5-0.1,1.2,0.2,1.3,0.6
		c0.1,0.2,0,0.4-0.2,0.6c0.4,0.3,0.9,0.5,1.6,0.2c0.1,0.3,0.4,0.6,0.5,0.9c0.1-0.2,0.3-0.5,0.4-0.7c2.6-0.6,3.3-0.3,3.8,2.1
		c1.5,0,3,0,4.5,0.1l0,0c0.7-0.3,1.5-0.7,2.5-1.1c-0.1-0.8,0-1.5,0.4-2.1c-0.1-0.2-0.1-0.4,0-0.6c0.2,0,0.4,0,0.5,0.1
		c0.2-0.2,0.5-0.4,0.8-0.6c0.8-0.5,1.3-1.4,1.9-2.2c-0.8,0-1.5,0-2.3,0c-0.1,0.7-0.5,1.5-0.7,2.2c-0.2,0.6-0.8,1.1-1.8,1.3
		c0-0.6-0.1-1.1-0.1-1.9c-0.8,0.2-1.4,0.4-2.1,0.7c-0.2-0.3-0.3-0.7-0.3-1c-0.2-0.1-0.3-0.2-0.5-0.3h-0.1c-0.1-0.1-0.3-0.1-0.4-0.2
		l0,0l0,0v-0.1c-0.1,0-0.2-0.1-0.3-0.1c0.1,0,0.1-0.1,0.2-0.1c0,0.1,0.1,0.2,0.1,0.3c0,0,0,0,0.1,0c0.1,0.1,0.3,0.1,0.4,0.2
		c0,0,0.1,0,0.1,0.1c0.1,0,0.3,0,0.4,0c0-0.3-0.1-0.7,0-1c-1.9,0-3.8-0.1-5.7-0.1c0.1,0.1,0.3,0.3,0.4,0.4c-1.4,0.6-1.8,0.5-1.9-0.4
		c-1.9,0-3.7-0.1-5.6-0.1c-0.3,0.2-0.7,0.3-1.2,0.3c0,0.4,0,0.7,0,1c-0.2,0-0.3-0.1-0.5-0.1c-0.1,0.2-0.2,0.4-0.4,0.6
		c0,0.3,0.1,0.6,0.1,1C353.1,90.1,353.2,90.1,353.3,90z M365.8,93.3L365.8,93.3L365.8,93.3C365.8,93.3,365.9,93.3,365.8,93.3
		C365.9,93.3,365.9,93.3,365.8,93.3C365.9,93.3,365.9,93.3,365.8,93.3C365.9,93.3,365.9,93.3,365.8,93.3L365.8,93.3z M367.8,90.4
		c0.2,0.1,0.4,0.1,0.4,0.2s0,0.3-0.1,0.3c-0.2,0-0.3,0-0.4,0C367.7,90.8,367.8,90.7,367.8,90.4z M365.4,90.8
		c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1-0.1,0.2-0.1,0.3c-0.1-0.1-0.2-0.1-0.2-0.2C365.3,90.9,365.4,90.8,365.4,90.8z M365.4,91.5
		c2.2-0.1,2.7,0.1,3.1,1.8c-0.8,0.6-1.6,0.5-2.3,0.1C365.4,93,365,92.3,365.4,91.5z"
      />
      <path
        class="st3"
        d="M318,85.4c-0.2,0.2-0.4,0.3-0.6,0.4c0.3,0,0.5,0,0.8,0C318.1,85.7,318.1,85.6,318,85.4z"
      />
      <path
        class="st3"
        d="M315.3,85.9c0.2,0,0.3,0,0.5,0c0-0.1,0.1-0.1,0.1-0.2s-0.2-0.2-0.3-0.3C315.5,85.6,315.4,85.8,315.3,85.9z"
      />
      <path
        class="st3"
        d="M368.8,85.5c0.9-0.8,0.3-1.5,0.1-2.2c-1.4,0.2-2.5,0.6-3.1,1.8c-0.2,0.3-0.7,0.6-1.1,0.8c-1-0.1-1.8-0.4-2.4-1
		c-0.2,0-0.3,0-0.5,0c0-0.1,0-0.2,0-0.3c0.1,0,0.2,0,0.3,0c0,0,0-0.1-0.1-0.1c-0.2-0.4-0.7-0.6-1-0.9c0.3-0.9,1.3-0.6,2-1
		c-0.1-0.6-0.3-1.2-0.4-1.9c-0.6,0.7-0.9,1.4-1.9,1.2c-0.1,0-0.4,0.2-0.4,0.3c-0.6,1.3-2.4,2-2.7,3.5c0,0.1,0,0.1-0.1,0.1
		c-0.2,0.1-0.4,0.1-0.6,0.3c3.8,0.1,7.6,0.2,11.4,0.3C368.3,85.9,368.5,85.7,368.8,85.5z"
      />
      <path
        class="st3"
        d="M404.7,69.7C404.7,69.7,404.7,69.6,404.7,69.7c-0.1-0.1-0.3-0.1-0.4-0.1c0.1,0,0.1,0.1,0.2,0.1
		C404.6,69.8,404.6,69.8,404.7,69.7z"
      />
      <path
        class="st3"
        d="M367.1,67.4l-0.1,0.1C367,67.4,367,67.4,367.1,67.4C367,67.4,367.1,67.4,367.1,67.4z"
      />
      <path
        class="st3"
        d="M455,59.8c0.1-0.1,0.2-0.2,0.3-0.4c-0.2-0.1-0.3-0.2-0.4-0.2C455,59.4,455,59.6,455,59.8z"
      />
      <path
        class="st3"
        d="M432,70.6c-0.1,0.4-0.2,0.8-0.3,1.2c0.3-0.5,1.1-1,2.2-1.2c0-0.1-0.1-0.3-0.1-0.4
		C433.4,70.4,432.8,70.5,432,70.6z"
      />
      <path
        class="st3"
        d="M565.2,184.7c-0.1,0.7-0.3,1.4-0.4,2c0.2-0.1,0.4-0.3,0.7-0.3c0.2-0.5,0.3-1.1,0.4-1.7
		C565.7,184.7,565.4,184.7,565.2,184.7z"
      />
      <path
        class="st3"
        d="M454.5,58.7c-0.1-0.2-0.1-0.5-0.2-0.8V58c0,0,0,0-0.1-0.1c-0.2,0-0.5,0-0.7,0c0.1-0.1,0.2-0.2,0.3-0.4
		c0.1,0.1,0.3,0.3,0.4,0.4c0,0,0,0,0.1,0c-0.1-0.9,0.9-1.7,0.7-2.5c-0.5,0.2-1,0.4-1.6,0.6c-0.6,1.2-0.3,2.2,0.4,3.1
		C454,58.9,454.3,58.8,454.5,58.7z"
      />
      <path
        class="st3"
        d="M456.7,59.7c0,0.1,0,0.1-0.1,0.2c-0.1,0.1-0.2,0.2-0.3,0.4c0.2-0.2,0.5-0.4,0.9-0.5
		C457,59.8,456.8,59.8,456.7,59.7z"
      />
      <path
        class="st3"
        d="M419,80.4c0.6-0.1,1.2,0.1,1.6,0.5c0.2-0.2,0.3-0.3,0.5-0.5c0.3-0.2,0.5-0.3,0.8-0.5c0-0.4-0.1-0.9-0.4-1.2
		c-0.3-0.3-0.5-0.5-0.6-0.6c-0.7,0.9-1.8,1.6-3.3,1.4c-0.6-0.1-1.2-0.4-1.6-0.8c-0.1,0.2-0.3,0.5-0.5,0.8c-0.3-0.2-0.6-0.4-0.6-0.5
		c0.1-0.3,0.4-0.5,0.6-0.7c0.1,0.1,0.2,0.1,0.4,0.2l0,0l0,0c-0.2-0.3-0.3-0.5-0.3-0.8v-0.1c-0.5,0.4-1.3,0.7-2,0.5
		c-1.1-0.2-2.1-1.1-1.6-1.9c0.6-1.1,0.1-2-0.4-3c1.6,0,1.6,0,2.3,1.2c0.2,0,0.3,0.1,0.5,0.1c0.2-0.1,0.4-0.2,0.6-0.2
		c0.9-0.2,1.7,0.3,2,1c0.2-0.2,0.5-0.3,0.8-0.5c-0.3-0.5-0.4-1-0.5-1.5c-4.1-0.1-8.1-0.1-12.2-0.2c0.6,0.8,1.4,1.6,0.1,2.7
		c-0.3-0.2-0.5-0.3-0.7-0.5c0,0.3,0,0.6-0.1,1c-0.4,1-1.4,1.6-2.7,1.7c0.3,0.9,0.2,1.7-0.6,2.7c-0.1-0.5-0.2-0.8-0.2-1.2
		c-0.1-0.5-0.1-1-0.2-1.6c-0.2,0-0.4,0-0.6,0c-0.1,0-0.2,0.1-0.3,0.1c-0.2-0.7-0.5-1.2-0.6-1.8c0-0.1,0-0.2,0-0.3
		c-0.2-0.1-0.4-0.2-0.5-0.4c-0.3-0.5-0.9-0.5-1.5-0.6c-0.7-0.1-1.3-0.4-1.7-0.7c-0.3,0.1-0.7,0.2-1,0.3c1.2,3.5,2.4,7,3.6,10.5
		c0.3-0.4,0.8-0.7,1.5-0.8c1.3-0.3,2.4,0.4,2.6,1.5c0,0.2,0,0.4,0,0.6c0.2,0.2,0.4,0.4,0.7,0.6c-0.4,0.6-0.9,0.6-1.3,0.5
		c-0.2,0.2-0.5,0.4-0.9,0.5V88c0.4,0.1,0.8,0.4,1.1,0.5c-0.2,0.1-0.4,0.2-0.7,0.3l0,0c0.2,0,0.5,0.1,0.8,0.1l0,0l0,0
		c0.2,0,0.5,0.1,0.8,0.1c-0.3,0.1-0.5,0.2-0.7,0.3l0,0c0,0,0,0-0.1,0c-0.4,0.2-0.8,0.4-1.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.3
		c0.2,0.4,0.4,0.8,0.6,1.3c-0.2,0-0.3,0-0.5,0c0.1,0.3,0.2,0.7,0.4,1c0.6,0.2,1.2,0.4,1.6,0.6c0.2,0.1,0.4,0.3,0.5,0.5
		c0,0.1-0.4,0.4-0.5,0.4c-0.4-0.1-0.9-0.2-1.3-0.4c0,0.1,0.1,0.2,0.1,0.3c0.1,0.3,0.7,0.5,1.1,0.5s0.7,0,1.1,0
		c0.1-0.4,0.3-0.9,0.4-1.3c-0.7-0.8-0.9-1.3-0.4-2c-0.4-0.3-0.7-0.7-0.4-1.3c0.1-0.3-0.3-0.7-0.4-1c-0.2-0.6,0.3-1,1.1-1
		c1.6,0.2,1.6,0.2,2.3,1.4c-0.2,0.3-0.3,0.6-0.5,1c0.3,0,0.7,0.1,1,0.2c1-1.6,2.3-0.5,3.5-0.5c-0.1-0.3-0.3-0.5-0.2-0.7
		c0.2-0.3,0.3-0.6,0.4-0.9c-0.7-0.4-0.8-1-0.7-1.7c0.4,0.1,0.7,0.2,0.9,0.3c0-0.1,0-0.1,0-0.2c0-0.6,0.5-1,1.3-1.2
		c0.7-0.2,1.4-0.1,1.8,0.4c0.3,0.3,0.6,0.7,0.8,1.1c1.8,0.1,3.7-0.3,5.4,0.2c0.2,0.1,0.6-0.1,0.9-0.1c0.5-0.1,0.9-0.3,1.2-0.6
		c-1-0.4-1.8-1-2.1-2.2c-0.1-0.2-0.1-0.5-0.1-0.7h-0.1c-1,0.1-1.8-0.3-1.9-1.2C417.4,81.4,418.1,80.6,419,80.4z M401.8,90.4
		C401.8,90.4,401.7,90.3,401.8,90.4h0.1C401.9,90.3,401.8,90.4,401.8,90.4z M404.6,83.1c0.1,0,0.1-0.1,0.2-0.1s0.1,0,0.2,0
		C404.8,83.1,404.7,83.1,404.6,83.1z M405.2,83.8C405.2,83.8,405.1,83.8,405.2,83.8c-0.1-0.1-0.1-0.1-0.1-0.2h0.1
		C405.2,83.7,405.2,83.8,405.2,83.8z M408,87.8c0.1,0.3,0.2,0.6,0.3,0.9C407.5,88.5,407.5,88.5,408,87.8z M407.9,87.3
		c0-0.1,0-0.2,0.1-0.2c0-0.1,0.1-0.2,0.1-0.2c0,0.1-0.1,0.2-0.1,0.3C408,87.2,407.9,87.2,407.9,87.3z M407.1,84.7
		c-0.1-0.2,0-0.5,0.1-0.5c0.2-0.1,0.6-0.1,0.8,0c0.2,0.2,0.3,0.5,0.5,0.7C407.8,85.4,407.3,85.3,407.1,84.7z M409.1,81.5
		c-0.3,0.8-0.9,1.3-1.8,1.5s-1.8,0-2.2-0.7c-0.5-0.7-0.9-1.5-1.3-2.2c0.1,0,0.2-0.1,0.3-0.1c0.3,0.1,0.6,0.3,0.9,0.4
		c0.1-0.1,0.1-0.1,0.2-0.2c-0.2-0.3-0.5-0.6-0.7-0.9c0.9-1.2,1.4-1.4,2.3-1.3c0.8,0.1,0.5,0.7,0.4,1.1c0.4,0.2,0.9,0.3,1.3,0.6
		C409.1,80.1,409.4,80.7,409.1,81.5z M409.5,74.1L409.5,74.1L409.5,74.1L409.5,74.1z M411.5,82.9c-0.1,0-0.1-0.1-0.2-0.1v-0.1
		c0.1,0,0.1,0,0.2,0C411.6,82.7,411.5,82.8,411.5,82.9z M414.3,83.3c-0.9-0.1-0.8-0.7-0.8-1.2c0.7-0.4,1.4-0.5,1.7,0.2
		C415.3,82.6,414.8,83.3,414.3,83.3z M416.9,80.5c-0.1-0.1-0.1-0.1-0.2-0.2c0.1-0.1,0.2-0.3,0.3-0.4c0.2-0.1,0.4-0.1,0.6-0.2
		c0.1,0.1,0.1,0.2,0.2,0.3C417.5,80.2,417.2,80.3,416.9,80.5z"
      />
      <path
        class="st3"
        d="M403.5,73.7c0.2,0.1,0.3,0.2,0.4,0.4c0-0.3,0-0.7,0.2-1.1c-0.1,0-0.2,0-0.3,0c-1.1,0-2.2,0-3.3-0.1
		c0,0.2,0,0.4,0,0.7C401.5,73.1,402.7,73.1,403.5,73.7z"
      />
      <path
        class="st3"
        d="M396,91.8c-0.4-0.1-0.9-0.4-1-0.3c-0.4,0.2-0.8,0.3-1.3,0.3c0.2,0.1,0.3,0.2,0.5,0.3c-0.7,0.3-1.1,0.1-1.4-0.2
		c-0.3,0.1-0.6,0.2-0.8,0.5c-0.6-0.6-1.1-1-0.7-2c-2,0.7-2.3-0.4-2.9-1.5c-0.5,0.3-0.8,0.6-1.3,0.9c-0.4,0-1-0.1-1.5-0.2
		c-0.2,0.3-0.4,0.6-0.7,1c-0.1-0.4-0.2-0.5-0.3-0.7c-0.2-0.8-0.5-1-1.3-0.8c-0.5,0.2-0.9,0.3-1.3-0.1c-0.3-0.4-0.9-0.7-0.6-1.3
		c-0.5,0-1.1,0-1.6-0.1c0,0,0,0-0.1,0c-0.3,0-0.5,0-0.8,0s-0.5,0-0.8,0c-0.1,0-0.1,0.1-0.2,0.1c0.2,0.2,0.3,0.3,0.4,0.4
		c1,0.7,1.3,1.6,0.9,2.7s-1.3,1.8-2.7,2c-0.6,0.1-1.3,0.4-2,0.6c0.2,0.4,0.4,0.6,0.5,0.9c4.4,0.1,8.8,0.3,13.1,0.4
		c0.1,0,0.2,0,0.2,0c-0.1-0.2-0.4-0.4-0.8-0.4c-1.2-0.2-1.5-0.9-1.8-1.8c0.4,0,0.9,0,1.2,0.1c0.6,0.4,1.2,0.8,2.2,0.5
		c0.5-0.1,1.3,0.8,1.1,1.3c-0.2,0.1-0.4,0.2-0.6,0.4c0.9,0,1.8,0.1,2.7,0.1c0.2-0.1,0.5-0.3,0.6-0.4c-0.1-0.4-0.2-0.8-0.2-1.1
		l0.1-0.1c1,0.2,1.4,0.3,1.5,0.9c0.1,0.3,0.2,0.6,0.4,0.8c0.9,0,1.7,0.1,2.6,0.1c0-0.1,0.1-0.2,0.1-0.4c0.2,0.1,0.4,0.2,0.4,0.3
		c0,0,0,0.1-0.1,0.1c0.2,0,0.5,0,0.7,0c-0.1-0.3-0.2-0.7-0.3-1l0,0c0,0,0,0,0-0.1c-0.3-0.8-0.5-1.6-0.8-2.3
		C396.9,91.9,396.5,91.9,396,91.8L396,91.8C396,91.9,396,91.9,396,91.8C396,91.9,396,91.9,396,91.8z M381.8,90.5l-0.1-0.1l0.1-0.1
		l0.1,0.1C381.9,90.4,381.8,90.4,381.8,90.5z M397.1,94.5c0.1,0,0.3,0.1,0.4,0.1c-0.1,0.1-0.2,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.3-0.1
		L397.1,94.5z M396.6,93.2c-0.3,0.8-1.2,0.8-1.8,1c-0.6-0.6-1.1-1,0-1.8c0.3,0,0.7,0,1.2,0C396.2,92.6,396.4,92.9,396.6,93.2z"
      />
      <path
        class="st3"
        d="M314.6,244.1c0.3,0.2,0.6,0.4,1,0.6c0-0.5,0.1-1.1-0.8-1.5C314.8,243.5,314.7,243.8,314.6,244.1z"
      />
      <path
        class="st3"
        d="M394.6,100.1c-0.5-0.1-0.8-0.1-1.1-0.1c-1.4-0.2-1.8-0.5-1.7-1.5c-0.8,0-1.6-0.1-2.5-0.1
		c-0.1,0.2-0.3,0.5-0.4,0.7c-0.1-0.1-0.3-0.1-0.4-0.2c0.2-0.2,0.3-0.4,0.5-0.6c-0.5,0-1,0-1.5-0.1c-0.1,0.5-0.3,0.9-0.6,1.3
		c0.1,0.1,0.2,0.3,0.3,0.4c-0.1-0.5,0.6-0.9,1.3-0.8c0.3,0,0.6,0.1,0.9,0.3l0.1-0.1c0,0.1,0,0.1,0.1,0.2c0,0,0,0,0.1,0
		c0,0,0,0,0.1,0.1h0.1h-0.1l0,0h-0.1c0,0,0,0,0-0.1c-0.1,0-0.1,0-0.2,0c0.5,0.2,0.9,0.5,1.3,0.6c0.7,0.2,1.2,0.6,1.5,1.1
		c0.2,0.2,0.4,0.4,0.8,0.7c0.4-0.5,0.7-0.9,1-1.3l0,0l0,0C394.3,100.4,394.4,100.2,394.6,100.1z"
      />
      <path
        class="st3"
        d="M312.2,270.5c-0.5-0.3-1-0.7-1.6-1c0,0.1,0,0.2-0.1,0.5c0.6,0.5,1.2,1.1,1.8,1.6c0.6,0.3,0.9,0.4,1.1,0.6h1
		c0.4-0.3,0.9-0.6,1.3-0.9c-0.5-0.5-0.7-1.1-0.8-1.7C314.4,270.4,312.8,270.9,312.2,270.5z"
      />
      <path
        class="st3"
        d="M386.4,115.5c-0.2-0.6-0.2-1.2,0.2-1.6c-0.8,0.2-1.5,0.3-2.3,0.5c0.5,0.4,1,0.8,1.4,1.3l0,0
		c0.3-0.1,0.6-0.1,0.9-0.2c0,0,0,0,0-0.1C386.5,115.5,386.4,115.5,386.4,115.5z"
      />
      <path
        class="st3"
        d="M387.8,112.5c0.1-0.2,0.2-0.3,0.4-0.4c-0.3,0-0.6-0.1-0.8-0.4c-0.2-0.2-0.4-0.5-0.5-0.6
		c-0.1-0.6,0-1.1,0.7-1.4c0.6-0.3,1.1-0.1,1.4,0.2c0.1,0.1,0.3,0.3,0.4,0.4c0.5,0.6,0.4,1-0.1,1.4c0.2,0,0.4,0.1,0.6,0.2
		c0.3-0.6,0.5-0.9,0.9-1.1c-0.1-0.6,0.5-1.4,1.3-1.7c0,0,0,0,0,0.1c0.3-0.1,0.5-0.1,0.7,0.1c0.2-0.3,0.3-0.6,0.4-0.8
		c0.1,0.1,0.2,0.2,0.3,0.3c0.4-0.4,0.9-0.7,1.2-1.2c-0.2,0.1-0.4,0.1-0.6,0.2c-0.6,0.3-1.5,0.7-1.9,0.5c-0.3-0.2-0.7-0.2-1-0.2
		c0,0,0,0,0.1,0c0.2,0.2,0.4,0.6,0.2,0.9c-0.2,0.4-0.6,0.8-0.9,1.1c-0.8,0-1.5-0.2-1.3-0.8c0.1-0.4,0.5-0.8,0.9-1.2
		c-0.2,0-0.4,0-0.6,0c0-0.1-0.1-0.1-0.1-0.2c-0.5,0.8-1.5,1.5-2.7,1.7c-2.1,0.4-3.9-0.7-4.2-2.5c-0.1-0.5,0-0.9,0-1.5
		c-0.4,0.2-0.7,0.3-1,0.4c-1.6,0.5-3,0.3-4-0.7c-0.5-0.5-0.9-0.7-1.6-0.8c-0.8-0.1-1-0.5-0.7-1c-1.1,0-2.2,0-3.3,0
		c0.5,0.3,0.8,0.7,0.9,1.3c0.1,0.2,0,0.5,0,0.7c0.4,0.1,0.8,0.3,1.1,0.5c0.3,0.2,0.8,0.6,0.1,1v0.2c0,0.1,0.1,0.1,0.1,0.1
		c0.9-1,1.9-1.3,3.1-0.9l0,0c0.2-0.2,0.6-0.2,1-0.4c0.5,0.3,1.1,0.7,1.7,1c-0.5,1.1-0.7,1.4-1.3,1.5c0,0.4-0.2,0.7-0.4,1
		c-0.7,0.9-1.7,1.2-3,0.9c0,0.1,0,0.2,0,0.3c-0.1,0.9-0.6,1.5-1.6,1.9c-0.8-0.4-1.3-0.8-1.5-1.2c-0.2,0.2-0.4,0.4-0.6,0.7
		c-0.4-0.6-0.7-0.9-0.9-1.2c-0.2,0.1-0.4,0.2-0.6,0.2c0,0.2-0.2,0.4-0.4,0.6c-0.1-0.2-0.1-0.3-0.2-0.4h-0.1c-0.7,0.5-1.1,1.1-1.1,2
		c0.5-0.4,0.9-0.8,1.3-1.2c0.4,0.4,0.9,0.7,1.3,0.9c0.7-0.6,1.8-0.7,2.7-0.2c0.6,0.4,0.8,1,0.6,1.6c0.1,0.1,0.2,0.3,0.3,0.4
		c0.5-0.1,1-0.2,1.5-0.3c-0.1-0.4-0.1-0.7-0.2-1.1c1,0.3,1.3-0.3,1.8-0.8c0.7-0.7,1.7-0.9,2.4-0.6c0-0.1,0-0.2,0-0.3
		c-0.3-0.2-0.5-0.4-0.8-1c-0.4,0-0.8,0.1-1.4,0.2c1.1-0.9,2.3-0.9,3.4-1.2c0.2,0,0.4,0,0.6,0.1c0,0,0,0,0.1,0h0.1
		c-0.1-0.1-0.2-0.1-0.3-0.1c0.3,0,0.5-0.1,0.8-0.1c0.2,0,0.4,0.1,0.6,0.2l0,0c0-0.1,0.1-0.1,0.1-0.2l0,0l0,0c0,0,0,0.1,0,0.2
		c0,0,0,0-0.1,0c0,0,0,0.1-0.1,0.1c0.8,0.1,1.5,0.7,1.6,1.5c0.1,0.6-0.1,1.2-0.5,1.7C385.2,113,386.5,112.8,387.8,112.5z
    M375.2,104.7c0.9,0.2,1.3,0.5,1.2,1.2C375.6,105.9,375.5,105.4,375.2,104.7z M375.8,111.2c0.1,0.1,0.2,0.2,0.2,0.3
		c0,0-0.2,0.1-0.3,0.2c-0.1-0.1-0.1-0.2-0.2-0.2C375.6,111.3,375.7,111.3,375.8,111.2z M375.3,113.2c0.4-0.2,0.6-0.2,0.7-0.3
		c0,0.1,0,0.1,0,0.2C375.9,113.2,375.7,113.2,375.3,113.2z M376.5,112C376.5,112,376.4,112,376.5,112c-0.1-0.1,0-0.1,0-0.2
		C376.6,111.9,376.6,111.9,376.5,112C376.6,112,376.6,112,376.5,112z M382.1,107c-0.1-0.1-0.2-0.1-0.2-0.2s0.1-0.1,0.2-0.2
		c0.1,0,0.2,0.1,0.2,0.1C382.3,106.8,382.2,106.9,382.1,107z M384,109.6c0,0,0.1,0,0.1,0.1l-0.1,0.1c0,0-0.1,0-0.1-0.1
		S384,109.6,384,109.6z M383.8,110.6c0-0.1,0-0.1,0-0.2c0.2,0,0.4,0,0.5,0v0.1C384.2,110.5,384,110.6,383.8,110.6z M385.6,111.9
		l0.1,0.2c-0.2,0.6-0.7,0.2-1.1,0.1C384.9,112.1,385.3,112,385.6,111.9z M384.4,112.9c0,0,0,0.1-0.1,0.1c0,0,0-0.1-0.1-0.1
		c0,0,0-0.1,0.1-0.1C384.4,112.9,384.4,112.9,384.4,112.9z"
      />
      <path
        class="st3"
        d="M432.2,73.4c-0.3,0-0.5,0-0.8,0c0,0.2-0.1,0.4-0.1,0.6c0.8,0.3,1.7,0.5,2.6,0.8c-0.1-0.3-0.2-0.7-0.2-1
		C433.1,73.9,432.6,73.7,432.2,73.4z"
      />
      <path
        class="st3"
        d="M443.2,73.6c-0.4,0-0.8,0-1.2,0c-0.1,0.4-0.3,0.9-0.5,1.6c0.3-0.1,0.6-0.2,0.9-0.2
		C442.7,74.5,443,74.1,443.2,73.6C443.2,73.7,443.2,73.6,443.2,73.6z"
      />
      <path
        class="st3"
        d="M429.9,82.6c0.2-0.2,0.5-0.4,0.7-0.6c-1.1-0.3-2.1-0.5-3-0.7c0,0.9,0,1.9,0,3c1,0,2.1,0,3.2,0
		c0.1-0.2,0.1-0.4,0.2-0.6C430.6,83.4,430.3,83.1,429.9,82.6z"
      />
      <path
        class="st3"
        d="M332.5,258.8L332.5,258.8c-0.3,0-0.6-0.1-0.9-0.2c-0.1,0.3-0.2,0.5-0.3,0.6c0.2,0.1,0.3,0.1,0.4,0.2
		C332,259.3,332.3,259.1,332.5,258.8z"
      />
      <path
        class="st3"
        d="M364.3,96.3c0.2-0.1,0.3-0.2,0.5-0.3c-0.5,0-1,0-1.5,0c0.2,0.1,0.4,0.2,0.5,0.3
		C364.1,96.3,364.2,96.3,364.3,96.3z"
      />
      <path
        class="st3"
        d="M404,89.8c0,0.1,0.1,0.3,0.1,0.4c0.2-0.1,0.3-0.1,0.5-0.2C404.4,89.9,404.2,89.8,404,89.8z"
      />
      <path
        class="st3"
        d="M396,99.4c-0.3,0.4-0.1,0.5,0.1,0.6c0-0.1,0-0.2,0-0.3l0,0C396.1,99.5,396.1,99.4,396,99.4
		C396.1,99.4,396.1,99.4,396,99.4z"
      />
      <path
        class="st3"
        d="M403.1,95.5C403.1,95.6,403.1,95.6,403.1,95.5C403.2,95.6,403.1,95.6,403.1,95.5L403.1,95.5z"
      />
      <path
        class="st3"
        d="M349.5,93.7C349.4,93.7,349.4,93.7,349.5,93.7c-0.1,0.2-0.1,0.3-0.2,0.5l0,0C349.4,94,349.4,93.9,349.5,93.7z"
      />
      <polygon class="st3" points="367.2,106.1 367.3,106.1 367.3,106 	" />
      <path
        class="st3"
        d="M396.6,98.6c0.2,0.1,0.4,0.1,0.5,0.2c0-0.1,0-0.1,0-0.2c-0.3,0-0.7,0-1,0l0,0c0,0.1,0.1,0.2,0.1,0.3
		C396.3,98.8,396.4,98.7,396.6,98.6z"
      />
      <path
        class="st3"
        d="M343.9,248.7c-0.2,0.2-0.4,0.4-0.6,0.5c-0.5-0.3-0.9-0.5-1.3-0.7c-2.2-1.3-4.5-2.6-6.7-4
		c-0.3,0.6-0.9,1.1-1.7,1.4c-0.1,0-0.2,0.1-0.3,0.1c0.7,0.4,1.5,0.9,2.2,1.3c0-0.1,0-0.3,0-0.5c0.3,0.3,0.5,0.5,0.7,0.8
		c0.2-0.3,0.5-0.6,0.8-0.6c0.5-0.1,1.1,0.2,1.2,0.6c0.1,0.4-0.2,0.8-0.6,1c0.1,0.1,0.2,0.1,0.3,0.1c2-0.5,2.3-0.4,3.6,1
		c0.5,0.5,0.6,1.2,1.1,1.7c0,0,0,0,0,0.1c0.7-0.5,1.4-1,2.1-1.5C344.4,249.6,344.1,249.2,343.9,248.7z"
      />
      <path
        class="st3"
        d="M400,228c-1.2,0.7-2.6,0.7-3.7,0.2c-0.5-0.3-1-0.6-1.5-1c0-0.4,0-0.7,0.1-1.1c-0.3,0.2-0.5,0.4-0.8,0.6
		c0.2,0.2,0.4,0.4,0.5,0.6c0.2,0.4,0.2,0.9,0.3,1.3c0.5,0.1,1,0.3,1.6,0.4c-0.1,0.3-0.2,0.5-0.3,0.7l0,0l0,0
		c0.5-0.2,0.9-0.5,1.4-0.7c1.2-0.4,2.5-0.2,3.1,0.6c0.4-0.5,1-0.9,1.7-1.1c0.1,0,0.1,0,0.2-0.1c0-0.2,0-0.4,0-0.6
		c-0.9,0.2-1.6,0.4-2.4,0.7C400.1,228.4,400,228.2,400,228z"
      />
      <path
        class="st3"
        d="M313.9,247.1c-0.2-0.1-0.4-0.3-0.6-0.4c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0.1,0.3,0.3,0.6,0.4
		C313.7,247.3,313.8,247.2,313.9,247.1z"
      />
      <path
        class="st3"
        d="M548.8,190.9c-0.3,0.2-0.7,0.2-1.2,0.2c-0.2,0.5-0.4,1-0.6,1.5c-0.2,0.7-0.4,1.4-0.6,2.1l0,0l0,0
		c0.1,0,0.2,0,0.3,0c0,0,0,0.1-0.1,0.1c0.3,0.1,0.6,0.3,0.9,0.4c0.1,0.5,0.2,0.9,0.3,1.5c0.1,0,0.2,0,0.3-0.1
		c0.7-1.8,1.3-3.6,1.8-5.5C549.6,191.1,549.2,191,548.8,190.9z"
      />
      <path
        class="st3"
        d="M306,244.7v0.5c0.3,0.1,0.5,0.3,0.7,0.5c0.7,0,1.4,0.2,2,0.7c0-0.1-0.1-0.1-0.1-0.2c0-0.2,0-0.5,0-0.7
		c-1,0.1-1.5-0.5-2-1.1C306.4,244.6,306.2,244.7,306,244.7z"
      />
      <path
        class="st3"
        d="M316.4,250.7c-0.1,0.8-0.3,1.7-0.4,2.5c0.4-0.2,0.9-0.3,1.4-0.2c0.2,0,0.3,0,0.5,0v-0.1
		c-0.2-1.1,0.2-2,1.2-2.7c-0.2-0.1-0.4-0.2-0.6-0.3C318,250.1,317.3,250.4,316.4,250.7z"
      />
      <path
        class="st3"
        d="M547.9,190.7C547.8,190.7,547.8,190.7,547.9,190.7c-0.1,0-0.2,0.1-0.2,0.2
		C547.8,190.8,547.8,190.8,547.9,190.7z"
      />
      <path
        class="st3"
        d="M456.8,74.8c0.3,0.8-0.1,1.3-0.8,1.8c0.2,0.5,0.3,1,0.4,1.5c0.4-0.2,0.8-0.3,1.2-0.4c0.9-0.2,1.8-0.1,2.7-0.2
		c0.1-0.8,0.3-1.5,0.4-2.3c-1.9-0.1-3.2-0.5-4.1-1.2C456.7,74.3,456.7,74.6,456.8,74.8z M459.5,77.2L459.5,77.2l-0.1,0.1L459.5,77.2
		z"
      />
      <path
        class="st3"
        d="M486.3,207.2c0.1-0.1,0.1-0.1,0.2-0.2l0,0C486.4,207.1,486.4,207.2,486.3,207.2z"
      />
      <path
        class="st3"
        d="M407.6,226.3C407.6,226.3,407.7,226.3,407.6,226.3c0.2-0.4,0.3-0.9,0.5-1.3c-0.6-0.1-1.1-0.1-1.6-0.2
		c0.2-0.2,0.3-0.4,0.3-0.5c-0.5,0-1.2,0-2.1,0c0.6,0.8,0.6,1.6,0.2,2.5c-0.2,0.5-0.4,1-0.5,1.5c0.3,0.1,0.6,0.1,0.9,0.2
		C406.1,227.9,406.6,226.9,407.6,226.3z"
      />
      <path
        class="st3"
        d="M348.2,226.2c-0.2,0.1-0.4,0.1-0.6,0.2c0.1-0.4,0.1-0.8,0.2-1.2c-0.8,0.1-1.1,0.6-1.6,1.1c0.1,0.3,0,0.6,0,0.9
		c1.1,0.3,1.7,1,2.5,1.5c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0.1-0.1,0.1c0,0,0.1,0,0.1,0.1
		c0.2-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.4-0.3c-0.1-0.6-0.3-1.2-0.9-1.6C348.5,226.6,348.3,226.4,348.2,226.2z"
      />
      <path
        class="st3"
        d="M356.2,241.6l0.1-0.1c0,0-0.1,0-0.1-0.1C356.2,241.5,356.2,241.6,356.2,241.6z"
      />
      <path
        class="st3"
        d="M350.6,229.8c2.3,1.1,4.6,2.2,6.9,3.4c0.2-0.2,0.4-0.3,0.6-0.5c-0.4-0.1-0.7-0.2-0.9-0.2
		c0.3-0.7,0.6-1.5,0.9-2.1c-0.4-0.3-0.6-0.6-0.8-0.7l0,0c-0.9-0.4-1.8-0.9-2.7-1.3c-0.6-0.3-1.3-0.5-1.8-0.9c0,0,0,0-0.1,0l0,0
		c-0.1,0-0.5-0.1-0.9-0.2c0.1-0.2,0.2-0.3,0.4-0.4c-0.1-0.2-0.3-0.4-0.4-0.5c0.1,0,0.2-0.1,0.3-0.2c-0.5-0.2-1-0.6-1.8-1.5
		c-0.3,0.2-0.6,0.5-0.9,0.8v0.1c0.3,0.4,0.6,0.7,0.9,1.1C351,227.8,351.2,228.8,350.6,229.8z M356.7,231.1c0.1,0,0.1,0,0.2,0v0.1
		C356.8,231.1,356.7,231.1,356.7,231.1C356.6,231.1,356.7,231.1,356.7,231.1z M356.5,229.8L356.5,229.8c0-0.1,0.1-0.2,0.1-0.3
		C356.6,229.6,356.5,229.7,356.5,229.8L356.5,229.8c0,0.2,0,0.5,0.1,0.9C356.3,230.3,355.9,230.1,356.5,229.8z M356,231.8L356,231.8
		L356,231.8L356,231.8z M353,230.5L353,230.5v-0.1V230.5z M353,228.2c0.3,0.6,0.6,1,0.9,1.6C352.5,229.4,352.5,229.4,353,228.2z
    M351.1,228.6c0,0,0.1,0,0.1,0.1l-0.1,0.1H351C351.1,228.7,351.1,228.6,351.1,228.6z"
      />
      <path
        class="st3"
        d="M347.8,223.8c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0,0.2,0,0.2,0C347.8,223.9,347.8,223.8,347.8,223.8z"
      />
      <path
        class="st3"
        d="M350.3,231.6c0.1,0.1,0.3,0.1,0.4,0.2l0,0l0,0c0.3,0.2,0.7,0.3,1,0.5c0-0.2,0-0.3,0-0.5
		c-0.4-0.2-0.8-0.4-1.2-0.6C350.5,231.3,350.4,231.4,350.3,231.6z"
      />
      <path
        class="st3"
        d="M391,226.5c0.5-0.3,1.1-0.4,1.6-0.4c0.8-0.7,1.7-1.3,2.5-2c-0.2-0.2-0.4-0.4-0.6-0.6c-0.1-0.1-0.3-0.1-0.4-0.2
		c0.1,0,0.2,0,0.2,0c-0.4-0.4-0.7-0.8-1.2-1.2c0,0,0,0-0.1,0c-0.1,0.1-0.2,0.1-0.3,0.2c0,0.4,0,0.7-0.1,1c-0.8,0.3-0.9,0.3-1.5,0.2
		c-0.9,0.7-1.7,1.3-2.6,2c0,0,0,0,0.1,0c-0.1,0.1-0.2,0.1-0.2,0.1l0,0c-0.5,0.4-1,0.7-1.4,1.1c0.6,0.2,0.9,0.7,1.2,1.2
		c-0.1,0-0.1,0.1-0.2,0.1c0.2,0.1,0.3,0.2,0.4,0.4c0.1,0.3,0.3,0.5,0.5,0.7c0.3-0.2,0.5-0.4,0.8-0.6c0.2-0.3,0.3-0.5,0.6-0.6
		C390.3,227.5,390.6,226.8,391,226.5z"
      />
      <path
        class="st3"
        d="M322.5,95.9c-3.1,0.1-6.2,0.1-9.3,0.2c-0.5,0.3-1.1,0.2-1.2,0.4l0,0c3.6-0.1,7.1-0.2,10.7-0.2
		C322.6,96.2,322.5,96,322.5,95.9z"
      />
      <path
        class="st3"
        d="M326.8,230.7L326.8,230.7c0.1-0.2,0-0.2,0-0.3c-0.2,0-0.4,0.1-0.6,0.1C326.4,230.6,326.6,230.7,326.8,230.7z"
      />
      <path
        class="st3"
        d="M359.1,242c-0.1-0.1-0.1-0.1-0.2-0.2c-0.3,0-0.6,0.1-0.8,0.1c-0.2,0.2-0.5,0.4-0.7,0.5
		c0.7-0.3,1.5-0.4,2.1-0.2l0,0C359.2,242.2,359.1,242.1,359.1,242z"
      />
      <path
        class="st3"
        d="M323.2,127.2c-0.1,0-0.2,0-0.3,0.1c0,0.1-0.1,0.1-0.1,0.2C322.9,127.3,323.1,127.3,323.2,127.2z"
      />
      <path
        class="st3"
        d="M347.2,242.1c0.2-0.2,0.4-0.5,0.6-0.8c-0.2,0.2-0.5,0.4-0.7,0.7C347.2,242.1,347.2,242.1,347.2,242.1z"
      />
      <path
        class="st3"
        d="M513.3,38.1L513.3,38.1c-0.1,0-0.1,0.1,0,0.1C513.2,38.2,513.3,38.1,513.3,38.1z"
      />
      <path
        class="st3"
        d="M323.1,124.9c-0.5,0.1-1,0.2-1.4,0.3c0,0.1,0,0.1,0,0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.4,0.1
		c0,0.1,0.1,0.1,0.2,0.1c0.4,0.2,0.6,0.4,0.6,0.7c0.5-0.1,1-0.2,1.5-0.3C323.1,125.6,323.1,125.3,323.1,124.9z"
      />
      <path
        class="st3"
        d="M608,31.6c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0.5-0.2,0.9-0.2,1.4c0.1,0,0.2,0.1,0.3,0.1l0,0
		C607.9,32.6,608,32.1,608,31.6z"
      />
      <path
        class="st3"
        d="M335.2,236.6c-0.3,0.2-0.6,0.5-1.1,0.8c-1.3,0.7-1.6,1.9-0.7,2.9c0.2,0.3,0.5,0.5,0.7,0.8
		c2.7,1.4,5.3,2.9,8,4.3c0.5,0.3,1,0.6,1.5,0.9c0.1-0.3,0.1-0.6,0.3-0.9c0.3-0.6,0.8-1.2,1.4-1.7c-1.3-0.7-2.5-1.3-3.8-2
		c0.1,0.2,0,0.4-0.2,0.8c-0.3-0.5-0.5-0.8-0.8-1.1c0.2,0,0.4,0,0.5,0c-0.5-0.3-1-0.5-1.5-0.8c-1,0.7-2.3,0.8-3.1,0.2
		c-0.6-0.5-0.7-1.3-0.4-2c-0.2-0.1-0.4-0.2-0.6-0.3c-0.4-0.3-0.7-0.7-1-1.1C334.7,237.1,335,236.9,335.2,236.6
		C335.4,236.7,335.3,236.6,335.2,236.6z"
      />
      <path
        class="st3"
        d="M430.8,60.9c-0.1,0.4-0.2,0.8-0.4,1.2c-0.1,0.4-0.4,0.7-0.6,1c0.6,0.1,1.3,0.2,1.9,0.3
		C431.6,61.3,431.6,61.3,430.8,60.9z"
      />
      <path
        class="st3"
        d="M348,241.1c0.9,0,1.4,0.2,1.3,1.2c0.7-0.4,1.2-0.6,1.6-0.9c-0.9-0.5-1.8-1-2.7-1.4
		C348.3,240.5,348.2,240.8,348,241.1z"
      />
      <path
        class="st3"
        d="M401.3,233.4c-0.4-0.3-0.7-0.6-0.9-0.9c-0.4,0.3-0.8,0.6-1.3,0.7c0.6,0.4,1,1,1.4,1.7c0.3-0.2,0.6-0.4,0.9-0.6
		v-0.1C401.3,234,401.3,233.7,401.3,233.4z"
      />
      <path
        class="st3"
        d="M396.1,229.7c-0.9,0.5-1.7,0.7-2.7,0.3c-0.2-0.1-0.5-0.1-0.8-0.1l0,0c0.3,0.2,0.7,0.4,1.2,0.7
		c-0.4,0.4-0.8,0.8-1.2,1c0,0.2,0,0.5,0,0.7c0.2,0.2,0.3,0.4,0.3,0.7c-0.1,0-0.2,0-0.2-0.1c0,0.3,0.2,0.7,0.5,0.9
		c0.8-0.7,1.8-1.2,3.1-1.3c-0.4-0.4-0.6-1.1-0.5-1.7C395.9,230.5,396,230.1,396.1,229.7C396.1,229.8,396.1,229.8,396.1,229.7
		C396.1,229.8,396.1,229.7,396.1,229.7z"
      />
      <path
        class="st3"
        d="M487.5,41c0.1,0.1,0.2,0.2,0.3,0.3c0.1-0.1,0.1-0.3,0.2-0.5C487.8,40.9,487.6,41,487.5,41z"
      />
      <path
        class="st3"
        d="M606.8,32.7c-1,0-1.4,0.6-1.9,1.2c0,0,0,0.1,0.1,0.1c0.4-0.2,0.8-0.3,1.3-0.4C606.4,33.3,606.6,33,606.8,32.7z
		"
      />
      <path
        class="st3"
        d="M316.7,236.1c0.5-0.3,1-0.7,1-1.4c0-0.1,0.1-0.3,0.2-0.4l0,0c-0.4,0.4-1,0.7-1.6,1
		C316.5,235.6,316.6,235.9,316.7,236.1z"
      />
      <path
        class="st3"
        d="M576.8,25.4c0,0.1,0,0.1,0,0.2C576.8,25.5,576.8,25.4,576.8,25.4C576.9,25.3,576.8,25.4,576.8,25.4z"
      />
      <path
        class="st3"
        d="M322.1,127.8c0.1-0.1,0.2-0.1,0.3-0.2c-0.1-0.1-0.3-0.2-0.4-0.2l0,0C322,127.6,322,127.7,322.1,127.8z"
      />
      <path
        class="st3"
        d="M306,95.3c0.2,0,0.5,0,0.7,0c-0.1-0.1-0.4-0.2-0.7-0.2V95.3z"
      />
      <path
        class="st3"
        d="M438.5,50.2c-0.3-0.1-0.7-0.2-1.3-0.3C437.7,50.5,438.1,50.4,438.5,50.2z"
      />
      <path
        class="st3"
        d="M366.9,109c0.1,0,0.2-0.1,0.3-0.1c0.5-0.1,1.1,0,1.5,0.2c0.7-0.2,1.4,0.1,2.2,0.7c0.5-0.2,0.9-0.4,1.4-0.6
		c-0.4-0.5-0.4-1.1-0.6-1.8c-0.3,0.3-0.8,0.5-1.2,0.6c-0.6,0.1-1.2,0.1-1.7-0.1c-0.2,0.3-0.6,0.5-0.9,0.5s-0.7,0-0.9-0.1
		C367,108.5,366.9,108.7,366.9,109z M370.2,108.3c0.3,0.3,0.6,0.6,0.9,1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.3-0.3-0.7-0.6-1-1
		C370,108.4,370.1,108.3,370.2,108.3z"
      />
      <path
        class="st3"
        d="M306,94.8c0.1-0.2,0.1-0.3,0.2-0.5c-0.1,0-0.1,0-0.2,0V94.8z"
      />
      <path
        class="st3"
        d="M399.3,223c0.9,0.1,1.6,0.5,2,1.1c0.6-0.6,0.4-1.3-0.1-1.9c-0.8,0.2-1.7,0.2-2.3,0.8
		C399,223,399.1,223,399.3,223z"
      />
      <path
        class="st3"
        d="M345.7,250.9c-0.8,0.6-1.6,1.1-2.3,1.7c0.4,0.7,0.5,1.4,0.6,2.2c0.8,0,0-1.6,1.5-0.6c-0.1-0.9-0.1-1.6-0.1-2.3
		c0.1,0,0.2-0.1,0.3-0.1c0.1,0.2,0.3,0.4,0.5,0.6c0.2-0.3,0.3-0.6,0.4-0.8c-0.1-0.2-0.1-0.3-0.2-0.3
		C346.1,251.2,345.9,251,345.7,250.9z"
      />
      <path
        class="st3"
        d="M319.6,121.6c0,0,0,0.1-0.1,0.1c0.2,0,0.4-0.1,0.6-0.1C320,121.6,319.9,121.6,319.6,121.6
		C319.7,121.5,319.7,121.6,319.6,121.6C319.7,121.6,319.7,121.6,319.6,121.6z"
      />
      <path
        class="st3"
        d="M385.2,228.3c0,0.2,0.1,0.3,0.1,0.5l0,0l0.1,0.1c0.3-0.3,0.6-0.5,0.8-0.6c-0.1-0.1-0.2-0.3-0.3-0.5
		C385.6,227.9,385.4,228.1,385.2,228.3z"
      />
      <path
        class="st3"
        d="M420.1,50.2c0.3-0.7,0-1-0.7-1.3c0,0.5,0,0.9-0.1,1.2s-0.2,0.5-0.4,0.7c0.3,0,0.6,0.1,0.8,0.2
		C419.8,50.8,419.9,50.5,420.1,50.2z"
      />
      <path
        class="st3"
        d="M334.8,259.4c-1.3,0.9,0,1.6,0.1,2.8c-0.4-0.5-0.6-0.7-0.7-0.9c-0.1-0.4-0.3-0.8-0.3-1.2c0-0.2,0-0.4-0.1-0.6
		c-0.6,0.5-1.3,0.9-1.9,1.4c-0.2,0.2-0.4,0.4-0.7,0.5c-0.8,0.6-1.7,1.2-2.5,1.8c0.6,1.3,0,2.5-1,3.4c0.2,0.3,0.5,0.5,1,0.6
		s0.6,0.9,1.3,0.5c0.5,1.2,1.9,0.8,2.9,0.8c0.7,0,1.4-0.5,1.2-1.4c-0.9-0.2-2-0.1-2.2-1.2c0-0.1-0.4-0.2-0.6-0.3
		c-0.3-0.1-0.6-0.1-0.9-0.2c-0.8-0.3-1.3-1-0.9-1.5c0.4-0.4,1-0.6,1.6-0.6c0.8-0.1,1,0.3,1,1.1c0,0.2,0,0.5-0.1,0.7
		c0.6,0,1.3,0,1.9,0c0.5,0,1.1,0,1.7,0c0-1.2,0.1-2.3,0.1-3.5c0.7-0.4,1.3-0.7,2-1.1C337.4,259,335.9,259.5,334.8,259.4z
    M331.9,263.3c-0.1-0.3-0.2-0.6-0.4-0.9c0.1,0,0.1-0.1,0.2-0.1c0.2,0.3,0.3,0.5,0.5,0.8C332.2,263.2,332,263.3,331.9,263.3z"
      />
      <path
        class="st3"
        d="M324,267.9c0.1,0.4,0.2,0.7,0.2,1c0.3-0.2,0.5-0.3,0.7-0.4c0,0,0,0,0.1,0c0.1-0.1,0.1-0.1,0.2-0.2
		c0.2-0.2,0.4-0.4,0.6-0.7c-0.3,0.1-0.5,0.1-0.8,0.1C324.7,267.8,324.4,267.8,324,267.9z"
      />
      <path
        class="st3"
        d="M324,269.6c0,0,0.1,0,0.1-0.1l0,0C324,269.5,324,269.5,324,269.6z"
      />
      <path
        class="st3"
        d="M320.2,124.1c0.8-0.2,1.7-0.3,2.5-0.5c-0.3-0.3-0.5-0.6-0.6-1c-0.9,0.2-1.7,0.3-2.6,0.5l0.1,0.1
		C319.9,123.4,320.1,123.8,320.2,124.1z"
      />
      <path
        class="st3"
        d="M353.6,236.1c-0.7-0.5-0.7-1.1,0.1-1.5c-0.3-0.1-0.5-0.3-0.8-0.4c-0.1,0.1-0.2,0.2-0.4,0.2
		c-1-0.5-1.7-1.1-2.6-1.3c-1-0.1-1.2-0.6-1.3-1.1c-0.1,0.3-0.1,0.5,0,0.8c-0.4,0.2-0.8,0.3-1,0.5s-0.3,0.7-0.5,0.8
		c-0.4,0.1-0.8,0.3-1.1,0.5c0.1,0,0.1,0.1,0.2,0.1c-0.2,0.3-0.5,0.7-0.8,1.1c-0.1,0-0.2,0-0.3-0.1c1.7,0.8,3.5,1.7,5.2,2.5
		c0-0.3-0.1-0.5-0.2-0.7c-0.4-0.9,0.9-1.5,1.4-2.2c1.1,0.8,1.7,1.6,0.8,2.8c-0.2,0.2,0,0.5,0,0.8c0,0.1,0,0.2,0,0.3
		c0.3,0.1,0.6,0.3,0.9,0.4c0.3,0.1,0.6,0.2,0.9,0.4c0.2-0.1,0.4-0.2,0.6-0.4s0.3-0.5,0.5-0.7c0.2-0.5,0.4-1,0.9-1.3
		c-0.3-0.1-0.6-0.3-0.8-0.5C354.7,236.8,354.1,236.4,353.6,236.1z M350.7,235.4c-0.2,0.5-0.6,0.6-1.7,0.3c0.3-0.6,0.5-1.2,1.4-0.9
		C350.6,234.8,350.8,235.2,350.7,235.4z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "FootballCover_c1",
  props: ["fill"],
};
</script>
